/* eslint-disable */
;(function(global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined'
    ? (module.exports = factory())
    : typeof define === 'function' && define.amd
    ? define(factory)
    : ((global = typeof globalThis !== 'undefined' ? globalThis : global || self),
      (global.cloudRender = factory()))
})(this, function() {
  'use strict'

  /******************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */
  /* global Reflect, Promise, SuppressedError, Symbol */

  function __awaiter$1(thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P
        ? value
        : new P(function(resolve) {
            resolve(value)
          })
    }
    return new (P || (P = Promise))(function(resolve, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value))
        } catch (e) {
          reject(e)
        }
      }
      function rejected(value) {
        try {
          step(generator['throw'](value))
        } catch (e) {
          reject(e)
        }
      }
      function step(result) {
        result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected)
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next())
    })
  }

  typeof SuppressedError === 'function'
    ? SuppressedError
    : function(error, suppressed, message) {
        var e = new Error(message)
        return (e.name = 'SuppressedError'), (e.error = error), (e.suppressed = suppressed), e
      }

  var ILoadFileStatus
  ;(function(ILoadFileStatus) {
    ILoadFileStatus[(ILoadFileStatus['Error'] = 0)] = 'Error'
    ILoadFileStatus[(ILoadFileStatus['DownLoading'] = 1)] = 'DownLoading'
    ILoadFileStatus[(ILoadFileStatus['DownLoadSuccess'] = 2)] = 'DownLoadSuccess'
  })(ILoadFileStatus || (ILoadFileStatus = {}))

  var LoadEngineStatus
  ;(function(LoadEngineStatus) {
    LoadEngineStatus[(LoadEngineStatus['NativeLoad'] = 0)] = 'NativeLoad'
    LoadEngineStatus[(LoadEngineStatus['Connected'] = 1)] = 'Connected'
    LoadEngineStatus[(LoadEngineStatus['Disconnected'] = 2)] = 'Disconnected'
    LoadEngineStatus[(LoadEngineStatus['UserTimeOut'] = 3)] = 'UserTimeOut'
  })(LoadEngineStatus || (LoadEngineStatus = {}))
  var ILoadModelStatus
  ;(function(ILoadModelStatus) {
    ILoadModelStatus[(ILoadModelStatus['Init'] = 0)] = 'Init'
    ILoadModelStatus[(ILoadModelStatus['Loading'] = 1)] = 'Loading'
    ILoadModelStatus[(ILoadModelStatus['Error'] = 2)] = 'Error'
    ILoadModelStatus[(ILoadModelStatus['DownLoading'] = 3)] = 'DownLoading'
    ILoadModelStatus[(ILoadModelStatus['LoadSuccess'] = 4)] = 'LoadSuccess'
    ILoadModelStatus[(ILoadModelStatus['DownLoadSuccess'] = 5)] = 'DownLoadSuccess'
    ILoadModelStatus[(ILoadModelStatus['UnLoadModel'] = 6)] = 'UnLoadModel'
  })(ILoadModelStatus || (ILoadModelStatus = {}))

  /*
   * @Author: fengxiaojing
   * @LastEditTime: 2023-08-21 15:35:24
   * @Description:
   * @LastEditors: fengxiaojing
   */
  /**
   * @description: 生成唯一的uuid
   * @return {*}
   */
  function generateUUID() {
    let d = new Date().getTime()
    if (window.performance && typeof window.performance.now === 'function') {
      d += performance.now()
    }
    const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = (d + Math.random() * 16) % 16 | 0
      d = Math.floor(d / 16)
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
    })
    return uuid
  }
  /**
   * @description: 检查player是否有效
   * @param {IPlayer} player
   * @return {*}
   */
  function checkPlayerLoad(player) {
    if (!player) {
      return false
    }
    if (!player.Native) {
      return false
    }
    return true
  }
  function sendEvent(eventData, name = 'CloudRender') {
    window.dispatchEvent(
      new CustomEvent(name, {
        detail: Object.assign({}, eventData),
        bubbles: true,
        cancelable: false,
      })
    )
  }
  function hex2rgba(hex) {
    const result = {
      r: 0,
      g: 0,
      b: 0,
      a: 255,
    }
    result.r = Number(parseInt(hex.substring(1, 3), 16)) || 0
    result.g = Number(parseInt(hex.substring(3, 5), 16)) || 0
    result.b = Number(parseInt(hex.substring(5, 7), 16)) || 0
    result.a = Number(parseInt(hex.substring(7), 16)) || 255
    return result
  }
  function computedByteLen(str) {
    const chineseReg = /[^\x00=\xff]/g
    return str.replace(chineseReg, '**').length
  }
  function computedTextWidth(text, font = '14px Microsoft YaHei') {
    const canvas = document.createElement('canvas')
    const context = canvas.getContext('2d')
    if (!context) {
      return 0
    }
    context.font = font
    const metrics = context.measureText(text)
    return Math.ceil(metrics.width)
  }

  /*
   * @Author: fengxiaojing
   * @LastEditTime: 2023-09-26 14:01:35
   * @Description:
   * 文件相关方法
   * 1.检查文件是否存在
   * 2.文件下载
   * @LastEditors: fengxiaojing
   */
  class File {
    constructor(player, loadFileParams, id) {
      this.downloadProgressChangeFun = () => {}
      this.downloadFinishFun = () => {}
      this.downloadList = []
      this.player = {}
      this.connectFlag = false
      this.id = id || generateUUID()
      if (checkPlayerLoad(player)) {
        this.changeStatus(ILoadFileStatus.Error, 'player实例无效')
      }
      this.player = player
      if (loadFileParams === null || loadFileParams === void 0 ? void 0 : loadFileParams.fileList) {
        if (!Array.isArray(loadFileParams.fileList)) {
          loadFileParams.fileList = [loadFileParams.fileList]
        }
        this.setConnect()
        this.connectFlag = false
        this.init(loadFileParams.fileList, loadFileParams.httpOptions, loadFileParams.type)
      }
    }
    /**
     * @description: 初始化下载文件的任务
     * @param {Array} fileList 文件列表
     * @param {ILoadFileHttpOptions} httpOptions 接口的方法+请求头
     * @return {*}
     */
    init(fileList, httpOptions, type) {
      fileList.forEach((file) =>
        __awaiter$1(this, void 0, void 0, function*() {
          var _a
          const isExistFile = yield this.checkFile(this.player, file.targetUrl)
          if (isExistFile) {
            this.changeStatus(ILoadFileStatus.DownLoadSuccess, '模型下载完成！', {
              tempPath: file.tempPath || '',
              targetUrl: file.targetUrl,
              md5: file.md5 || '',
              type: type || '',
            })
            return
          }
          // 创建下载任务
          const res = yield (_a = this.player.Native) === null || _a === void 0
            ? void 0
            : _a.File.downloadFile(
                file.tempPath,
                (httpOptions === null || httpOptions === void 0 ? void 0 : httpOptions.methods) ||
                  'GET',
                file.fileUrl,
                (httpOptions === null || httpOptions === void 0 ? void 0 : httpOptions.header) || {}
              )
          if (res) {
            // 存储当前处于下载的队列,tempPath一定存在
            this.downloadList.push({
              tempPath: file.tempPath || '',
              targetUrl: file.targetUrl,
              md5: file.md5 || '',
              type: type || '',
            })
          } else {
            this.changeStatus(ILoadFileStatus.Error, '创建下载模型任务失败！', {
              tempPath: file.tempPath || '',
              targetUrl: file.targetUrl,
              md5: file.md5 || '',
              type: type || '',
            })
          }
        })
      )
    }
    /**
     * @description: 追加文件
     * @param {Array} fileList
     * @param {ILoadFileHttpOptions} httpOptions
     * @return {*}
     */
    addFileList(loadFileParams) {
      if (!this.connectFlag) {
        this.setConnect()
        this.connectFlag = true
      }
      if (!Array.isArray(loadFileParams.fileList)) {
        loadFileParams.fileList = [loadFileParams.fileList]
      }
      this.init(loadFileParams.fileList, loadFileParams.httpOptions, loadFileParams.type)
    }
    checkFile(player, targetUrl) {
      var _a
      return __awaiter$1(this, void 0, void 0, function*() {
        // 检查文件是否存在
        const isExistFile = yield (_a = player.Native) === null || _a === void 0
          ? void 0
          : _a.File.exists(targetUrl)
        return isExistFile
      })
    }
    setConnect() {
      var _a,
        _b
        // 设置下载的监听
      ;(_a = this.player.Native) === null || _a === void 0
        ? void 0
        : _a.File.EventDownloadProcessChanged.connect(this.downloadProgressChange())
      ;(_b = this.player.Native) === null || _b === void 0
        ? void 0
        : _b.File.EventDownloadFinish.connect(this.downloadFinishMsg())
    }
    disConnect() {
      var _a,
        _b
        // 设置下载的监听
      ;(_a = this.player.Native) === null || _a === void 0
        ? void 0
        : _a.File.EventDownloadProcessChanged.disconnect(this.downloadProgressChangeFun)
      ;(_b = this.player.Native) === null || _b === void 0
        ? void 0
        : _b.File.EventDownloadFinish.disconnect(this.downloadFinishFun)
    }
    /**
     * @description: 下载进度变化
     * @return {*}
     * @internal
     */
    downloadProgressChange() {
      const that = this
      this.downloadProgressChangeFun = (file, bytesReceived, bytesTotal) => {
        const currentFile = that.downloadList.find((el) => {
          return el.tempPath === file
        })
        let loadPercentage = 0
        if (bytesTotal) {
          loadPercentage = (bytesReceived / bytesTotal) * 100
        }
        // 更新消息
        that.changeStatus(ILoadFileStatus.DownLoading, '下载中...', currentFile, loadPercentage)
      }
      return this.downloadProgressChangeFun
    }
    /**
     * @description: 下载模型成功回调
     * @return {*}
     * @internal
     */
    downloadFinishMsg() {
      const that = this
      this.downloadFinishFun = (file, err, bytesTotal) =>
        __awaiter$1(this, void 0, void 0, function*() {
          var _a, _b, _c, _d, _e, _f, _g, _h
          const currentFileIndex = that.downloadList.findIndex((el) => {
            return el.tempPath === file
          })
          if (currentFileIndex !== -1) {
            const currentFile = that.downloadList.splice(currentFileIndex, 1)
            if (that.downloadList.length === 0) {
              that.disConnect()
            }
            // 存在则报错
            if (err) {
              // 更新消息
              that.changeStatus(
                ILoadFileStatus.Error,
                err,
                (_a = currentFile[0]) !== null && _a !== void 0 ? _a : undefined
              )
            }
            // 检查下载的md5是否一致
            const downloadFileMd5 = yield (_b = that.player.Native) === null || _b === void 0
              ? void 0
              : _b.File.getFileMd5(file)
            if (
              downloadFileMd5 ===
              ((_c = currentFile[0]) === null || _c === void 0 ? void 0 : _c.md5)
            ) {
              const moveStatus = yield (_d = that.player.Native) === null || _d === void 0
                ? void 0
                : _d.File.move(
                    (_e = currentFile[0]) === null || _e === void 0 ? void 0 : _e.tempPath,
                    (_f = currentFile[0]) === null || _f === void 0 ? void 0 : _f.targetUrl
                  )
              // 更新消息
              that.changeStatus(
                moveStatus ? ILoadFileStatus.DownLoadSuccess : ILoadFileStatus.Error,
                moveStatus ? '下载成功' : '模型移动失败',
                (_g = currentFile[0]) !== null && _g !== void 0 ? _g : undefined
              )
            } else {
              that.changeStatus(
                ILoadFileStatus.Error,
                '下载的文件与模型的md5不一致',
                (_h = currentFile[0]) !== null && _h !== void 0 ? _h : undefined
              )
            }
          }
        })
      return this.downloadFinishFun
    }
    /**
     * @description: 状态变化时发送事件
     * @param {ILoadFileStatus} status 下载的状态
     * @param {string} message
     * @param {IDownloadList} currentFile 下载的文件信息
     * @param {number} process 下载的进度
     * @return {*}
     */
    changeStatus(status, message, currentFile, process = -1) {
      sendEvent(
        {
          message,
          status: status !== ILoadFileStatus.Error,
          data: {
            type: 'fileStauts',
            currentState: status,
            data: Object.assign(Object.assign({}, currentFile), { process, id: this.id }),
          },
        },
        'File'
      )
    }
  }

  /**
   * 操作模型（加载，卸载）
   * @remarks
   * ```javaScript
   * interface eventMsg {
   *  detail: {
   *      data: {
   *          type: string, // 由谁触发
   *          currentState: number, // 当前的状态
   *          data: modelResponseData, // 需要传输的数据
   *      },
   *      status: boolean,
   *      message: string
   *  }
   * }
   * interface modelResponseData extends ILoadModelParameter{
   *  process: number// 进度
   * },
   * ```
   *
   * @example
   * ```javaScript
   * // 监听加载or下载进度
   * window.addEventListener('CloudRender', res: eventMsg=> {
   *  const eventData =  res.detail
   * })
   * // 创建了一个加载模型的任务
   * const ModelOperate = new cloudRender.Model(modelList, player)
   * ```
   */
  class Model {
    /**
     * 传入模型列表和player实例，并加载模型
     */
    constructor(paramData, player) {
      /** 当前模型加载的状态
       * @internal
       */
      this.LoadStatus = {}
      /** 加载过程中的监听方法 start
       * @internal
       */
      this.loadModelProgressChangeFun = () => {}
      /**@internal  */
      this.loadModelFinishFun = () => {}
      /**@internal  */
      this.player = {}
      /** 判断是否需要开启监听
       * @internal
       */
      this.connectFlag = false
      this.fileObject = { addFileList: () => {} }
      this.dealFileData = (e) => {
        var _a, _b, _c, _d, _e, _f
        const detail = e.detail
        if (
          ((_a = detail.data) === null || _a === void 0 ? void 0 : _a.data.id) !==
          this.fileInstanceId
        )
          return
        const currentModel = this.modelList.find((el) => {
          var _a, _b, _c, _d
          if (
            ((_a = detail.data) === null || _a === void 0 ? void 0 : _a.data.type) === 'modelDecals'
          ) {
            return (
              ((_b = el.modelDecals) === null || _b === void 0 ? void 0 : _b.targetUrl) ===
              ((_c = detail.data) === null || _c === void 0 ? void 0 : _c.data.targetUrl)
            )
          }
          return (
            el.targetUrl ===
            ((_d = detail.data) === null || _d === void 0 ? void 0 : _d.data.targetUrl)
          )
        })
        if (!currentModel) return
        switch ((_b = detail.data) === null || _b === void 0 ? void 0 : _b.currentState) {
          case ILoadFileStatus.Error:
            this.changeLoadStatus(
              currentModel === null || currentModel === void 0 ? void 0 : currentModel.modelId,
              ILoadModelStatus.Error,
              '下载失败',
              (_c = detail.data) === null || _c === void 0 ? void 0 : _c.data.type
            )
            break
          case ILoadFileStatus.DownLoadSuccess:
            this.changeLoadStatus(
              currentModel === null || currentModel === void 0 ? void 0 : currentModel.modelId,
              ILoadModelStatus.DownLoadSuccess,
              '下载成功',
              (_d = detail.data) === null || _d === void 0 ? void 0 : _d.data.type
            )
            break
          case ILoadFileStatus.DownLoading:
            this.changeLoadStatus(
              currentModel === null || currentModel === void 0 ? void 0 : currentModel.modelId,
              ILoadModelStatus.DownLoading,
              '下载中...',
              (_e = detail.data) === null || _e === void 0 ? void 0 : _e.data.type,
              (_f = detail.data) === null || _f === void 0 ? void 0 : _f.data.process
            )
            break
        }
      }
      this.modelList = this.collatingData(paramData)
      this.fileInstanceId = generateUUID()
      if (player) {
        const isCurrentPlayer = checkPlayerLoad(player)
        if (isCurrentPlayer) {
          this.fileObject = new File(player, undefined, this.fileInstanceId)
          this.init(player)
        } else {
          this.changeLoadStatus(null, ILoadModelStatus.Error, 'player实例无效')
        }
      }
    }
    /**
     * @description:
     * @param {Array} paramData
     * @return {*}
     * @internal
     */
    collatingData(paramData) {
      var _a, _b, _c, _d
      if (Array.isArray(paramData)) {
        return paramData.map((model) => {
          var _a, _b, _c, _d
          const modelId =
            ((_a = model.options) === null || _a === void 0 ? void 0 : _a.modelId) || generateUUID()
          return {
            md5: model.md5 || '',
            fileUrl: model.fileUrl || '',
            targetUrl: model.targetUrl,
            modelId,
            modelDecals: (_b = model.options) === null || _b === void 0 ? void 0 : _b.modelDecals,
            gisSetting: (_c = model.options) === null || _c === void 0 ? void 0 : _c.gisSetting,
            httpOptions: (_d = model.options) === null || _d === void 0 ? void 0 : _d.httpOptions,
            tempPath:
              (model === null || model === void 0 ? void 0 : model.tempPath) ||
              `data://../temps/models/${modelId}/${modelId}.pr`,
            loadSetting: model.loadSetting || { dynamicLoadEnabled: false },
          }
        })
      } else {
        const modelId =
          ((_a = paramData.options) === null || _a === void 0 ? void 0 : _a.modelId) ||
          generateUUID()
        return [
          {
            md5: paramData.md5 || '',
            fileUrl: paramData.fileUrl || '',
            targetUrl: paramData.targetUrl,
            modelId,
            modelDecals:
              (_b = paramData.options) === null || _b === void 0 ? void 0 : _b.modelDecals,
            gisSetting: (_c = paramData.options) === null || _c === void 0 ? void 0 : _c.gisSetting,
            httpOptions:
              (_d = paramData.options) === null || _d === void 0 ? void 0 : _d.httpOptions,
            tempPath:
              (paramData === null || paramData === void 0 ? void 0 : paramData.tempPath) ||
              `data://../temps/models/${modelId}/${modelId}.pr`,
            loadSetting: paramData.loadSetting || { dynamicLoadEnabled: false },
          },
        ]
      }
    }
    /**@internal  */
    init(player) {
      // 检查player的有效性
      this.player = player
      if (!this.connectFlag) {
        this.setConnect()
        this.connectFlag = true
      }
      this.modelList.forEach((model) => {
        if (!this.LoadStatus[model.modelId]) {
          // 初始化LoadStatus
          this.LoadStatus[model.modelId] = {
            modelStatus: ILoadModelStatus.Init,
          }
          // 检查是否需要加载贴图
          if (model.modelDecals) {
            this.LoadStatus[model.modelId].modelDecalsStatus = ILoadModelStatus.Init
            // 判断是否存在临时路径,不存在设置默认值
            if (!model.modelDecals.tempPath) {
              model.modelDecals.tempPath = `data://../temps/models/${model.modelId}/${model.modelId}.pr.texPackage`
            }
            this.fileObject.addFileList({
              fileList: model.modelDecals,
              httpOptions: model.httpOptions,
              type: 'modelDecals',
            })
          }
          this.fileObject.addFileList({
            fileList: model,
            httpOptions: model.httpOptions,
            type: 'modelStatus',
          })
        }
      })
    }
    /**@internal  */
    setConnect() {
      var _a, _b
      // 设置文件加载状态的监听
      window.addEventListener('File', this.dealFileData)
      // 设置加载的监听
      ;(_a = this.player.Native) === null || _a === void 0
        ? void 0
        : _a.Model.EventProgress.connect(this.loadModelProgressChange())
      ;(_b = this.player.Native) === null || _b === void 0
        ? void 0
        : _b.Model.EventProgressEnd.connect(this.loadModelFinish())
    }
    /**@internal  */
    disConnect() {
      var _a, _b
      window.removeEventListener('File', this.dealFileData)
      // 设置加载的监听
      ;(_a = this.player.Native) === null || _a === void 0
        ? void 0
        : _a.Model.EventProgress.disconnect(this.loadModelProgressChangeFun)
      ;(_b = this.player.Native) === null || _b === void 0
        ? void 0
        : _b.Model.EventProgressEnd.disconnect(this.loadModelFinishFun)
    }
    /**
     * @description: 加载模型进度变化
     * @return {*}
     * @internal
     */
    loadModelProgressChange() {
      const that = this
      this.loadModelProgressChangeFun = (data, ptr, name) => {
        // 更新消息
        that.changeLoadStatus(
          name,
          ILoadModelStatus.Loading,
          '加载中...',
          'modelStatus',
          data * 100
        )
      }
      return this.loadModelProgressChangeFun
    }
    /**
     * @description: 加载模型成功回调
     * @return {*}
     * @internal
     */
    loadModelFinish() {
      const that = this
      this.loadModelFinishFun = (data, ptr, name) => {
        // 更新消息
        that.changeLoadStatus(
          name,
          ILoadModelStatus.LoadSuccess,
          '加载完成',
          'modelStatus',
          data * 100
        )
      }
      return this.loadModelFinishFun
    }
    /**
     * @description: 加载模型
     * @param {IPlayer} player
     * @param {ILoadFileParameter} fileDetail
     * @param {ILoadFileHttpOptions} httpOptions
     * @param {string} modelId
     * @param {string} type
     * @return {*}
     * @internal
     */
    loadFile(player, fileDetail, httpOptions, modelId, type) {
      var _a
      return __awaiter$1(this, void 0, void 0, function*() {
        const res = yield (_a = player.Native) === null || _a === void 0
          ? void 0
          : _a.Model.loadModelWithParam(modelId, fileDetail.targetUrl, fileDetail.loadSetting)
        if (res !== '') {
          this.changeLoadStatus(modelId, ILoadModelStatus.Error, '创建加载任务失败', 'modelStatus')
        } else {
          this.changeLoadStatus(modelId, ILoadModelStatus.Loading, '加载中...', 'modelStatus', 0)
        }
      })
    }
    /**
     * @description: 状态变化，发送消息
     * @param modelId -模型id
     * @param {ILoadModelStatus} status
     * @param {string} message
     * @param {string} type
     * @param {number} process
     * @return {*}
     * @internal
     */
    changeLoadStatus(modelId, status, message, type = 'modelStatus', process = -1) {
      return __awaiter$1(this, void 0, void 0, function*() {
        let currentModel = null
        if (modelId) {
          this.LoadStatus[modelId] = Object.assign(this.LoadStatus[modelId], { [type]: status })
          currentModel = this.modelList.find((el) => {
            return el.modelId === modelId
          })
          if (currentModel) {
            // 根据当前状态，执行不同的方法
            switch (status) {
              case ILoadModelStatus.DownLoadSuccess:
                // 模型下载成功
                const unDownLoadSuccessIndex = Object.values(
                  this.LoadStatus[modelId || -1]
                ).findIndex((el) => {
                  return el !== ILoadModelStatus.DownLoadSuccess
                })
                if (unDownLoadSuccessIndex === -1) {
                  this.loadFile(
                    this.player,
                    currentModel,
                    currentModel === null || currentModel === void 0
                      ? void 0
                      : currentModel.httpOptions,
                    modelId,
                    type
                  )
                }
                break
              case ILoadModelStatus.UnLoadModel:
                // 卸载模型
                this.modelList = this.modelList.filter((item) => {
                  return item.modelId !== modelId
                })
                delete this.LoadStatus[modelId]
                break
              case ILoadModelStatus.LoadSuccess:
                yield this.setModelGisPosition(modelId, currentModel.gisSetting)
                break
            }
          }
        }
        sendEvent({
          message,
          status: status !== ILoadModelStatus.Error,
          data: {
            type,
            currentState: status,
            data: Object.assign(Object.assign({}, currentModel), { process }),
          },
        })
      })
    }
    /**
     * @description:
     * @param paramsData - 模型列表，可传单个模型配置信息
     * @return
     */
    addModelList(paramsData) {
      if (this.player) {
        const collatingDataList = this.collatingData(paramsData)
        const unloadModelList = collatingDataList.filter((model) => {
          return (
            this.modelList.findIndex((el) => {
              return el.modelId === model.modelId
            }) === -1
          )
        })
        this.modelList = [...this.modelList, ...unloadModelList]
        this.init(this.player)
      } else {
        this.changeLoadStatus(null, ILoadModelStatus.Error, 'player实例无效')
      }
    }
    /**
     * 批量卸载模型
     * @param modelId - 模型的id集合
     * @return
     */
    destoryModelList(modelId) {
      var _a, _b
      return __awaiter$1(this, void 0, void 0, function*() {
        if (this.player) {
          if (Array.isArray(modelId)) {
            for (let i = 0; i < modelId.length; i++) {
              const element = modelId[i]
              yield (_a = this.player.Native) === null || _a === void 0
                ? void 0
                : _a.Model.unloadModel(element)
              this.modelList = this.modelList.filter((item) => {
                return item.modelId !== element
              })
              delete this.LoadStatus[element]
            }
            return {
              status: true,
              message: '卸载成功',
            }
          } else {
            yield (_b = this.player.Native) === null || _b === void 0
              ? void 0
              : _b.Model.unloadModel(modelId)
            return {
              status: true,
              message: '卸载成功',
            }
          }
        } else {
          return {
            status: false,
            message: 'player实例无效',
          }
        }
      })
    }
    /**
     * 卸载所有模型
     * @return
     */
    destoryAllModel() {
      var _a, _b
      return __awaiter$1(this, void 0, void 0, function*() {
        if (this.player) {
          const loadModelList = yield (_a = this.player.Native) === null || _a === void 0
            ? void 0
            : _a.Model.getAllInfo()
          for (let i = 0; i < Object.keys(loadModelList).length; i++) {
            const element = Object.keys(loadModelList)[i]
            if (
              this.modelList.findIndex((model) => {
                return model.modelId === element
              }) !== -1
            ) {
              yield (_b = this.player.Native) === null || _b === void 0
                ? void 0
                : _b.Model.unloadModel(element)
              this.modelList = this.modelList.filter((item) => {
                return item.modelId !== element
              })
              delete this.LoadStatus[element]
            }
          }
          // 取消模型的进度监听
          this.disConnect()
          this.connectFlag = false
          return {
            status: true,
            message: '卸载成功',
          }
        } else {
          return {
            status: false,
            message: 'player实例无效',
          }
        }
      })
    }
    /**
     * 设置模型的位置
     * @param modelId - 模型的id,可从消息返回中获取
     * @param gisSetting - 模型放置于地球中的配置
     * @return
     */
    setModelGisPosition(modelId, gisSetting) {
      var _a, _b, _c, _d, _e, _f, _g
      return __awaiter$1(this, void 0, void 0, function*() {
        const isGisMode = yield (_a = this.player.Native) === null || _a === void 0
          ? void 0
          : _a.GisPlatform.isGisMode()
        if (isGisMode) {
          if (gisSetting) {
            const modelInfo = yield (_b = this.player.Native) === null || _b === void 0
              ? void 0
              : _b.Model.getInfo(modelId)
            if (modelInfo) {
              // 加载地球后的操作
              const latitude = gisSetting.Latitude || 0
              const longitude = gisSetting.Longitude || 0
              let llh = [longitude, latitude, gisSetting.Elevation || 0] // 获取经纬度和高度向量
              // 设置地形攀爬
              yield (_c = this.player.Native) === null || _c === void 0
                ? void 0
                : _c.NodeProxy.setNodeClampTerrain(modelInfo.nodePtr, gisSetting.IsAutoFollowFloor)
              if (gisSetting.IsAutoFollowFloor) {
                // 查询经纬度的高程信息,返回的是数组,批量查询结果与单个查询一致，但性能更高
                llh[2] =
                  (yield (_d = this.player.Native) === null || _d === void 0
                    ? void 0
                    : _d.GisPlatform.queryDEM([[longitude, latitude]])[0]) || 0
              }
              // 设置模型位置
              yield (_e = this.player.Native) === null || _e === void 0
                ? void 0
                : _e.NodeProxy.setNodeGisPos(modelInfo.nodePtr, llh)
              // 设置模型的旋转
              yield (_f = this.player.Native) === null || _f === void 0
                ? void 0
                : _f.NodeProxy.setNodeRotation(modelInfo.nodePtr, [
                    gisSetting.X_Axis_Angle || 0,
                    gisSetting.Y_Axis_Angle || 0,
                    gisSetting.Z_Axis_Angle || 0,
                  ])
              // 设置地形攀爬偏移量
              yield (_g = this.player.Native) === null || _g === void 0
                ? void 0
                : _g.NodeProxy.setNodeClampOffset(modelInfo.nodePtr, gisSetting.Model_Offset || 0)
              return {
                status: true,
                message: '',
              }
            } else {
              return {
                status: false,
                message: '模型未加载完全',
              }
            }
          } else {
            return {
              status: false,
              message: 'Gis的配置不存在',
            }
          }
        } else {
          return {
            status: false,
            message: '未加载地球',
          }
        }
      })
    }
    /**
     * 获取当前player加载的所有模型信息
     * @param player
     * @returns
     */
    static getAllInfo(player) {
      var _a
      return __awaiter$1(this, void 0, void 0, function*() {
        if (!checkPlayerLoad(player)) {
          return {
            data: null,
            status: false,
            message: 'player实例无效',
          }
        }
        const modelAllInfo = yield (_a = player.Native) === null || _a === void 0
          ? void 0
          : _a.Model.getAllInfo()
        return {
          data: modelAllInfo,
          status: true,
          message: '',
        }
      })
    }
  }

  /****************************************************************************
   **
   ** Copyright (C) 2016 The Qt Company Ltd.
   ** Copyright (C) 2016 Klarälvdalens Datakonsult AB, a KDAB Group company, info@kdab.com, author Milian Wolff <milian.wolff@kdab.com>
   ** Contact: https://www.qt.io/licensing/
   **
   ** This file is part of the QtWebChannel module of the Qt Toolkit.
   **
   ** $QT_BEGIN_LICENSE:LGPL$
   ** Commercial License Usage
   ** Licensees holding valid commercial Qt licenses may use this file in
   ** accordance with the commercial license agreement provided with the
   ** Software or, alternatively, in accordance with the terms contained in
   ** a written agreement between you and The Qt Company. For licensing terms
   ** and conditions see https://www.qt.io/terms-conditions. For further
   ** information use the contact form at https://www.qt.io/contact-us.
   **
   ** GNU Lesser General Public License Usage
   ** Alternatively, this file may be used under the terms of the GNU Lesser
   ** General Public License version 3 as published by the Free Software
   ** Foundation and appearing in the file LICENSE.LGPL3 included in the
   ** packaging of this file. Please review the following information to
   ** ensure the GNU Lesser General Public License version 3 requirements
   ** will be met: https://www.gnu.org/licenses/lgpl-3.0.html.
   **
   ** GNU General Public License Usage
   ** Alternatively, this file may be used under the terms of the GNU
   ** General Public License version 2.0 or (at your option) the GNU General
   ** Public license version 3 or any later version approved by the KDE Free
   ** Qt Foundation. The licenses are as published by the Free Software
   ** Foundation and appearing in the file LICENSE.GPL2 and LICENSE.GPL3
   ** included in the packaging of this file. Please review the following
   ** information to ensure the GNU General Public License requirements will
   ** be met: https://www.gnu.org/licenses/gpl-2.0.html and
   ** https://www.gnu.org/licenses/gpl-3.0.html.
   **
   ** $QT_END_LICENSE$
   **
   ****************************************************************************/

  var QWebChannelMessageTypes = {
    signal: 1,
    propertyUpdate: 2,
    init: 3,
    idle: 4,
    debug: 5,
    invokeMethod: 6,
    connectToSignal: 7,
    disconnectFromSignal: 8,
    setProperty: 9,
    response: 10,
  }

  var QWebChannel = function(transport, initCallback, logger) {
    if (typeof transport !== 'object' || typeof transport.send !== 'function') {
      return
    }

    var channel = this
    this.transport = transport
    this.logger = logger

    this.send = function(data) {
      if (typeof data !== 'string') {
        data = JSON.stringify(data)
      }
      channel.transport.send(data)
    }

    this.transport.onmessage = function(message) {
      var data = message.data
      if (typeof data === 'string') {
        data = JSON.parse(data)
      }
      switch (data.type) {
        case QWebChannelMessageTypes.signal:
          channel.handleSignal(data)
          break
        case QWebChannelMessageTypes.response:
          channel.handleResponse(data)
          break
        case QWebChannelMessageTypes.propertyUpdate:
          channel.handlePropertyUpdate(data)
          break
        default:
          break
      }
    }

    this.execCallbacks = {}
    this.execId = 0
    this.exec = function(data, callback) {
      if (!callback) {
        // if no callback is given, send directly
        channel.send(data)
        return
      }
      if (channel.execId === Number.MAX_VALUE) {
        // wrap
        channel.execId = Number.MIN_VALUE
      }
      if (data.hasOwnProperty('id')) {
        return
      }
      data.id = channel.execId++
      channel.execCallbacks[data.id] = callback

      if (this.logger && this.inited) {
        if (data.type == QWebChannelMessageTypes.invokeMethod) {
          var uri = this.objects[data.object].objectName + '.' + data.method
          this.logger.onRequest(data.id, uri, data.args)
        }
        //TODO: else ?
      }

      channel.send(data)
    }

    this.objects = {}

    this.handleSignal = function(message) {
      var object = channel.objects[message.object]
      if (object) {
        object.signalEmitted(message.signal, message.args)
      } else {
      }
    }

    this.handleResponse = function(message) {
      if (!message.hasOwnProperty('id')) {
        return
      }
      if (this.logger && this.inited) {
        this.logger.onResponse(message.id, message.data)
      }
      channel.execCallbacks[message.id](message.data)
      delete channel.execCallbacks[message.id]
    }

    this.handlePropertyUpdate = function(message) {
      message.data.forEach((data) => {
        var object = channel.objects[data.object]
        if (object) {
          object.propertyUpdate(data.signals, data.properties)
        } else {
        }
      })
      channel.exec({ type: QWebChannelMessageTypes.idle })
    }

    this.debug = function(message) {
      channel.send({ type: QWebChannelMessageTypes.debug, data: message })
    }

    channel.exec({ type: QWebChannelMessageTypes.init }, function(data) {
      for (const objectName of Object.keys(data)) {
        new QObject(objectName, data[objectName], channel)
      }

      // now unwrap properties, which might reference other registered objects
      for (const objectName of Object.keys(channel.objects)) {
        channel.objects[objectName].unwrapProperties()
      }

      if (initCallback) {
        channel.inited = true
        initCallback(channel)
      }
      channel.exec({ type: QWebChannelMessageTypes.idle })
    })
  }

  function QObject(name, data, webChannel) {
    this.__id__ = name
    webChannel.objects[name] = this

    // List of callbacks that get invoked upon signal emission
    this.__objectSignals__ = {}

    // Cache of all properties, updated when a notify signal is emitted
    this.__propertyCache__ = {}

    var object = this

    // ----------------------------------------------------------------------

    this.unwrapQObject = function(response) {
      if (response instanceof Array) {
        // support list of objects
        return response.map((qobj) => object.unwrapQObject(qobj))
      }
      if (!(response instanceof Object)) return response

      if (!response['__QObject*__'] || response.id === undefined) {
        var jObj = {}
        for (const propName of Object.keys(response)) {
          jObj[propName] = object.unwrapQObject(response[propName])
        }
        return jObj
      }

      var objectId = response.id
      if (webChannel.objects[objectId]) return webChannel.objects[objectId]

      if (!response.data) {
        return
      }

      var qObject = new QObject(objectId, response.data, webChannel)
      qObject.destroyed.connect(function() {
        if (webChannel.objects[objectId] === qObject) {
          delete webChannel.objects[objectId]
          // reset the now deleted QObject to an empty {} object
          // just assigning {} though would not have the desired effect, but the
          // below also ensures all external references will see the empty map
          // NOTE: this detour is necessary to workaround QTBUG-40021
          Object.keys(qObject).forEach((name) => delete qObject[name])
        }
      })
      // here we are already initialized, and thus must directly unwrap the properties
      qObject.unwrapProperties()
      return qObject
    }

    this.unwrapProperties = function() {
      for (const propertyIdx of Object.keys(object.__propertyCache__)) {
        object.__propertyCache__[propertyIdx] = object.unwrapQObject(
          object.__propertyCache__[propertyIdx]
        )
      }
    }

    function addSignal(signalData, isPropertyNotifySignal) {
      var signalName = signalData[0]
      var signalIndex = signalData[1]
      object[signalName] = {
        connect: function(callback) {
          if (typeof callback !== 'function') {
            return
          }

          object.__signaleNames__ = object.__signaleNames__ || {}
          object.__signaleNames__[signalIndex] = signalName
          object.__objectSignals__[signalIndex] = object.__objectSignals__[signalIndex] || []
          object.__objectSignals__[signalIndex].push(callback)

          if (webChannel.logger && webChannel.inited) {
            var fullName = webChannel.objects[object.__id__].objectName + '.' + signalName
            webChannel.logger.onConnectSignal(
              object.__objectSignals__[signalIndex].length - 1,
              fullName,
              callback
            )
          }

          // only required for "pure" signals, handled separately for properties in propertyUpdate
          if (isPropertyNotifySignal) return

          // also note that we always get notified about the destroyed signal
          if (
            signalName === 'destroyed' ||
            signalName === 'destroyed()' ||
            signalName === 'destroyed(QObject*)'
          )
            return

          // and otherwise we only need to be connected only once
          if (object.__objectSignals__[signalIndex].length == 1) {
            webChannel.exec({
              type: QWebChannelMessageTypes.connectToSignal,
              object: object.__id__,
              signal: signalIndex,
            })
          }
        },
        disconnect: function(callback) {
          if (typeof callback !== 'function') {
            return
          }
          object.__objectSignals__[signalIndex] = object.__objectSignals__[signalIndex] || []
          var idx = object.__objectSignals__[signalIndex].indexOf(callback)
          if (idx === -1) {
            return
          }

          if (webChannel.logger && webChannel.inited) {
            var fullName = webChannel.objects[object.__id__].objectName + '.' + signalName
            webChannel.logger.onDisconnectSignal(idx, fullName, callback)
          }

          object.__objectSignals__[signalIndex].splice(idx, 1)
          if (!isPropertyNotifySignal && object.__objectSignals__[signalIndex].length === 0) {
            // only required for "pure" signals, handled separately for properties in propertyUpdate
            webChannel.exec({
              type: QWebChannelMessageTypes.disconnectFromSignal,
              object: object.__id__,
              signal: signalIndex,
            })
          }
        },
      }
    }

    /**
     * Invokes all callbacks for the given signalname. Also works for property notify callbacks.
     */
    function invokeSignalCallbacks(signalName, signalArgs) {
      var connections = object.__objectSignals__[signalName]
      if (connections) {
        connections.forEach(function(callback) {
          callback.apply(callback, signalArgs)
        })
      }
    }

    this.propertyUpdate = function(signals, propertyMap) {
      // update property cache
      for (const propertyIndex of Object.keys(propertyMap)) {
        var propertyValue = propertyMap[propertyIndex]
        object.__propertyCache__[propertyIndex] = this.unwrapQObject(propertyValue)
      }

      for (const signalName of Object.keys(signals)) {
        // Invoke all callbacks, as signalEmitted() does not. This ensures the
        // property cache is updated before the callbacks are invoked.
        invokeSignalCallbacks(signalName, signals[signalName])
      }
    }

    this.signalEmitted = function(signalName, signalArgs) {
      if (webChannel.logger && webChannel.inited) {
        var fullName =
          webChannel.objects[object.__id__].objectName + '.' + object.__signaleNames__[signalName]
        webChannel.logger.onSignal(fullName, signalArgs)
      }
      invokeSignalCallbacks(signalName, this.unwrapQObject(signalArgs))
    }

    function addMethod(methodData) {
      var methodName = methodData[0]
      var methodIdx = methodData[1]

      // Fully specified methods are invoked by id, others by name for host-side overload resolution
      var invokedMethod = methodName[methodName.length - 1] === ')' ? methodIdx : methodName

      object[methodName] = function() {
        var args = []
        var callback
        var errCallback
        for (var i = 0; i < arguments.length; ++i) {
          var argument = arguments[i]
          if (typeof argument === 'function') callback = argument
          else if (argument instanceof QObject && webChannel.objects[argument.__id__] !== undefined)
            args.push({
              id: argument.__id__,
            })
          else args.push(argument)
        }

        var result
        // during test, webChannel.exec synchronously calls the callback
        // therefore, the promise must be constucted before calling
        // webChannel.exec to ensure the callback is set up
        if (!callback && typeof Promise === 'function') {
          result = new Promise(function(resolve, reject) {
            callback = resolve
            errCallback = reject
          })
        }

        webChannel.exec(
          {
            type: QWebChannelMessageTypes.invokeMethod,
            object: object.__id__,
            method: invokedMethod,
            args: args,
          },
          function(response) {
            if (response !== undefined) {
              var result = object.unwrapQObject(response)
              if (callback) {
                callback(result)
              }
            } else if (errCallback) {
              errCallback()
            }
          }
        )

        return result
      }
    }

    function bindGetterSetter(propertyInfo) {
      var propertyIndex = propertyInfo[0]
      var propertyName = propertyInfo[1]
      var notifySignalData = propertyInfo[2]
      // initialize property cache with current value
      // NOTE: if this is an object, it is not directly unwrapped as it might
      // reference other QObject that we do not know yet
      object.__propertyCache__[propertyIndex] = propertyInfo[3]

      if (notifySignalData) {
        if (notifySignalData[0] === 1) {
          // signal name is optimized away, reconstruct the actual name
          notifySignalData[0] = propertyName + 'Changed'
        }
        addSignal(notifySignalData, true)
      }

      Object.defineProperty(object, propertyName, {
        configurable: true,
        get: function() {
          var propertyValue = object.__propertyCache__[propertyIndex]
          if (propertyValue === undefined) {
            // This shouldn't happen
          }

          return propertyValue
        },
        set: function(value) {
          if (value === undefined) {
            return
          }
          object.__propertyCache__[propertyIndex] = value
          var valueToSend = value
          if (
            valueToSend instanceof QObject &&
            webChannel.objects[valueToSend.__id__] !== undefined
          )
            valueToSend = { id: valueToSend.__id__ }
          webChannel.exec({
            type: QWebChannelMessageTypes.setProperty,
            object: object.__id__,
            property: propertyIndex,
            value: valueToSend,
          })
        },
      })
    }

    // ----------------------------------------------------------------------

    data.methods.forEach(addMethod)

    data.properties.forEach(bindGetterSetter)

    data.signals.forEach(function(signal) {
      addSignal(signal, false)
    })

    Object.assign(object, data.enums)
  }

  window.qWebChannel = QWebChannel
  const RemotePlayerMsgType = {
    MIN_USER_INPUT_MSG_ID: 0,
    MouseMove: 0,
    MouseDown: 1,
    MouseUp: 2,
    MouseWheel: 3,
    MouseDBClick: 4,
    WindowSize: 5,
    TouchDown: 6,
    TouchUp: 7,
    TouchMove: 8,
    Exit: 9,
    KeyDown: 10,
    KeyUp: 11,
    MAX_USER_INPUT_MSG_ID: 11,

    RELAY_JPG_REQ: 12,
  }

  // Check if Native app
  window.isNativeApp = typeof qt == 'object' && qt.webChannelTransport
  if (window.isNativeApp) {
    if ('undefined' != typeof QWebChannel) {
      window.NativeAppLoad = new Promise((resolve) => {
        window.gWebChannel = new QWebChannel(qt.webChannelTransport, function(channel) {
          window.NativeApp = {}
          Object.assign(window.NativeApp, channel.objects)
          resolve()
        })
      })
    } else {
      window.isNativeApp = false
    }
  }

  function RemotePlayer(config) {
    this.fileVersion = 'For WIZPlayer 4.0.42+'

    let $self = this

    // 配置检查
    config = config || {}

    if (!config.logger && config.debug) {
      const TimeToString = (t) => {
        return '[' + t.toLocaleTimeString() + ':' + t.getMilliseconds() + ']'
      }
      config.logger = {
        onRequest: function(cmdId, request, args) {
          let t = new Date()
        },
        onResponse: function(cmdId, ret) {
          let t = new Date()
        },
        onConnectSignal: function(idx, signalName, callback) {},
        onDisconnectSignal: function(idx, signalName, callback) {},
        onSignal: function(signalName, args) {},
      }
    }

    // 服务器地址
    config.signalServer = config.signalServer || 'ws://localhost:8080'
    // 引擎ID
    config.engineId = config.engineId
    // player要绑定的视频标签
    config.video = config.video || document.getElementsByTagName('video')[0]
    config.isImage = config.video.tagName == 'IMG'
    config.video.style.transform = 'rotateX(180deg)'
    // 是否启用自定义用户输入事件，启用则不监听视频标签上的鼠标、触屏事件，需要用户自行调用输入函数
    config.customInputEvent = config.customInputEvent ? true : false
    // 自动调整引擎画面大小与绑定视频标签同步
    config.autoResize = config.autoResize ? true : false
    // 限制用户每秒鼠标移动和触屏的事件个数，事件过多时操作不流畅，限制事件个数来提高操作流畅性
    config.limtMoveCPS = config.limtMoveCPS == undefined ? 10 : config.limtMoveCPS
    // 用户操作超时时间，当用户鼠标或触屏在该时间内没有产生操作，将首次提示用户，在exitTimeout后将断开连接来节约云渲染资源
    config.userTimeout = isNaN(config.userTimeout) ? 1000 * 60 * 5 : config.userTimeout
    // 用户操作超时后的延迟断开时间，首次提示后的将过该时间后断开连接，在真正断开前可取消resetTimer();
    config.exitTimeout = isNaN(config.exitTimeout) ? 1000 * 10 : config.exitTimeout
    // 当前断开后引擎需要保持的时间
    config.maxTimeout = isNaN(config.maxTimeout) ? 0 : config.maxTimeout

    $self.config = config
    config.video.oncontextmenu = (e) => {
      e.preventDefault()
    }

    $self.finishEventObjMap = {}
    $self.eventMap = {}
    $self.event = new Proxy(
      {},
      {
        set: (target, property, fn) => {
          this.eventMap[property] || (this.eventMap[property] = [])
          this.eventMap[property].push(fn)
          return true
        },
      }
    )

    $self.isNativeApp = false
    if (window.NativeAppLoad) {
      $self.isNativeApp = true
      $self.reconnect = () => {}
      window.NativeAppLoad.then(() => {
        window.NativeApp.EngineMgr.create($self.config.engineId, { visible: false }, (objId) => {
          $self.checkVideoPos = function() {
            var p = $self.config.video.getBoundingClientRect()
            var pos = [p.left, p.top]
            window.NativeApp.EngineMgr.update($self.config.engineId, { pos: pos })
          }
          var p = $self.config.video.getBoundingClientRect()
          window.NativeApp.EngineMgr.update($self.config.engineId, {
            pos: [p.left, p.top],
            visible: true,
          })
          var qtTransportWrap = {
            send: (msg) => {
              qt.webChannelTransport.send(msg)
            },
          }
          new QWebChannel(
            qtTransportWrap,
            function(channel) {
              $self.Native = channel.objects[objId]
              $self.objects = channel.objects
              window.NativeApp = {}
              window.webchannelDebug = $self.config.debug
              Object.assign(window.NativeApp, channel.objects)
              if ($self.Native.ControlChannel) {
                $self._controlChannel = {
                  send: (buffer) => {
                    var str = window.btoa(String.fromCharCode(...new Uint8Array(buffer)))
                    $self.Native.ControlChannel.send(str)
                  },
                }
              } else {
              }
              $self.finishEventObjMap['NativeLoad'] = $self.Native
              $self.emit('NativeLoad', $self.Native)
            },
            $self.config.logger
          )
        })
      })
    } else {
      $self._ws = null
      $self._pc = null

      $self.resetTimer = function() {
        if ($self._pc && !$self.exited) {
          clearTimeout($self._userTimer)
          $self._userTimer = setTimeout(() => {
            $self._userTimer = setTimeout(() => {
              if (!$self.exited) {
                $self.exit()
                if (!$self.emit('TimeOutExit', $self)) {
                  alert(`长时间没有操作，已断开连接`)
                }
              }
            }, $self.config.exitTimeout)
            $self.emit('UserTimeOut', $self)
          }, $self.config.userTimeout)
        }
      }

      function configPeerConnection() {
        $self._controlChannel = null

        var connectionCreator = RTCPeerConnection ? RTCPeerConnection : webkitRTCPeerConnection
        $self._pc = new connectionCreator({ iceServers: $self.iceServers })

        $self._pc.onicecandidate = function(evt) {
          if (evt.candidate !== null) {
            $self._ws.send(
              JSON.stringify({
                type: 'IceCandidate',
                data: evt.candidate,
              })
            )
          }
        }

        $self._pc.ondatachannel = (evt) => {
          if (evt.channel && evt.channel.label == 'Control') {
            let checksend = () => {
              while (
                $self._controlChannel.sendQueue.length > 0 &&
                evt.channel.bufferedAmount <= evt.channel.bufferedAmountLowThreshold
              ) {
                evt.channel.send($self._controlChannel.sendQueue.shift())
              }
            }
            $self._controlChannel = {
              sendQueue: [],
              send: (msg) => {
                if (msg.length > evt.channel.bufferedAmountLowThreshold) {
                  let pktCount = Math.ceil(msg.length / evt.channel.bufferedAmountLowThreshold)
                  $self._controlChannel.sendQueue.push(`NEXT_COUNT:${pktCount}`)
                  let s = 0
                  while (s < msg.length) {
                    let e =
                      s +
                      Math.min(
                        evt.channel.bufferedAmountLowThreshold,
                        msg.length - evt.channel.bufferedAmountLowThreshold
                      )
                    $self._controlChannel.sendQueue.push(msg.slice(s, e))
                    s = e
                  }
                } else {
                  $self._controlChannel.sendQueue.push(msg)
                }
                checksend()
              },
            }
            evt.channel.bufferedAmountLowThreshold = 65536
            evt.channel.onbufferedamountlow = checksend
            evt.channel.onopen = () => {
              new QWebChannel(
                $self._controlChannel,
                function(channel) {
                  $self.Native = channel.objects.Native
                  $self.objects = channel.objects
                  window.webchannelDebug = $self.config.debug
                  $self.finishEventObjMap['NativeLoad'] = $self.Native
                  $self.emit('NativeLoad', $self.Native)
                },
                $self.config.logger
              )
            }

            evt.channel.onclose = () => {
              $self._controlChannel = null
              $self.Native = null
              $self.nativeObjects = []
              $self.finishEventObjMap['NativeLoad'] = null
              $self.emit('Disconnected', 'webrtc channel closed')
            }

            $self.config.video.buffers = []
            $self.config.video.strBuffer = ''
            $self.config.video.strCount = 0
            let relay_jpg_req = new ArrayBuffer(4) // for request next frame;
            let dataView = new DataView(relay_jpg_req)
            dataView.setInt32(0, RemotePlayerMsgType.RELAY_JPG_REQ, true)
            let lastImage = new Image()
            evt.channel.onmessage = (event) => {
              const max_data_channel_buffersize = 256 * 1024
              if (typeof event.data == 'string') {
                if ('function' == typeof $self._controlChannel.onmessage) {
                  // setup by QWebChannel
                  $self.config.video.strCount--
                  if ($self.config.video.strCount == -1) {
                    if (event.data.startsWith('NEXT_COUNT:')) {
                      $self.config.video.strCount = parseInt(event.data.substr(11))
                    } else {
                      $self.config.video.strCount = 0
                      $self._controlChannel.onmessage({ data: JSON.parse(event.data) })
                    }
                  } else {
                    $self.config.video.strBuffer += event.data
                    if ($self.config.video.strCount == 0) {
                      var allStr = $self.config.video.strBuffer
                      $self.config.video.strBuffer = ''
                      $self._controlChannel.onmessage({ data: JSON.parse(allStr) })
                    }
                  }
                }
              } else {
                if (event.data.byteLength > 4) {
                  $self.config.video.buffers.push(event.data)
                }
                if (event.data.byteLength < max_data_channel_buffersize) {
                  if ($self.config.video.buffers.length > 0) {
                    var src = URL.createObjectURL(new Blob($self.config.video.buffers))
                    $self.config.video.buffers = []
                    lastImage.src = src
                    lastImage
                      .decode()
                      .then(() => {
                        var oldSrc
                        if ($self.config.video.tagName == 'VIDEO') {
                          let stream = $self.config.video.srcObject
                          oldSrc = $self.config.video.poster
                          $self.config.video.poster = src
                          $self.config.video.src = ''
                          $self.config.video.srcObject = stream
                        } // img
                        else {
                          if ($self._controlChannel) $self._controlChannel.send(relay_jpg_req)
                          oldSrc = $self.config.video.src
                          $self.config.video.src = src
                        }
                        if (oldSrc) URL.revokeObjectURL(oldSrc)
                      })
                      .catch((err) => {
                        if ($self._controlChannel && $self.config.video.tagName != 'VIDEO')
                          $self._controlChannel.send(relay_jpg_req)
                        URL.revokeObjectURL(src)
                      })
                  } else {
                    if ($self._controlChannel && $self.config.video.tagName != 'VIDEO')
                      $self._controlChannel.send(relay_jpg_req)
                  }
                }
              }
            }
          }
        }

        $self._pc.ontrack = (evt) => {
          $self._pc._track = evt.track
          config.video.srcObject = evt.streams[0]
          config.video.play()
          $self.finishEventObjMap['VideoReady'] = $self.config.video
          $self.emit('VideoReady', $self.config.video)
          $self.resetTimer()
        }

        $self._pc.onconnectionstatechange = (evt) => {
          switch ($self._pc.connectionState) {
            case 'connecting':
              break
            case 'connected':
              {
                $self.emit('Connected')
              }
              break
            case 'disconnected':
              {
                $self._pc.close()
                $self.finishEventObjMap['NativeLoad'] = null
                $self.emit('Disconnected')
              }
              break
            case 'failed':
              {
                $self._pc.close()
                $self.emit('ConnectedFailed', evt)
              }
              break
          }
        }
      }

      $self.reconnect = function() {
        if ($self.exited) return
        try {
          $self._ws = new WebSocket(
            `${config.signalServer}?engineId=${config.engineId}&maxTimeout=${
              config.maxTimeout
            }&type=${config.isImage ? 'img' : 'video'}&rtcIni=${config.rtcIni}&jpgQuality=${
              config.jpgQuality
            }`
          )
          $self._ws.onopen = function() {}
          $self._ws.onerror = function(e) {
            $self.emit('Disconnected', 'signal websocket error')
          }
          $self._ws.onmessage = function(msgData) {
            msgData = msgData.data
            var msg = JSON.parse(msgData)

            // 提示信息
            if (msg.type == 'Message') {
              if (!$self.emit('Message', msg.data)) {
                alert(msg.data)
              }
            }
            // 收到引擎会话的地址
            else if (msg.type == 'EngineWs') {
              $self.sessionWs = msg.data
              $self._engineWs = new WebSocket($self.sessionWs)
              let transport = {
                send: (msg) => {
                  $self._engineWs.send(msg)
                },
              }
              $self._engineWs.onopen = () => {
                $self.emit('Connected')
                new QWebChannel(
                  transport,
                  function(channel) {
                    $self.Native = channel.objects.Native
                    $self.objects = channel.objects
                    window.webchannelDebug = $self.config.debug
                    $self.finishEventObjMap['NativeLoad'] = $self.Native
                    $self._controlChannel = {
                      send: (buffer) => {
                        var str = window.btoa(String.fromCharCode(...new Uint8Array(buffer)))
                        $self.Native.ControlChannel.send(str)
                      },
                    }
                    $self.emit('NativeLoad', $self.Native)
                  },
                  $self.config.logger
                )
              }

              $self._engineWs.onclose = () => {
                $self._controlChannel = null
                $self.Native = null
                $self.nativeObjects = []
                $self.finishEventObjMap['NativeLoad'] = null
                $self.emit('Disconnected', 'Engine session closed')
              }

              $self._engineWs.onmessage = (event) => {
                if (typeof event.data == 'string') {
                  if ('function' == typeof transport.onmessage) {
                    // setup by QWebChannel
                    transport.onmessage({ data: JSON.parse(event.data) })
                  }
                } else {
                  var oldSrc = $self.config.video.src
                  $self.config.video.src = URL.createObjectURL(event.data)
                  if (oldSrc) URL.revokeObjectURL(oldSrc)
                }
              }
            }
            // 收到连接引擎上线消息
            else if (msg.type == 'OpenSession') {
              $self.iceServers = msg.data
              const connectMsg = JSON.stringify({
                type: 'ConnectRequest',
                data: {},
              })
              $self._ws.send(connectMsg)
            }
            // 收到连接引擎回复
            else if (msg.type == 'OfferToClient') {
              configPeerConnection()
              var romoteSdp = new RTCSessionDescription(msg.data)
              $self._pc.setRemoteDescription(romoteSdp).then(
                () => {
                  $self._pc.createAnswer().then(
                    (myDesc) => {
                      var localSdp = new RTCSessionDescription(myDesc)
                      $self._pc.setLocalDescription(localSdp).then(
                        () => {
                          $self._ws.send(
                            JSON.stringify({
                              type: 'AnswerToEngine',
                              data: localSdp,
                            })
                          )
                        },
                        (err) => {}
                      )
                    },
                    (err) => {}
                  )
                },
                (err) => {}
              )
            }
            // 收到IceCandidate消息
            else if (msg.type === 'IceCandidate') {
              $self._pc.addIceCandidate(new RTCIceCandidate(msg.data))
            }
            // 收到关闭消息
            else if (msg.type === 'CloseSession') {
              $self.exit()
            } else {
              alert(`${msg.type}: ${msg.data}`)
            }
          }
        } catch (e) {
          $self.emit('Disconnected', e)
        }
      }

      $self.startCheckSignal = function(tripTimeCb, packetsLostCb) {
        let maxPacketsLost = 0,
          lastPacketsLost = 0
        let get = (sipCb, sfuCb) => {
          if ($self._pc) {
            $self._pc.getStats().then(function(report) {
              report.forEach((value, key) => {
                if (value.type === 'candidate-pair') {
                  sipCb(value.currentRoundTripTime)
                }
                if (value.type == 'inbound-rtp' || value.googContentType === 'realtime') {
                  sfuCb(value.packetsLost)
                }
              })
            })
          } else {
            sipCb(99.999)
            sfuCb(999999)
          }
        }
        let lastTripTime,
          lastLost = -1
        $self.watchSignalTimer = setInterval(() => {
          get(
            (tripTime) => {
              if (lastTripTime != tripTime) {
                lastTripTime = tripTime
                tripTimeCb(tripTime)
              }
            },
            (packetsLost) => {
              let lost = packetsLost - lastPacketsLost
              if (lost <= 0) maxPacketsLost = 0
              else if (lost > maxPacketsLost) maxPacketsLost = lost
              else lost = maxPacketsLost
              lastPacketsLost = packetsLost

              if (lost > 0) {
              }
              if (lost != lastLost) {
                lastLost = lost
                packetsLostCb(lost)
              }
            }
          )
        }, 1000)
      }

      $self.stopCheckSignalstartCheckSignal = function() {
        if ($self.watchSignalTimer) {
          clearInterval($self.watchSignalTimer)
          $self.watchSignalTimer = null
        }
      }
    }

    // 初始化输入事件
    let style = getComputedStyle(config.video)
    let isMouseDown = false // 用于全局监听判断鼠标是否按下
    let mouseDownInfo = {} // 鼠标按下信息
    let keyList = [] // 键盘按键
    // 注册输入事件
    if (!config.customInputEvent) {
      var events = {
        MouseMove: (e) => {
          let x = (e.offsetX / parseFloat(style.width)) * 2 - 1
          let y = (e.offsetY / parseFloat(style.height)) * 2 - 1
          $self.mousemove(x, y)
          e.preventDefault()
        },
        MouseDown: (e) => {
          mouseDownInfo = e
          let x = (e.offsetX / parseFloat(style.width)) * 2 - 1
          let y = (e.offsetY / parseFloat(style.height)) * 2 - 1
          $self.mousedown(x, y, e.button)
          isMouseDown = true
          e.preventDefault()
        },
        MouseUp: (e) => {
          if (isMouseDown) {
            mouseDownInfo = {}
            let x = (e.offsetX / parseFloat(style.width)) * 2 - 1
            let y = (e.offsetY / parseFloat(style.height)) * 2 - 1
            $self.mouseup(x, y, e.button)
            isMouseDown = false
            e.preventDefault()
          }
        },
        MouseWheel: (e) => {
          let x = (e.offsetX / parseFloat(style.width)) * 2 - 1
          let y = (e.offsetY / parseFloat(style.height)) * 2 - 1
          $self.mosuewheel(x, y, e.wheelDeltaY)
          e.preventDefault()
        },
        MouseDBClick: (e) => {
          let x = (e.offsetX / parseFloat(style.width)) * 2 - 1
          let y = (e.offsetY / parseFloat(style.height)) * 2 - 1
          $self.mousedbclick(x, y, e.button)
          e.preventDefault()
        },
        TouchDown: (e) => {
          let w = parseFloat(style.width)
          let h = parseFloat(style.height)
          let box = $self.config.video.getBoundingClientRect()
          for (let i = 0; i < e.changedTouches.length; ++i) {
            const t = e.changedTouches[i]
            let x = ((t.clientX - box.left) / w) * 2 - 1
            let y = ((t.clientY - box.top) / h) * 2 - 1
            y = -y
            $self.touchdown(x, y, t.identifier)
          }
          e.preventDefault()
        },
        TouchUp: (e) => {
          let w = parseFloat(style.width)
          let h = parseFloat(style.height)
          let box = $self.config.video.getBoundingClientRect()
          for (let i = 0; i < e.changedTouches.length; ++i) {
            const t = e.changedTouches[i]
            let x = ((t.clientX - box.left) / w) * 2 - 1
            let y = ((t.clientY - box.top) / h) * 2 - 1
            y = -y
            $self.touchup(x, y, t.identifier)
          }
          e.preventDefault()
        },
        TouchMove: (e) => {
          let w = parseFloat(style.width)
          let h = parseFloat(style.height)
          let box = $self.config.video.getBoundingClientRect()
          for (let i = 0; i < e.changedTouches.length; ++i) {
            const t = e.changedTouches[i]
            let x = ((t.clientX - box.left) / w) * 2 - 1
            let y = ((t.clientY - box.top) / h) * 2 - 1
            y = -y
            $self.touchmove(x, y, t.identifier)
          }
          e.preventDefault()
        },
        KeyDown: (e) => {
          const keyIndex = keyList.findIndex((item) => {
            return item.keyCode === e.keyCode
          })
          if (keyIndex === -1) {
            keyList.push(e)
          }
          $self.keydown(e.keyCode)
        },
        KeyUp: (e) => {
          const keyIndex = keyList.findIndex((item) => {
            return item.keyCode === e.keyCode
          })
          keyList.splice(keyIndex, 1)
          $self.keyup(e.keyCode)
        },
        Blur: (e) => {
          if (isMouseDown) {
            let x = (mouseDownInfo.offsetX / parseFloat(style.width)) * 2 - 1
            let y = (mouseDownInfo.offsetY / parseFloat(style.height)) * 2 - 1
            $self.mouseup(x, y, mouseDownInfo.button)
            isMouseDown = false
            mouseDownInfo = {}
          }
          for (let i = 0; i < keyList.length; i += 1) {
            $self.keyup(keyList[i].keyCode)
          }
          keyList = []
        },
      }
      if (config.limtMoveCPS > 0) {
        var limtFuns = (function() {
          let mouse_x, mouse_y, mouse_hasChanged
          let touch_hasChanged, touch_moveList
          touch_moveList = new Map()
          return {
            mouse_intervalFun: () => {
              if (mouse_hasChanged) {
                mouse_hasChanged = false
                $self.mousemove(mouse_x, mouse_y)
              }
            },
            mouse_moveFun: (evt) => {
              mouse_x = (evt.offsetX / parseFloat(style.width)) * 2 - 1
              mouse_y = (evt.offsetY / parseFloat(style.height)) * 2 - 1
              mouse_hasChanged = true
            },
            touch_intervalFun: () => {
              if (touch_hasChanged) {
                touch_hasChanged = false
                touch_moveList.forEach((v, k) => {
                  $self.touchmove(v.x, v.y, k)
                })
                touch_moveList.clear()
              }
            },
            touch_moveFun: (evt) => {
              let w = parseFloat(style.width)
              let h = parseFloat(style.height)
              let box = $self.config.video.getBoundingClientRect()
              for (let i = 0; i < evt.changedTouches.length; ++i) {
                const t = evt.changedTouches[i]
                let x = ((t.clientX - box.left) / w) * 2 - 1
                let y = ((t.clientY - box.top) / h) * 2 - 1
                y = -y
                var o = touch_moveList.get(t.identifier)
                if (!o || o.x != x || o.y != y) {
                  touch_moveList.set(t.identifier, { x: x, y: y })
                  touch_hasChanged = true
                }
              }
            },
          }
        })()

        var limtFunsMouseMoveInterval = setInterval(
          limtFuns.mouse_intervalFun,
          1000 / config.limtMoveCPS
        )
        config.video.addEventListener('mousedown', (e) => {
          clearInterval(limtFunsMouseMoveInterval)
          limtFunsMouseMoveInterval = setInterval(
            limtFuns.mouse_intervalFun,
            1000 / (config.limtMoveCPS * 2)
          )
        })
        config.video.addEventListener('mouseup', (e) => {
          if (e.buttons == 0) {
            clearInterval(limtFunsMouseMoveInterval)
            limtFunsMouseMoveInterval = setInterval(
              limtFuns.mouse_intervalFun,
              1000 / config.limtMoveCPS
            )
          }
        })
        config.video.addEventListener('mousemove', limtFuns.mouse_moveFun)

        var limtTouchMoveInterval
        config.video.addEventListener('touchstart', (e) => {
          limtFuns.touch_intervalFun() // flush all mouse move event
          if (!limtTouchMoveInterval)
            limtTouchMoveInterval = setInterval(
              limtFuns.touch_intervalFun,
              1000 / (config.limtMoveCPS * 3)
            )
        })
        config.video.addEventListener('touchend', (e) => {
          limtFuns.touch_intervalFun() // flush all mouse move event
          if (e.buttons == 0) clearInterval(limtTouchMoveInterval)
        })
        config.video.addEventListener('touchmove', limtFuns.touch_moveFun, { passive: false })
      } else {
        config.video.addEventListener('mousemove', events.MouseMove)
        config.video.addEventListener('touchmove', events.TouchMove, { passive: false })
      }
      config.video.addEventListener('mousedown', events.MouseDown)
      config.video.addEventListener('mouseup', events.MouseUp)
      var win = window
      // while (win.parent && win.parent != win) win = win.parent;
      win.addEventListener('mouseup', events.MouseUp)

      config.video.addEventListener('mousewheel', events.MouseWheel)
      config.video.addEventListener('dblclick', events.MouseDBClick)

      config.video.addEventListener('touchstart', events.TouchDown)
      config.video.addEventListener('touchend', events.TouchUp)

      win.addEventListener('keydown', events.KeyDown)
      win.addEventListener('keyup', events.KeyUp)
      win.addEventListener('blur', events.Blur)

      if (!$self.isNativeApp) {
        config.video.addEventListener('mousedown', $self.resetTimer)
        config.video.addEventListener('mousemove', $self.resetTimer)
        config.video.addEventListener('mouseup', $self.resetTimer)
        config.video.addEventListener('mousewheel', $self.resetTimer)
        config.video.addEventListener('touchstart', $self.resetTimer)
        config.video.addEventListener('touchmove', $self.resetTimer)
        config.video.addEventListener('touchend', $self.resetTimer)
      }
    }

    if (config.autoResize) {
      setInterval(
        (function() {
          let videoWidth, videoHeight
          return function(force) {
            let width = Math.round(parseFloat(style.width))
            let height = Math.round(parseFloat(style.height))
            if (force || videoWidth != width || videoHeight != height) {
              if ($self.resize(width, height)) {
                videoWidth = width
                videoHeight = height
              }
            }
          }
        })(),
        100
      )
    }

    $self.reconnect()
  }

  RemotePlayer.prototype.constructor = RemotePlayer

  // for event system
  RemotePlayer.prototype.on = function(name, fn) {
    this.event[name] = fn
    var arg = this.finishEventObjMap[name]
    if (arg) fn(arg)
  }
  RemotePlayer.prototype.off = function(name) {
    delete this.eventMap[name]
  }
  RemotePlayer.prototype.emit = function(name, ...val) {
    if (this.eventMap[name] && this.eventMap[name].length > 0)
      this.eventMap[name].forEach((fn) => {
        fn(...val)
      })
    else return false
    return true
  }

  // send mousemove event
  RemotePlayer.prototype.mousemove = (function() {
    let buffer = new ArrayBuffer(12)
    let dataView = new DataView(buffer)
    dataView.setInt32(0, RemotePlayerMsgType.MouseMove, true)
    return function(x, y) {
      if (this._controlChannel) {
        dataView.setFloat32(4, x, true)
        dataView.setFloat32(8, y, true)
        this._controlChannel.send(buffer)
        return true
      }
      return false
    }
  })()

  // send mousedown event
  RemotePlayer.prototype.mousedown = (function() {
    let buffer = new ArrayBuffer(16)
    let dataView = new DataView(buffer)
    dataView.setInt32(0, RemotePlayerMsgType.MouseDown, true)
    return function(x, y, btn) {
      if (this._controlChannel) {
        dataView.setFloat32(4, x, true)
        dataView.setFloat32(8, y, true)
        dataView.setInt32(12, btn, true)
        this._controlChannel.send(buffer)
        return true
      }
      return false
    }
  })()

  // send mouseup event
  RemotePlayer.prototype.mouseup = (function() {
    let buffer = new ArrayBuffer(16)
    let dataView = new DataView(buffer)
    dataView.setInt32(0, RemotePlayerMsgType.MouseUp, true)
    return function(x, y, btn) {
      if (this._controlChannel) {
        dataView.setFloat32(4, x, true)
        dataView.setFloat32(8, y, true)
        dataView.setInt32(12, btn, true)
        this._controlChannel.send(buffer)
        return true
      }
      return false
    }
  })()

  // send mousewheel event
  RemotePlayer.prototype.mosuewheel = (function() {
    let buffer = new ArrayBuffer(16)
    let dataView = new DataView(buffer)
    dataView.setInt32(0, RemotePlayerMsgType.MouseWheel, true)
    return function(x, y, delta) {
      if (this._controlChannel) {
        dataView.setFloat32(4, x, true)
        dataView.setFloat32(8, y, true)
        dataView.setInt32(12, delta, true)
        this._controlChannel.send(buffer)
        return true
      }
      return false
    }
  })()

  // send mousedbclick event
  RemotePlayer.prototype.mousedbclick = (function() {
    let buffer = new ArrayBuffer(16)
    let dataView = new DataView(buffer)
    dataView.setInt32(0, RemotePlayerMsgType.MouseDBClick, true)
    return function(x, y, btn) {
      if (this._controlChannel) {
        dataView.setFloat32(4, x, true)
        dataView.setFloat32(8, y, true)
        dataView.setInt32(12, btn, true)
        this._controlChannel.send(buffer)
        return true
      }
      return false
    }
  })()

  // send resize event
  RemotePlayer.prototype.resize = (function() {
    let buffer = new ArrayBuffer(16)
    let dataView = new DataView(buffer)
    dataView.setInt32(0, RemotePlayerMsgType.WindowSize, true)
    return function(w, h) {
      if (this._controlChannel && w >= 64 && h >= 64) {
        w = Math.ceil(w / 2.0) * 2.0
        h = Math.ceil(h / 2.0) * 2.0
        dataView.setFloat32(4, w, true)
        dataView.setFloat32(8, h, true)
        dataView.setInt32(12, 96 /*DPI*/, true)
        this._controlChannel.send(buffer)
        return true
      }
      return false
    }
  })()

  // send touchdown event
  RemotePlayer.prototype.touchdown = (function() {
    let buffer = new ArrayBuffer(16)
    let dataView = new DataView(buffer)
    dataView.setInt32(0, RemotePlayerMsgType.TouchDown, true)
    return function(x, y, id) {
      if (this._controlChannel) {
        dataView.setFloat32(4, x, true)
        dataView.setFloat32(8, y, true)
        dataView.setInt32(12, id, true)
        this._controlChannel.send(buffer)
        return true
      }
      return false
    }
  })()

  // send touchup event
  RemotePlayer.prototype.touchup = (function() {
    let buffer = new ArrayBuffer(16)
    let dataView = new DataView(buffer)
    dataView.setInt32(0, RemotePlayerMsgType.TouchUp, true)
    return function(x, y, id) {
      if (this._controlChannel) {
        dataView.setFloat32(4, x, true)
        dataView.setFloat32(8, y, true)
        dataView.setInt32(12, id, true)
        this._controlChannel.send(buffer)
        return true
      }
      return false
    }
  })()

  // send touchmove event
  RemotePlayer.prototype.touchmove = (function() {
    let buffer = new ArrayBuffer(16)
    let dataView = new DataView(buffer)
    dataView.setInt32(0, RemotePlayerMsgType.TouchMove, true)
    return function(x, y, id) {
      if (this._controlChannel) {
        dataView.setFloat32(4, x, true)
        dataView.setFloat32(8, y, true)
        dataView.setInt32(12, id, true)
        this._controlChannel.send(buffer)
        return true
      }
      return false
    }
  })()

  // send keydown event
  RemotePlayer.prototype.keydown = (function() {
    let buffer = new ArrayBuffer(8)
    let dataView = new DataView(buffer)
    dataView.setInt32(0, RemotePlayerMsgType.KeyDown, true)
    return function(keycode) {
      if (this._controlChannel) {
        dataView.setInt32(4, keycode, true)
        this._controlChannel.send(buffer)
        return true
      }
      return false
    }
  })()

  // send keyup event
  RemotePlayer.prototype.keyup = (function() {
    let buffer = new ArrayBuffer(8)
    let dataView = new DataView(buffer)
    dataView.setInt32(0, RemotePlayerMsgType.KeyUp, true)
    return function(keycode) {
      if (this._controlChannel) {
        dataView.setInt32(4, keycode, true)
        this._controlChannel.send(buffer)
        return true
      }
      return false
    }
  })()

  // send exit event
  RemotePlayer.prototype.exit = (function() {
    let buffer = new ArrayBuffer(4)
    let dataView = new DataView(buffer)
    dataView.setInt32(0, RemotePlayerMsgType.Exit, true)
    return function() {
      clearTimeout(this._userTimer)
      if (this._controlChannel) {
        this._controlChannel.send(buffer)
        this._controlChannel = null
      }
      if (this._ws) {
        this._ws.close()
        this._ws = null
      }
      if (this._pc) {
        this._pc.close()
        this._pc = null
      }
      if (!this.exited) {
        this.exited = true
      }
      return true
    }
  })()

  RemotePlayer.prototype.snapshot = function() {
    var canvas = document.createElement('canvas')
    canvas.width = this.config.video.width | this.config.video.videoWidth
    canvas.height = this.config.video.height | this.config.video.videoHeight
    var ctx = canvas.getContext('2d')
    ctx.translate(canvas.width / 2, canvas.height / 2)
    ctx.scale(1, -1)
    ctx.translate(-canvas.width / 2, -canvas.height / 2)
    ctx.drawImage(this.config.video, 0, 0, canvas.width, canvas.height)
    var img = document.createElement('img')
    img.src = canvas.toDataURL('image/jpeg', 1)
    img.save = function() {
      var alink = document.createElement('a')
      alink.href = img.src
      alink.download = 'snapshot.jpg'
      alink.click()
    }
    return img
  }

  /**
   * @description: 加载引擎
   * @param {ILoadEngineParameter} paramData 引擎的配置项
   * @return {Promise<IResponse<IPlayer>>} 成功返回player实例
   */
  function loadEngine(paramData) {
    return new Promise((resolve, reject) => {
      var _a, _b, _c, _d, _e
      const videoDom = document.createElement('video')
      videoDom.autoplay = true
      videoDom.muted = true
      videoDom.id = `playerEngineId_${generateUUID()}`
      let reconnect = false // 是否正在重新连接
      let reconnectTimer // 重新连接的定时器
      let reconnectTime = 0 // 重连次数
      const config = {
        video:
          ((_a = paramData === null || paramData === void 0 ? void 0 : paramData.options) ===
            null || _a === void 0
            ? void 0
            : _a.videoDom) || videoDom,
        signalServer: paramData.signalServer,
        engineId: generateUUID(),
        autoResize: true,
        userTimeout:
          ((_b = paramData === null || paramData === void 0 ? void 0 : paramData.options) ===
            null || _b === void 0
            ? void 0
            : _b.userTimeout) || 3600000,
        exitTimeout:
          ((_c = paramData === null || paramData === void 0 ? void 0 : paramData.options) ===
            null || _c === void 0
            ? void 0
            : _c.exitTimeout) || 60000,
        maxTimeout:
          ((_d = paramData === null || paramData === void 0 ? void 0 : paramData.options) ===
            null || _d === void 0
            ? void 0
            : _d.maxTimeout) || 1000,
        debug:
          ((_e = paramData === null || paramData === void 0 ? void 0 : paramData.options) ===
            null || _e === void 0
            ? void 0
            : _e.openDebug) || false,
      }
      const player = new RemotePlayer(config)
      // 监听连接成功消息
      player.on('Connected', () => {})
      // 监听连接失败消息
      player.on('Disconnected', (e) => {
        // 连接断开尝试重连
        if (e === 'webrtc channel closed') {
          reconnect = true
          player.reconnect()
          if (reconnectTimer) {
            clearInterval(reconnectTimer)
          }
          reconnectTimer = setInterval(() => {
            if (reconnectTime < config.maxTimeout / 1000 && reconnect) {
              reconnectTime += 1
            } else {
              player.exit()
              clearInterval(reconnectTimer)
              resolve({
                status: false,
                message: '多次重连失败',
              })
            }
          }, 1000)
        } else if (e === 'signal websocket error') {
          // websorket reconnect 连接失败
          if (!reconnect || reconnectTime >= 60) {
            clearInterval(reconnectTimer)
          } else {
            player.reconnect()
          }
        }
      })
      // usertimeout,引擎接收鼠标事件超时发出的通知
      player.on('UserTimeOut', () => {
        resolve({
          status: false,
          message: '用户操作超时',
        })
      })
      // 远程调用加载完成通知，可以调用Native中的方法了
      player.on('NativeLoad', (Native) => {
        // 重连不需要再次执行native加载成功的方法
        if (reconnect) {
          reconnect = false
          reconnectTime = 0
          clearInterval(reconnectTimer)
          return
        }
        resolve({
          status: true,
          message: '',
          data: player,
        })
      })
    })
  }
  /**
   * @description: 卸载引擎
   * @param {IPlayer} player
   * @return {IResponse<void>} 是否成功
   */
  function destoryEngine(player) {
    if (checkPlayerLoad(player)) {
      player.exit()
    }
    return {
      status: true,
      message: '',
    }
  }
  const Engine = {
    loadEngine,
    destoryEngine,
  }

  /**
   * 加载地球场景
   * -  注意：加载地球场景，需要根据业务判断是否需要移动模型到地球的某个位置
   * @param {IPlayer} player - player实例
   * @param {string} globalMapPath - GIS地图路径
   * @return
   */
  function loadGis(player, globalMapPath) {
    var _a
    return __awaiter$1(this, void 0, void 0, function*() {
      if (checkPlayerLoad(player)) {
        if (!globalMapPath) {
          return {
            status: false,
            message: '地图路径无效',
          }
        }
        // 先卸载地图
        yield unLoadGis(player)
        const res = yield (_a = player.Native) === null || _a === void 0
          ? void 0
          : _a.GisPlatform.loadMap(globalMapPath)
        return {
          status: res,
          message: '',
        }
      } else {
        return {
          status: false,
          message: 'player实例无效',
        }
      }
    })
  }
  /**
   * 卸载地球场景
   * @param {IPlayer} player - player实例
   * @return {*}
   */
  function unLoadGis(player) {
    var _a
    return __awaiter$1(this, void 0, void 0, function*() {
      if (checkPlayerLoad(player)) {
        yield (_a = player.Native) === null || _a === void 0 ? void 0 : _a.GisPlatform.unloadMap()
        return {
          status: true,
          message: '',
        }
      } else {
        return {
          status: false,
          message: 'player实例无效',
        }
      }
    })
  }
  const GIS = {
    loadGis,
    unLoadGis,
  }

  // 漫游相关
  const roamCom = ['system.walk.first', 'system.walk.fixView']
  // 操作类
  const operateTabBar = ['system.Pickup', 'system.PickupCenter']
  // 测量工具集合
  var measureList
  ;(function(measureList) {
    measureList[(measureList['M_None'] = 0)] = 'M_None'
    measureList[(measureList['M_Line'] = 1)] = 'M_Line'
    measureList[(measureList['M_Point'] = 2)] = 'M_Point'
    measureList[(measureList['M_Vertical'] = 3)] = 'M_Vertical'
    measureList[(measureList['M_Stereo'] = 4)] = 'M_Stereo'
    measureList[(measureList['M_Angel'] = 5)] = 'M_Angel'
    measureList[(measureList['M_Area'] = 6)] = 'M_Area'
    measureList[(measureList['M_WheelBase'] = 7)] = 'M_WheelBase'
  })(measureList || (measureList = {}))
  const operatMode$1 = {
    OF_None: 0,
    'system.Pickup': 1,
    OF_FreePickUp: 2,
    OF_Hide: 3,
    'system.PickupCenter': 4, // 居中
  }
  /**
   * @description: 设置当前激活的工具
   * @param {ITagParams} tag
   * @return {*}
   */
  function setTool(tag, status, player) {
    var _a, _b, _c, _d, _e, _f, _g
    return __awaiter$1(this, void 0, void 0, function*() {
      if (!checkPlayerLoad(player)) {
        return {
          status: false,
          message: '请传入正确的player',
        }
      }
      let closeTagList = []
      switch (tag) {
        // 测量
        case Object.keys(measureList).find((el) => {
          return el === tag
        }):
          let measureCloseList = yield setMeasureStatus(tag, status, player)
          closeTagList = [...closeTagList, ...measureCloseList]
          break
        // 操作类
        case operateTabBar.find((el) => {
          return el === tag
        }):
          if (status) {
            ;(_a = player.Native) === null || _a === void 0
              ? void 0
              : _a.OperatingMode.enableOperate(operatMode$1[tag])
          } else {
            ;(_b = player.Native) === null || _b === void 0
              ? void 0
              : _b.OperatingMode.disableOperate(operatMode$1[tag])
          }
          break
        // 漫游相关
        case roamCom.find((el) => {
          return el === tag
        }):
          if (status) {
            ;(_c = player.Native) === null || _c === void 0
              ? void 0
              : _c.PhysicsMgr.updatePhysicsScene()
            ;(_d = player.Native) === null || _d === void 0 ? void 0 : _d.PhysicsMgr.walkAxis(2)
            ;(_e = player.Native) === null || _e === void 0 ? void 0 : _e.Tools.setCurrentTool(tag)
          } else {
            ;(_f = player.Native) === null || _f === void 0
              ? void 0
              : _f.PhysicsMgr.releasePhysicsScene()
          }
          break
        default:
          ;(_g = player.Native) === null || _g === void 0 ? void 0 : _g.Tools.setCurrentTool(tag)
          break
      }
      return {
        status: true,
        data: {
          closeTagList,
        },
        message: '',
      }
    })
  }
  function setMeasureStatus(tag, status, player) {
    var _a, _b, _c, _d, _e, _f
    return __awaiter$1(this, void 0, void 0, function*() {
      let closeTagList = []
      if (status) {
        const isOpenPickup = yield (_a = player.Native) === null || _a === void 0
          ? void 0
          : _a.OperatingMode.isEnable(operatMode$1['system.Pickup'])
        if (isOpenPickup) {
          yield (_b = player.Native) === null || _b === void 0
            ? void 0
            : _b.OperatingMode.disableOperate(operatMode$1['system.Pickup'])
          closeTagList.push('system.Pickup')
        }
        // 设置测量相关功能
        ;(_c = player.Native) === null || _c === void 0
          ? void 0
          : _c.ModelMeasure.selectMeasure(measureList[tag])
        if (tag === 'M_None') {
          // 如果是清除按钮
          ;(_d = player.Native) === null || _d === void 0
            ? void 0
            : _d.ModelMeasure.clearAllResult()
        }
      } else {
        ;(_e = player.Native) === null || _e === void 0 ? void 0 : _e.ModelMeasure.selectMeasure(0)
        ;(_f = player.Native) === null || _f === void 0 ? void 0 : _f.ModelMeasure.clearAllResult()
      }
      return closeTagList
    })
  }

  var EClipType
  ;(function(EClipType) {
    EClipType[(EClipType['box'] = 0)] = 'box'
    EClipType[(EClipType['singlePanel'] = 1)] = 'singlePanel'
    EClipType[(EClipType['doublePanel'] = 2)] = 'doublePanel'
    EClipType[(EClipType['ThreePanel'] = 3)] = 'ThreePanel'
  })(EClipType || (EClipType = {}))
  var EClipDataType
  ;(function(EClipDataType) {
    EClipDataType[(EClipDataType['aabb'] = 0)] = 'aabb'
    EClipDataType[(EClipDataType['model'] = 1)] = 'model'
    EClipDataType[(EClipDataType['node'] = 2)] = 'node'
    EClipDataType[(EClipDataType['item'] = 3)] = 'item'
    EClipDataType[(EClipDataType['clipData'] = 4)] = 'clipData'
  })(EClipDataType || (EClipDataType = {}))
  var IAxisType
  ;(function(IAxisType) {
    IAxisType[(IAxisType['EditAxisTypeUnknown'] = 0)] = 'EditAxisTypeUnknown'
    IAxisType[(IAxisType['EditAxisTypeMove'] = 1)] = 'EditAxisTypeMove'
    IAxisType[(IAxisType['EditAxisTypeRotate'] = 2)] = 'EditAxisTypeRotate'
    IAxisType[(IAxisType['EditAxisTypeScale'] = 3)] = 'EditAxisTypeScale'
    IAxisType[(IAxisType['EditAxisTypeSingleMove'] = 4)] = 'EditAxisTypeSingleMove'
    IAxisType[(IAxisType['EditAxisTypeSingleRotate'] = 5)] = 'EditAxisTypeSingleRotate'
    IAxisType[(IAxisType['EditAxisTypeFaceMove'] = 6)] = 'EditAxisTypeFaceMove'
  })(IAxisType || (IAxisType = {}))

  var IAxisStyle
  ;(function(IAxisStyle) {
    IAxisStyle[(IAxisStyle['arrow'] = 0)] = 'arrow'
    IAxisStyle[(IAxisStyle['cone'] = 1)] = 'cone'
  })(IAxisStyle || (IAxisStyle = {}))

  /**
   * 三维向量，包含向量常用的运算方法，当前系统使用数组表示向量，三维向量是包含三个Number的数组
   */
  let Vec3 = (function() {
    return {
      /**
       * 判断对象是否是合格的向量
       * @param {*} a 检查对象
       */
      check: function(a) {
        if (!Array.isArray(a)) return false
        for (let i = 0; i < 3; ++i) if (isNaN(a[i])) return false
        return true
      },

      /**
       * 向量a与向量b相加，a + b
       * @param {[Number, Number, Number]} a 向量a
       * @param {[Number, Number, Number]} b 向量b
       */
      add: function(a, b) {
        return [a[0] + b[0], a[1] + b[1], a[2] + b[2]]
      },

      /**
       * 向量a与常数b相加，a + b
       * @param {[Number, Number, Number]} a 向量a
       * @param {Number} b 常数b
       */
      addScalar: function(a, b) {
        return [a[0] + b, a[1] + b, a[2] + b]
      },

      /**
       * 向量a与向量b相减， a - b
       * @param {[Number, Number, Number]} a 向量a
       * @param {[Number, Number, Number]} b 向量b
       */
      sub: function(a, b) {
        return [a[0] - b[0], a[1] - b[1], a[2] - b[2]]
      },

      /**
       * 向量a与常数b相减，a - b
       * @param {[Number, Number, Number]} a 向量a
       * @param {Number} b 常数b
       */
      subScalar: function(a, b) {
        return [a[0] - b, a[1] - b, a[2] - b]
      },

      /**
       * 向量a与向量b相乘， a * b
       * @param {[Number, Number, Number]} a 向量a
       * @param {[Number, Number, Number]} b 向量b
       */
      multiply: function(a, b) {
        return [a[0] * b[0], a[1] * b[1], a[2] * b[2]]
      },

      /**
       * 向量a与常数b相乘，a * b
       * @param {[Number, Number, Number]} a 向量a
       * @param {Number} b 常数b
       */
      multiplyScalar: function(a, b) {
        return [a[0] * b, a[1] * b, a[2] * b]
      },

      /**
       * 向量a与向量b相除， a / b
       * @param {[Number, Number, Number]} a 向量a
       * @param {[Number, Number, Number]} b 向量b
       * @note 向量b各分量不能为0
       */
      divide: function(a, b) {
        return [a[0] / b[0], a[1] / b[1], a[2] / b[2]]
      },

      /**
       * 向量a与常数b相除，a / b
       * @param {[Number, Number, Number]} a 向量a
       * @param {Number} b 常数b
       * @note 常数b不能为0
       */
      divideScalar: function(a, b) {
        return [a[0] / b, a[1] / b, a[2] / b]
      },

      /**
       * 向量a与向量b点乘， dot(a, b) = |a| * |b| * cos
       * @param {[Number, Number, Number]} a 向量a
       * @param {[Number, Number, Number]} b 向量b
       */
      dot: function(a, b) {
        return a[0] * b[0] + a[1] * b[1] + a[2] * b[2]
      },

      /**
       * 向量a与向量b叉乘， cross(a, b) = 法向量，同时垂直于向量a和向量b
       * @param {[Number, Number, Number]} a 向量a
       * @param {[Number, Number, Number]} b 向量b
       */
      cross: function(a, b) {
        return [a[1] * b[2] - b[1] * a[2], a[2] * b[0] - b[2] * a[0], a[0] * b[1] - b[0] * a[1]]
      },

      /**
       * 获取向量a的模长/长度, length(a) = |a|
       * @param {[Number, Number, Number]} a 向量a
       */
      length: function(a) {
        return Math.sqrt(a[0] * a[0] + a[1] * a[1] + a[2] * a[2])
      },

      /**
       * 获取向量a的模长/长度的平方，lengthSq(a) = length(a) * length(a)
       * @param {[Number, Number, Number]} a 向量a
       */
      lengthSq: function(a) {
        return a[0] * a[0] + a[1] * a[1] + a[2] * a[2]
      },

      /**
       * 向量取反
       * @param {[Number, Number, Number]} a 向量a
       */
      negate: function(a) {
        return [-a[0], -a[1], -a[2]]
      },

      /**
       * 获取单位向量
       * @param {[Number, Number, Number]} a 向量a
       */
      normalize: function(a) {
        var len = Math.sqrt(a[0] * a[0] + a[1] * a[1] + a[2] * a[2]) || 1
        return [a[0] / len, a[1] / len, a[2] / len]
      },

      /**
       * 向量a与向量b的夹角
       * @param {[Number, Number, Number]} a 向量a
       * @param {[Number, Number, Number]} b 向量b
       * @param 返回两个向量的夹角(角度制)
       */
      angleBetween: function(a, b) {
        const denominator = Vec3.length(a) * Vec3.length(b)

        if (denominator === 0) return (Math.PI / 2) * (180 / Math.PI)

        let theta = Vec3.dot(a, b) / denominator

        if (theta < -1) theta = -1
        if (theta > 1) theta = 1

        let angle = Math.acos(theta)
        angle *= 180 / Math.PI

        return angle
      },
    }
  })()

  /**
   * 行优先4x4矩阵
   */
  let Matrix4 = (function() {
    return {
      /**
       * 获取单位矩阵
       * @returns 单位矩阵
       */
      identity: function() {
        return [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
      },

      /**
       * 检查a是否是合法的矩阵
       * @param {*} a 检查对象
       */
      check: function(a) {
        if (!Array.isArray(a)) return false
        for (let i = 0; i < 16; ++i) if (isNaN(a[i])) return false
        return true
      },

      /**
       * 矩阵a与矩阵b相乘
       * @param {[...Number]} a
       * @param {[...Number]} b
       */
      multiply: function(a, b) {
        const ae = a
        const be = b

        const a11 = ae[0],
          a12 = ae[4],
          a13 = ae[8],
          a14 = ae[12]
        const a21 = ae[1],
          a22 = ae[5],
          a23 = ae[9],
          a24 = ae[13]
        const a31 = ae[2],
          a32 = ae[6],
          a33 = ae[10],
          a34 = ae[14]
        const a41 = ae[3],
          a42 = ae[7],
          a43 = ae[11],
          a44 = ae[15]

        const b11 = be[0],
          b12 = be[4],
          b13 = be[8],
          b14 = be[12]
        const b21 = be[1],
          b22 = be[5],
          b23 = be[9],
          b24 = be[13]
        const b31 = be[2],
          b32 = be[6],
          b33 = be[10],
          b34 = be[14]
        const b41 = be[3],
          b42 = be[7],
          b43 = be[11],
          b44 = be[15]

        let rMat = []

        rMat[0] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41
        rMat[4] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42
        rMat[8] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43
        rMat[12] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44

        rMat[1] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41
        rMat[5] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42
        rMat[9] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43
        rMat[13] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44

        rMat[2] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41
        rMat[6] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42
        rMat[10] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43
        rMat[14] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44

        rMat[3] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41
        rMat[7] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42
        rMat[11] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43
        rMat[15] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44

        return rMat
      },

      /**
       * 矩阵a与三维坐标b相乘，返回变换后的坐标
       * @param {[...Number]} a 矩阵a
       * @param {[Number,Number,Number]} b 三维坐标b
       */
      multiplyPos: function(a, b) {
        var ret = []
        for (var i = 0; i < 3; ++i) {
          ret[i] = a[12 + i]
          for (var j = 0; j < 3; ++j) {
            ret[i] += b[j] * a[j * 4 + i]
          }
        }
        return ret
      },

      /**
       * 矩阵a与方向向量b相乘，返回变化后的方向
       * @param {[...Number]} a 矩阵a
       * @param {[Number,Number,Number]} b 三维向量b
       */
      multiplyDir: function(a, b) {
        var ret = []
        for (var i = 0; i < 3; ++i) {
          ret[i] = 0
          for (var j = 0; j < 3; ++j) {
            ret[i] += b[j] * a[j * 4 + i]
          }
        }
        return ret
      },

      /**
       * 构造TRS矩阵
       * @param position 位置
       * @param quaternion 旋转四元数(顺序wxyz)
       * @param scale 缩放
       * @returns 4x4 TRS矩阵
       */
      compose: function(position, quaternion, scale) {
        var ret = []

        const x = quaternion[1]
        const y = quaternion[2]
        const z = quaternion[3]
        const w = quaternion[0]

        const x2 = x + x
        const y2 = y + y
        const z2 = z + z
        const xx = x * x2
        const xy = x * y2
        const xz = x * z2
        const yy = y * y2
        const yz = y * z2
        const zz = z * z2
        const wx = w * x2
        const wy = w * y2
        const wz = w * z2

        const sx = scale[0]
        const sy = scale[1]
        const sz = scale[2]

        ret[0] = (1 - (yy + zz)) * sx
        ret[1] = (xy + wz) * sx
        ret[2] = (xz - wy) * sx
        ret[3] = 0

        ret[4] = (xy - wz) * sy
        ret[5] = (1 - (xx + zz)) * sy
        ret[6] = (yz + wx) * sy
        ret[7] = 0

        ret[8] = (xz + wy) * sz
        ret[9] = (yz - wx) * sz
        ret[10] = (1 - (xx + yy)) * sz
        ret[11] = 0

        ret[12] = position[0]
        ret[13] = position[1]
        ret[14] = position[2]
        ret[15] = 1

        return ret
      },

      /**
       * 矩阵萃取
       * @param {*} m 将被萃取的矩阵对象
       * @returns 萃取结果
       *          - position: 萃取的位置信息
       *          - quaternion: 萃取的旋转四元数信息
       *          - rotation: 萃取的旋转矩阵信息
       *          - scale:萃取的缩放信息
       */
      decompose: function(m) {
        var a = {
          position: [],
          quaternion: [],
          rotation: [],
          scale: [],
        }

        var vx = [m[0], m[1], m[2]]
        var vy = [m[4], m[5], m[6]]
        var vz = [m[8], m[9], m[10]]

        let sx = Vec3.length(vx)
        const sy = Vec3.length(vy)
        const sz = Vec3.length(vz)

        // if determine is negative, we need to invert one scale
        const det = Matrix4.determinant(m)
        if (det < 0) sx = -sx

        a.position = []
        a.position[0] = m[12]
        a.position[1] = m[13]
        a.position[2] = m[14]

        // scale the rotation part
        var rMat = m
        rMat[12] = 0
        rMat[13] = 0
        rMat[14] = 0

        const invSX = 1 / sx
        const invSY = 1 / sy
        const invSZ = 1 / sz

        rMat[0] *= invSX
        rMat[1] *= invSX
        rMat[2] *= invSX

        rMat[4] *= invSY
        rMat[5] *= invSY
        rMat[6] *= invSY

        rMat[8] *= invSZ
        rMat[9] *= invSZ
        rMat[10] *= invSZ

        a.rotation = rMat
        a.quaternion = Quat.fromRotationMatrix(rMat)

        a.scale = []
        a.scale[0] = sx
        a.scale[1] = sy
        a.scale[2] = sz

        return a
      },

      /**
       * 计算矩阵行列式
       * @param {*} m 将被计算行列式的矩阵对象
       * @returns 矩阵的行列式值
       */
      determinant: function(m) {
        const n11 = m[0],
          n12 = m[1],
          n13 = m[2],
          n14 = m[3]
        const n21 = m[4],
          n22 = m[5],
          n23 = m[6],
          n24 = m[7]
        const n31 = m[8],
          n32 = m[9],
          n33 = m[10],
          n34 = m[11]
        const n41 = m[12],
          n42 = m[13],
          n43 = m[14],
          n44 = m[15]

        return (
          n41 *
            (+n14 * n23 * n32 -
              n13 * n24 * n32 -
              n14 * n22 * n33 +
              n12 * n24 * n33 +
              n13 * n22 * n34 -
              n12 * n23 * n34) +
          n42 *
            (+n11 * n23 * n34 -
              n11 * n24 * n33 +
              n14 * n21 * n33 -
              n13 * n21 * n34 +
              n13 * n24 * n31 -
              n14 * n23 * n31) +
          n43 *
            (+n11 * n24 * n32 -
              n11 * n22 * n34 -
              n14 * n21 * n32 +
              n12 * n21 * n34 +
              n14 * n22 * n31 -
              n12 * n24 * n31) +
          n44 *
            (-n13 * n22 * n31 -
              n11 * n23 * n32 +
              n11 * n22 * n33 +
              n13 * n21 * n32 -
              n12 * n21 * n33 +
              n12 * n23 * n31)
        )
      },

      /**
       * 计算矩阵的逆
       * @param {*} m 将被计算逆的矩阵对象
       * @returns 矩阵的逆矩阵
       * */
      inverse: function(m) {
        // based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm

        const n11 = m[0],
          n21 = m[1],
          n31 = m[2],
          n41 = m[3],
          n12 = m[4],
          n22 = m[5],
          n32 = m[6],
          n42 = m[7],
          n13 = m[8],
          n23 = m[9],
          n33 = m[10],
          n43 = m[11],
          n14 = m[12],
          n24 = m[13],
          n34 = m[14],
          n44 = m[15],
          t11 =
            n23 * n34 * n42 -
            n24 * n33 * n42 +
            n24 * n32 * n43 -
            n22 * n34 * n43 -
            n23 * n32 * n44 +
            n22 * n33 * n44,
          t12 =
            n14 * n33 * n42 -
            n13 * n34 * n42 -
            n14 * n32 * n43 +
            n12 * n34 * n43 +
            n13 * n32 * n44 -
            n12 * n33 * n44,
          t13 =
            n13 * n24 * n42 -
            n14 * n23 * n42 +
            n14 * n22 * n43 -
            n12 * n24 * n43 -
            n13 * n22 * n44 +
            n12 * n23 * n44,
          t14 =
            n14 * n23 * n32 -
            n13 * n24 * n32 -
            n14 * n22 * n33 +
            n12 * n24 * n33 +
            n13 * n22 * n34 -
            n12 * n23 * n34

        const det = n11 * t11 + n21 * t12 + n31 * t13 + n41 * t14

        if (det === 0) return [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]

        const detInv = 1 / det

        let invMat = []

        invMat[0] = t11 * detInv
        invMat[1] =
          (n24 * n33 * n41 -
            n23 * n34 * n41 -
            n24 * n31 * n43 +
            n21 * n34 * n43 +
            n23 * n31 * n44 -
            n21 * n33 * n44) *
          detInv
        invMat[2] =
          (n22 * n34 * n41 -
            n24 * n32 * n41 +
            n24 * n31 * n42 -
            n21 * n34 * n42 -
            n22 * n31 * n44 +
            n21 * n32 * n44) *
          detInv
        invMat[3] =
          (n23 * n32 * n41 -
            n22 * n33 * n41 -
            n23 * n31 * n42 +
            n21 * n33 * n42 +
            n22 * n31 * n43 -
            n21 * n32 * n43) *
          detInv

        invMat[4] = t12 * detInv
        invMat[5] =
          (n13 * n34 * n41 -
            n14 * n33 * n41 +
            n14 * n31 * n43 -
            n11 * n34 * n43 -
            n13 * n31 * n44 +
            n11 * n33 * n44) *
          detInv
        invMat[6] =
          (n14 * n32 * n41 -
            n12 * n34 * n41 -
            n14 * n31 * n42 +
            n11 * n34 * n42 +
            n12 * n31 * n44 -
            n11 * n32 * n44) *
          detInv
        invMat[7] =
          (n12 * n33 * n41 -
            n13 * n32 * n41 +
            n13 * n31 * n42 -
            n11 * n33 * n42 -
            n12 * n31 * n43 +
            n11 * n32 * n43) *
          detInv

        invMat[8] = t13 * detInv
        invMat[9] =
          (n14 * n23 * n41 -
            n13 * n24 * n41 -
            n14 * n21 * n43 +
            n11 * n24 * n43 +
            n13 * n21 * n44 -
            n11 * n23 * n44) *
          detInv
        invMat[10] =
          (n12 * n24 * n41 -
            n14 * n22 * n41 +
            n14 * n21 * n42 -
            n11 * n24 * n42 -
            n12 * n21 * n44 +
            n11 * n22 * n44) *
          detInv
        invMat[11] =
          (n13 * n22 * n41 -
            n12 * n23 * n41 -
            n13 * n21 * n42 +
            n11 * n23 * n42 +
            n12 * n21 * n43 -
            n11 * n22 * n43) *
          detInv

        invMat[12] = t14 * detInv
        invMat[13] =
          (n13 * n24 * n31 -
            n14 * n23 * n31 +
            n14 * n21 * n33 -
            n11 * n24 * n33 -
            n13 * n21 * n34 +
            n11 * n23 * n34) *
          detInv
        invMat[14] =
          (n14 * n22 * n31 -
            n12 * n24 * n31 -
            n14 * n21 * n32 +
            n11 * n24 * n32 +
            n12 * n21 * n34 -
            n11 * n22 * n34) *
          detInv
        invMat[15] =
          (n12 * n23 * n31 -
            n13 * n22 * n31 +
            n13 * n21 * n32 -
            n11 * n23 * n32 -
            n12 * n21 * n33 +
            n11 * n22 * n33) *
          detInv

        return invMat
      },

      /**
       * 指定旋转角和旋转轴计算一个旋转矩阵
       * @param {Number} angle 旋转角(角度制)
       * @param {[Number, Number, Number]} axis 旋转轴(单位向量)
       * @returns 4x4的旋转矩阵
       * */
      makeRotationAxis: function(angle, axis) {
        const tAngne = (angle * Math.PI) / 180
        // Based on http://www.gamedev.net/reference/articles/article1199.asp
        const c = Math.cos(tAngne)
        const s = Math.sin(tAngne)
        const t = 1 - c
        const x = axis[0],
          y = axis[1],
          z = axis[2]
        const tx = t * x,
          ty = t * y

        let rMat = []
        rMat[0] = tx * x + c
        rMat[4] = tx * y - s * z
        rMat[8] = tx * z + s * y
        rMat[12] = 0
        rMat[1] = tx * y + s * z
        rMat[5] = ty * y + c
        rMat[9] = ty * z - s * x
        rMat[13] = 0
        rMat[2] = tx * z - s * y
        rMat[6] = ty * z + s * x
        rMat[10] = t * z * z + c
        rMat[14] = 0
        rMat[3] = 0
        rMat[7] = 0
        rMat[11] = 0
        rMat[15] = 1
        return rMat
      },
    }
  })()

  /**
   * 四元素
   *  注：这里四元数对应Player返回的四元数对象，Player返回的四元数的顺序是 [w,x,y,z]
   *   因此这里四元数所有算法也应该遵循Player中的 [w,x,y,z]顺序
   */
  let Quat = (function() {
    return {
      /**
       * 检查a是否是合法的四元数
       * @param {*} a 检查对象
       */
      check: function(a) {
        if (!Array.isArray(a)) return false
        for (let i = 0; i < 4; ++i) if (isNaN(a[i])) return false
        if (Math.abs(a[0] * a[0] + a[1] * a[1] + a[2] * a[2] + a[3] * a[3] - 1) > 0.01) return false
        return true
      },
      /**
       * 转换旋转矩阵到四元数
       * @param {*} m 旋转矩阵
       * @returns 旋转四元数
       */
      fromRotationMatrix: function(m) {
        const m11 = m[0],
          m12 = m[4],
          m13 = m[8],
          m21 = m[1],
          m22 = m[5],
          m23 = m[9],
          m31 = m[2],
          m32 = m[6],
          m33 = m[10],
          trace = m11 + m22 + m33

        const q = []

        if (trace > 0) {
          const s = 0.5 / Math.sqrt(trace + 1.0)

          q[0] = 0.25 / s
          q[1] = (m32 - m23) * s
          q[2] = (m13 - m31) * s
          q[3] = (m21 - m12) * s
        } else if (m11 > m22 && m11 > m33) {
          const s = 2.0 * Math.sqrt(1.0 + m11 - m22 - m33)

          q[0] = (m32 - m23) / s
          q[1] = 0.25 * s
          q[2] = (m12 + m21) / s
          q[3] = (m13 + m31) / s
        } else if (m22 > m33) {
          const s = 2.0 * Math.sqrt(1.0 + m22 - m11 - m33)

          q[0] = (m13 - m31) / s
          q[1] = (m12 + m21) / s
          q[2] = 0.25 * s
          q[3] = (m23 + m32) / s
        } else {
          const s = 2.0 * Math.sqrt(1.0 + m33 - m11 - m22)

          q[0] = (m21 - m12) / s
          q[1] = (m13 + m31) / s
          q[2] = (m23 + m32) / s
          q[3] = 0.25 * s
        }

        return q
      },
      /**
       * 转换四元数到旋转矩阵
       * @param m 旋转四元数
       * @returns 旋转矩阵
       */
      toRotationMatrix: function(q) {
        return Matrix4.compose([0, 0, 0], q, [1, 1, 1])
      },
    }
  })()
  /**
   * 包围盒
   */
  let Aabb = (function() {
    return {
      /**
       * 检查a是否是合法的包围盒
       * @param {*} a 检查对象
       */
      check: function(a) {
        if (!Array.isArray(a)) return false
        if (isNaN(a.min) || isNaN(a.max)) return false
        for (let i = 0; i < 3; ++i) if (isNaN(a.min[i]) || isNaN(a.max[i])) return false
        return true
      },

      /**
       * map(min、max)解成二维数组
       * @param {[{"min", [Number, Number, Number]}， {"max", [Number, Number, Number]}]} a map a
       */
      deMap: function(a) {
        return [a.min, a.max]
      },

      /**
       * 获取包围盒8个顶点
       * @param a [ [Number, Number, Number]，[Number, Number, Number]] a aabb
       */
      vertex8: function(a) {
        return [
          [a[0][0], a[0][1], a[0][2]],

          [a[0][0], a[1][1], a[0][2]],

          [a[1][0], a[1][1], a[0][2]],

          [a[1][0], a[0][1], a[0][2]],

          [a[1][0], a[1][1], a[1][2]],

          [a[0][0], a[1][1], a[1][2]],

          [a[0][0], a[0][1], a[1][2]],

          [a[1][0], a[0][1], a[1][2]],
        ]
      },
      /**
       * 获取包围盒某个面
       * @param a [ [Number, Number, Number]，[Number, Number, Number]] a aabb
       * @param faceName 面名称: X,XN,Y,YN,Z,ZN
       */
      face: function(a, faceName = 'Z') {
        let fIdx = []
        switch (faceName) {
          case 'X':
            {
              fIdx = [3, 2, 4, 7] //X
            }
            break
          case 'XN':
            {
              fIdx = [1, 0, 6, 5] //XN
            }
            break
          case 'Y':
            {
              fIdx = [2, 1, 5, 4] //Y
            }
            break
          case 'YN':
            {
              fIdx = [0, 3, 7, 6] //YN
            }
            break
          case 'Z':
            {
              fIdx = [6, 7, 4, 5] //Z
            }
            break
          case 'ZN':
            {
              fIdx = [1, 2, 3, 0] //ZN
            }
            break
          default: {
            return []
          }
        }
        const v8 = Aabb.vertex8(a)
        return [v8[fIdx[0]], v8[fIdx[1]], v8[fIdx[2]], v8[fIdx[3]]]
      },
      /**
       * 获取包围盒某个面中心点
       * @param a [ [Number, Number, Number]，[Number, Number, Number]] a aabb
       * @param faceName 面名称: X,XN,Y,YN,Z,ZN
       */
      faceCenter: function(a, faceName = 'Z') {
        const face = Aabb.face(a, faceName)
        const a0 = Vec3.add(face[0], face[1])
        const a1 = Vec3.add(a0, face[2])
        let a2 = Vec3.add(a1, face[3])
        a2[0] /= 4
        a2[1] /= 4
        a2[2] /= 4
        return a2
      },
      /**
       * 获取包围盒中心点
       * @param [ [Number, Number, Number]，[Number, Number, Number]] a aabb
       */
      center: function(a) {
        let cen = Vec3.add(a[0], a[1])
        cen = Vec3.multiplyScalar(cen, 0.5)
        return cen
      },
    }
  })()

  var operatMode
  ;(function(operatMode) {
    operatMode[(operatMode['OF_None'] = 0)] = 'OF_None'
    operatMode[(operatMode['system.Pickup'] = 1)] = 'system.Pickup'
    operatMode[(operatMode['OF_FreePickUp'] = 2)] = 'OF_FreePickUp'
    operatMode[(operatMode['OF_Hide'] = 3)] = 'OF_Hide'
    operatMode[(operatMode['system.PickupCenter'] = 4)] = 'system.PickupCenter'
  })(operatMode || (operatMode = {}))
  var IDirection
  ;(function(IDirection) {
    /** 向上 */
    IDirection[(IDirection['up'] = 0)] = 'up'
    /** 向下 */
    IDirection[(IDirection['down'] = 1)] = 'down'
  })(IDirection || (IDirection = {}))
  var ISearchType
  ;(function(ISearchType) {
    /** 包含 */
    ISearchType[(ISearchType['include'] = 0)] = 'include'
    /** 从头匹配 */
    ISearchType[(ISearchType['start'] = 1)] = 'start'
    /** 从尾匹配 */
    ISearchType[(ISearchType['end'] = 2)] = 'end'
    /** 相等 */
    ISearchType[(ISearchType['equal'] = 3)] = 'equal'
  })(ISearchType || (ISearchType = {}))
  var INodeEditorType
  ;(function(INodeEditorType) {
    INodeEditorType[(INodeEditorType['None'] = 0)] = 'None'
    INodeEditorType[(INodeEditorType['Translate'] = 1)] = 'Translate'
    INodeEditorType[(INodeEditorType['Rotate'] = 2)] = 'Rotate'
    INodeEditorType[(INodeEditorType['Scale'] = 3)] = 'Scale' //缩放
  })(INodeEditorType || (INodeEditorType = {}))

  /**
   * @description: 根据item查找模型数据
   * @param {IPlayer} player
   * @param {String} item
   * @return {*}
   */
  function getInfoByITEM(player, item) {
    var _a
    return __awaiter$1(this, void 0, void 0, function*() {
      if (!item)
        return {
          status: false,
          message: '请传入item',
        }
      const res = yield (_a = player.Native) === null || _a === void 0
        ? void 0
        : _a.ModelTree.getItemInfo(item)
      return {
        status: !!res,
        data: res,
        message: !!res ? '成功' : '失败',
      }
    })
  }
  /**
   * @description: 根据selfId查找模型信息
   * @param {IPlayer} player
   * @param {String} selfId
   * @return {*}
   */
  function getInfoBySELFID(player, selfId) {
    var _a
    return __awaiter$1(this, void 0, void 0, function*() {
      if (!selfId)
        return {
          status: false,
          message: '请传入selfId',
        }
      const res = yield (_a = player.Native) === null || _a === void 0
        ? void 0
        : _a.ModelTree.getItemBySelfId(selfId)
      return {
        status: !!res,
        data: res,
        message: !!res ? '成功' : '失败',
      }
    })
  }
  /**
   * @description: 根据code查找模型信息
   * @param {IPlayer} player
   * @param {String} params
   * @return {*}
   */
  function getInfoByCODE(player, code) {
    var _a
    return __awaiter$1(this, void 0, void 0, function*() {
      if (!code)
        return {
          status: false,
          message: '请传入code',
        }
      const res = yield (_a = player.Native) === null || _a === void 0
        ? void 0
        : _a.ModelTree.getItemByCode(code)
      return {
        status: !!res,
        data: res,
        message: !!res ? '成功' : '失败',
      }
    })
  }
  /**
   * @description: 根据Node查找模型信息
   * @param {IPlayer} player
   * @param {number} nodePtr 模型的节点指针
   * @return {*}
   */
  function getInfoByNode(player, nodePtr) {
    var _a
    return __awaiter$1(this, void 0, void 0, function*() {
      if (!nodePtr)
        return {
          status: false,
          message: '请传入nodePtr',
        }
      const res = yield (_a = player.Native) === null || _a === void 0
        ? void 0
        : _a.NodeProxy.getNodeInfo(nodePtr)
      return {
        status: !!res,
        data: res,
        message: !!res ? '成功' : '失败',
      }
    })
  }
  /**
   * @description: 根据不同的参数查找模型信息
   * @param {IPlayer} player
   * @param {ViewType} type
   * @param {String} param
   * @return {*}
   */
  function getInfo(player, type, param) {
    return __awaiter$1(this, void 0, void 0, function*() {
      const isCurrentPlayer = checkPlayerLoad(player)
      if (isCurrentPlayer) {
        switch (type) {
          case 'Item':
            return yield getInfoByITEM(player, param)
          case 'SelfId':
            return yield getInfoBySELFID(player, param)
          case 'Code':
            return yield getInfoByCODE(player, param)
          case 'Node':
            return yield getInfoByNode(player, param)
          default:
            return {
              data: null,
              status: false,
              message:
                '当前传入的类型不支持查询模型节点信息。支持查询的列表：Item、Code、SelfId、Node',
            }
        }
      } else {
        return {
          data: null,
          status: false,
          message: 'player实例无效',
        }
      }
    })
  }
  /**
   * @description: 设置节点的状态
   * @param {IPlayer} player
   * @param {Number} nodePtr 节点对象/item
   * @param {Boolean} visible 显示/隐藏
   * @return {*}
   */
  function setNodeStatus(player, nodePtr, visible) {
    var _a
    return __awaiter$1(this, void 0, void 0, function*() {
      // 判断player
      const isCurrentPlayer = checkPlayerLoad(player)
      if (!isCurrentPlayer)
        return {
          status: false,
          message: 'player实例无效',
        }
      // 判断node是否有效
      const nodeRes = yield checkNode(player, nodePtr)
      if (!nodeRes.status) return nodeRes
      yield (_a = player.Native) === null || _a === void 0
        ? void 0
        : _a.NodeProxy.setNodeVisible(nodePtr, visible)
      return {
        status: true,
        message: '',
      }
    })
  }
  /**
   * @description: 设置Item的状态
   * @param {IPlayer} player
   * @param {Number} item item
   * @param {Boolean} visible 显示/隐藏
   * @return {*}
   */
  function setItemStatus(player, item, visible) {
    var _a
    return __awaiter$1(this, void 0, void 0, function*() {
      // 判断player
      const isCurrentPlayer = checkPlayerLoad(player)
      if (!isCurrentPlayer)
        return {
          status: false,
          message: 'player实例无效',
        }
      yield (_a = player.Native) === null || _a === void 0
        ? void 0
        : _a.ModelTree.setItemVisible(item, visible)
      return {
        status: true,
        message: '',
      }
    })
  }
  /**
   * @description: 获取node的父节点信息
   * @param {IPlayer} player
   * @param {Number} nodePtr
   * @return {*}
   */
  function findNodeParent(player, nodePtr) {
    var _a
    return __awaiter$1(this, void 0, void 0, function*() {
      // 判断player
      const isCurrentPlayer = checkPlayerLoad(player)
      if (!isCurrentPlayer)
        return {
          status: false,
          message: 'player实例无效',
        }
      // 判断node是否有效
      const nodeRes = yield checkNode(player, nodePtr)
      if (!nodeRes.status) return nodeRes
      const nodeData = yield (_a = player.Native) === null || _a === void 0
        ? void 0
        : _a.NodeProxy.getNodeParent(nodePtr)
      return {
        status: true,
        data: nodeData,
        message: '',
      }
    })
  }
  /**
   * @description: 获取node的所有子节点列表
   * @param {IPlayer} player
   * @param {Number} nodePtr
   * @return {*}
   */
  function findNodeChild(player, nodePtr) {
    var _a
    return __awaiter$1(this, void 0, void 0, function*() {
      // 判断player
      const isCurrentPlayer = checkPlayerLoad(player)
      if (!isCurrentPlayer)
        return {
          status: false,
          message: 'player实例无效',
        }
      // 判断node是否有效
      const nodeRes = yield checkNode(player, nodePtr)
      if (!nodeRes.status) return nodeRes
      const nodeData = yield (_a = player.Native) === null || _a === void 0
        ? void 0
        : _a.NodeProxy.getNodeChildren(nodePtr)
      return {
        status: true,
        data: nodeData,
        message: '',
      }
    })
  }
  /**
   * @description: 获取Item的所有子节点列表
   * @param {IPlayer} player
   * @param {Number} nodePtr
   * @return {*}
   */
  function findItemChild(player, item) {
    var _a
    return __awaiter$1(this, void 0, void 0, function*() {
      // 判断player
      const isCurrentPlayer = checkPlayerLoad(player)
      if (!isCurrentPlayer)
        return {
          status: false,
          message: 'player实例无效',
        }
      const modelData = yield (_a = player.Native) === null || _a === void 0
        ? void 0
        : _a.ModelTree.getSubItems(item)
      return {
        status: true,
        data: modelData,
        message: '',
      }
    })
  }
  /**
   * @description: 获取当前选中的节点
   * @param {IPlayer} player
   * @return {*}
   */
  function getSelectedItem(player) {
    var _a
    return __awaiter$1(this, void 0, void 0, function*() {
      // 判断player
      const isCurrentPlayer = checkPlayerLoad(player)
      if (!isCurrentPlayer)
        return {
          status: false,
          message: 'player实例无效',
        }
      const modelData = yield (_a = player.Native) === null || _a === void 0
        ? void 0
        : _a.ModelTree.getSelectedItem()
      return {
        status: true,
        data: modelData,
        message: '',
      }
    })
  }
  /**
   * @description: 移除选中的节点
   * @param {IPlayer} player
   * @return {*}
   */
  function removeSelectedItem(player) {
    var _a
    return __awaiter$1(this, void 0, void 0, function*() {
      // 判断player
      const isCurrentPlayer = checkPlayerLoad(player)
      if (!isCurrentPlayer)
        return {
          status: false,
          message: 'player实例无效',
        }
      yield (_a = player.Native) === null || _a === void 0 ? void 0 : _a.ModelTree.setSelectItem(0)
      return {
        status: true,
        message: '',
      }
    })
  }
  /**
   * @description: 判断node是否有效
   * @param {IPlayer} player
   * @param {Number} nodePtr
   * @return {*}
   */
  function checkNode(player, nodePtr) {
    var _a
    return __awaiter$1(this, void 0, void 0, function*() {
      const isNode = yield (_a = player.Native) === null || _a === void 0
        ? void 0
        : _a.NodeProxy.isNode(nodePtr)
      if (!isNode)
        return {
          status: false,
          message: 'nodePtr不是一个节点对象',
        }
      return {
        status: true,
      }
    })
  }
  let localPlayer = {}
  let localPtr = 0
  function editorListener() {
    var _a, _b, _c
    return __awaiter$1(this, void 0, void 0, function*() {
      let localPos = {
        Position: [],
        Rotate: [],
        Scale: [],
      }
      localPos.Position = yield (_a =
        localPlayer === null || localPlayer === void 0 ? void 0 : localPlayer.Native) === null ||
      _a === void 0
        ? void 0
        : _a.NodeProxy.localTranslation(localPtr)
      localPos.Rotate = yield (_b =
        localPlayer === null || localPlayer === void 0 ? void 0 : localPlayer.Native) === null ||
      _b === void 0
        ? void 0
        : _b.NodeProxy.localRotation(localPtr)
      localPos.Scale = yield (_c =
        localPlayer === null || localPlayer === void 0 ? void 0 : localPlayer.Native) === null ||
      _c === void 0
        ? void 0
        : _c.NodeProxy.localScaling(localPtr)
      sendEvent(
        {
          message: '',
          status: true,
          data: {
            type: 'NodeEditor',
            currentState: 1,
            data: localPos,
          },
        },
        'NodeEditor'
      )
    })
  }
  /**
   *
   * @param player
   * @param nodePtr
   * @param type
   * @returns
   */
  //设置node编辑类型
  function setNodeEditType(player, nodePtr, type) {
    var _a, _b, _c, _d, _e, _f
    return __awaiter$1(this, void 0, void 0, function*() {
      const isCurrentPlayer = checkPlayerLoad(player)
      if (!isCurrentPlayer)
        return {
          status: false,
          message: 'player实例无效',
        }
      const isNode = yield checkNode(player, nodePtr)
      if (!isNode.status) return isNode
      yield (_a = player.Native) === null || _a === void 0 ? void 0 : _a.NodeEditor.setNode(nodePtr)
      switch (type) {
        case INodeEditorType.Translate:
        case INodeEditorType.Rotate:
        case INodeEditorType.Scale:
          localPtr
            ? yield (_b = player.Native) === null || _b === void 0
                ? void 0
                : _b.NodeEditor.EventEditFinished.disconnect(editorListener)
            : null
          localPlayer = player
          localPtr = nodePtr
          yield (_c = player.Native) === null || _c === void 0
            ? void 0
            : _c.NodeEditor.setEditType(type)
          ;(_d = player.Native) === null || _d === void 0
            ? void 0
            : _d.NodeEditor.EventEditFinished.connect(editorListener)
          break
        case INodeEditorType.None:
          localPtr
            ? yield (_e = player.Native) === null || _e === void 0
                ? void 0
                : _e.NodeEditor.EventEditFinished.disconnect(editorListener)
            : null
          yield (_f = player.Native) === null || _f === void 0
            ? void 0
            : _f.NodeEditor.setEditType(type)
          localPlayer = {}
          localPtr = 0
          break
      }
      return {
        status: true,
      }
    })
  }
  //通过数据设置node节点的位置、旋转、缩放
  function setNodeLocal(player, nodePtr, options) {
    var _a, _b, _c
    return __awaiter$1(this, void 0, void 0, function*() {
      const isCurrentPlayer = checkPlayerLoad(player)
      if (!isCurrentPlayer)
        return {
          status: false,
          message: 'player实例无效',
        }
      const isNode = yield checkNode(player, nodePtr)
      if (!isNode.status) return isNode
      //判断传入参数是否存在且是否为空数组
      if (options.Position && options.Position.length > 0) {
        yield (_a = player.Native) === null || _a === void 0
          ? void 0
          : _a.NodeProxy.setLocalTranslation(nodePtr, options.Position)
      }
      if (options.Rotate && options.Rotate.length > 0) {
        yield (_b = player.Native) === null || _b === void 0
          ? void 0
          : _b.NodeProxy.setLocalRotation(nodePtr, options.Rotate)
      }
      if (options.Scale && options.Scale.length > 0) {
        yield (_c = player.Native) === null || _c === void 0
          ? void 0
          : _c.NodeProxy.setLocalScaling(nodePtr, options.Scale)
      }
      return {
        status: true,
      }
    })
  }
  function destroyNode(player, nodePtr) {
    var _a, _b
    return __awaiter$1(this, void 0, void 0, function*() {
      //检验player是否存在
      if (!checkPlayerLoad(player)) {
        // 加载失败
        return {
          status: false,
          message: 'player无效',
        }
      }
      const isNode = yield checkNode(player, nodePtr)
      if (!isNode.status) return isNode
      const disConnect = yield setNodeEditType(player, nodePtr, 0)
      if (!disConnect.status) return disConnect
      yield (_a = player.Native) === null || _a === void 0
        ? void 0
        : _a.NodeEditor.setNode('nullptr')
      yield (_b = player.Native) === null || _b === void 0
        ? void 0
        : _b.NodeProxy.destroyNode(nodePtr)
      return {
        status: true,
      }
    })
  }
  /**
   * @description: 根据名称查找
   * @param {IPlayer} player
   * @param {string} content 名称
   * @param {number} startItem 开始查询的节点 默认取0
   * @param {IDirection} direction 查询的方向  默认向下查询
   * @param {ISearchType} type 查询的方式  默认是模糊匹配
   * @return {*}
   */
  function findItemByName(player, content, startItem, direction, type) {
    var _a
    return __awaiter$1(this, void 0, void 0, function*() {
      if (!checkPlayerLoad(player))
        return {
          status: false,
          message: 'player实例无效',
        }
      const modelInfo = yield (_a = player.Native) === null || _a === void 0
        ? void 0
        : _a.ModelTree.findItemByName(
            content,
            startItem | 0,
            direction | IDirection.down,
            type | ISearchType.include
          )
      return {
        status: true,
        data: modelInfo,
        message: '',
      }
    })
  }
  const Node$1 = {
    getInfo,
    setNodeStatus,
    setItemStatus,
    findNodeParent,
    findNodeChild,
    findItemChild,
    getSelectedItem,
    removeSelectedItem,
    checkNode,
    setNodeEditType,
    setNodeLocal,
    destroyNode,
    findItemByName,
  }

  let axisObjs = []
  let isAxisEdtingConnection = false
  const onEditting = (param) =>
    __awaiter$1(void 0, void 0, void 0, function*() {
      sendEvent(
        {
          message: '编辑完成',
          status: true,
          data: {
            type: 'Axis',
            currentState: 0,
            data: {
              relativeOffset: param.relativeOffset,
              absoluteOffset: param.absoluteOffset,
              axisObject: param.sender,
              axisRotate: param.axis,
            },
          },
        },
        'Axis'
      )
    })
  const createAxis = (player, axisType, editNode, options) =>
    __awaiter$1(void 0, void 0, void 0, function*() {
      var _a, _b, _c, _d
      const currentAxisData = {
        id: generateUUID(),
        axisObject: [],
        axisType,
      }
      if (options === null || options === void 0 ? void 0 : options.axisNum) {
        for (
          let i = 0;
          i < (options === null || options === void 0 ? void 0 : options.axisNum);
          i += 1
        ) {
          const currentAxisStyle = (options === null || options === void 0
          ? void 0
          : options.axisConfigList)
            ? (options === null || options === void 0 ? void 0 : options.axisConfigList[i]) || {}
            : {}
          // 创建轴对象  4.为单轴移动编辑轴
          currentAxisData.axisObject[i] = yield (_a = player.Native) === null || _a === void 0
            ? void 0
            : _a.Axis.createEditAxis(axisType)
          const tmpPs = yield (_b = player.Native) === null || _b === void 0
            ? void 0
            : _b.Axis.properties(currentAxisData.axisObject[i])
          // 轴的风格属性,0:箭头风格;1:圆锥风格
          tmpPs.style =
            (currentAxisStyle === null || currentAxisStyle === void 0
              ? void 0
              : currentAxisStyle.axisStyle) || tmpPs.style
          tmpPs.position =
            (currentAxisStyle === null || currentAxisStyle === void 0
              ? void 0
              : currentAxisStyle.position) || tmpPs.position
          tmpPs.dir =
            (currentAxisStyle === null || currentAxisStyle === void 0
              ? void 0
              : currentAxisStyle.dir) || tmpPs.dir
          tmpPs.transform =
            (currentAxisStyle === null || currentAxisStyle === void 0
              ? void 0
              : currentAxisStyle.transform) || tmpPs.transform
          ;(_c = player.Native) === null || _c === void 0
            ? void 0
            : _c.Axis.setProperties(currentAxisData.axisObject[i], tmpPs)
        }
      }
      axisObjs.push(currentAxisData)
      if (!isAxisEdtingConnection) {
        ;(_d = player.Native) === null || _d === void 0
          ? void 0
          : _d.Axis.EventAxisEditting.connect(onEditting)
        isAxisEdtingConnection = true
      }
      return {
        status: true,
        data: {
          id: currentAxisData.id,
        },
        message: '创建成功',
      }
    })
  /**
   * @description: 更新轴的位置
   * @param {IPlayer} player
   * @param {number} axisIndex
   * @param {IAxisConfig} options
   * @return {*}
   */
  const updateAxis = (player, id, options) =>
    __awaiter$1(void 0, void 0, void 0, function*() {
      var _e, _f
      if (!checkPlayerLoad(player)) {
        return {
          status: true,
          message: 'player无效',
        }
      }
      const currentAxis = axisObjs.find((item) => {
        return item.id === id
      })
      if ((options === null || options === void 0 ? void 0 : options.axisNum) && currentAxis) {
        for (
          let i = 0;
          i < (options === null || options === void 0 ? void 0 : options.axisNum);
          i += 1
        ) {
          const currentAxisStyle = (options === null || options === void 0
          ? void 0
          : options.axisConfigList)
            ? (options === null || options === void 0 ? void 0 : options.axisConfigList[i]) || {}
            : {}
          const tmpPs = yield (_e = player.Native) === null || _e === void 0
            ? void 0
            : _e.Axis.properties(currentAxis.axisObject[i])
          // 轴的风格属性,0:箭头风格;1:圆锥风格
          tmpPs.style =
            (currentAxisStyle === null || currentAxisStyle === void 0
              ? void 0
              : currentAxisStyle.axisStyle) || tmpPs.style
          tmpPs.position =
            (currentAxisStyle === null || currentAxisStyle === void 0
              ? void 0
              : currentAxisStyle.position) || tmpPs.position
          tmpPs.dir =
            (currentAxisStyle === null || currentAxisStyle === void 0
              ? void 0
              : currentAxisStyle.dir) || tmpPs.dir
          tmpPs.transform =
            (currentAxisStyle === null || currentAxisStyle === void 0
              ? void 0
              : currentAxisStyle.transform) || tmpPs.transform
          ;(_f = player.Native) === null || _f === void 0
            ? void 0
            : _f.Axis.setProperties(currentAxis.axisObject[i], tmpPs)
        }
        return {
          status: true,
          message: '更新成功',
        }
      } else {
        return {
          status: false,
          message: '当前轴不存在',
        }
      }
    })
  const destoryAxis = (player, id) => {
    var _a, _b
    if (!checkPlayerLoad(player)) {
      return {
        status: true,
        message: 'player无效',
      }
    }
    const currentAxisIndex = axisObjs.findIndex((item) => {
      return item.id === id
    })
    if (currentAxisIndex !== -1) {
      ;(_a = player.Native) === null || _a === void 0 ? void 0 : _a.Axis.destroyAllEditAxis()
      axisObjs.splice(currentAxisIndex, 1)
      if (axisObjs.length === 0 && isAxisEdtingConnection) {
        ;(_b = player.Native) === null || _b === void 0
          ? void 0
          : _b.Axis.EventAxisEditting.disconnect(onEditting)
        isAxisEdtingConnection = false
      }
      return {
        status: true,
        message: '销毁成功',
      }
    } else {
      return {
        status: false,
        message: '当前轴不存在',
      }
    }
  }
  /**
   * @description: 查找当前轴的序号
   * @param {string} id
   * @param {number} axis
   * @return {*}
   */
  const findAxisIndex = (id, axis) => {
    const currentIndex = axisObjs.findIndex((el) => {
      return el.id === id
    })
    if (currentIndex !== -1) {
      const axisIndex = axisObjs[currentIndex].axisObject.findIndex((el) => {
        return el === axis
      })
      if (axisIndex === -1)
        return {
          status: false,
          message: '未在当前id下找到相应的轴',
        }
      return {
        status: true,
        message: '',
        data: axisIndex,
      }
    }
    return {
      status: false,
      message: '当前id未创建轴',
    }
  }
  const setAxisVisible = (player, id, visible) =>
    __awaiter$1(void 0, void 0, void 0, function*() {
      var _g
      if (!checkPlayerLoad(player)) {
        return {
          status: true,
          message: 'player无效',
        }
      }
      const currentIndex = axisObjs.findIndex((el) => {
        return el.id === id
      })
      if (currentIndex !== -1) {
        for (let i = 0; i < axisObjs[currentIndex].axisObject.length; i++) {
          const element = axisObjs[currentIndex].axisObject[i]
          yield (_g = player.Native) === null || _g === void 0
            ? void 0
            : _g.Axis.setProperties(element, {
                visible: visible,
              })
        }
        return {
          status: true,
          message: '更新成功',
        }
      }
      return {
        status: false,
        message: '当前id未创建轴',
      }
    })
  const Axis = { createAxis, destoryAxis, updateAxis, findAxisIndex, setAxisVisible }

  /*
   * @Author: fengxiaojing
   * @LastEditTime: 2023-11-02 17:24:27
   * @Description: 剖切相关
   * @LastEditors: fengxiaojing
   */
  let currentAxisId = ''
  let clipObj = 0
  let publicPlayer = {}
  let publicClipType = EClipType.box
  let drawPloygonEndFun = () => {}
  let VerticesData = []
  let ploygonClipData = {}
  let startOption = {}
  const dealAxisData = (e) =>
    __awaiter$1(void 0, void 0, void 0, function*() {
      var _a, _b, _c, _d, _e
      // 更新轴和面
      const currentData = e.detail.data
      let axisOptions = {}
      let currentAxisIndex = -1
      let aabb = []
      switch (publicClipType) {
        case EClipType.box:
          const axisIndexRes = yield Axis.findAxisIndex(currentAxisId, currentData.data.axisObject)
          if (axisIndexRes && axisIndexRes.status) {
            currentAxisIndex = (_a = axisIndexRes.data) !== null && _a !== void 0 ? _a : -1
          }
          if (currentAxisIndex === -1) return
          yield (_b = publicPlayer.Native) === null || _b === void 0
            ? void 0
            : _b.ClipBox.clipBoxMovePanel(
                clipObj,
                currentData.data.relativeOffset,
                currentAxisIndex
              )
          // 包围盒固定为6个面
          axisOptions.axisNum = 6
          for (let i = 0; i < 6; i += 1) {
            let axisStyle = {}
            // 计算轴的位置
            axisStyle = yield computedAxisStyle(clipObj, i)
            if (
              axisOptions === null || axisOptions === void 0 ? void 0 : axisOptions.axisConfigList
            ) {
              axisOptions.axisConfigList[i] = axisStyle
            } else {
              axisOptions.axisConfigList = []
              axisOptions.axisConfigList[i] = axisStyle
            }
          }
          const aabbRes = yield getClipAabb(publicPlayer)
          if (aabbRes && aabbRes.status) {
            aabb = (_c = aabbRes.data) !== null && _c !== void 0 ? _c : []
          }
          break
        case EClipType.singlePanel:
        case EClipType.doublePanel:
        case EClipType.ThreePanel:
          yield (_d = publicPlayer.Native) === null || _d === void 0
            ? void 0
            : _d.NodeProxy.move(clipObj, currentData.data.relativeOffset)
          axisOptions.axisNum = 1
          axisOptions.axisConfigList = [
            {
              transform: yield computedTransform(publicPlayer, clipObj),
            },
          ]
          break
      }
      // 获取剖切数据
      const clipData = yield (_e = publicPlayer.Native) === null || _e === void 0
        ? void 0
        : _e.ClipBox.clipData()
      Axis.updateAxis(publicPlayer, currentAxisId, axisOptions)
      sendEvent(
        {
          message: '',
          status: true,
          data: {
            type: 'Clip',
            currentState: 0,
            data: {
              clipData,
              Aabb: aabb,
            },
          },
        },
        'Clip'
      )
    })
  /**
   * @description: 创建剖切盒子
   * @param {*}
   * @return {*}
   */
  const createCilpBox = (player, currentItem) =>
    __awaiter$1(void 0, void 0, void 0, function*() {
      var _f, _g, _h
      const itemAabbData = yield (_f = player.Native) === null || _f === void 0
        ? void 0
        : _f.ModelTree.calcItemAabbData(currentItem)
      // 计算剖切的旋转矩阵
      yield (_g = player.Native) === null || _g === void 0
        ? void 0
        : _g.ClipBox.setGisMatrix(clipObj, itemAabbData.localMatrix)
      ;(_h = player.Native) === null || _h === void 0
        ? void 0
        : _h.ClipBox.clipBoxInitByAabb(clipObj, itemAabbData.localAabb)
    })
  const createCilpBoxByNode = (player, currentNode) =>
    __awaiter$1(void 0, void 0, void 0, function*() {
      var _j, _k, _l, _m
      const itemAabbData = yield (_j = player.Native) === null || _j === void 0
        ? void 0
        : _j.NodeProxy.getAabb(currentNode)
      const localMatrix = yield (_k = player.Native) === null || _k === void 0
        ? void 0
        : _k.NodeProxy.getNodeMatrix(currentNode)
      // 计算剖切的旋转矩阵
      yield (_l = player.Native) === null || _l === void 0
        ? void 0
        : _l.ClipBox.setGisMatrix(clipObj, localMatrix)
      ;(_m = player.Native) === null || _m === void 0
        ? void 0
        : _m.ClipBox.clipBoxInitByAabb(clipObj, itemAabbData)
    })
  /**
   * @description: 计算当前锚点与视角
   * @param {IPlayer} player
   * @param {string} modelId
   * @return {*}
   */
  const computedPanelInitPoints = (player, nodePtr) =>
    __awaiter$1(void 0, void 0, void 0, function*() {
      var _o, _p, _q, _r, _s
      let { eye: cameraEye } = yield (_o = player.Native) === null || _o === void 0
        ? void 0
        : _o.Camera.currentParam()
      let anchorPosition = yield (_p = player.Native) === null || _p === void 0
        ? void 0
        : _p.Camera.getAnchorPos()
      // 获取模型在地球上的位置
      const nodePos = yield (_q = player.Native) === null || _q === void 0
        ? void 0
        : _q.NodeProxy.nodeGisPos(nodePtr)
      if (nodePos.length > 0) {
        // 获取当前位置的旋转矩阵
        const gisTransform = yield (_r = player.Native) === null || _r === void 0
          ? void 0
          : _r.GisPlatform.makeGisTransform(nodePos)
        const gisTransformInv = Matrix4.inverse(gisTransform)
        // 计算出当前视角+锚点位置相对原点所做的旋转
        cameraEye = Matrix4.multiplyPos(gisTransformInv, cameraEye)
        anchorPosition = Matrix4.multiplyPos(gisTransformInv, anchorPosition)
        yield (_s = player.Native) === null || _s === void 0
          ? void 0
          : _s.ClipBox.setGisMatrix(clipObj, gisTransform)
      }
      return {
        anchorPosition,
        cameraEye,
      }
    })
  const computedTransform = (player, clipNode) =>
    __awaiter$1(void 0, void 0, void 0, function*() {
      var _t
      const clipObjMat = yield (_t = player.Native) === null || _t === void 0
        ? void 0
        : _t.NodeProxy.getNodeMatrix(clipNode)
      return clipObjMat
    })
  const computedAxisStyle = (clipObj, index) =>
    __awaiter$1(void 0, void 0, void 0, function*() {
      var _u
      const axisStyle = {}
      const tmpTR = yield (_u = publicPlayer.Native) === null || _u === void 0
        ? void 0
        : _u.ClipBox.clipBoxPanelTRMatrix(clipObj, index)
      const d = Matrix4.decompose(tmpTR)
      axisStyle.position = d.position
      axisStyle.dir = Matrix4.multiplyDir(d.rotation, [0, 0, 1])
      axisStyle.axisStyle = IAxisStyle.cone
      return axisStyle
    })
  /**
   * @description: 开启剖切 [废弃]
   * @param {IPlayer} player
   * @param {string} modelId 模型id 对哪个模型进行剖切
   * @param {EClipType} clipType 剖切类型
   * @param {IClipOption} options 剖切的可选参数
   * @return {*}
   */
  function setCilp(player, modelId, clipType, options) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y
    return __awaiter$1(this, void 0, void 0, function*() {
      if (!checkPlayerLoad(player)) {
        return {
          status: false,
          message: 'player无效',
        }
      }
      yield cancelClip(player)
      // 获取当前点选的对象
      const selectInfo = yield Node$1.getSelectedItem(player)
      let currentItem = 0
      const axisOptions = {
        axisNum: 0,
        axisConfigList: [],
      }
      if (selectInfo.status && selectInfo.data && selectInfo.data.item) {
        currentItem = selectInfo.data.item
      } else {
        // 未选择模型时，获取整个模型的item
        const modelInfo = yield (_a = player.Native) === null || _a === void 0
          ? void 0
          : _a.Model.getInfo(modelId)
        currentItem = modelInfo.treeItem
      }
      // 设置默认值，面剖切默认使用移动编辑轴， 盒子剖切默认使用单轴移动轴
      options = {
        axisType:
          (options === null || options === void 0 ? void 0 : options.axisType) ||
          EClipType.box === clipType
            ? IAxisType.EditAxisTypeSingleMove
            : IAxisType.EditAxisTypeMove,
        setIsInside:
          (_b = options === null || options === void 0 ? void 0 : options.setIsInside) !== null &&
          _b !== void 0
            ? _b
            : true,
        setPartCilp:
          (_c = options === null || options === void 0 ? void 0 : options.setPartCilp) !== null &&
          _c !== void 0
            ? _c
            : false,
        panelSize: (options === null || options === void 0 ? void 0 : options.panelSize) || [
          2,
          2,
          2,
        ],
        clipData: (options === null || options === void 0 ? void 0 : options.clipData) || undefined,
      }
      {
        window.addEventListener('Axis', dealAxisData)
      }
      publicPlayer = player
      publicClipType = clipType
      // 是否启用局部剖切
      if (options.setPartCilp) {
        yield (_d = player.Native) === null || _d === void 0
          ? void 0
          : _d.ClipBox.setLocalEnabled(currentItem)
      } else {
        yield (_e = player.Native) === null || _e === void 0
          ? void 0
          : _e.ClipBox.setLocalDisabled()
      }
      // 创建剖切对象
      switch (clipType) {
        case EClipType.box:
          // 盒子剖切
          clipObj = yield (_f = player.Native) === null || _f === void 0
            ? void 0
            : _f.ClipBox.activeClipBox()
          // 根据剖切数据初始化
          if (options.clipData) {
            // 设置剖切数据
            yield (_g = player.Native) === null || _g === void 0
              ? void 0
              : _g.ClipBox.clipObjectInitByClipData(clipObj, options.clipData, options.panelSize)
          } else {
            // 创建剖切盒子
            yield createCilpBox(player, currentItem)
          }
          // 包围盒固定为6个面
          axisOptions.axisNum = 6
          for (let i = 0; i < 6; i += 1) {
            let axisStyle = {}
            // 计算轴的位置
            axisStyle = yield computedAxisStyle(clipObj, i)
            if (
              axisOptions === null || axisOptions === void 0 ? void 0 : axisOptions.axisConfigList
            ) {
              axisOptions.axisConfigList[i] = axisStyle
            } else {
              axisOptions.axisConfigList = []
              axisOptions.axisConfigList[i] = axisStyle
            }
          }
          break
        case EClipType.singlePanel:
          // 单面剖切
          clipObj = yield (_h = player.Native) === null || _h === void 0
            ? void 0
            : _h.ClipBox.activeClipPanel()
          // 根据剖切数据初始化
          if (options.clipData) {
            // 设置剖切数据
            yield (_j = player.Native) === null || _j === void 0
              ? void 0
              : _j.ClipBox.clipObjectInitByClipData(clipObj, options.clipData, options.panelSize)
          } else {
            const modelInfo = yield (_k = player.Native) === null || _k === void 0
              ? void 0
              : _k.Model.getInfo(modelId)
            const panelInitData = yield computedPanelInitPoints(player, modelInfo.nodePtr)
            ;(_l = player.Native) === null || _l === void 0
              ? void 0
              : _l.ClipBox.clipPanelInitByPoint(
                  clipObj,
                  panelInitData.anchorPosition,
                  panelInitData.cameraEye,
                  options.panelSize
                )
          }
          axisOptions.axisNum = 1
          axisOptions.axisConfigList = [
            {
              transform: yield computedTransform(player, clipObj),
            },
          ]
          break
        case EClipType.doublePanel:
          // 双面剖切
          clipObj = yield (_m = player.Native) === null || _m === void 0
            ? void 0
            : _m.ClipBox.activeClipTwoPanel()
          // 根据剖切数据初始化
          if (options.clipData) {
            // 设置剖切数据
            yield (_o = player.Native) === null || _o === void 0
              ? void 0
              : _o.ClipBox.clipObjectInitByClipData(clipObj, options.clipData, options.panelSize)
          } else {
            const modelInfo = yield (_p = player.Native) === null || _p === void 0
              ? void 0
              : _p.Model.getInfo(modelId)
            const twoPanelInitData = yield computedPanelInitPoints(player, modelInfo.nodePtr)
            ;(_q = player.Native) === null || _q === void 0
              ? void 0
              : _q.ClipBox.clipTwoPanelInitByPoints(
                  clipObj,
                  twoPanelInitData.anchorPosition,
                  twoPanelInitData.cameraEye,
                  options.panelSize
                )
          }
          axisOptions.axisNum = 1
          axisOptions.axisConfigList = [
            {
              transform: yield computedTransform(player, clipObj),
            },
          ]
          break
        case EClipType.ThreePanel:
          // 三面剖切
          clipObj = yield (_r = player.Native) === null || _r === void 0
            ? void 0
            : _r.ClipBox.activeClipThreePanel()
          // 根据剖切数据初始化
          if (options.clipData) {
            // 设置剖切数据
            yield (_s = player.Native) === null || _s === void 0
              ? void 0
              : _s.ClipBox.clipObjectInitByClipData(clipObj, options.clipData, options.panelSize)
          } else {
            const modelInfo = yield (_t = player.Native) === null || _t === void 0
              ? void 0
              : _t.Model.getInfo(modelId)
            const threePanelInitData = yield computedPanelInitPoints(player, modelInfo.nodePtr)
            ;(_u = player.Native) === null || _u === void 0
              ? void 0
              : _u.ClipBox.clipThreePanelInitByPoints(
                  clipObj,
                  threePanelInitData.anchorPosition,
                  threePanelInitData.cameraEye,
                  options.panelSize
                )
          }
          axisOptions.axisNum = 1
          axisOptions.axisConfigList = [
            {
              transform: yield computedTransform(player, clipObj),
            },
          ]
          break
      }
      // 启用剖切
      yield (_v = player.Native) === null || _v === void 0 ? void 0 : _v.ClipBox.setEnabled(true)
      // 是否启用内剖切
      yield (_w = player.Native) === null || _w === void 0
        ? void 0
        : _w.ClipBox.setIsInside(options.setIsInside)
      yield (_x = player.Native) === null || _x === void 0
        ? void 0
        : _x.ClipBox.clipObjectSetVisible(clipObj, true)
      // 创建编辑轴
      const axisData = yield Axis.createAxis(player, options.axisType, clipObj, axisOptions)
      if (axisData.status && axisData.data) {
        currentAxisId = (_y = axisData.data) === null || _y === void 0 ? void 0 : _y.id
      }
      return {
        message: '创建剖切成功',
        status: true,
      }
    })
  }
  /** 创建剖切 */
  function createCilp(player, clipDataType, clipType, options) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l
    return __awaiter$1(this, void 0, void 0, function*() {
      if (!checkPlayerLoad(player)) {
        return {
          status: false,
          message: 'player无效',
        }
      }
      yield cancelClip(player)
      let currentItem = 0
      let currentNode = 0
      let currentAabb = []
      let currentClipData = null
      // 获取当前需要剖切的对象
      switch (clipDataType) {
        case EClipDataType.aabb:
          // 通过aabb创建剖切
          if (
            !(options === null || options === void 0 ? void 0 : options.aabb) ||
            ((_a = options === null || options === void 0 ? void 0 : options.aabb) === null ||
            _a === void 0
              ? void 0
              : _a.length) < 2
          ) {
            return {
              status: false,
              message: 'options中未传入aabb, 或aabb不符合规范',
            }
          }
          if (clipType !== EClipType.box) {
            return {
              status: false,
              message: '通过aabb剖切时需要指定为盒子剖切',
            }
          }
          if (options === null || options === void 0 ? void 0 : options.setPartCilp) {
            return {
              status: false,
              message: '通过aabb剖切时需要为全局剖切',
            }
          }
          currentAabb = options.aabb
          break
        case EClipDataType.model:
          // 通过modelId创建剖切
          if (!(options === null || options === void 0 ? void 0 : options.modelId)) {
            return {
              status: false,
              message: 'options中未传入modelId',
            }
          }
          const modelInfo = yield (_b = player.Native) === null || _b === void 0
            ? void 0
            : _b.Model.getInfo(options === null || options === void 0 ? void 0 : options.modelId)
          currentItem = modelInfo.treeItem
          break
        case EClipDataType.node:
          // 通过node创建剖切
          if (!(options === null || options === void 0 ? void 0 : options.node)) {
            return {
              status: false,
              message: 'options中未传入node',
            }
          }
          if (options === null || options === void 0 ? void 0 : options.setPartCilp) {
            return {
              status: false,
              message: '通过node剖切时需要为全局剖切',
            }
          }
          const nodeInfo = yield (_c = player.Native) === null || _c === void 0
            ? void 0
            : _c.NodeProxy.getNodeInfo(
                options === null || options === void 0 ? void 0 : options.node
              )
          currentNode = nodeInfo.nodePtr
          break
        case EClipDataType.item:
          // 通过item创建剖切
          if (!(options === null || options === void 0 ? void 0 : options.item)) {
            return {
              status: false,
              message: 'options中未传入item',
            }
          }
          currentItem = options === null || options === void 0 ? void 0 : options.item
          break
        case EClipDataType.clipData:
          // 通过clipData创建剖切
          if (!(options === null || options === void 0 ? void 0 : options.clipData)) {
            return {
              status: false,
              message: 'options中未传入clipData',
            }
          }
          currentClipData = options === null || options === void 0 ? void 0 : options.clipData
          break
        default:
          return {
            status: false,
            message: '当前剖切数据类型不支持',
          }
      }
      // 设置默认值，面剖切默认使用移动编辑轴， 盒子剖切默认使用单轴移动轴
      options = {
        axisType:
          (options === null || options === void 0 ? void 0 : options.axisType) ||
          EClipType.box === clipType
            ? IAxisType.EditAxisTypeSingleMove
            : IAxisType.EditAxisTypeMove,
        setIsInside:
          (_d = options === null || options === void 0 ? void 0 : options.setIsInside) !== null &&
          _d !== void 0
            ? _d
            : true,
        setPartCilp:
          (_e = options === null || options === void 0 ? void 0 : options.setPartCilp) !== null &&
          _e !== void 0
            ? _e
            : false,
        panelSize: (options === null || options === void 0 ? void 0 : options.panelSize) || [
          2,
          2,
          2,
        ],
        item: currentItem,
        node: currentNode,
        aabb: currentAabb,
        clipData: currentClipData || undefined,
      }
      {
        window.addEventListener('Axis', dealAxisData)
      }
      publicPlayer = player
      publicClipType = clipType
      // 是否启用局部剖切
      if (options.setPartCilp) {
        yield (_f = player.Native) === null || _f === void 0
          ? void 0
          : _f.ClipBox.setLocalEnabled(currentItem)
      } else {
        yield (_g = player.Native) === null || _g === void 0
          ? void 0
          : _g.ClipBox.setLocalDisabled()
      }
      const { data } = yield createClipObject(player, clipType, options)
      if (!data) {
        return {
          status: false,
          message: '系统错误',
        }
      }
      // 启用剖切
      yield (_h = player.Native) === null || _h === void 0 ? void 0 : _h.ClipBox.setEnabled(true)
      // 是否启用内剖切
      yield (_j = player.Native) === null || _j === void 0
        ? void 0
        : _j.ClipBox.setIsInside(options.setIsInside)
      yield (_k = player.Native) === null || _k === void 0
        ? void 0
        : _k.ClipBox.clipObjectSetVisible(clipObj, true)
      // 创建编辑轴
      const axisData = yield Axis.createAxis(player, options.axisType, clipObj, data)
      if (axisData.status && axisData.data) {
        currentAxisId = (_l = axisData.data) === null || _l === void 0 ? void 0 : _l.id
      }
      return {
        message: '创建剖切成功',
        status: true,
      }
    })
  }
  /** 根据不同的剖切类型创建不同剖切对象 */
  function createClipObject(player, clipType, options) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r
    return __awaiter$1(this, void 0, void 0, function*() {
      const axisOptions = {
        axisNum: 0,
        axisConfigList: [],
      }
      // 创建剖切对象
      switch (clipType) {
        case EClipType.box:
          // 盒子剖切
          clipObj = yield (_a = player.Native) === null || _a === void 0
            ? void 0
            : _a.ClipBox.activeClipBox()
          // 根据剖切数据初始化
          if (options.clipData) {
            // 设置剖切数据
            yield (_b = player.Native) === null || _b === void 0
              ? void 0
              : _b.ClipBox.clipObjectInitByClipData(clipObj, options.clipData, options.panelSize)
          } else if (
            options.aabb &&
            ((_c = options.aabb) === null || _c === void 0 ? void 0 : _c.length) === 2
          ) {
            yield (_d = player.Native) === null || _d === void 0
              ? void 0
              : _d.ClipBox.clipBoxInitByAabb(clipObj, options.aabb)
          } else if (options.item) {
            // 创建剖切盒子
            yield createCilpBox(player, options.item)
          } else if (options.node) {
            yield createCilpBoxByNode(player, options.node)
          }
          // 包围盒固定为6个面
          axisOptions.axisNum = 6
          for (let i = 0; i < 6; i += 1) {
            let axisStyle = {}
            // 计算轴的位置
            axisStyle = yield computedAxisStyle(clipObj, i)
            if (
              axisOptions === null || axisOptions === void 0 ? void 0 : axisOptions.axisConfigList
            ) {
              axisOptions.axisConfigList[i] = axisStyle
            } else {
              axisOptions.axisConfigList = []
              axisOptions.axisConfigList[i] = axisStyle
            }
          }
          break
        case EClipType.singlePanel:
          // 单面剖切
          clipObj = yield (_e = player.Native) === null || _e === void 0
            ? void 0
            : _e.ClipBox.activeClipPanel()
          // 根据剖切数据初始化
          if (options.clipData) {
            // 设置剖切数据
            yield (_f = player.Native) === null || _f === void 0
              ? void 0
              : _f.ClipBox.clipObjectInitByClipData(clipObj, options.clipData, options.panelSize)
          } else {
            if (!options.item) {
              return {
                status: false,
              }
            }
            const nodeptr =
              (_g = player.Native) === null || _g === void 0
                ? void 0
                : _g.ModelTree.convertToNode(options.item, false)
            const panelInitData = yield computedPanelInitPoints(player, nodeptr)
            ;(_h = player.Native) === null || _h === void 0
              ? void 0
              : _h.ClipBox.clipPanelInitByPoint(
                  clipObj,
                  panelInitData.anchorPosition,
                  panelInitData.cameraEye,
                  options.panelSize
                )
          }
          axisOptions.axisNum = 1
          axisOptions.axisConfigList = [
            {
              transform: yield computedTransform(player, clipObj),
            },
          ]
          break
        case EClipType.doublePanel:
          // 双面剖切
          clipObj = yield (_j = player.Native) === null || _j === void 0
            ? void 0
            : _j.ClipBox.activeClipTwoPanel()
          // 根据剖切数据初始化
          if (options.clipData) {
            // 设置剖切数据
            yield (_k = player.Native) === null || _k === void 0
              ? void 0
              : _k.ClipBox.clipObjectInitByClipData(clipObj, options.clipData, options.panelSize)
          } else {
            if (!options.item) {
              return {
                status: false,
              }
            }
            const nodeptr =
              (_l = player.Native) === null || _l === void 0
                ? void 0
                : _l.ModelTree.convertToNode(options.item, false)
            const twoPanelInitData = yield computedPanelInitPoints(player, nodeptr)
            ;(_m = player.Native) === null || _m === void 0
              ? void 0
              : _m.ClipBox.clipTwoPanelInitByPoints(
                  clipObj,
                  twoPanelInitData.anchorPosition,
                  twoPanelInitData.cameraEye,
                  options.panelSize
                )
          }
          axisOptions.axisNum = 1
          axisOptions.axisConfigList = [
            {
              transform: yield computedTransform(player, clipObj),
            },
          ]
          break
        case EClipType.ThreePanel:
          // 三面剖切
          clipObj = yield (_o = player.Native) === null || _o === void 0
            ? void 0
            : _o.ClipBox.activeClipThreePanel()
          // 根据剖切数据初始化
          if (options.clipData) {
            // 设置剖切数据
            yield (_p = player.Native) === null || _p === void 0
              ? void 0
              : _p.ClipBox.clipObjectInitByClipData(clipObj, options.clipData, options.panelSize)
          } else {
            if (!options.item) {
              return {
                status: false,
              }
            }
            const nodeptr =
              (_q = player.Native) === null || _q === void 0
                ? void 0
                : _q.ModelTree.convertToNode(options.item, false)
            const threePanelInitData = yield computedPanelInitPoints(player, nodeptr)
            ;(_r = player.Native) === null || _r === void 0
              ? void 0
              : _r.ClipBox.clipThreePanelInitByPoints(
                  clipObj,
                  threePanelInitData.anchorPosition,
                  threePanelInitData.cameraEye,
                  options.panelSize
                )
          }
          axisOptions.axisNum = 1
          axisOptions.axisConfigList = [
            {
              transform: yield computedTransform(player, clipObj),
            },
          ]
          break
      }
      return {
        status: true,
        data: axisOptions,
      }
    })
  }
  /** 通过剖切盒子更新剖切数据 */
  function updateClipDataByAabb(player, aabb) {
    var _a
    return __awaiter$1(this, void 0, void 0, function*() {
      let axisOptions = {}
      if (publicClipType !== EClipType.box) {
        return {
          status: false,
          mesaage: '通过aabb构造时，需要使用盒子剖切',
        }
      }
      // 获取当前剖切对象的盒子, 遍历六个面获取出aabb
      const currentAabbRes = yield getClipAabb(player)
      if (currentAabbRes && currentAabbRes.status) {
        const currentAabb = currentAabbRes.data
        // 求每个面的偏移
        const panelList = ['X', 'XN', 'Y', 'YN', 'Z', 'ZN']
        for (let i = 0; i < 6; i++) {
          const afterPanel = Aabb.faceCenter(currentAabb, panelList[i])
          const beforePanel = Aabb.faceCenter(aabb, panelList[i])
          let relativeOffset = Vec3.sub(beforePanel, afterPanel)
          switch (panelList[i]) {
            case 'X':
            case 'XN':
              relativeOffset = [relativeOffset[0], 0, 0]
              break
            case 'Y':
            case 'YN':
              relativeOffset = [0, relativeOffset[1], 0]
              break
            case 'Z':
            case 'ZN':
              relativeOffset = [0, 0, relativeOffset[2]]
              break
          }
          yield (_a = player.Native) === null || _a === void 0
            ? void 0
            : _a.ClipBox.clipBoxMovePanel(clipObj, relativeOffset, i)
        }
        // 包围盒固定为6个面
        axisOptions.axisNum = 6
        for (let i = 0; i < 6; i += 1) {
          let axisStyle = {}
          // 计算轴的位置
          axisStyle = yield computedAxisStyle(clipObj, i)
          if (
            axisOptions === null || axisOptions === void 0 ? void 0 : axisOptions.axisConfigList
          ) {
            axisOptions.axisConfigList[i] = axisStyle
          } else {
            axisOptions.axisConfigList = []
            axisOptions.axisConfigList[i] = axisStyle
          }
        }
        Axis.updateAxis(player, currentAxisId, axisOptions)
      }
      return {
        status: false,
        message: '获取包围盒错误',
      }
    })
  }
  /** 获取剖切的包围盒 */
  function getClipAabb(player) {
    var _a, _b
    return __awaiter$1(this, void 0, void 0, function*() {
      if (!checkPlayerLoad(player))
        return {
          status: false,
          message: 'player无效',
        }
      let min = [Infinity, Infinity, Infinity]
      let max = [-Infinity, -Infinity, -Infinity]
      // 上顶面
      const upVertices = yield (_a = player.Native) === null || _a === void 0
        ? void 0
        : _a.ClipBox.clipBoxPanelVertices(clipObj, 4)
      // 下底面
      const downVertices = yield (_b = player.Native) === null || _b === void 0
        ? void 0
        : _b.ClipBox.clipBoxPanelVertices(clipObj, 5)
      for (let i = 0; i < upVertices.length; i++) {
        const upPoint = upVertices[i]
        if (upPoint[0] < min[0] || upPoint[1] < min[1] || upPoint[2] < min[2]) {
          min = upPoint
        }
        if (upPoint[0] > max[0] || upPoint[1] > max[1] || upPoint[2] > max[2]) {
          max = upPoint
        }
      }
      for (let i = 0; i < downVertices.length; i++) {
        const downPoint = downVertices[i]
        if (downPoint[0] < min[0] || downPoint[1] < min[1] || downPoint[2] < min[2]) {
          min = downPoint
        }
        if (downPoint[0] > max[0] || downPoint[1] > max[1] || downPoint[2] > max[2]) {
          max = downPoint
        }
      }
      return {
        status: true,
        data: [min, max],
      }
    })
  }
  /**
   * @description: 取消剖切
   * @param {*}
   * @return {*}
   */
  function cancelClip(player) {
    var _a, _b
    return __awaiter$1(this, void 0, void 0, function*() {
      // 取消激活剖切对象
      yield (_a = player.Native) === null || _a === void 0 ? void 0 : _a.ClipBox.setEnabled(false)
      yield (_b = player.Native) === null || _b === void 0
        ? void 0
        : _b.ClipBox.inactiveClipObject()
      yield Axis.destoryAxis(player, currentAxisId)
    })
  }
  /**
   * @description: 获取剖切的数据
   * @param {IPlayer} player
   * @return {*}
   */
  function getClipData(player) {
    var _a
    return __awaiter$1(this, void 0, void 0, function*() {
      if (!checkPlayerLoad(player)) {
        return {
          status: false,
          message: 'player无效',
        }
      }
      const clipData = yield (_a = player.Native) === null || _a === void 0
        ? void 0
        : _a.ClipBox.clipData()
      return {
        data: clipData,
        status: true,
        message: '',
      }
    })
  }
  /**
   * @description: 设置轴或面的可见性
   * @param {IPlayer} player
   * @param {ClipElement} clipElement 剖切元素 Axis 或 Panel
   * @param {boolean} visible 是否可见
   * @return {*}
   */
  function setVisible(player, clipElement, visible) {
    var _a
    return __awaiter$1(this, void 0, void 0, function*() {
      if (!checkPlayerLoad(player)) {
        return {
          status: true,
          message: 'player无效',
        }
      }
      let res = {
        status: false,
        message: '',
      }
      switch (clipElement) {
        case 'Axis':
          res = yield Axis.setAxisVisible(player, currentAxisId, visible)
          break
        case 'Panel':
          yield (_a = player.Native) === null || _a === void 0
            ? void 0
            : _a.ClipBox.clipObjectSetVisible(clipObj, visible)
          res = {
            status: true,
            message: '更新成功',
          }
          break
        default:
          res = {
            status: false,
            message: "clipElement传值错误，当前仅支持存入'Axis'、'Panel'",
          }
          break
      }
      return res
    })
  }
  /**
   * @description: 鼠标右键的点击事件
   * @param {any} e
   * @return {*}
   */
  function clickBrowseRClick(player) {
    drawPloygonEndFun = (e) =>
      __awaiter$1(this, void 0, void 0, function*() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o
        yield (_a = player.Native) === null || _a === void 0
          ? void 0
          : _a.ClipBox.clipObjectSetVisible(clipObj, true)
        yield (_b = player.Native) === null || _b === void 0 ? void 0 : _b.ClipBox.setEnabled(true)
        VerticesData = yield (_c = player.Native) === null || _c === void 0
          ? void 0
          : _c.ClipBox.clipPolygonInit(
              clipObj,
              (_d =
                startOption === null || startOption === void 0 ? void 0 : startOption.height) !==
                null && _d !== void 0
                ? _d
                : 1,
              (_e = startOption === null || startOption === void 0 ? void 0 : startOption.ratio) !==
                null && _e !== void 0
                ? _e
                : 0
            )
        yield (_f = player.Native) === null || _f === void 0
          ? void 0
          : _f.ClipBox.setSideTexture(clipObj, 'data://icon/side.jpg')
        yield (_g = player.Native) === null || _g === void 0
          ? void 0
          : _g.ClipBox.setBottomTexture(clipObj, 'data://icon/bottom.jpg')
        yield (_h = player.Native) === null || _h === void 0 ? void 0 : _h.ClipBox.endDrawPloygon()
        // 获取上顶面数据
        const upPanel = yield (_j = player.Native) === null || _j === void 0
          ? void 0
          : _j.ClipBox.clipBoxPanelVertices(clipObj, VerticesData.length - 1)
        // 获取上底面数据
        const downPanel = yield (_k = player.Native) === null || _k === void 0
          ? void 0
          : _k.ClipBox.clipBoxPanelVertices(clipObj, VerticesData.length)
        ploygonClipData = {
          VerticesData,
          height:
            (_l = startOption === null || startOption === void 0 ? void 0 : startOption.height) !==
              null && _l !== void 0
              ? _l
              : 1,
          ratio:
            (_m = startOption === null || startOption === void 0 ? void 0 : startOption.ratio) !==
              null && _m !== void 0
              ? _m
              : 0,
          upPanel,
          downPanel,
        }
        ;(_o = player.Native) === null || _o === void 0
          ? void 0
          : _o.ModelTree.EventBrowseRClick.disconnect(drawPloygonEndFun)
        sendEvent(
          {
            message: '剖切完成',
            status: true,
            data: {
              type: 'Clip',
              currentState: 0,
              data: ploygonClipData,
            },
          },
          'Clip'
        )
      })
    return drawPloygonEndFun
  }
  /**
   * @description: 开启多边形创建剖切
   * @param {IPlayer} player
   * @return {*}
   */
  function startDrawPloygonClip(player, options) {
    var _a, _b, _c, _d, _e, _f
    return __awaiter$1(this, void 0, void 0, function*() {
      if (!checkPlayerLoad(player)) {
        return {
          status: false,
          message: 'player实例无效',
        }
      }
      publicPlayer = player
      yield (_a = player.Native) === null || _a === void 0
        ? void 0
        : _a.ClipBox.setIsInside(
            (_b = options === null || options === void 0 ? void 0 : options.setIsInside) !== null &&
              _b !== void 0
              ? _b
              : true
          )
      clipObj = yield (_c = player.Native) === null || _c === void 0
        ? void 0
        : _c.ClipBox.activeClipBox()
      yield (_d = player.Native) === null || _d === void 0
        ? void 0
        : _d.ClipBox.clipObjectSetVisible(clipObj, false)
      yield (_e = player.Native) === null || _e === void 0 ? void 0 : _e.ClipBox.beginDrawPloygon()
      // 监听鼠标右键事件
      startOption = options || {}
      ;(_f = player.Native) === null || _f === void 0
        ? void 0
        : _f.ModelTree.EventBrowseRClick.connect(clickBrowseRClick(player))
      return {
        status: true,
        message: '',
      }
    })
  }
  /**
   * @description: 获取当前的剖切数据
   * @return {*}
   */
  function getPloygonClipData() {
    if (clipObj && Object.values(ploygonClipData).length !== 0) {
      return {
        status: true,
        message: '',
        data: ploygonClipData,
      }
    }
    return {
      status: false,
      message: '当前无剖切数据',
    }
  }
  function setPloyonClipData(player, options) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t
    return __awaiter$1(this, void 0, void 0, function*() {
      if (!checkPlayerLoad(player)) {
        return {
          status: false,
          message: 'player实例无效',
        }
      }
      if (!clipObj) {
        yield (_a = player.Native) === null || _a === void 0 ? void 0 : _a.ClipBox.setIsInside(true)
        clipObj = yield (_b = player.Native) === null || _b === void 0
          ? void 0
          : _b.ClipBox.activeClipBox()
        yield (_c = player.Native) === null || _c === void 0
          ? void 0
          : _c.ClipBox.beginDrawPloygon()
      }
      ploygonClipData.VerticesData =
        (_d = options === null || options === void 0 ? void 0 : options.VerticesData) !== null &&
        _d !== void 0
          ? _d
          : ploygonClipData.VerticesData
      ploygonClipData.height =
        (_e = options === null || options === void 0 ? void 0 : options.height) !== null &&
        _e !== void 0
          ? _e
          : ploygonClipData.height
      ploygonClipData.ratio =
        (_f = options === null || options === void 0 ? void 0 : options.ratio) !== null &&
        _f !== void 0
          ? _f
          : ploygonClipData.ratio
      yield (_g = player.Native) === null || _g === void 0
        ? void 0
        : _g.ClipBox.clipPolygonInitByPoint(
            clipObj,
            (_h = options === null || options === void 0 ? void 0 : options.VerticesData) !==
              null && _h !== void 0
              ? _h
              : ploygonClipData.VerticesData,
            (_j = options === null || options === void 0 ? void 0 : options.height) !== null &&
              _j !== void 0
              ? _j
              : ploygonClipData.height,
            (_k = options === null || options === void 0 ? void 0 : options.ratio) !== null &&
              _k !== void 0
              ? _k
              : ploygonClipData.ratio
          )
      if (options === null || options === void 0 ? void 0 : options.offset) {
        yield (_l = player.Native) === null || _l === void 0
          ? void 0
          : _l.ClipBox.moveClipBox(clipObj, options.offset)
        // 更新顶点数据
        ploygonClipData.VerticesData =
          (_m = ploygonClipData.VerticesData) === null || _m === void 0
            ? void 0
            : _m.map((el) => {
                var _a, _b
                if (options.offset) {
                  return [
                    el[0] + options.offset[0],
                    (_a = el[1] + options.offset[1]) !== null && _a !== void 0 ? _a : 0,
                    (_b = el[2] + options.offset[2]) !== null && _b !== void 0 ? _b : 0,
                  ]
                }
                return el
              })
      }
      // 更新面数据
      // 获取上顶面数据
      ploygonClipData.upPanel = yield (_o = player.Native) === null || _o === void 0
        ? void 0
        : _o.ClipBox.clipBoxPanelVertices(clipObj, ploygonClipData.VerticesData.length - 1)
      // 获取上底面数据
      ploygonClipData.downPanel = yield (_p = player.Native) === null || _p === void 0
        ? void 0
        : _p.ClipBox.clipBoxPanelVertices(clipObj, ploygonClipData.VerticesData.length)
      yield (_q = player.Native) === null || _q === void 0
        ? void 0
        : _q.ClipBox.setSideTexture(clipObj, 'data://icon/side.jpg')
      yield (_r = player.Native) === null || _r === void 0
        ? void 0
        : _r.ClipBox.setBottomTexture(clipObj, 'data://icon/bottom.jpg')
      yield (_s = player.Native) === null || _s === void 0
        ? void 0
        : _s.ClipBox.clipObjectSetVisible(clipObj, true)
      yield (_t = player.Native) === null || _t === void 0 ? void 0 : _t.ClipBox.endDrawPloygon()
      return {
        status: true,
        message: '',
        data: ploygonClipData,
      }
    })
  }
  /**
   * @description: 取消多边形剖切
   * @param {IPlayer} player
   * @return {*}
   */
  function cancelPloygonClip(player) {
    var _a, _b, _c, _d, _e, _f
    return __awaiter$1(this, void 0, void 0, function*() {
      ;(_a = player.Native) === null || _a === void 0
        ? void 0
        : _a.ModelTree.EventBrowseRClick.disconnect(drawPloygonEndFun)
      yield (_b = player.Native) === null || _b === void 0 ? void 0 : _b.ClipBox.setEnabled(false)
      if (clipObj) {
        yield (_c = player.Native) === null || _c === void 0
          ? void 0
          : _c.ClipBox.clipObjectSetVisible(clipObj, false)
      }
      yield (_d = player.Native) === null || _d === void 0 ? void 0 : _d.ClipBox.setLocalEnabled([])
      yield (_e = player.Native) === null || _e === void 0 ? void 0 : _e.ClipBox.endDrawPloygon()
      yield (_f = player.Native) === null || _f === void 0
        ? void 0
        : _f.ClipBox.inactiveClipObject()
      ploygonClipData = {}
      clipObj = 0
    })
  }
  // 获取被剖掉的对象
  function getClipObjects(player) {
    var _a, _b
    return __awaiter$1(this, void 0, void 0, function*() {
      if (!checkPlayerLoad(player)) {
        return {
          status: false,
          message: 'player实例无效',
        }
      }
      const items = yield (_a = player.Native) === null || _a === void 0
        ? void 0
        : _a.ClipBox.localClipItems()
      const itemInfoList = []
      for (let i = 0; i < items.length; i++) {
        const itemInfo = yield (_b = player.Native) === null || _b === void 0
          ? void 0
          : _b.ModelTree.getItemInfo(items[i])
        itemInfoList.push(itemInfo)
      }
      return {
        status: true,
        message: '',
        data: itemInfoList,
      }
    })
  }
  // 设置剖切对象
  function setClipItem(player, items) {
    var _a
    return __awaiter$1(this, void 0, void 0, function*() {
      if (!checkPlayerLoad(player)) {
        return {
          status: false,
          message: 'player实例无效',
        }
      }
      yield (_a = player.Native) === null || _a === void 0
        ? void 0
        : _a.ClipBox.setLocalEnabled(items)
      return {
        status: true,
        message: '',
      }
    })
  }
  const Clip = {
    setCilp,
    createCilp,
    cancelClip,
    getClipData,
    setVisible,
    startDrawPloygonClip,
    cancelPloygonClip,
    getPloygonClipData,
    setPloyonClipData,
    getClipObjects,
    setClipItem,
    updateClipDataByAabb,
    getClipAabb,
  }

  // 根据item定位
  function moveCameraByITEM(player, moveSpeed, param) {
    var _a
    return __awaiter$1(this, void 0, void 0, function*() {
      yield (_a = player.Native) === null || _a === void 0
        ? void 0
        : _a.Camera.moveToItem(
            param !== null && param !== void 0 ? param : '',
            moveSpeed !== null && moveSpeed !== void 0 ? moveSpeed : 2
          )
      return {
        status: true,
        data: null,
        message: '',
      }
    })
  }
  // 根据code定位
  function moveCameraByCODE(player, moveSpeed, param) {
    var _a
    return __awaiter$1(this, void 0, void 0, function*() {
      yield (_a = player.Native) === null || _a === void 0
        ? void 0
        : _a.Camera.moveToCode(
            param !== null && param !== void 0 ? param : '',
            moveSpeed !== null && moveSpeed !== void 0 ? moveSpeed : 2
          )
      return {
        status: true,
        data: null,
        message: '',
      }
    })
  }
  // 定位到原点
  function moveCameraByHOME(player, moveSpeed) {
    var _a
    return __awaiter$1(this, void 0, void 0, function*() {
      yield (_a = player.Native) === null || _a === void 0
        ? void 0
        : _a.Camera.goHome(moveSpeed !== null && moveSpeed !== void 0 ? moveSpeed : 2)
      return {
        status: true,
        data: null,
        message: '',
      }
    })
  }
  // 根据相机参数定位
  function moveCameraByCAMERAPARAM(player, moveSpeed, param) {
    var _a
    return __awaiter$1(this, void 0, void 0, function*() {
      // 判断param是否为string
      if (typeof param !== 'string') {
        return {
          status: false,
          data: null,
          message: '参数应为序列化后的字符串',
        }
      }
      try {
        const cameraParam = JSON.parse(param)
        if (
          Object.keys(cameraParam).filter((key) => ['eye', 'target', 'up'].indexOf(key) > -1)
            .length === 3
        ) {
          yield (_a = player.Native) === null || _a === void 0
            ? void 0
            : _a.Camera.moveTo(
                cameraParam.eye,
                cameraParam.target,
                cameraParam.up,
                moveSpeed !== null && moveSpeed !== void 0 ? moveSpeed : 2
              )
          return {
            status: true,
            data: null,
            message: '',
          }
        } else {
          return {
            status: false,
            data: null,
            message: "格式化后的字符串应同时含有'eye', 'target', 'up'",
          }
        }
      } catch (error) {
        return {
          status: false,
          data: null,
          message: error,
        }
      }
    })
  }
  // 根据经纬高定位
  function moveCameraByLLH(player, moveSpeed, param) {
    var _a
    return __awaiter$1(this, void 0, void 0, function*() {
      // 判断params是否为数组
      if (!Array.isArray(param)) {
        return {
          status: false,
          data: null,
          message: '参数需要传递数组类型',
        }
      }
      if (param.filter((el) => typeof el === 'number').length === 3) {
        yield (_a = player.Native) === null || _a === void 0
          ? void 0
          : _a.Camera.moveToLLH(
              param[0],
              param[1],
              param[2],
              moveSpeed !== null && moveSpeed !== void 0 ? moveSpeed : 2
            )
        return {
          status: true,
          data: null,
          message: '',
        }
      } else {
        return {
          status: false,
          data: null,
          message: '参数需要数值类型的数组',
        }
      }
    })
  }
  function moveCameraByORIGINOFFSET(player, modelInfo, moveSpeed, param) {
    var _a, _b, _c, _d, _e, _f
    return __awaiter$1(this, void 0, void 0, function*() {
      if (!modelInfo)
        return {
          status: false,
          data: null,
          message: '未传入模型信息',
        }
      // 判断param是否为string
      if (typeof param !== 'string') {
        return {
          status: false,
          data: null,
          message: '参数应为序列化后的字符串',
        }
      }
      try {
        const cameraParam = JSON.parse(param)
        if (
          Object.keys(cameraParam).filter((key) => ['eye', 'target', 'up'].indexOf(key) > -1)
            .length === 3
        ) {
          // 定位 判断是否加载了地球
          const isGisMode = yield (_a = player.Native) === null || _a === void 0
            ? void 0
            : _a.GisPlatform.isGisMode()
          const restoreOfsetRes = yield restoreOfset(
            player,
            modelInfo.modelId,
            cameraParam,
            modelInfo.offset,
            isGisMode
          )
          const { eye, target, up } = restoreOfsetRes.data || {}
          if (isGisMode) {
            // 缓慢降低相机的高度，不适用模型放置在高海拔
            const cameraCurrParam = yield (_b = player.Native) === null || _b === void 0
              ? void 0
              : _b.Camera.currentParam()
            const currEyeHeight = Vec3.length(cameraCurrParam.eye)
            const tarEyeHeight = Vec3.length(eye)
            const heightOffset = currEyeHeight - tarEyeHeight
            const tarEyeLLH = yield (_c = player.Native) === null || _c === void 0
              ? void 0
              : _c.GisPlatform.worldToLLH(eye)
            let h0 = tarEyeLLH[2] + heightOffset * 0.2
            h0 = Math.max(h0, tarEyeLLH[2] + 2000.0)
            yield (_d = player.Native) === null || _d === void 0
              ? void 0
              : _d.Camera.addMoveToLLH(
                  [tarEyeLLH[0], tarEyeLLH[1], h0],
                  moveSpeed !== null && moveSpeed !== void 0 ? moveSpeed : 2 / 2
                )
            let h1 = tarEyeLLH[2] + heightOffset * 0.05
            h1 = Math.max(h1, tarEyeLLH[2] + 500)
            ;(_e = player.Native) === null || _e === void 0
              ? void 0
              : _e.Camera.addMoveToLLH(
                  [tarEyeLLH[0], tarEyeLLH[1], h1],
                  moveSpeed !== null && moveSpeed !== void 0 ? moveSpeed : 2 / 2
                )
          } else {
            yield (_f = player.Native) === null || _f === void 0
              ? void 0
              : _f.Camera.addMoveTo(
                  eye,
                  target,
                  up,
                  moveSpeed !== null && moveSpeed !== void 0 ? moveSpeed : 2
                )
          }
          return {
            status: true,
            data: null,
            message: '',
          }
        } else {
          return {
            status: false,
            data: null,
            message: "格式化后的字符串应同时含有'eye', 'target', 'up'",
          }
        }
      } catch (error) {
        return {
          status: false,
          data: null,
          message: error,
        }
      }
    })
  }
  /**
   * @description: 移动相机
   * @param {IPlayer} player 云渲染实例
   * @param {MoveType} moveType 相机移动的类型
   * @param {Number} moveSpeed 相机移动速度
   * @param {String} param 相机移动时的参数
   * @return {*}
   */
  function moveCamera(player, moveType, param, moveSpeed, modelInfo) {
    return __awaiter$1(this, void 0, void 0, function*() {
      switch (moveType) {
        case 'Item':
          return yield moveCameraByITEM(player, moveSpeed, param)
        case 'CameraParam':
          return yield moveCameraByCAMERAPARAM(player, moveSpeed, param)
        case 'Code':
          return yield moveCameraByCODE(player, moveSpeed, param)
        case 'Home':
          return yield moveCameraByHOME(player, moveSpeed)
        case 'LLH':
          return yield moveCameraByLLH(player, moveSpeed)
        case 'OriginOffset':
          return yield moveCameraByORIGINOFFSET(player, modelInfo, moveSpeed, param)
        default:
          return {
            status: false,
            data: null,
            message: '相机移动类型错误',
          }
      }
    })
  }
  /**
   * @description: 获取当前相机的参数
   * @param {IPlayer} player
   * @return {*}
   */
  function getCurrentCamera(player) {
    var _a
    return __awaiter$1(this, void 0, void 0, function*() {
      const currentParam = yield (_a = player.Native) === null || _a === void 0
        ? void 0
        : _a.Camera.currentParam()
      return {
        status: true,
        data: currentParam,
        message: '',
      }
    })
  }
  /**
   * @description: 计算当前相机相对模型原点的位置
   * @param {IPlayer} player
   * @return {*}
   */
  function calcOfsetByOrigin(player, modelName) {
    var _a, _b, _c
    return __awaiter$1(this, void 0, void 0, function*() {
      // 获取模型信息
      const modelInfo = yield (_a = player.Native) === null || _a === void 0
        ? void 0
        : _a.Model.getInfo(modelName)
      // 获取模型的空间坐标位置
      const modelPosistion = yield (_b = player.Native) === null || _b === void 0
        ? void 0
        : _b.NodeProxy.globalTranslation(modelInfo.nodePtr)
      // 当前相机参数
      const cameraParam = yield (_c = player.Native) === null || _c === void 0
        ? void 0
        : _c.Camera.currentParam()
      // 计算偏移量
      const offsetEye = Vec3.sub(cameraParam.eye, modelPosistion)
      const offsetTarget = Vec3.sub(cameraParam.target, modelPosistion)
      const up = cameraParam.up
      return {
        status: true,
        data: {
          eye: offsetEye,
          target: offsetTarget,
          up: up,
        },
        message: '',
      }
    })
  }
  function restoreOfset(player, modelName, offsetParams, modelOffset, isLoadedGis) {
    var _a, _b, _c, _d, _e, _f, _g
    return __awaiter$1(this, void 0, void 0, function*() {
      // 获取模型信息
      const modelInfo = yield (_a = player.Native) === null || _a === void 0
        ? void 0
        : _a.Model.getInfo(modelName)
      // 获取模型的空间坐标位置
      const modelPosistion = yield (_b = player.Native) === null || _b === void 0
        ? void 0
        : _b.NodeProxy.globalTranslation(modelInfo.nodePtr)
      let eye = offsetParams.eye
      let target = offsetParams.target
      let up = offsetParams.up
      // 获取模型的局部变换矩阵
      const modelLocalTransform = yield (_c = player.Native) === null || _c === void 0
        ? void 0
        : _c.NodeProxy.localTransform(modelInfo.nodePtr)
      //从模型的局部变换矩阵中萃取旋转矩阵
      const modelLocalRotation = Matrix4.decompose(modelLocalTransform).rotation
      //将模型的旋转应用到定位参数偏移量
      eye = Matrix4.multiplyPos(modelLocalRotation, eye)
      target = Matrix4.multiplyPos(modelLocalRotation, target)
      up = Matrix4.multiplyPos(modelLocalRotation, up)
      if (isLoadedGis) {
        // 有地球
        //使用当前模型位置转换为经纬高
        let modelLLH = yield (_d = player.Native) === null || _d === void 0
          ? void 0
          : _d.GisPlatform.worldToLLH(modelPosistion)
        //使用经纬度查询当前真实高程
        const realH = yield (_e = player.Native) === null || _e === void 0
          ? void 0
          : _e.GisPlatform.queryDEM([modelLLH[0], modelLLH[1]])
        //使用查询出来的真实高程,并且需要将地形攀爬偏移量加上
        modelLLH[2] = Number(realH) + Number(modelOffset)
        //转换为模型的真实空间坐标位置，然后做相机定位计算
        const realModelPosition = yield (_f = player.Native) === null || _f === void 0
          ? void 0
          : _f.GisPlatform.llhToWorld(modelLLH)
        //计算球上的某个位置对应的旋转矩阵
        const matRotate = yield (_g = player.Native) === null || _g === void 0
          ? void 0
          : _g.GisPlatform.makeGisTransform(modelLLH)
        matRotate[12] = 0
        matRotate[13] = 0
        matRotate[14] = 0
        //计算球上该位置的旋转矩阵应用到定位参数偏移量
        eye = Matrix4.multiplyPos(matRotate, eye)
        target = Matrix4.multiplyPos(matRotate, target)
        up = Matrix4.multiplyPos(matRotate, up)
        //使用模型的真实空间坐标位置偏移定位参数偏移量
        eye = Vec3.add(realModelPosition, eye)
        target = Vec3.add(realModelPosition, target)
      } else {
        // 无地球
        //使用模型的真实空间坐标位置偏移定位参数偏移量
        eye = Vec3.add(modelPosistion, eye)
        target = Vec3.add(modelPosistion, target)
      }
      return {
        status: true,
        data: {
          eye,
          target,
          up,
        },
      }
    })
  }
  const Camera = { moveCamera, getCurrentCamera, calcOfsetByOrigin }

  /**
   * @description: 保存string到文件里面
   * @param {IPlayer} player
   * @param {string} filePath 文件地址
   * @param {string} fileData 文件的内容
   * @return {*}
   */
  function saveSetting(player, filePath, fileData) {
    var _a
    return __awaiter$1(this, void 0, void 0, function*() {
      if (!checkPlayerLoad(player)) {
        return {
          status: false,
          message: 'player无效',
        }
      }
      const saveStatus = yield (_a = player.Native) === null || _a === void 0
        ? void 0
        : _a.Settings.saveJsonString(filePath, fileData)
      return {
        status: saveStatus,
        message: saveStatus ? '保存成功' : '保存失败',
      }
    })
  }
  /**
   * @description: 获取指定文件的内容
   * @param {IPlayer} player
   * @param {string} filePath 文件地址
   * @return {*}
   */
  function getSettingData(player, filePath) {
    var _a
    return __awaiter$1(this, void 0, void 0, function*() {
      if (!checkPlayerLoad(player)) {
        return {
          status: false,
          message: 'player无效',
        }
      }
      const jsonString = yield (_a = player.Native) === null || _a === void 0
        ? void 0
        : _a.Settings.loadJsonString(filePath)
      return {
        status: true,
        message: '成功',
        data: jsonString,
      }
    })
  }
  /**
   * @description: 获取当前的所有配置
   * @param {IPlayer} player
   * @return {*}
   */
  function getAll(player) {
    var _a
    return __awaiter$1(this, void 0, void 0, function*() {
      if (!checkPlayerLoad(player)) {
        return {
          status: false,
          message: 'player无效',
        }
      }
      const settings = yield (_a = player.Native) === null || _a === void 0
        ? void 0
        : _a.Settings.getAll()
      return {
        status: true,
        message: '成功',
        data: settings,
      }
    })
  }
  /**
   * @description: 设置
   * @param {IPlayer} player
   * @param {Array} playerSettings
   * @return {*}
   */
  function set(player, playerSettings) {
    var _a
    return __awaiter$1(this, void 0, void 0, function*() {
      if (!checkPlayerLoad(player)) {
        return {
          status: false,
          message: 'player无效',
        }
      }
      if (!Array.isArray(playerSettings)) {
        playerSettings = [playerSettings]
      }
      for (let i = 0; i < playerSettings.length; i++) {
        const element = playerSettings[i]
        yield (_a = player.Native) === null || _a === void 0
          ? void 0
          : _a.Settings.set(element.name, element.type, element.value)
      }
      return {
        status: true,
        message: '成功',
      }
    })
  }
  /**
   * @description: 获取配置
   * @param {IPlayer} player
   * @param {Array} name
   * @return {*}
   */
  function get(player, name) {
    var _a
    return __awaiter$1(this, void 0, void 0, function*() {
      if (!checkPlayerLoad(player)) {
        return {
          status: false,
          message: 'player无效',
        }
      }
      const settingList = []
      if (!Array.isArray(name)) {
        name = [name]
      }
      for (let i = 0; i < name.length; i++) {
        settingList.push(
          yield (_a = player.Native) === null || _a === void 0 ? void 0 : _a.Settings.get(name[i])
        )
      }
      return {
        status: true,
        message: '成功',
        data: settingList,
      }
    })
  }
  const setting = { saveSetting, getSettingData, getAll, set, get }

  /**键盘与code的对应 */
  var IKeyCodeAndHotKey
  ;(function(IKeyCodeAndHotKey) {
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['Zero'] = 48)] = 'Zero'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['One'] = 49)] = 'One'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['Two'] = 50)] = 'Two'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['Three'] = 51)] = 'Three'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['Four'] = 52)] = 'Four'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['Five'] = 53)] = 'Five'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['Six'] = 54)] = 'Six'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['Seven'] = 55)] = 'Seven'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['Eight'] = 56)] = 'Eight'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['Nine'] = 57)] = 'Nine'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['A'] = 65)] = 'A'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['B'] = 66)] = 'B'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['C'] = 67)] = 'C'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['D'] = 68)] = 'D'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['E'] = 69)] = 'E'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['F'] = 70)] = 'F'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['G'] = 71)] = 'G'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['H'] = 72)] = 'H'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['I'] = 73)] = 'I'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['J'] = 74)] = 'J'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['K'] = 75)] = 'K'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['L'] = 76)] = 'L'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['M'] = 77)] = 'M'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['N'] = 78)] = 'N'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['O'] = 79)] = 'O'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['P'] = 80)] = 'P'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['Q'] = 81)] = 'Q'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['R'] = 82)] = 'R'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['S'] = 83)] = 'S'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['T'] = 84)] = 'T'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['U'] = 85)] = 'U'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['V'] = 86)] = 'V'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['W'] = 87)] = 'W'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['X'] = 88)] = 'X'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['Y'] = 89)] = 'Y'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['Z'] = 90)] = 'Z'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['End'] = 35)] = 'End'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['Home'] = 36)] = 'Home'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['ArrowLeft'] = 37)] = 'ArrowLeft'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['ArrowUp'] = 38)] = 'ArrowUp'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['ArrowRight'] = 39)] = 'ArrowRight'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['ArrowDown'] = 40)] = 'ArrowDown'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['PageDown'] = 34)] = 'PageDown'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['PageUp'] = 33)] = 'PageUp'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['Insert'] = 45)] = 'Insert'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['Delete'] = 46)] = 'Delete'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['F1'] = 112)] = 'F1'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['F2'] = 113)] = 'F2'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['F3'] = 114)] = 'F3'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['F4'] = 115)] = 'F4'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['F5'] = 116)] = 'F5'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['F6'] = 117)] = 'F6'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['F7'] = 118)] = 'F7'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['F8'] = 119)] = 'F8'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['F9'] = 120)] = 'F9'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['F10'] = 121)] = 'F10'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['F11'] = 122)] = 'F11'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['F12'] = 123)] = 'F12'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['Escape'] = 27)] = 'Escape'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['Return'] = 13)] = 'Return'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['Add'] = 187)] = 'Add'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['Subtract'] = 189)] = 'Subtract'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['Divide'] = 111)] = 'Divide'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['Enter'] = 108)] = 'Enter'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['Multiply'] = 106)] = 'Multiply'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['Capital'] = 20)] = 'Capital'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['Backspace'] = 8)] = 'Backspace'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['Tab'] = 9)] = 'Tab'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['Alt'] = 18)] = 'Alt'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['LeftAlt'] = 164)] = 'LeftAlt'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['RightAl'] = 165)] = 'RightAl'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['LeftWin'] = 91)] = 'LeftWin'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['RightWi'] = 92)] = 'RightWi'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['Shift'] = 16)] = 'Shift'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['LeftShift'] = 160)] = 'LeftShift'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['RightShift'] = 161)] = 'RightShift'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['Control'] = 17)] = 'Control'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['LeftControl'] = 162)] = 'LeftControl'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['RightControl'] = 163)] = 'RightControl'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['Comma'] = 188)] = 'Comma'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['Pause'] = 19)] = 'Pause'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['ScrollLock'] = 145)] = 'ScrollLock'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['Space'] = 32)] = 'Space'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['NumLock'] = 144)] = 'NumLock'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['Numpad0'] = 96)] = 'Numpad0'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['Numpad1'] = 97)] = 'Numpad1'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['Numpad2'] = 98)] = 'Numpad2'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['Numpad3'] = 99)] = 'Numpad3'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['Numpad4'] = 100)] = 'Numpad4'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['Numpad5'] = 101)] = 'Numpad5'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['Numpad6'] = 102)] = 'Numpad6'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['Numpad7'] = 103)] = 'Numpad7'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['Numpad8'] = 104)] = 'Numpad8'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['Numpad9'] = 105)] = 'Numpad9'
    IKeyCodeAndHotKey[(IKeyCodeAndHotKey['Decimal'] = 106)] = 'Decimal'
  })(IKeyCodeAndHotKey || (IKeyCodeAndHotKey = {}))
  /** 已有的皮肤 */
  var IAvatarSkin
  ;(function(IAvatarSkin) {
    IAvatarSkin['blue'] = 'blue'
    IAvatarSkin['orange'] = 'orange'
    IAvatarSkin['red'] = 'red'
    IAvatarSkin['white'] = 'white'
    IAvatarSkin['yellow'] = 'yellow'
  })(IAvatarSkin || (IAvatarSkin = {}))
  /** 已有类型 */
  var IAvatarSkinType
  ;(function(IAvatarSkinType) {
    IAvatarSkinType['GongRen'] = 'GongRen'
  })(IAvatarSkinType || (IAvatarSkinType = {}))
  var IHotKeyName
  ;(function(IHotKeyName) {
    IHotKeyName['\u524D\u8FDB'] = '\u524D\u8FDB'
    IHotKeyName['\u540E\u9000'] = '\u540E\u9000'
    IHotKeyName['\u5411\u5DE6\u79FB\u52A8'] = '\u5411\u5DE6\u79FB\u52A8'
    IHotKeyName['\u5411\u53F3\u79FB\u52A8'] = '\u5411\u53F3\u79FB\u52A8'
    IHotKeyName['\u5411\u4E0A\u4EF0\u89C6'] = '\u5411\u4E0A\u4EF0\u89C6'
    IHotKeyName['\u5411\u4E0B\u4FEF\u89C6'] = '\u5411\u4E0B\u4FEF\u89C6'
    IHotKeyName['\u5DE6\u8F6C'] = '\u5DE6\u8F6C'
    IHotKeyName['\u53F3\u8F6C'] = '\u53F3\u8F6C'
    IHotKeyName['\u8DF3\u8D77'] = '\u8DF3\u8D77'
    IHotKeyName['\u65E0\u91CD\u529B\u8DF3'] = '\u65E0\u91CD\u529B\u8DF3'
    IHotKeyName['\u5954\u8DD1'] = '\u5954\u8DD1'
    IHotKeyName['\u8E72\u4E0B'] = '\u8E72\u4E0B'
    IHotKeyName['\u5782\u76F4\u5411\u4E0A\u79FB\u52A8'] = '\u5782\u76F4\u5411\u4E0A\u79FB\u52A8'
    IHotKeyName['\u5782\u76F4\u5411\u4E0B\u79FB\u52A8'] = '\u5782\u76F4\u5411\u4E0B\u79FB\u52A8'
    IHotKeyName['\u5F00\u542F/\u5173\u95ED\u4EBA\u7269\u7A7F\u5899'] =
      '\u5F00\u542F/\u5173\u95ED\u4EBA\u7269\u7A7F\u5899'
    IHotKeyName['\u5F00\u542F/\u5173\u95ED\u4EBA\u7269\u98DE\u884C\u6A21\u5F0F'] =
      '\u5F00\u542F/\u5173\u95ED\u4EBA\u7269\u98DE\u884C\u6A21\u5F0F'
  })(IHotKeyName || (IHotKeyName = {}))

  /*
   * @Author: fengxiaojing
   * @LastEditTime: 2023-03-28 14:38:29
   * @Description:
   * @LastEditors: fengxiaojing
   */
  /** 检查文件是否存在*/
  function checkFile(player, url) {
    var _a
    return __awaiter$1(this, void 0, void 0, function*() {
      const status = yield (_a = player.Native) === null || _a === void 0
        ? void 0
        : _a.File.exists(url)
      return !!status
    })
  }
  // export async function downLoadFile(player: any, fileUrl: string, md5: string, targetUrl: string, modelId: string): Promise<boolean> {
  // }

  /**
   * @description: 获取漫游所有的快捷键
   * @param {IPlayer} player
   * @return {*}
   */
  function getAllHotKey(player) {
    var _a
    return __awaiter$1(this, void 0, void 0, function*() {
      if (!checkPlayerLoad(player)) {
        return {
          status: false,
          message: 'player无效',
        }
      }
      const resData = []
      const hotkeys = yield (_a = player.Native) === null || _a === void 0
        ? void 0
        : _a.Walking.getHotkeys()
      Object.keys(hotkeys).forEach((item) => {
        resData.push({
          label: item,
          value: hotkeys[item],
          code: hotkeys[item].map((keys) => {
            const keyList = keys.split('+')
            return keyList.map((key) => {
              return IKeyCodeAndHotKey[key]
            })
          }),
        })
      })
      return {
        message: '',
        status: true,
        data: resData,
      }
    })
  }
  /**
   * @description:  获取当前快捷键是否可用
   * @param {IPlayer} player
   * @param {number} code
   * @return {*}
   */
  function isEnableHotKey(player, code) {
    return __awaiter$1(this, void 0, void 0, function*() {
      if (!checkPlayerLoad(player)) {
        return {
          status: false,
          message: 'player无效',
        }
      }
      if (
        !code.every((el) => {
          return !!IKeyCodeAndHotKey[el]
        })
      ) {
        return {
          status: false,
          message: '不支持当前快捷键',
        }
      }
      const hotkeysRes = yield getAllHotKey(player)
      if (hotkeysRes && hotkeysRes.data) {
        const isExis = hotkeysRes.data.some((element) => {
          return (
            element.value[0] ===
            code
              .map((item) => {
                return IKeyCodeAndHotKey[item]
              })
              .join('+')
          )
        })
        return {
          status: true,
          message: isExis ? '当前快捷键已被占用' : '设置成功',
          data: !isExis,
        }
      }
      return {
        status: false,
        message: '',
      }
    })
  }
  /**
   * @description: 批量设置快捷键
   * @param {IPlayer} player
   * @param {Array} hotkeys
   * @return {*}
   */
  function setHotKeys(player, hotkeys) {
    var _a
    return __awaiter$1(this, void 0, void 0, function*() {
      if (!checkPlayerLoad(player)) {
        return {
          status: false,
          message: 'player无效',
        }
      }
      const failCodeList = []
      if (!Array.isArray(hotkeys)) {
        hotkeys = [hotkeys]
      }
      for (let i = 0; i < hotkeys.length; i++) {
        const element = hotkeys[i]
        // 判断是否可以设置当前快捷键
        if (
          !element.code.every((el) => {
            return !!IKeyCodeAndHotKey[el]
          })
        ) {
          failCodeList.push(element)
          continue
        }
        if (!IHotKeyName[element.name]) {
          // 判断name是否支持可设置
          failCodeList.push(element)
          continue
        }
        // 判断当前快捷键是否被占用
        const isEnableRes = yield isEnableHotKey(player, element.code)
        if (isEnableRes && !isEnableRes.data) {
          failCodeList.push(element)
          continue
        }
        yield (_a = player.Native) === null || _a === void 0
          ? void 0
          : _a.Walking.setHotkey(element.name, [
              element.code.map((el) => {
                return IKeyCodeAndHotKey[el]
              }),
            ])
      }
      return {
        data: {
          failCodeList,
        },
        status: true,
        message: `批量设置成功${hotkeys.length - failCodeList.length}个， 设置失败${
          failCodeList.length
        }`,
      }
    })
  }
  /**
   * @description: 获取人物的基准速度
   * @param {IPlayer} player
   * @return {*}
   */
  function getAvatarSpeed(player) {
    var _a
    return __awaiter$1(this, void 0, void 0, function*() {
      if (!checkPlayerLoad(player)) {
        return {
          status: false,
          message: 'player无效',
        }
      }
      const speed = yield (_a = player.Native) === null || _a === void 0
        ? void 0
        : _a.Walking.avatarMoveSpeed()
      return {
        message: '',
        status: true,
        data: speed,
      }
    })
  }
  /**
   * @description: 设置人物的基准速度
   * @param {IPlayer} player
   * @param {number} speed 速度
   * @return {*}
   */
  function setAvatarSpeed(player, speed) {
    var _a
    return __awaiter$1(this, void 0, void 0, function*() {
      if (!checkPlayerLoad(player)) {
        return {
          status: false,
          message: 'player无效',
        }
      }
      yield (_a = player.Native) === null || _a === void 0
        ? void 0
        : _a.Walking.setAvatarMoveSpeed(speed)
      return {
        message: '',
        status: true,
      }
    })
  }
  /**
   * @description: 设置皮肤
   * @param {IPlayer} player
   * @param {ISkinOption} skinOption
   * @return {*}
   */
  function setAvatarSkin(player, type, skinOption) {
    var _a, _b
    return __awaiter$1(this, void 0, void 0, function*() {
      if (!checkPlayerLoad(player)) {
        return {
          status: false,
          message: 'player无效',
        }
      }
      let message = ''
      if (skinOption.body) {
        const bodyUrl = `data://../apps/skin/${type}/body_${skinOption.body}`
        if (yield checkFile(player, bodyUrl)) {
          yield (_a = player.Native) === null || _a === void 0
            ? void 0
            : _a.Walking.setAvatarBodySkin(bodyUrl)
        } else {
          message += ' 身体贴图设置失败!'
        }
      }
      if (skinOption.head) {
        const headUrl = `data://../apps/skin/${type}/head_${skinOption.head}`
        if (yield checkFile(player, headUrl)) {
          yield (_b = player.Native) === null || _b === void 0
            ? void 0
            : _b.Walking.setAvatarCapSkin(headUrl)
        } else {
          message += ' 头部贴图设置失败!'
        }
      }
      return {
        message,
        status: true,
      }
    })
  }
  const walking = {
    getAllHotKey,
    isEnableHotKey,
    getAvatarSpeed,
    setAvatarSpeed,
    setAvatarSkin,
    setHotKeys,
    hotKeyMap: IKeyCodeAndHotKey,
  }

  class ModelGlitter {
    constructor() {}
    /**
     * @description: 开启模型闪烁
     * @param {IPlayer} player
     * @param {Number} item
     * @param {Array} colorList
     * @param {Number} frequency
     * @return {*}
     */
    static open(player, item, colorList, frequency) {
      const isCurrentPlayer = checkPlayerLoad(player)
      if (!isCurrentPlayer)
        return {
          status: false,
          message: 'player实例无效',
        }
      // 转化颜色
      const currentColorList = colorList.map((item) => {
        return item.replace('#', '0x')
      })
      let currentIndex = 0
      const cuurentId = generateUUID()
      this.currentGlitterItemList[cuurentId] = {
        item,
        internal: undefined,
      }
      this.currentGlitterItemList[cuurentId].internal = window.setInterval(
        () =>
          __awaiter$1(this, void 0, void 0, function*() {
            var _a
            if (currentIndex > currentColorList.length - 1) {
              currentIndex = 0
            }
            yield (_a = player.Native) === null || _a === void 0
              ? void 0
              : _a.ModelTree.setItemColor(
                  this.currentGlitterItemList[cuurentId].item,
                  Number(currentColorList[currentIndex])
                )
            currentIndex += 1
          }),
        frequency
      )
    }
    /**
     * @description: 关闭模型闪烁
     * @param {IPlayer} player
     * @param {Number} item
     * @return {*}
     */
    static close(player, item) {
      var _a, _b, _c
      return __awaiter$1(this, void 0, void 0, function*() {
        const isCurrentPlayer = checkPlayerLoad(player)
        if (!isCurrentPlayer)
          return {
            status: false,
            message: 'player实例无效',
          }
        yield (_a = player.Native) === null || _a === void 0
          ? void 0
          : _a.ModelTree.restoreItemColor(item)
        // 移除存在于闪烁列表的item
        for (const key in this.currentGlitterItemList) {
          if (Object.prototype.hasOwnProperty.call(this.currentGlitterItemList, key)) {
            const element = this.currentGlitterItemList[key]
            if (Array.isArray(element.item)) {
              element.item = element.item.filter((el) => {
                if (Array.isArray(item)) {
                  return !item.includes(el)
                }
                return el !== item
              })
              if (element.item.length === 0) {
                clearInterval(element.internal)
                delete this.currentGlitterItemList[key]
                // 恢复模型颜色
                ;(_b = player.Native) === null || _b === void 0
                  ? void 0
                  : _b.ModelTree.restoreItemColor(item)
              }
            } else {
              if ((Array.isArray(item) && item.includes(element.item)) || item === element.item) {
                clearInterval(element.internal)
                delete this.currentGlitterItemList[key]
                // 恢复模型颜色
                ;(_c = player.Native) === null || _c === void 0
                  ? void 0
                  : _c.ModelTree.restoreItemColor(item)
              }
            }
          }
        }
      })
    }
  }
  ModelGlitter.currentGlitterItemList = {}

  var EMarkPosType
  ;(function(EMarkPosType) {
    EMarkPosType[(EMarkPosType['leftTop'] = 0)] = 'leftTop'
    EMarkPosType[(EMarkPosType['midTop'] = 1)] = 'midTop'
    EMarkPosType[(EMarkPosType['rightTop'] = 2)] = 'rightTop'
    EMarkPosType[(EMarkPosType['leftBottom'] = 3)] = 'leftBottom'
    EMarkPosType[(EMarkPosType['midBottom'] = 4)] = 'midBottom'
    EMarkPosType[(EMarkPosType['rightBottom'] = 5)] = 'rightBottom'
  })(EMarkPosType || (EMarkPosType = {}))

  /*!
   * html2canvas 1.4.1 <https://html2canvas.hertzen.com>
   * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
   * Released under MIT License
   */
  /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */
  /* global Reflect, Promise */

  var extendStatics = function(d, b) {
    extendStatics =
      Object.setPrototypeOf ||
      ({ __proto__: [] } instanceof Array &&
        function(d, b) {
          d.__proto__ = b
        }) ||
      function(d, b) {
        for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]
      }
    return extendStatics(d, b)
  }

  function __extends(d, b) {
    if (typeof b !== 'function' && b !== null)
      throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null')
    extendStatics(d, b)
    function __() {
      this.constructor = d
    }
    d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __())
  }

  var __assign = function() {
    __assign =
      Object.assign ||
      function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i]
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p]
        }
        return t
      }
    return __assign.apply(this, arguments)
  }

  function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P
        ? value
        : new P(function(resolve) {
            resolve(value)
          })
    }
    return new (P || (P = Promise))(function(resolve, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value))
        } catch (e) {
          reject(e)
        }
      }
      function rejected(value) {
        try {
          step(generator['throw'](value))
        } catch (e) {
          reject(e)
        }
      }
      function step(result) {
        result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected)
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next())
    })
  }

  function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
          if (t[0] & 1) throw t[1]
          return t[1]
        },
        trys: [],
        ops: [],
      },
      f,
      y,
      t,
      g
    return (
      (g = { next: verb(0), throw: verb(1), return: verb(2) }),
      typeof Symbol === 'function' &&
        (g[Symbol.iterator] = function() {
          return this
        }),
      g
    )
    function verb(n) {
      return function(v) {
        return step([n, v])
      }
    }
    function step(op) {
      if (f) throw new TypeError('Generator is already executing.')
      while (_)
        try {
          if (
            ((f = 1),
            y &&
              (t =
                op[0] & 2
                  ? y['return']
                  : op[0]
                  ? y['throw'] || ((t = y['return']) && t.call(y), 0)
                  : y.next) &&
              !(t = t.call(y, op[1])).done)
          )
            return t
          if (((y = 0), t)) op = [op[0] & 2, t.value]
          switch (op[0]) {
            case 0:
            case 1:
              t = op
              break
            case 4:
              _.label++
              return { value: op[1], done: false }
            case 5:
              _.label++
              y = op[1]
              op = [0]
              continue
            case 7:
              op = _.ops.pop()
              _.trys.pop()
              continue
            default:
              if (
                !((t = _.trys), (t = t.length > 0 && t[t.length - 1])) &&
                (op[0] === 6 || op[0] === 2)
              ) {
                _ = 0
                continue
              }
              if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                _.label = op[1]
                break
              }
              if (op[0] === 6 && _.label < t[1]) {
                _.label = t[1]
                t = op
                break
              }
              if (t && _.label < t[2]) {
                _.label = t[2]
                _.ops.push(op)
                break
              }
              if (t[2]) _.ops.pop()
              _.trys.pop()
              continue
          }
          op = body.call(thisArg, _)
        } catch (e) {
          op = [6, e]
          y = 0
        } finally {
          f = t = 0
        }
      if (op[0] & 5) throw op[1]
      return { value: op[0] ? op[1] : void 0, done: true }
    }
  }

  function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2)
      for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
          if (!ar) ar = Array.prototype.slice.call(from, 0, i)
          ar[i] = from[i]
        }
      }
    return to.concat(ar || from)
  }

  var Bounds = /** @class */ (function() {
    function Bounds(left, top, width, height) {
      this.left = left
      this.top = top
      this.width = width
      this.height = height
    }
    Bounds.prototype.add = function(x, y, w, h) {
      return new Bounds(this.left + x, this.top + y, this.width + w, this.height + h)
    }
    Bounds.fromClientRect = function(context, clientRect) {
      return new Bounds(
        clientRect.left + context.windowBounds.left,
        clientRect.top + context.windowBounds.top,
        clientRect.width,
        clientRect.height
      )
    }
    Bounds.fromDOMRectList = function(context, domRectList) {
      var domRect = Array.from(domRectList).find(function(rect) {
        return rect.width !== 0
      })
      return domRect
        ? new Bounds(
            domRect.left + context.windowBounds.left,
            domRect.top + context.windowBounds.top,
            domRect.width,
            domRect.height
          )
        : Bounds.EMPTY
    }
    Bounds.EMPTY = new Bounds(0, 0, 0, 0)
    return Bounds
  })()
  var parseBounds = function(context, node) {
    return Bounds.fromClientRect(context, node.getBoundingClientRect())
  }
  var parseDocumentSize = function(document) {
    var body = document.body
    var documentElement = document.documentElement
    if (!body || !documentElement) {
      throw new Error('Unable to get document size')
    }
    var width = Math.max(
      Math.max(body.scrollWidth, documentElement.scrollWidth),
      Math.max(body.offsetWidth, documentElement.offsetWidth),
      Math.max(body.clientWidth, documentElement.clientWidth)
    )
    var height = Math.max(
      Math.max(body.scrollHeight, documentElement.scrollHeight),
      Math.max(body.offsetHeight, documentElement.offsetHeight),
      Math.max(body.clientHeight, documentElement.clientHeight)
    )
    return new Bounds(0, 0, width, height)
  }

  /*
   * css-line-break 2.1.0 <https://github.com/niklasvh/css-line-break#readme>
   * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
   * Released under MIT License
   */
  var toCodePoints$1 = function(str) {
    var codePoints = []
    var i = 0
    var length = str.length
    while (i < length) {
      var value = str.charCodeAt(i++)
      if (value >= 0xd800 && value <= 0xdbff && i < length) {
        var extra = str.charCodeAt(i++)
        if ((extra & 0xfc00) === 0xdc00) {
          codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000)
        } else {
          codePoints.push(value)
          i--
        }
      } else {
        codePoints.push(value)
      }
    }
    return codePoints
  }
  var fromCodePoint$1 = function() {
    var codePoints = []
    for (var _i = 0; _i < arguments.length; _i++) {
      codePoints[_i] = arguments[_i]
    }
    if (String.fromCodePoint) {
      return String.fromCodePoint.apply(String, codePoints)
    }
    var length = codePoints.length
    if (!length) {
      return ''
    }
    var codeUnits = []
    var index = -1
    var result = ''
    while (++index < length) {
      var codePoint = codePoints[index]
      if (codePoint <= 0xffff) {
        codeUnits.push(codePoint)
      } else {
        codePoint -= 0x10000
        codeUnits.push((codePoint >> 10) + 0xd800, (codePoint % 0x400) + 0xdc00)
      }
      if (index + 1 === length || codeUnits.length > 0x4000) {
        result += String.fromCharCode.apply(String, codeUnits)
        codeUnits.length = 0
      }
    }
    return result
  }
  var chars$2 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
  // Use a lookup table to find the index.
  var lookup$2 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256)
  for (var i$2 = 0; i$2 < chars$2.length; i$2++) {
    lookup$2[chars$2.charCodeAt(i$2)] = i$2
  }

  /*
   * utrie 1.0.2 <https://github.com/niklasvh/utrie>
   * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
   * Released under MIT License
   */
  var chars$1$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
  // Use a lookup table to find the index.
  var lookup$1$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256)
  for (var i$1$1 = 0; i$1$1 < chars$1$1.length; i$1$1++) {
    lookup$1$1[chars$1$1.charCodeAt(i$1$1)] = i$1$1
  }
  var decode$1 = function(base64) {
    var bufferLength = base64.length * 0.75,
      len = base64.length,
      i,
      p = 0,
      encoded1,
      encoded2,
      encoded3,
      encoded4
    if (base64[base64.length - 1] === '=') {
      bufferLength--
      if (base64[base64.length - 2] === '=') {
        bufferLength--
      }
    }
    var buffer =
      typeof ArrayBuffer !== 'undefined' &&
      typeof Uint8Array !== 'undefined' &&
      typeof Uint8Array.prototype.slice !== 'undefined'
        ? new ArrayBuffer(bufferLength)
        : new Array(bufferLength)
    var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer)
    for (i = 0; i < len; i += 4) {
      encoded1 = lookup$1$1[base64.charCodeAt(i)]
      encoded2 = lookup$1$1[base64.charCodeAt(i + 1)]
      encoded3 = lookup$1$1[base64.charCodeAt(i + 2)]
      encoded4 = lookup$1$1[base64.charCodeAt(i + 3)]
      bytes[p++] = (encoded1 << 2) | (encoded2 >> 4)
      bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2)
      bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63)
    }
    return buffer
  }
  var polyUint16Array$1 = function(buffer) {
    var length = buffer.length
    var bytes = []
    for (var i = 0; i < length; i += 2) {
      bytes.push((buffer[i + 1] << 8) | buffer[i])
    }
    return bytes
  }
  var polyUint32Array$1 = function(buffer) {
    var length = buffer.length
    var bytes = []
    for (var i = 0; i < length; i += 4) {
      bytes.push((buffer[i + 3] << 24) | (buffer[i + 2] << 16) | (buffer[i + 1] << 8) | buffer[i])
    }
    return bytes
  }

  /** Shift size for getting the index-2 table offset. */
  var UTRIE2_SHIFT_2$1 = 5
  /** Shift size for getting the index-1 table offset. */
  var UTRIE2_SHIFT_1$1 = 6 + 5
  /**
   * Shift size for shifting left the index array values.
   * Increases possible data size with 16-bit index values at the cost
   * of compactability.
   * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
   */
  var UTRIE2_INDEX_SHIFT$1 = 2
  /**
   * Difference between the two shift sizes,
   * for getting an index-1 offset from an index-2 offset. 6=11-5
   */
  var UTRIE2_SHIFT_1_2$1 = UTRIE2_SHIFT_1$1 - UTRIE2_SHIFT_2$1
  /**
   * The part of the index-2 table for U+D800..U+DBFF stores values for
   * lead surrogate code _units_ not code _points_.
   * Values for lead surrogate code _points_ are indexed with this portion of the table.
   * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
   */
  var UTRIE2_LSCP_INDEX_2_OFFSET$1 = 0x10000 >> UTRIE2_SHIFT_2$1
  /** Number of entries in a data block. 32=0x20 */
  var UTRIE2_DATA_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_2$1
  /** Mask for getting the lower bits for the in-data-block offset. */
  var UTRIE2_DATA_MASK$1 = UTRIE2_DATA_BLOCK_LENGTH$1 - 1
  var UTRIE2_LSCP_INDEX_2_LENGTH$1 = 0x400 >> UTRIE2_SHIFT_2$1
  /** Count the lengths of both BMP pieces. 2080=0x820 */
  var UTRIE2_INDEX_2_BMP_LENGTH$1 = UTRIE2_LSCP_INDEX_2_OFFSET$1 + UTRIE2_LSCP_INDEX_2_LENGTH$1
  /**
   * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
   * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
   */
  var UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 = UTRIE2_INDEX_2_BMP_LENGTH$1
  var UTRIE2_UTF8_2B_INDEX_2_LENGTH$1 =
    0x800 >> 6 /* U+0800 is the first code point after 2-byte UTF-8 */
  /**
   * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
   * Variable length, for code points up to highStart, where the last single-value range starts.
   * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
   * (For 0x100000 supplementary code points U+10000..U+10ffff.)
   *
   * The part of the index-2 table for supplementary code points starts
   * after this index-1 table.
   *
   * Both the index-1 table and the following part of the index-2 table
   * are omitted completely if there is only BMP data.
   */
  var UTRIE2_INDEX_1_OFFSET$1 = UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 + UTRIE2_UTF8_2B_INDEX_2_LENGTH$1
  /**
   * Number of index-1 entries for the BMP. 32=0x20
   * This part of the index-1 table is omitted from the serialized form.
   */
  var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 = 0x10000 >> UTRIE2_SHIFT_1$1
  /** Number of entries in an index-2 block. 64=0x40 */
  var UTRIE2_INDEX_2_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_1_2$1
  /** Mask for getting the lower bits for the in-index-2-block offset. */
  var UTRIE2_INDEX_2_MASK$1 = UTRIE2_INDEX_2_BLOCK_LENGTH$1 - 1
  var slice16$1 = function(view, start, end) {
    if (view.slice) {
      return view.slice(start, end)
    }
    return new Uint16Array(Array.prototype.slice.call(view, start, end))
  }
  var slice32$1 = function(view, start, end) {
    if (view.slice) {
      return view.slice(start, end)
    }
    return new Uint32Array(Array.prototype.slice.call(view, start, end))
  }
  var createTrieFromBase64$1 = function(base64, _byteLength) {
    var buffer = decode$1(base64)
    var view32 = Array.isArray(buffer) ? polyUint32Array$1(buffer) : new Uint32Array(buffer)
    var view16 = Array.isArray(buffer) ? polyUint16Array$1(buffer) : new Uint16Array(buffer)
    var headerLength = 24
    var index = slice16$1(view16, headerLength / 2, view32[4] / 2)
    var data =
      view32[5] === 2
        ? slice16$1(view16, (headerLength + view32[4]) / 2)
        : slice32$1(view32, Math.ceil((headerLength + view32[4]) / 4))
    return new Trie$1(view32[0], view32[1], view32[2], view32[3], index, data)
  }
  var Trie$1 = /** @class */ (function() {
    function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
      this.initialValue = initialValue
      this.errorValue = errorValue
      this.highStart = highStart
      this.highValueIndex = highValueIndex
      this.index = index
      this.data = data
    }
    /**
     * Get the value for a code point as stored in the Trie.
     *
     * @param codePoint the code point
     * @return the value
     */
    Trie.prototype.get = function(codePoint) {
      var ix
      if (codePoint >= 0) {
        if (codePoint < 0x0d800 || (codePoint > 0x0dbff && codePoint <= 0x0ffff)) {
          // Ordinary BMP code point, excluding leading surrogates.
          // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
          // 16 bit data is stored in the index array itself.
          ix = this.index[codePoint >> UTRIE2_SHIFT_2$1]
          ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1)
          return this.data[ix]
        }
        if (codePoint <= 0xffff) {
          // Lead Surrogate Code Point.  A Separate index section is stored for
          // lead surrogate code units and code points.
          //   The main index has the code unit data.
          //   For this function, we need the code point data.
          // Note: this expression could be refactored for slightly improved efficiency, but
          //       surrogate code points will be so rare in practice that it's not worth it.
          ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET$1 + ((codePoint - 0xd800) >> UTRIE2_SHIFT_2$1)]
          ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1)
          return this.data[ix]
        }
        if (codePoint < this.highStart) {
          // Supplemental code point, use two-level lookup.
          ix =
            UTRIE2_INDEX_1_OFFSET$1 -
            UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 +
            (codePoint >> UTRIE2_SHIFT_1$1)
          ix = this.index[ix]
          ix += (codePoint >> UTRIE2_SHIFT_2$1) & UTRIE2_INDEX_2_MASK$1
          ix = this.index[ix]
          ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1)
          return this.data[ix]
        }
        if (codePoint <= 0x10ffff) {
          return this.data[this.highValueIndex]
        }
      }
      // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
      return this.errorValue
    }
    return Trie
  })()

  /*
   * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
   * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
   * Released under MIT License
   */
  var chars$3 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
  // Use a lookup table to find the index.
  var lookup$3 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256)
  for (var i$3 = 0; i$3 < chars$3.length; i$3++) {
    lookup$3[chars$3.charCodeAt(i$3)] = i$3
  }

  var base64$1 =
    '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'

  var LETTER_NUMBER_MODIFIER = 50
  // Non-tailorable Line Breaking Classes
  var BK = 1 //  Cause a line break (after)
  var CR$1 = 2 //  Cause a line break (after), except between CR and LF
  var LF$1 = 3 //  Cause a line break (after)
  var CM = 4 //  Prohibit a line break between the character and the preceding character
  var NL = 5 //  Cause a line break (after)
  var WJ = 7 //  Prohibit line breaks before and after
  var ZW = 8 //  Provide a break opportunity
  var GL = 9 //  Prohibit line breaks before and after
  var SP = 10 // Enable indirect line breaks
  var ZWJ$1 = 11 // Prohibit line breaks within joiner sequences
  // Break Opportunities
  var B2 = 12 //  Provide a line break opportunity before and after the character
  var BA = 13 //  Generally provide a line break opportunity after the character
  var BB = 14 //  Generally provide a line break opportunity before the character
  var HY = 15 //  Provide a line break opportunity after the character, except in numeric context
  var CB = 16 //   Provide a line break opportunity contingent on additional information
  // Characters Prohibiting Certain Breaks
  var CL = 17 //  Prohibit line breaks before
  var CP = 18 //  Prohibit line breaks before
  var EX = 19 //  Prohibit line breaks before
  var IN = 20 //  Allow only indirect line breaks between pairs
  var NS = 21 //  Allow only indirect line breaks before
  var OP = 22 //  Prohibit line breaks after
  var QU = 23 //  Act like they are both opening and closing
  // Numeric Context
  var IS = 24 //  Prevent breaks after any and before numeric
  var NU = 25 //  Form numeric expressions for line breaking purposes
  var PO = 26 //  Do not break following a numeric expression
  var PR = 27 //  Do not break in front of a numeric expression
  var SY = 28 //  Prevent a break before; and allow a break after
  // Other Characters
  var AI = 29 //  Act like AL when the resolvedEAW is N; otherwise; act as ID
  var AL = 30 //  Are alphabetic characters or symbols that are used with alphabetic characters
  var CJ = 31 //  Treat as NS or ID for strict or normal breaking.
  var EB = 32 //  Do not break from following Emoji Modifier
  var EM = 33 //  Do not break from preceding Emoji Base
  var H2 = 34 //  Form Korean syllable blocks
  var H3 = 35 //  Form Korean syllable blocks
  var HL = 36 //  Do not break around a following hyphen; otherwise act as Alphabetic
  var ID = 37 //  Break before or after; except in some numeric context
  var JL = 38 //  Form Korean syllable blocks
  var JV = 39 //  Form Korean syllable blocks
  var JT = 40 //  Form Korean syllable blocks
  var RI$1 = 41 //  Keep pairs together. For pairs; break before and after other classes
  var SA = 42 //  Provide a line break opportunity contingent on additional, language-specific context analysis
  var XX = 43 //  Have as yet unknown line breaking behavior or unassigned code positions
  var ea_OP = [0x2329, 0xff08]
  var BREAK_MANDATORY = '!'
  var BREAK_NOT_ALLOWED$1 = '×'
  var BREAK_ALLOWED$1 = '÷'
  var UnicodeTrie$1 = createTrieFromBase64$1(base64$1)
  var ALPHABETICS = [AL, HL]
  var HARD_LINE_BREAKS = [BK, CR$1, LF$1, NL]
  var SPACE$1 = [SP, ZW]
  var PREFIX_POSTFIX = [PR, PO]
  var LINE_BREAKS = HARD_LINE_BREAKS.concat(SPACE$1)
  var KOREAN_SYLLABLE_BLOCK = [JL, JV, JT, H2, H3]
  var HYPHEN = [HY, BA]
  var codePointsToCharacterClasses = function(codePoints, lineBreak) {
    if (lineBreak === void 0) {
      lineBreak = 'strict'
    }
    var types = []
    var indices = []
    var categories = []
    codePoints.forEach(function(codePoint, index) {
      var classType = UnicodeTrie$1.get(codePoint)
      if (classType > LETTER_NUMBER_MODIFIER) {
        categories.push(true)
        classType -= LETTER_NUMBER_MODIFIER
      } else {
        categories.push(false)
      }
      if (['normal', 'auto', 'loose'].indexOf(lineBreak) !== -1) {
        // U+2010, – U+2013, 〜 U+301C, ゠ U+30A0
        if ([0x2010, 0x2013, 0x301c, 0x30a0].indexOf(codePoint) !== -1) {
          indices.push(index)
          return types.push(CB)
        }
      }
      if (classType === CM || classType === ZWJ$1) {
        // LB10 Treat any remaining combining mark or ZWJ as AL.
        if (index === 0) {
          indices.push(index)
          return types.push(AL)
        }
        // LB9 Do not break a combining character sequence; treat it as if it has the line breaking class of
        // the base character in all of the following rules. Treat ZWJ as if it were CM.
        var prev = types[index - 1]
        if (LINE_BREAKS.indexOf(prev) === -1) {
          indices.push(indices[index - 1])
          return types.push(prev)
        }
        indices.push(index)
        return types.push(AL)
      }
      indices.push(index)
      if (classType === CJ) {
        return types.push(lineBreak === 'strict' ? NS : ID)
      }
      if (classType === SA) {
        return types.push(AL)
      }
      if (classType === AI) {
        return types.push(AL)
      }
      // For supplementary characters, a useful default is to treat characters in the range 10000..1FFFD as AL
      // and characters in the ranges 20000..2FFFD and 30000..3FFFD as ID, until the implementation can be revised
      // to take into account the actual line breaking properties for these characters.
      if (classType === XX) {
        if (
          (codePoint >= 0x20000 && codePoint <= 0x2fffd) ||
          (codePoint >= 0x30000 && codePoint <= 0x3fffd)
        ) {
          return types.push(ID)
        } else {
          return types.push(AL)
        }
      }
      types.push(classType)
    })
    return [indices, types, categories]
  }
  var isAdjacentWithSpaceIgnored = function(a, b, currentIndex, classTypes) {
    var current = classTypes[currentIndex]
    if (Array.isArray(a) ? a.indexOf(current) !== -1 : a === current) {
      var i = currentIndex
      while (i <= classTypes.length) {
        i++
        var next = classTypes[i]
        if (next === b) {
          return true
        }
        if (next !== SP) {
          break
        }
      }
    }
    if (current === SP) {
      var i = currentIndex
      while (i > 0) {
        i--
        var prev = classTypes[i]
        if (Array.isArray(a) ? a.indexOf(prev) !== -1 : a === prev) {
          var n = currentIndex
          while (n <= classTypes.length) {
            n++
            var next = classTypes[n]
            if (next === b) {
              return true
            }
            if (next !== SP) {
              break
            }
          }
        }
        if (prev !== SP) {
          break
        }
      }
    }
    return false
  }
  var previousNonSpaceClassType = function(currentIndex, classTypes) {
    var i = currentIndex
    while (i >= 0) {
      var type = classTypes[i]
      if (type === SP) {
        i--
      } else {
        return type
      }
    }
    return 0
  }
  var _lineBreakAtIndex = function(codePoints, classTypes, indicies, index, forbiddenBreaks) {
    if (indicies[index] === 0) {
      return BREAK_NOT_ALLOWED$1
    }
    var currentIndex = index - 1
    if (Array.isArray(forbiddenBreaks) && forbiddenBreaks[currentIndex] === true) {
      return BREAK_NOT_ALLOWED$1
    }
    var beforeIndex = currentIndex - 1
    var afterIndex = currentIndex + 1
    var current = classTypes[currentIndex]
    // LB4 Always break after hard line breaks.
    // LB5 Treat CR followed by LF, as well as CR, LF, and NL as hard line breaks.
    var before = beforeIndex >= 0 ? classTypes[beforeIndex] : 0
    var next = classTypes[afterIndex]
    if (current === CR$1 && next === LF$1) {
      return BREAK_NOT_ALLOWED$1
    }
    if (HARD_LINE_BREAKS.indexOf(current) !== -1) {
      return BREAK_MANDATORY
    }
    // LB6 Do not break before hard line breaks.
    if (HARD_LINE_BREAKS.indexOf(next) !== -1) {
      return BREAK_NOT_ALLOWED$1
    }
    // LB7 Do not break before spaces or zero width space.
    if (SPACE$1.indexOf(next) !== -1) {
      return BREAK_NOT_ALLOWED$1
    }
    // LB8 Break before any character following a zero-width space, even if one or more spaces intervene.
    if (previousNonSpaceClassType(currentIndex, classTypes) === ZW) {
      return BREAK_ALLOWED$1
    }
    // LB8a Do not break after a zero width joiner.
    if (UnicodeTrie$1.get(codePoints[currentIndex]) === ZWJ$1) {
      return BREAK_NOT_ALLOWED$1
    }
    // zwj emojis
    if ((current === EB || current === EM) && UnicodeTrie$1.get(codePoints[afterIndex]) === ZWJ$1) {
      return BREAK_NOT_ALLOWED$1
    }
    // LB11 Do not break before or after Word joiner and related characters.
    if (current === WJ || next === WJ) {
      return BREAK_NOT_ALLOWED$1
    }
    // LB12 Do not break after NBSP and related characters.
    if (current === GL) {
      return BREAK_NOT_ALLOWED$1
    }
    // LB12a Do not break before NBSP and related characters, except after spaces and hyphens.
    if ([SP, BA, HY].indexOf(current) === -1 && next === GL) {
      return BREAK_NOT_ALLOWED$1
    }
    // LB13 Do not break before ‘]’ or ‘!’ or ‘;’ or ‘/’, even after spaces.
    if ([CL, CP, EX, IS, SY].indexOf(next) !== -1) {
      return BREAK_NOT_ALLOWED$1
    }
    // LB14 Do not break after ‘[’, even after spaces.
    if (previousNonSpaceClassType(currentIndex, classTypes) === OP) {
      return BREAK_NOT_ALLOWED$1
    }
    // LB15 Do not break within ‘”[’, even with intervening spaces.
    if (isAdjacentWithSpaceIgnored(QU, OP, currentIndex, classTypes)) {
      return BREAK_NOT_ALLOWED$1
    }
    // LB16 Do not break between closing punctuation and a nonstarter (lb=NS), even with intervening spaces.
    if (isAdjacentWithSpaceIgnored([CL, CP], NS, currentIndex, classTypes)) {
      return BREAK_NOT_ALLOWED$1
    }
    // LB17 Do not break within ‘——’, even with intervening spaces.
    if (isAdjacentWithSpaceIgnored(B2, B2, currentIndex, classTypes)) {
      return BREAK_NOT_ALLOWED$1
    }
    // LB18 Break after spaces.
    if (current === SP) {
      return BREAK_ALLOWED$1
    }
    // LB19 Do not break before or after quotation marks, such as ‘ ” ’.
    if (current === QU || next === QU) {
      return BREAK_NOT_ALLOWED$1
    }
    // LB20 Break before and after unresolved CB.
    if (next === CB || current === CB) {
      return BREAK_ALLOWED$1
    }
    // LB21 Do not break before hyphen-minus, other hyphens, fixed-width spaces, small kana, and other non-starters, or after acute accents.
    if ([BA, HY, NS].indexOf(next) !== -1 || current === BB) {
      return BREAK_NOT_ALLOWED$1
    }
    // LB21a Don't break after Hebrew + Hyphen.
    if (before === HL && HYPHEN.indexOf(current) !== -1) {
      return BREAK_NOT_ALLOWED$1
    }
    // LB21b Don’t break between Solidus and Hebrew letters.
    if (current === SY && next === HL) {
      return BREAK_NOT_ALLOWED$1
    }
    // LB22 Do not break before ellipsis.
    if (next === IN) {
      return BREAK_NOT_ALLOWED$1
    }
    // LB23 Do not break between digits and letters.
    if (
      (ALPHABETICS.indexOf(next) !== -1 && current === NU) ||
      (ALPHABETICS.indexOf(current) !== -1 && next === NU)
    ) {
      return BREAK_NOT_ALLOWED$1
    }
    // LB23a Do not break between numeric prefixes and ideographs, or between ideographs and numeric postfixes.
    if (
      (current === PR && [ID, EB, EM].indexOf(next) !== -1) ||
      ([ID, EB, EM].indexOf(current) !== -1 && next === PO)
    ) {
      return BREAK_NOT_ALLOWED$1
    }
    // LB24 Do not break between numeric prefix/postfix and letters, or between letters and prefix/postfix.
    if (
      (ALPHABETICS.indexOf(current) !== -1 && PREFIX_POSTFIX.indexOf(next) !== -1) ||
      (PREFIX_POSTFIX.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1)
    ) {
      return BREAK_NOT_ALLOWED$1
    }
    // LB25 Do not break between the following pairs of classes relevant to numbers:
    if (
      // (PR | PO) × ( OP | HY )? NU
      ([PR, PO].indexOf(current) !== -1 &&
        (next === NU || ([OP, HY].indexOf(next) !== -1 && classTypes[afterIndex + 1] === NU))) ||
      // ( OP | HY ) × NU
      ([OP, HY].indexOf(current) !== -1 && next === NU) ||
      // NU ×	(NU | SY | IS)
      (current === NU && [NU, SY, IS].indexOf(next) !== -1)
    ) {
      return BREAK_NOT_ALLOWED$1
    }
    // NU (NU | SY | IS)* × (NU | SY | IS | CL | CP)
    if ([NU, SY, IS, CL, CP].indexOf(next) !== -1) {
      var prevIndex = currentIndex
      while (prevIndex >= 0) {
        var type = classTypes[prevIndex]
        if (type === NU) {
          return BREAK_NOT_ALLOWED$1
        } else if ([SY, IS].indexOf(type) !== -1) {
          prevIndex--
        } else {
          break
        }
      }
    }
    // NU (NU | SY | IS)* (CL | CP)? × (PO | PR))
    if ([PR, PO].indexOf(next) !== -1) {
      var prevIndex = [CL, CP].indexOf(current) !== -1 ? beforeIndex : currentIndex
      while (prevIndex >= 0) {
        var type = classTypes[prevIndex]
        if (type === NU) {
          return BREAK_NOT_ALLOWED$1
        } else if ([SY, IS].indexOf(type) !== -1) {
          prevIndex--
        } else {
          break
        }
      }
    }
    // LB26 Do not break a Korean syllable.
    if (
      (JL === current && [JL, JV, H2, H3].indexOf(next) !== -1) ||
      ([JV, H2].indexOf(current) !== -1 && [JV, JT].indexOf(next) !== -1) ||
      ([JT, H3].indexOf(current) !== -1 && next === JT)
    ) {
      return BREAK_NOT_ALLOWED$1
    }
    // LB27 Treat a Korean Syllable Block the same as ID.
    if (
      (KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 && [IN, PO].indexOf(next) !== -1) ||
      (KOREAN_SYLLABLE_BLOCK.indexOf(next) !== -1 && current === PR)
    ) {
      return BREAK_NOT_ALLOWED$1
    }
    // LB28 Do not break between alphabetics (“at”).
    if (ALPHABETICS.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) {
      return BREAK_NOT_ALLOWED$1
    }
    // LB29 Do not break between numeric punctuation and alphabetics (“e.g.”).
    if (current === IS && ALPHABETICS.indexOf(next) !== -1) {
      return BREAK_NOT_ALLOWED$1
    }
    // LB30 Do not break between letters, numbers, or ordinary symbols and opening or closing parentheses.
    if (
      (ALPHABETICS.concat(NU).indexOf(current) !== -1 &&
        next === OP &&
        ea_OP.indexOf(codePoints[afterIndex]) === -1) ||
      (ALPHABETICS.concat(NU).indexOf(next) !== -1 && current === CP)
    ) {
      return BREAK_NOT_ALLOWED$1
    }
    // LB30a Break between two regional indicator symbols if and only if there are an even number of regional
    // indicators preceding the position of the break.
    if (current === RI$1 && next === RI$1) {
      var i = indicies[currentIndex]
      var count = 1
      while (i > 0) {
        i--
        if (classTypes[i] === RI$1) {
          count++
        } else {
          break
        }
      }
      if (count % 2 !== 0) {
        return BREAK_NOT_ALLOWED$1
      }
    }
    // LB30b Do not break between an emoji base and an emoji modifier.
    if (current === EB && next === EM) {
      return BREAK_NOT_ALLOWED$1
    }
    return BREAK_ALLOWED$1
  }
  var cssFormattedClasses = function(codePoints, options) {
    if (!options) {
      options = { lineBreak: 'normal', wordBreak: 'normal' }
    }
    var _a = codePointsToCharacterClasses(codePoints, options.lineBreak),
      indicies = _a[0],
      classTypes = _a[1],
      isLetterNumber = _a[2]
    if (options.wordBreak === 'break-all' || options.wordBreak === 'break-word') {
      classTypes = classTypes.map(function(type) {
        return [NU, AL, SA].indexOf(type) !== -1 ? ID : type
      })
    }
    var forbiddenBreakpoints =
      options.wordBreak === 'keep-all'
        ? isLetterNumber.map(function(letterNumber, i) {
            return letterNumber && codePoints[i] >= 0x4e00 && codePoints[i] <= 0x9fff
          })
        : undefined
    return [indicies, classTypes, forbiddenBreakpoints]
  }
  var Break = /** @class */ (function() {
    function Break(codePoints, lineBreak, start, end) {
      this.codePoints = codePoints
      this.required = lineBreak === BREAK_MANDATORY
      this.start = start
      this.end = end
    }
    Break.prototype.slice = function() {
      return fromCodePoint$1.apply(void 0, this.codePoints.slice(this.start, this.end))
    }
    return Break
  })()
  var LineBreaker = function(str, options) {
    var codePoints = toCodePoints$1(str)
    var _a = cssFormattedClasses(codePoints, options),
      indicies = _a[0],
      classTypes = _a[1],
      forbiddenBreakpoints = _a[2]
    var length = codePoints.length
    var lastEnd = 0
    var nextIndex = 0
    return {
      next: function() {
        if (nextIndex >= length) {
          return { done: true, value: null }
        }
        var lineBreak = BREAK_NOT_ALLOWED$1
        while (
          nextIndex < length &&
          (lineBreak = _lineBreakAtIndex(
            codePoints,
            classTypes,
            indicies,
            ++nextIndex,
            forbiddenBreakpoints
          )) === BREAK_NOT_ALLOWED$1
        ) {}
        if (lineBreak !== BREAK_NOT_ALLOWED$1 || nextIndex === length) {
          var value = new Break(codePoints, lineBreak, lastEnd, nextIndex)
          lastEnd = nextIndex
          return { value: value, done: false }
        }
        return { done: true, value: null }
      },
    }
  }

  // https://www.w3.org/TR/css-syntax-3
  var FLAG_UNRESTRICTED = 1 << 0
  var FLAG_ID = 1 << 1
  var FLAG_INTEGER = 1 << 2
  var FLAG_NUMBER = 1 << 3
  var LINE_FEED = 0x000a
  var SOLIDUS = 0x002f
  var REVERSE_SOLIDUS = 0x005c
  var CHARACTER_TABULATION = 0x0009
  var SPACE = 0x0020
  var QUOTATION_MARK = 0x0022
  var EQUALS_SIGN = 0x003d
  var NUMBER_SIGN = 0x0023
  var DOLLAR_SIGN = 0x0024
  var PERCENTAGE_SIGN = 0x0025
  var APOSTROPHE = 0x0027
  var LEFT_PARENTHESIS = 0x0028
  var RIGHT_PARENTHESIS = 0x0029
  var LOW_LINE = 0x005f
  var HYPHEN_MINUS = 0x002d
  var EXCLAMATION_MARK = 0x0021
  var LESS_THAN_SIGN = 0x003c
  var GREATER_THAN_SIGN = 0x003e
  var COMMERCIAL_AT = 0x0040
  var LEFT_SQUARE_BRACKET = 0x005b
  var RIGHT_SQUARE_BRACKET = 0x005d
  var CIRCUMFLEX_ACCENT = 0x003d
  var LEFT_CURLY_BRACKET = 0x007b
  var QUESTION_MARK = 0x003f
  var RIGHT_CURLY_BRACKET = 0x007d
  var VERTICAL_LINE = 0x007c
  var TILDE = 0x007e
  var CONTROL = 0x0080
  var REPLACEMENT_CHARACTER = 0xfffd
  var ASTERISK = 0x002a
  var PLUS_SIGN = 0x002b
  var COMMA = 0x002c
  var COLON = 0x003a
  var SEMICOLON = 0x003b
  var FULL_STOP = 0x002e
  var NULL = 0x0000
  var BACKSPACE = 0x0008
  var LINE_TABULATION = 0x000b
  var SHIFT_OUT = 0x000e
  var INFORMATION_SEPARATOR_ONE = 0x001f
  var DELETE = 0x007f
  var EOF = -1
  var ZERO = 0x0030
  var a = 0x0061
  var e = 0x0065
  var f = 0x0066
  var u = 0x0075
  var z = 0x007a
  var A = 0x0041
  var E = 0x0045
  var F = 0x0046
  var U = 0x0055
  var Z = 0x005a
  var isDigit = function(codePoint) {
    return codePoint >= ZERO && codePoint <= 0x0039
  }
  var isSurrogateCodePoint = function(codePoint) {
    return codePoint >= 0xd800 && codePoint <= 0xdfff
  }
  var isHex = function(codePoint) {
    return (
      isDigit(codePoint) || (codePoint >= A && codePoint <= F) || (codePoint >= a && codePoint <= f)
    )
  }
  var isLowerCaseLetter = function(codePoint) {
    return codePoint >= a && codePoint <= z
  }
  var isUpperCaseLetter = function(codePoint) {
    return codePoint >= A && codePoint <= Z
  }
  var isLetter = function(codePoint) {
    return isLowerCaseLetter(codePoint) || isUpperCaseLetter(codePoint)
  }
  var isNonASCIICodePoint = function(codePoint) {
    return codePoint >= CONTROL
  }
  var isWhiteSpace = function(codePoint) {
    return codePoint === LINE_FEED || codePoint === CHARACTER_TABULATION || codePoint === SPACE
  }
  var isNameStartCodePoint = function(codePoint) {
    return isLetter(codePoint) || isNonASCIICodePoint(codePoint) || codePoint === LOW_LINE
  }
  var isNameCodePoint = function(codePoint) {
    return isNameStartCodePoint(codePoint) || isDigit(codePoint) || codePoint === HYPHEN_MINUS
  }
  var isNonPrintableCodePoint = function(codePoint) {
    return (
      (codePoint >= NULL && codePoint <= BACKSPACE) ||
      codePoint === LINE_TABULATION ||
      (codePoint >= SHIFT_OUT && codePoint <= INFORMATION_SEPARATOR_ONE) ||
      codePoint === DELETE
    )
  }
  var isValidEscape = function(c1, c2) {
    if (c1 !== REVERSE_SOLIDUS) {
      return false
    }
    return c2 !== LINE_FEED
  }
  var isIdentifierStart = function(c1, c2, c3) {
    if (c1 === HYPHEN_MINUS) {
      return isNameStartCodePoint(c2) || isValidEscape(c2, c3)
    } else if (isNameStartCodePoint(c1)) {
      return true
    } else if (c1 === REVERSE_SOLIDUS && isValidEscape(c1, c2)) {
      return true
    }
    return false
  }
  var isNumberStart = function(c1, c2, c3) {
    if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
      if (isDigit(c2)) {
        return true
      }
      return c2 === FULL_STOP && isDigit(c3)
    }
    if (c1 === FULL_STOP) {
      return isDigit(c2)
    }
    return isDigit(c1)
  }
  var stringToNumber = function(codePoints) {
    var c = 0
    var sign = 1
    if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
      if (codePoints[c] === HYPHEN_MINUS) {
        sign = -1
      }
      c++
    }
    var integers = []
    while (isDigit(codePoints[c])) {
      integers.push(codePoints[c++])
    }
    var int = integers.length ? parseInt(fromCodePoint$1.apply(void 0, integers), 10) : 0
    if (codePoints[c] === FULL_STOP) {
      c++
    }
    var fraction = []
    while (isDigit(codePoints[c])) {
      fraction.push(codePoints[c++])
    }
    var fracd = fraction.length
    var frac = fracd ? parseInt(fromCodePoint$1.apply(void 0, fraction), 10) : 0
    if (codePoints[c] === E || codePoints[c] === e) {
      c++
    }
    var expsign = 1
    if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
      if (codePoints[c] === HYPHEN_MINUS) {
        expsign = -1
      }
      c++
    }
    var exponent = []
    while (isDigit(codePoints[c])) {
      exponent.push(codePoints[c++])
    }
    var exp = exponent.length ? parseInt(fromCodePoint$1.apply(void 0, exponent), 10) : 0
    return sign * (int + frac * Math.pow(10, -fracd)) * Math.pow(10, expsign * exp)
  }
  var LEFT_PARENTHESIS_TOKEN = {
    type: 2 /* LEFT_PARENTHESIS_TOKEN */,
  }
  var RIGHT_PARENTHESIS_TOKEN = {
    type: 3 /* RIGHT_PARENTHESIS_TOKEN */,
  }
  var COMMA_TOKEN = { type: 4 /* COMMA_TOKEN */ }
  var SUFFIX_MATCH_TOKEN = { type: 13 /* SUFFIX_MATCH_TOKEN */ }
  var PREFIX_MATCH_TOKEN = { type: 8 /* PREFIX_MATCH_TOKEN */ }
  var COLUMN_TOKEN = { type: 21 /* COLUMN_TOKEN */ }
  var DASH_MATCH_TOKEN = { type: 9 /* DASH_MATCH_TOKEN */ }
  var INCLUDE_MATCH_TOKEN = { type: 10 /* INCLUDE_MATCH_TOKEN */ }
  var LEFT_CURLY_BRACKET_TOKEN = {
    type: 11 /* LEFT_CURLY_BRACKET_TOKEN */,
  }
  var RIGHT_CURLY_BRACKET_TOKEN = {
    type: 12 /* RIGHT_CURLY_BRACKET_TOKEN */,
  }
  var SUBSTRING_MATCH_TOKEN = { type: 14 /* SUBSTRING_MATCH_TOKEN */ }
  var BAD_URL_TOKEN = { type: 23 /* BAD_URL_TOKEN */ }
  var BAD_STRING_TOKEN = { type: 1 /* BAD_STRING_TOKEN */ }
  var CDO_TOKEN = { type: 25 /* CDO_TOKEN */ }
  var CDC_TOKEN = { type: 24 /* CDC_TOKEN */ }
  var COLON_TOKEN = { type: 26 /* COLON_TOKEN */ }
  var SEMICOLON_TOKEN = { type: 27 /* SEMICOLON_TOKEN */ }
  var LEFT_SQUARE_BRACKET_TOKEN = {
    type: 28 /* LEFT_SQUARE_BRACKET_TOKEN */,
  }
  var RIGHT_SQUARE_BRACKET_TOKEN = {
    type: 29 /* RIGHT_SQUARE_BRACKET_TOKEN */,
  }
  var WHITESPACE_TOKEN = { type: 31 /* WHITESPACE_TOKEN */ }
  var EOF_TOKEN = { type: 32 /* EOF_TOKEN */ }
  var Tokenizer = /** @class */ (function() {
    function Tokenizer() {
      this._value = []
    }
    Tokenizer.prototype.write = function(chunk) {
      this._value = this._value.concat(toCodePoints$1(chunk))
    }
    Tokenizer.prototype.read = function() {
      var tokens = []
      var token = this.consumeToken()
      while (token !== EOF_TOKEN) {
        tokens.push(token)
        token = this.consumeToken()
      }
      return tokens
    }
    Tokenizer.prototype.consumeToken = function() {
      var codePoint = this.consumeCodePoint()
      switch (codePoint) {
        case QUOTATION_MARK:
          return this.consumeStringToken(QUOTATION_MARK)
        case NUMBER_SIGN:
          var c1 = this.peekCodePoint(0)
          var c2 = this.peekCodePoint(1)
          var c3 = this.peekCodePoint(2)
          if (isNameCodePoint(c1) || isValidEscape(c2, c3)) {
            var flags = isIdentifierStart(c1, c2, c3) ? FLAG_ID : FLAG_UNRESTRICTED
            var value = this.consumeName()
            return { type: 5 /* HASH_TOKEN */, value: value, flags: flags }
          }
          break
        case DOLLAR_SIGN:
          if (this.peekCodePoint(0) === EQUALS_SIGN) {
            this.consumeCodePoint()
            return SUFFIX_MATCH_TOKEN
          }
          break
        case APOSTROPHE:
          return this.consumeStringToken(APOSTROPHE)
        case LEFT_PARENTHESIS:
          return LEFT_PARENTHESIS_TOKEN
        case RIGHT_PARENTHESIS:
          return RIGHT_PARENTHESIS_TOKEN
        case ASTERISK:
          if (this.peekCodePoint(0) === EQUALS_SIGN) {
            this.consumeCodePoint()
            return SUBSTRING_MATCH_TOKEN
          }
          break
        case PLUS_SIGN:
          if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
            this.reconsumeCodePoint(codePoint)
            return this.consumeNumericToken()
          }
          break
        case COMMA:
          return COMMA_TOKEN
        case HYPHEN_MINUS:
          var e1 = codePoint
          var e2 = this.peekCodePoint(0)
          var e3 = this.peekCodePoint(1)
          if (isNumberStart(e1, e2, e3)) {
            this.reconsumeCodePoint(codePoint)
            return this.consumeNumericToken()
          }
          if (isIdentifierStart(e1, e2, e3)) {
            this.reconsumeCodePoint(codePoint)
            return this.consumeIdentLikeToken()
          }
          if (e2 === HYPHEN_MINUS && e3 === GREATER_THAN_SIGN) {
            this.consumeCodePoint()
            this.consumeCodePoint()
            return CDC_TOKEN
          }
          break
        case FULL_STOP:
          if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
            this.reconsumeCodePoint(codePoint)
            return this.consumeNumericToken()
          }
          break
        case SOLIDUS:
          if (this.peekCodePoint(0) === ASTERISK) {
            this.consumeCodePoint()
            while (true) {
              var c = this.consumeCodePoint()
              if (c === ASTERISK) {
                c = this.consumeCodePoint()
                if (c === SOLIDUS) {
                  return this.consumeToken()
                }
              }
              if (c === EOF) {
                return this.consumeToken()
              }
            }
          }
          break
        case COLON:
          return COLON_TOKEN
        case SEMICOLON:
          return SEMICOLON_TOKEN
        case LESS_THAN_SIGN:
          if (
            this.peekCodePoint(0) === EXCLAMATION_MARK &&
            this.peekCodePoint(1) === HYPHEN_MINUS &&
            this.peekCodePoint(2) === HYPHEN_MINUS
          ) {
            this.consumeCodePoint()
            this.consumeCodePoint()
            return CDO_TOKEN
          }
          break
        case COMMERCIAL_AT:
          var a1 = this.peekCodePoint(0)
          var a2 = this.peekCodePoint(1)
          var a3 = this.peekCodePoint(2)
          if (isIdentifierStart(a1, a2, a3)) {
            var value = this.consumeName()
            return { type: 7 /* AT_KEYWORD_TOKEN */, value: value }
          }
          break
        case LEFT_SQUARE_BRACKET:
          return LEFT_SQUARE_BRACKET_TOKEN
        case REVERSE_SOLIDUS:
          if (isValidEscape(codePoint, this.peekCodePoint(0))) {
            this.reconsumeCodePoint(codePoint)
            return this.consumeIdentLikeToken()
          }
          break
        case RIGHT_SQUARE_BRACKET:
          return RIGHT_SQUARE_BRACKET_TOKEN
        case CIRCUMFLEX_ACCENT:
          if (this.peekCodePoint(0) === EQUALS_SIGN) {
            this.consumeCodePoint()
            return PREFIX_MATCH_TOKEN
          }
          break
        case LEFT_CURLY_BRACKET:
          return LEFT_CURLY_BRACKET_TOKEN
        case RIGHT_CURLY_BRACKET:
          return RIGHT_CURLY_BRACKET_TOKEN
        case u:
        case U:
          var u1 = this.peekCodePoint(0)
          var u2 = this.peekCodePoint(1)
          if (u1 === PLUS_SIGN && (isHex(u2) || u2 === QUESTION_MARK)) {
            this.consumeCodePoint()
            this.consumeUnicodeRangeToken()
          }
          this.reconsumeCodePoint(codePoint)
          return this.consumeIdentLikeToken()
        case VERTICAL_LINE:
          if (this.peekCodePoint(0) === EQUALS_SIGN) {
            this.consumeCodePoint()
            return DASH_MATCH_TOKEN
          }
          if (this.peekCodePoint(0) === VERTICAL_LINE) {
            this.consumeCodePoint()
            return COLUMN_TOKEN
          }
          break
        case TILDE:
          if (this.peekCodePoint(0) === EQUALS_SIGN) {
            this.consumeCodePoint()
            return INCLUDE_MATCH_TOKEN
          }
          break
        case EOF:
          return EOF_TOKEN
      }
      if (isWhiteSpace(codePoint)) {
        this.consumeWhiteSpace()
        return WHITESPACE_TOKEN
      }
      if (isDigit(codePoint)) {
        this.reconsumeCodePoint(codePoint)
        return this.consumeNumericToken()
      }
      if (isNameStartCodePoint(codePoint)) {
        this.reconsumeCodePoint(codePoint)
        return this.consumeIdentLikeToken()
      }
      return { type: 6 /* DELIM_TOKEN */, value: fromCodePoint$1(codePoint) }
    }
    Tokenizer.prototype.consumeCodePoint = function() {
      var value = this._value.shift()
      return typeof value === 'undefined' ? -1 : value
    }
    Tokenizer.prototype.reconsumeCodePoint = function(codePoint) {
      this._value.unshift(codePoint)
    }
    Tokenizer.prototype.peekCodePoint = function(delta) {
      if (delta >= this._value.length) {
        return -1
      }
      return this._value[delta]
    }
    Tokenizer.prototype.consumeUnicodeRangeToken = function() {
      var digits = []
      var codePoint = this.consumeCodePoint()
      while (isHex(codePoint) && digits.length < 6) {
        digits.push(codePoint)
        codePoint = this.consumeCodePoint()
      }
      var questionMarks = false
      while (codePoint === QUESTION_MARK && digits.length < 6) {
        digits.push(codePoint)
        codePoint = this.consumeCodePoint()
        questionMarks = true
      }
      if (questionMarks) {
        var start_1 = parseInt(
          fromCodePoint$1.apply(
            void 0,
            digits.map(function(digit) {
              return digit === QUESTION_MARK ? ZERO : digit
            })
          ),
          16
        )
        var end = parseInt(
          fromCodePoint$1.apply(
            void 0,
            digits.map(function(digit) {
              return digit === QUESTION_MARK ? F : digit
            })
          ),
          16
        )
        return { type: 30 /* UNICODE_RANGE_TOKEN */, start: start_1, end: end }
      }
      var start = parseInt(fromCodePoint$1.apply(void 0, digits), 16)
      if (this.peekCodePoint(0) === HYPHEN_MINUS && isHex(this.peekCodePoint(1))) {
        this.consumeCodePoint()
        codePoint = this.consumeCodePoint()
        var endDigits = []
        while (isHex(codePoint) && endDigits.length < 6) {
          endDigits.push(codePoint)
          codePoint = this.consumeCodePoint()
        }
        var end = parseInt(fromCodePoint$1.apply(void 0, endDigits), 16)
        return { type: 30 /* UNICODE_RANGE_TOKEN */, start: start, end: end }
      } else {
        return { type: 30 /* UNICODE_RANGE_TOKEN */, start: start, end: start }
      }
    }
    Tokenizer.prototype.consumeIdentLikeToken = function() {
      var value = this.consumeName()
      if (value.toLowerCase() === 'url' && this.peekCodePoint(0) === LEFT_PARENTHESIS) {
        this.consumeCodePoint()
        return this.consumeUrlToken()
      } else if (this.peekCodePoint(0) === LEFT_PARENTHESIS) {
        this.consumeCodePoint()
        return { type: 19 /* FUNCTION_TOKEN */, value: value }
      }
      return { type: 20 /* IDENT_TOKEN */, value: value }
    }
    Tokenizer.prototype.consumeUrlToken = function() {
      var value = []
      this.consumeWhiteSpace()
      if (this.peekCodePoint(0) === EOF) {
        return { type: 22 /* URL_TOKEN */, value: '' }
      }
      var next = this.peekCodePoint(0)
      if (next === APOSTROPHE || next === QUOTATION_MARK) {
        var stringToken = this.consumeStringToken(this.consumeCodePoint())
        if (stringToken.type === 0 /* STRING_TOKEN */) {
          this.consumeWhiteSpace()
          if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
            this.consumeCodePoint()
            return { type: 22 /* URL_TOKEN */, value: stringToken.value }
          }
        }
        this.consumeBadUrlRemnants()
        return BAD_URL_TOKEN
      }
      while (true) {
        var codePoint = this.consumeCodePoint()
        if (codePoint === EOF || codePoint === RIGHT_PARENTHESIS) {
          return { type: 22 /* URL_TOKEN */, value: fromCodePoint$1.apply(void 0, value) }
        } else if (isWhiteSpace(codePoint)) {
          this.consumeWhiteSpace()
          if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
            this.consumeCodePoint()
            return { type: 22 /* URL_TOKEN */, value: fromCodePoint$1.apply(void 0, value) }
          }
          this.consumeBadUrlRemnants()
          return BAD_URL_TOKEN
        } else if (
          codePoint === QUOTATION_MARK ||
          codePoint === APOSTROPHE ||
          codePoint === LEFT_PARENTHESIS ||
          isNonPrintableCodePoint(codePoint)
        ) {
          this.consumeBadUrlRemnants()
          return BAD_URL_TOKEN
        } else if (codePoint === REVERSE_SOLIDUS) {
          if (isValidEscape(codePoint, this.peekCodePoint(0))) {
            value.push(this.consumeEscapedCodePoint())
          } else {
            this.consumeBadUrlRemnants()
            return BAD_URL_TOKEN
          }
        } else {
          value.push(codePoint)
        }
      }
    }
    Tokenizer.prototype.consumeWhiteSpace = function() {
      while (isWhiteSpace(this.peekCodePoint(0))) {
        this.consumeCodePoint()
      }
    }
    Tokenizer.prototype.consumeBadUrlRemnants = function() {
      while (true) {
        var codePoint = this.consumeCodePoint()
        if (codePoint === RIGHT_PARENTHESIS || codePoint === EOF) {
          return
        }
        if (isValidEscape(codePoint, this.peekCodePoint(0))) {
          this.consumeEscapedCodePoint()
        }
      }
    }
    Tokenizer.prototype.consumeStringSlice = function(count) {
      var SLICE_STACK_SIZE = 50000
      var value = ''
      while (count > 0) {
        var amount = Math.min(SLICE_STACK_SIZE, count)
        value += fromCodePoint$1.apply(void 0, this._value.splice(0, amount))
        count -= amount
      }
      this._value.shift()
      return value
    }
    Tokenizer.prototype.consumeStringToken = function(endingCodePoint) {
      var value = ''
      var i = 0
      do {
        var codePoint = this._value[i]
        if (codePoint === EOF || codePoint === undefined || codePoint === endingCodePoint) {
          value += this.consumeStringSlice(i)
          return { type: 0 /* STRING_TOKEN */, value: value }
        }
        if (codePoint === LINE_FEED) {
          this._value.splice(0, i)
          return BAD_STRING_TOKEN
        }
        if (codePoint === REVERSE_SOLIDUS) {
          var next = this._value[i + 1]
          if (next !== EOF && next !== undefined) {
            if (next === LINE_FEED) {
              value += this.consumeStringSlice(i)
              i = -1
              this._value.shift()
            } else if (isValidEscape(codePoint, next)) {
              value += this.consumeStringSlice(i)
              value += fromCodePoint$1(this.consumeEscapedCodePoint())
              i = -1
            }
          }
        }
        i++
      } while (true)
    }
    Tokenizer.prototype.consumeNumber = function() {
      var repr = []
      var type = FLAG_INTEGER
      var c1 = this.peekCodePoint(0)
      if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
        repr.push(this.consumeCodePoint())
      }
      while (isDigit(this.peekCodePoint(0))) {
        repr.push(this.consumeCodePoint())
      }
      c1 = this.peekCodePoint(0)
      var c2 = this.peekCodePoint(1)
      if (c1 === FULL_STOP && isDigit(c2)) {
        repr.push(this.consumeCodePoint(), this.consumeCodePoint())
        type = FLAG_NUMBER
        while (isDigit(this.peekCodePoint(0))) {
          repr.push(this.consumeCodePoint())
        }
      }
      c1 = this.peekCodePoint(0)
      c2 = this.peekCodePoint(1)
      var c3 = this.peekCodePoint(2)
      if (
        (c1 === E || c1 === e) &&
        (((c2 === PLUS_SIGN || c2 === HYPHEN_MINUS) && isDigit(c3)) || isDigit(c2))
      ) {
        repr.push(this.consumeCodePoint(), this.consumeCodePoint())
        type = FLAG_NUMBER
        while (isDigit(this.peekCodePoint(0))) {
          repr.push(this.consumeCodePoint())
        }
      }
      return [stringToNumber(repr), type]
    }
    Tokenizer.prototype.consumeNumericToken = function() {
      var _a = this.consumeNumber(),
        number = _a[0],
        flags = _a[1]
      var c1 = this.peekCodePoint(0)
      var c2 = this.peekCodePoint(1)
      var c3 = this.peekCodePoint(2)
      if (isIdentifierStart(c1, c2, c3)) {
        var unit = this.consumeName()
        return { type: 15 /* DIMENSION_TOKEN */, number: number, flags: flags, unit: unit }
      }
      if (c1 === PERCENTAGE_SIGN) {
        this.consumeCodePoint()
        return { type: 16 /* PERCENTAGE_TOKEN */, number: number, flags: flags }
      }
      return { type: 17 /* NUMBER_TOKEN */, number: number, flags: flags }
    }
    Tokenizer.prototype.consumeEscapedCodePoint = function() {
      var codePoint = this.consumeCodePoint()
      if (isHex(codePoint)) {
        var hex = fromCodePoint$1(codePoint)
        while (isHex(this.peekCodePoint(0)) && hex.length < 6) {
          hex += fromCodePoint$1(this.consumeCodePoint())
        }
        if (isWhiteSpace(this.peekCodePoint(0))) {
          this.consumeCodePoint()
        }
        var hexCodePoint = parseInt(hex, 16)
        if (hexCodePoint === 0 || isSurrogateCodePoint(hexCodePoint) || hexCodePoint > 0x10ffff) {
          return REPLACEMENT_CHARACTER
        }
        return hexCodePoint
      }
      if (codePoint === EOF) {
        return REPLACEMENT_CHARACTER
      }
      return codePoint
    }
    Tokenizer.prototype.consumeName = function() {
      var result = ''
      while (true) {
        var codePoint = this.consumeCodePoint()
        if (isNameCodePoint(codePoint)) {
          result += fromCodePoint$1(codePoint)
        } else if (isValidEscape(codePoint, this.peekCodePoint(0))) {
          result += fromCodePoint$1(this.consumeEscapedCodePoint())
        } else {
          this.reconsumeCodePoint(codePoint)
          return result
        }
      }
    }
    return Tokenizer
  })()

  var Parser = /** @class */ (function() {
    function Parser(tokens) {
      this._tokens = tokens
    }
    Parser.create = function(value) {
      var tokenizer = new Tokenizer()
      tokenizer.write(value)
      return new Parser(tokenizer.read())
    }
    Parser.parseValue = function(value) {
      return Parser.create(value).parseComponentValue()
    }
    Parser.parseValues = function(value) {
      return Parser.create(value).parseComponentValues()
    }
    Parser.prototype.parseComponentValue = function() {
      var token = this.consumeToken()
      while (token.type === 31 /* WHITESPACE_TOKEN */) {
        token = this.consumeToken()
      }
      if (token.type === 32 /* EOF_TOKEN */) {
        throw new SyntaxError('Error parsing CSS component value, unexpected EOF')
      }
      this.reconsumeToken(token)
      var value = this.consumeComponentValue()
      do {
        token = this.consumeToken()
      } while (token.type === 31 /* WHITESPACE_TOKEN */)
      if (token.type === 32 /* EOF_TOKEN */) {
        return value
      }
      throw new SyntaxError(
        'Error parsing CSS component value, multiple values found when expecting only one'
      )
    }
    Parser.prototype.parseComponentValues = function() {
      var values = []
      while (true) {
        var value = this.consumeComponentValue()
        if (value.type === 32 /* EOF_TOKEN */) {
          return values
        }
        values.push(value)
        values.push()
      }
    }
    Parser.prototype.consumeComponentValue = function() {
      var token = this.consumeToken()
      switch (token.type) {
        case 11 /* LEFT_CURLY_BRACKET_TOKEN */:
        case 28 /* LEFT_SQUARE_BRACKET_TOKEN */:
        case 2 /* LEFT_PARENTHESIS_TOKEN */:
          return this.consumeSimpleBlock(token.type)
        case 19 /* FUNCTION_TOKEN */:
          return this.consumeFunction(token)
      }
      return token
    }
    Parser.prototype.consumeSimpleBlock = function(type) {
      var block = { type: type, values: [] }
      var token = this.consumeToken()
      while (true) {
        if (token.type === 32 /* EOF_TOKEN */ || isEndingTokenFor(token, type)) {
          return block
        }
        this.reconsumeToken(token)
        block.values.push(this.consumeComponentValue())
        token = this.consumeToken()
      }
    }
    Parser.prototype.consumeFunction = function(functionToken) {
      var cssFunction = {
        name: functionToken.value,
        values: [],
        type: 18 /* FUNCTION */,
      }
      while (true) {
        var token = this.consumeToken()
        if (token.type === 32 /* EOF_TOKEN */ || token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */) {
          return cssFunction
        }
        this.reconsumeToken(token)
        cssFunction.values.push(this.consumeComponentValue())
      }
    }
    Parser.prototype.consumeToken = function() {
      var token = this._tokens.shift()
      return typeof token === 'undefined' ? EOF_TOKEN : token
    }
    Parser.prototype.reconsumeToken = function(token) {
      this._tokens.unshift(token)
    }
    return Parser
  })()
  var isDimensionToken = function(token) {
    return token.type === 15 /* DIMENSION_TOKEN */
  }
  var isNumberToken = function(token) {
    return token.type === 17 /* NUMBER_TOKEN */
  }
  var isIdentToken = function(token) {
    return token.type === 20 /* IDENT_TOKEN */
  }
  var isStringToken = function(token) {
    return token.type === 0 /* STRING_TOKEN */
  }
  var isIdentWithValue = function(token, value) {
    return isIdentToken(token) && token.value === value
  }
  var nonWhiteSpace = function(token) {
    return token.type !== 31 /* WHITESPACE_TOKEN */
  }
  var nonFunctionArgSeparator = function(token) {
    return token.type !== 31 /* WHITESPACE_TOKEN */ && token.type !== 4 /* COMMA_TOKEN */
  }
  var parseFunctionArgs = function(tokens) {
    var args = []
    var arg = []
    tokens.forEach(function(token) {
      if (token.type === 4 /* COMMA_TOKEN */) {
        if (arg.length === 0) {
          throw new Error('Error parsing function args, zero tokens for arg')
        }
        args.push(arg)
        arg = []
        return
      }
      if (token.type !== 31 /* WHITESPACE_TOKEN */) {
        arg.push(token)
      }
    })
    if (arg.length) {
      args.push(arg)
    }
    return args
  }
  var isEndingTokenFor = function(token, type) {
    if (
      type === 11 /* LEFT_CURLY_BRACKET_TOKEN */ &&
      token.type === 12 /* RIGHT_CURLY_BRACKET_TOKEN */
    ) {
      return true
    }
    if (
      type === 28 /* LEFT_SQUARE_BRACKET_TOKEN */ &&
      token.type === 29 /* RIGHT_SQUARE_BRACKET_TOKEN */
    ) {
      return true
    }
    return type === 2 /* LEFT_PARENTHESIS_TOKEN */ && token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */
  }

  var isLength = function(token) {
    return token.type === 17 /* NUMBER_TOKEN */ || token.type === 15 /* DIMENSION_TOKEN */
  }

  var isLengthPercentage = function(token) {
    return token.type === 16 /* PERCENTAGE_TOKEN */ || isLength(token)
  }
  var parseLengthPercentageTuple = function(tokens) {
    return tokens.length > 1 ? [tokens[0], tokens[1]] : [tokens[0]]
  }
  var ZERO_LENGTH = {
    type: 17 /* NUMBER_TOKEN */,
    number: 0,
    flags: FLAG_INTEGER,
  }
  var FIFTY_PERCENT = {
    type: 16 /* PERCENTAGE_TOKEN */,
    number: 50,
    flags: FLAG_INTEGER,
  }
  var HUNDRED_PERCENT = {
    type: 16 /* PERCENTAGE_TOKEN */,
    number: 100,
    flags: FLAG_INTEGER,
  }
  var getAbsoluteValueForTuple = function(tuple, width, height) {
    var x = tuple[0],
      y = tuple[1]
    return [getAbsoluteValue(x, width), getAbsoluteValue(typeof y !== 'undefined' ? y : x, height)]
  }
  var getAbsoluteValue = function(token, parent) {
    if (token.type === 16 /* PERCENTAGE_TOKEN */) {
      return (token.number / 100) * parent
    }
    if (isDimensionToken(token)) {
      switch (token.unit) {
        case 'rem':
        case 'em':
          return 16 * token.number // TODO use correct font-size
        case 'px':
        default:
          return token.number
      }
    }
    return token.number
  }

  var DEG = 'deg'
  var GRAD = 'grad'
  var RAD = 'rad'
  var TURN = 'turn'
  var angle = {
    name: 'angle',
    parse: function(_context, value) {
      if (value.type === 15 /* DIMENSION_TOKEN */) {
        switch (value.unit) {
          case DEG:
            return (Math.PI * value.number) / 180
          case GRAD:
            return (Math.PI / 200) * value.number
          case RAD:
            return value.number
          case TURN:
            return Math.PI * 2 * value.number
        }
      }
      throw new Error('Unsupported angle type')
    },
  }
  var isAngle = function(value) {
    if (value.type === 15 /* DIMENSION_TOKEN */) {
      if (value.unit === DEG || value.unit === GRAD || value.unit === RAD || value.unit === TURN) {
        return true
      }
    }
    return false
  }
  var parseNamedSide = function(tokens) {
    var sideOrCorner = tokens
      .filter(isIdentToken)
      .map(function(ident) {
        return ident.value
      })
      .join(' ')
    switch (sideOrCorner) {
      case 'to bottom right':
      case 'to right bottom':
      case 'left top':
      case 'top left':
        return [ZERO_LENGTH, ZERO_LENGTH]
      case 'to top':
      case 'bottom':
        return deg(0)
      case 'to bottom left':
      case 'to left bottom':
      case 'right top':
      case 'top right':
        return [ZERO_LENGTH, HUNDRED_PERCENT]
      case 'to right':
      case 'left':
        return deg(90)
      case 'to top left':
      case 'to left top':
      case 'right bottom':
      case 'bottom right':
        return [HUNDRED_PERCENT, HUNDRED_PERCENT]
      case 'to bottom':
      case 'top':
        return deg(180)
      case 'to top right':
      case 'to right top':
      case 'left bottom':
      case 'bottom left':
        return [HUNDRED_PERCENT, ZERO_LENGTH]
      case 'to left':
      case 'right':
        return deg(270)
    }
    return 0
  }
  var deg = function(deg) {
    return (Math.PI * deg) / 180
  }

  var color$1 = {
    name: 'color',
    parse: function(context, value) {
      if (value.type === 18 /* FUNCTION */) {
        var colorFunction = SUPPORTED_COLOR_FUNCTIONS[value.name]
        if (typeof colorFunction === 'undefined') {
          throw new Error('Attempting to parse an unsupported color function "' + value.name + '"')
        }
        return colorFunction(context, value.values)
      }
      if (value.type === 5 /* HASH_TOKEN */) {
        if (value.value.length === 3) {
          var r = value.value.substring(0, 1)
          var g = value.value.substring(1, 2)
          var b = value.value.substring(2, 3)
          return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), 1)
        }
        if (value.value.length === 4) {
          var r = value.value.substring(0, 1)
          var g = value.value.substring(1, 2)
          var b = value.value.substring(2, 3)
          var a = value.value.substring(3, 4)
          return pack(
            parseInt(r + r, 16),
            parseInt(g + g, 16),
            parseInt(b + b, 16),
            parseInt(a + a, 16) / 255
          )
        }
        if (value.value.length === 6) {
          var r = value.value.substring(0, 2)
          var g = value.value.substring(2, 4)
          var b = value.value.substring(4, 6)
          return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), 1)
        }
        if (value.value.length === 8) {
          var r = value.value.substring(0, 2)
          var g = value.value.substring(2, 4)
          var b = value.value.substring(4, 6)
          var a = value.value.substring(6, 8)
          return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), parseInt(a, 16) / 255)
        }
      }
      if (value.type === 20 /* IDENT_TOKEN */) {
        var namedColor = COLORS[value.value.toUpperCase()]
        if (typeof namedColor !== 'undefined') {
          return namedColor
        }
      }
      return COLORS.TRANSPARENT
    },
  }
  var isTransparent = function(color) {
    return (0xff & color) === 0
  }
  var asString = function(color) {
    var alpha = 0xff & color
    var blue = 0xff & (color >> 8)
    var green = 0xff & (color >> 16)
    var red = 0xff & (color >> 24)
    return alpha < 255
      ? 'rgba(' + red + ',' + green + ',' + blue + ',' + alpha / 255 + ')'
      : 'rgb(' + red + ',' + green + ',' + blue + ')'
  }
  var pack = function(r, g, b, a) {
    return ((r << 24) | (g << 16) | (b << 8) | (Math.round(a * 255) << 0)) >>> 0
  }
  var getTokenColorValue = function(token, i) {
    if (token.type === 17 /* NUMBER_TOKEN */) {
      return token.number
    }
    if (token.type === 16 /* PERCENTAGE_TOKEN */) {
      var max = i === 3 ? 1 : 255
      return i === 3 ? (token.number / 100) * max : Math.round((token.number / 100) * max)
    }
    return 0
  }
  var rgb = function(_context, args) {
    var tokens = args.filter(nonFunctionArgSeparator)
    if (tokens.length === 3) {
      var _a = tokens.map(getTokenColorValue),
        r = _a[0],
        g = _a[1],
        b = _a[2]
      return pack(r, g, b, 1)
    }
    if (tokens.length === 4) {
      var _b = tokens.map(getTokenColorValue),
        r = _b[0],
        g = _b[1],
        b = _b[2],
        a = _b[3]
      return pack(r, g, b, a)
    }
    return 0
  }
  function hue2rgb(t1, t2, hue) {
    if (hue < 0) {
      hue += 1
    }
    if (hue >= 1) {
      hue -= 1
    }
    if (hue < 1 / 6) {
      return (t2 - t1) * hue * 6 + t1
    } else if (hue < 1 / 2) {
      return t2
    } else if (hue < 2 / 3) {
      return (t2 - t1) * 6 * (2 / 3 - hue) + t1
    } else {
      return t1
    }
  }
  var hsl = function(context, args) {
    var tokens = args.filter(nonFunctionArgSeparator)
    var hue = tokens[0],
      saturation = tokens[1],
      lightness = tokens[2],
      alpha = tokens[3]
    var h =
      (hue.type === 17 /* NUMBER_TOKEN */ ? deg(hue.number) : angle.parse(context, hue)) /
      (Math.PI * 2)
    var s = isLengthPercentage(saturation) ? saturation.number / 100 : 0
    var l = isLengthPercentage(lightness) ? lightness.number / 100 : 0
    var a =
      typeof alpha !== 'undefined' && isLengthPercentage(alpha) ? getAbsoluteValue(alpha, 1) : 1
    if (s === 0) {
      return pack(l * 255, l * 255, l * 255, 1)
    }
    var t2 = l <= 0.5 ? l * (s + 1) : l + s - l * s
    var t1 = l * 2 - t2
    var r = hue2rgb(t1, t2, h + 1 / 3)
    var g = hue2rgb(t1, t2, h)
    var b = hue2rgb(t1, t2, h - 1 / 3)
    return pack(r * 255, g * 255, b * 255, a)
  }
  var SUPPORTED_COLOR_FUNCTIONS = {
    hsl: hsl,
    hsla: hsl,
    rgb: rgb,
    rgba: rgb,
  }
  var parseColor = function(context, value) {
    return color$1.parse(context, Parser.create(value).parseComponentValue())
  }
  var COLORS = {
    ALICEBLUE: 0xf0f8ffff,
    ANTIQUEWHITE: 0xfaebd7ff,
    AQUA: 0x00ffffff,
    AQUAMARINE: 0x7fffd4ff,
    AZURE: 0xf0ffffff,
    BEIGE: 0xf5f5dcff,
    BISQUE: 0xffe4c4ff,
    BLACK: 0x000000ff,
    BLANCHEDALMOND: 0xffebcdff,
    BLUE: 0x0000ffff,
    BLUEVIOLET: 0x8a2be2ff,
    BROWN: 0xa52a2aff,
    BURLYWOOD: 0xdeb887ff,
    CADETBLUE: 0x5f9ea0ff,
    CHARTREUSE: 0x7fff00ff,
    CHOCOLATE: 0xd2691eff,
    CORAL: 0xff7f50ff,
    CORNFLOWERBLUE: 0x6495edff,
    CORNSILK: 0xfff8dcff,
    CRIMSON: 0xdc143cff,
    CYAN: 0x00ffffff,
    DARKBLUE: 0x00008bff,
    DARKCYAN: 0x008b8bff,
    DARKGOLDENROD: 0xb886bbff,
    DARKGRAY: 0xa9a9a9ff,
    DARKGREEN: 0x006400ff,
    DARKGREY: 0xa9a9a9ff,
    DARKKHAKI: 0xbdb76bff,
    DARKMAGENTA: 0x8b008bff,
    DARKOLIVEGREEN: 0x556b2fff,
    DARKORANGE: 0xff8c00ff,
    DARKORCHID: 0x9932ccff,
    DARKRED: 0x8b0000ff,
    DARKSALMON: 0xe9967aff,
    DARKSEAGREEN: 0x8fbc8fff,
    DARKSLATEBLUE: 0x483d8bff,
    DARKSLATEGRAY: 0x2f4f4fff,
    DARKSLATEGREY: 0x2f4f4fff,
    DARKTURQUOISE: 0x00ced1ff,
    DARKVIOLET: 0x9400d3ff,
    DEEPPINK: 0xff1493ff,
    DEEPSKYBLUE: 0x00bfffff,
    DIMGRAY: 0x696969ff,
    DIMGREY: 0x696969ff,
    DODGERBLUE: 0x1e90ffff,
    FIREBRICK: 0xb22222ff,
    FLORALWHITE: 0xfffaf0ff,
    FORESTGREEN: 0x228b22ff,
    FUCHSIA: 0xff00ffff,
    GAINSBORO: 0xdcdcdcff,
    GHOSTWHITE: 0xf8f8ffff,
    GOLD: 0xffd700ff,
    GOLDENROD: 0xdaa520ff,
    GRAY: 0x808080ff,
    GREEN: 0x008000ff,
    GREENYELLOW: 0xadff2fff,
    GREY: 0x808080ff,
    HONEYDEW: 0xf0fff0ff,
    HOTPINK: 0xff69b4ff,
    INDIANRED: 0xcd5c5cff,
    INDIGO: 0x4b0082ff,
    IVORY: 0xfffff0ff,
    KHAKI: 0xf0e68cff,
    LAVENDER: 0xe6e6faff,
    LAVENDERBLUSH: 0xfff0f5ff,
    LAWNGREEN: 0x7cfc00ff,
    LEMONCHIFFON: 0xfffacdff,
    LIGHTBLUE: 0xadd8e6ff,
    LIGHTCORAL: 0xf08080ff,
    LIGHTCYAN: 0xe0ffffff,
    LIGHTGOLDENRODYELLOW: 0xfafad2ff,
    LIGHTGRAY: 0xd3d3d3ff,
    LIGHTGREEN: 0x90ee90ff,
    LIGHTGREY: 0xd3d3d3ff,
    LIGHTPINK: 0xffb6c1ff,
    LIGHTSALMON: 0xffa07aff,
    LIGHTSEAGREEN: 0x20b2aaff,
    LIGHTSKYBLUE: 0x87cefaff,
    LIGHTSLATEGRAY: 0x778899ff,
    LIGHTSLATEGREY: 0x778899ff,
    LIGHTSTEELBLUE: 0xb0c4deff,
    LIGHTYELLOW: 0xffffe0ff,
    LIME: 0x00ff00ff,
    LIMEGREEN: 0x32cd32ff,
    LINEN: 0xfaf0e6ff,
    MAGENTA: 0xff00ffff,
    MAROON: 0x800000ff,
    MEDIUMAQUAMARINE: 0x66cdaaff,
    MEDIUMBLUE: 0x0000cdff,
    MEDIUMORCHID: 0xba55d3ff,
    MEDIUMPURPLE: 0x9370dbff,
    MEDIUMSEAGREEN: 0x3cb371ff,
    MEDIUMSLATEBLUE: 0x7b68eeff,
    MEDIUMSPRINGGREEN: 0x00fa9aff,
    MEDIUMTURQUOISE: 0x48d1ccff,
    MEDIUMVIOLETRED: 0xc71585ff,
    MIDNIGHTBLUE: 0x191970ff,
    MINTCREAM: 0xf5fffaff,
    MISTYROSE: 0xffe4e1ff,
    MOCCASIN: 0xffe4b5ff,
    NAVAJOWHITE: 0xffdeadff,
    NAVY: 0x000080ff,
    OLDLACE: 0xfdf5e6ff,
    OLIVE: 0x808000ff,
    OLIVEDRAB: 0x6b8e23ff,
    ORANGE: 0xffa500ff,
    ORANGERED: 0xff4500ff,
    ORCHID: 0xda70d6ff,
    PALEGOLDENROD: 0xeee8aaff,
    PALEGREEN: 0x98fb98ff,
    PALETURQUOISE: 0xafeeeeff,
    PALEVIOLETRED: 0xdb7093ff,
    PAPAYAWHIP: 0xffefd5ff,
    PEACHPUFF: 0xffdab9ff,
    PERU: 0xcd853fff,
    PINK: 0xffc0cbff,
    PLUM: 0xdda0ddff,
    POWDERBLUE: 0xb0e0e6ff,
    PURPLE: 0x800080ff,
    REBECCAPURPLE: 0x663399ff,
    RED: 0xff0000ff,
    ROSYBROWN: 0xbc8f8fff,
    ROYALBLUE: 0x4169e1ff,
    SADDLEBROWN: 0x8b4513ff,
    SALMON: 0xfa8072ff,
    SANDYBROWN: 0xf4a460ff,
    SEAGREEN: 0x2e8b57ff,
    SEASHELL: 0xfff5eeff,
    SIENNA: 0xa0522dff,
    SILVER: 0xc0c0c0ff,
    SKYBLUE: 0x87ceebff,
    SLATEBLUE: 0x6a5acdff,
    SLATEGRAY: 0x708090ff,
    SLATEGREY: 0x708090ff,
    SNOW: 0xfffafaff,
    SPRINGGREEN: 0x00ff7fff,
    STEELBLUE: 0x4682b4ff,
    TAN: 0xd2b48cff,
    TEAL: 0x008080ff,
    THISTLE: 0xd8bfd8ff,
    TOMATO: 0xff6347ff,
    TRANSPARENT: 0x00000000,
    TURQUOISE: 0x40e0d0ff,
    VIOLET: 0xee82eeff,
    WHEAT: 0xf5deb3ff,
    WHITE: 0xffffffff,
    WHITESMOKE: 0xf5f5f5ff,
    YELLOW: 0xffff00ff,
    YELLOWGREEN: 0x9acd32ff,
  }

  var backgroundClip = {
    name: 'background-clip',
    initialValue: 'border-box',
    prefix: false,
    type: 1 /* LIST */,
    parse: function(_context, tokens) {
      return tokens.map(function(token) {
        if (isIdentToken(token)) {
          switch (token.value) {
            case 'padding-box':
              return 1 /* PADDING_BOX */
            case 'content-box':
              return 2 /* CONTENT_BOX */
          }
        }
        return 0 /* BORDER_BOX */
      })
    },
  }

  var backgroundColor = {
    name: 'background-color',
    initialValue: 'transparent',
    prefix: false,
    type: 3 /* TYPE_VALUE */,
    format: 'color',
  }

  var parseColorStop = function(context, args) {
    var color = color$1.parse(context, args[0])
    var stop = args[1]
    return stop && isLengthPercentage(stop)
      ? { color: color, stop: stop }
      : { color: color, stop: null }
  }
  var processColorStops = function(stops, lineLength) {
    var first = stops[0]
    var last = stops[stops.length - 1]
    if (first.stop === null) {
      first.stop = ZERO_LENGTH
    }
    if (last.stop === null) {
      last.stop = HUNDRED_PERCENT
    }
    var processStops = []
    var previous = 0
    for (var i = 0; i < stops.length; i++) {
      var stop_1 = stops[i].stop
      if (stop_1 !== null) {
        var absoluteValue = getAbsoluteValue(stop_1, lineLength)
        if (absoluteValue > previous) {
          processStops.push(absoluteValue)
        } else {
          processStops.push(previous)
        }
        previous = absoluteValue
      } else {
        processStops.push(null)
      }
    }
    var gapBegin = null
    for (var i = 0; i < processStops.length; i++) {
      var stop_2 = processStops[i]
      if (stop_2 === null) {
        if (gapBegin === null) {
          gapBegin = i
        }
      } else if (gapBegin !== null) {
        var gapLength = i - gapBegin
        var beforeGap = processStops[gapBegin - 1]
        var gapValue = (stop_2 - beforeGap) / (gapLength + 1)
        for (var g = 1; g <= gapLength; g++) {
          processStops[gapBegin + g - 1] = gapValue * g
        }
        gapBegin = null
      }
    }
    return stops.map(function(_a, i) {
      var color = _a.color
      return { color: color, stop: Math.max(Math.min(1, processStops[i] / lineLength), 0) }
    })
  }
  var getAngleFromCorner = function(corner, width, height) {
    var centerX = width / 2
    var centerY = height / 2
    var x = getAbsoluteValue(corner[0], width) - centerX
    var y = centerY - getAbsoluteValue(corner[1], height)
    return (Math.atan2(y, x) + Math.PI * 2) % (Math.PI * 2)
  }
  var calculateGradientDirection = function(angle, width, height) {
    var radian = typeof angle === 'number' ? angle : getAngleFromCorner(angle, width, height)
    var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian))
    var halfWidth = width / 2
    var halfHeight = height / 2
    var halfLineLength = lineLength / 2
    var yDiff = Math.sin(radian - Math.PI / 2) * halfLineLength
    var xDiff = Math.cos(radian - Math.PI / 2) * halfLineLength
    return [
      lineLength,
      halfWidth - xDiff,
      halfWidth + xDiff,
      halfHeight - yDiff,
      halfHeight + yDiff,
    ]
  }
  var distance = function(a, b) {
    return Math.sqrt(a * a + b * b)
  }
  var findCorner = function(width, height, x, y, closest) {
    var corners = [
      [0, 0],
      [0, height],
      [width, 0],
      [width, height],
    ]
    return corners.reduce(
      function(stat, corner) {
        var cx = corner[0],
          cy = corner[1]
        var d = distance(x - cx, y - cy)
        if (closest ? d < stat.optimumDistance : d > stat.optimumDistance) {
          return {
            optimumCorner: corner,
            optimumDistance: d,
          }
        }
        return stat
      },
      {
        optimumDistance: closest ? Infinity : -Infinity,
        optimumCorner: null,
      }
    ).optimumCorner
  }
  var calculateRadius = function(gradient, x, y, width, height) {
    var rx = 0
    var ry = 0
    switch (gradient.size) {
      case 0 /* CLOSEST_SIDE */:
        // The ending shape is sized so that that it exactly meets the side of the gradient box closest to the gradient’s center.
        // If the shape is an ellipse, it exactly meets the closest side in each dimension.
        if (gradient.shape === 0 /* CIRCLE */) {
          rx = ry = Math.min(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height))
        } else if (gradient.shape === 1 /* ELLIPSE */) {
          rx = Math.min(Math.abs(x), Math.abs(x - width))
          ry = Math.min(Math.abs(y), Math.abs(y - height))
        }
        break
      case 2 /* CLOSEST_CORNER */:
        // The ending shape is sized so that that it passes through the corner of the gradient box closest to the gradient’s center.
        // If the shape is an ellipse, the ending shape is given the same aspect-ratio it would have if closest-side were specified.
        if (gradient.shape === 0 /* CIRCLE */) {
          rx = ry = Math.min(
            distance(x, y),
            distance(x, y - height),
            distance(x - width, y),
            distance(x - width, y - height)
          )
        } else if (gradient.shape === 1 /* ELLIPSE */) {
          // Compute the ratio ry/rx (which is to be the same as for "closest-side")
          var c =
            Math.min(Math.abs(y), Math.abs(y - height)) / Math.min(Math.abs(x), Math.abs(x - width))
          var _a = findCorner(width, height, x, y, true),
            cx = _a[0],
            cy = _a[1]
          rx = distance(cx - x, (cy - y) / c)
          ry = c * rx
        }
        break
      case 1 /* FARTHEST_SIDE */:
        // Same as closest-side, except the ending shape is sized based on the farthest side(s)
        if (gradient.shape === 0 /* CIRCLE */) {
          rx = ry = Math.max(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height))
        } else if (gradient.shape === 1 /* ELLIPSE */) {
          rx = Math.max(Math.abs(x), Math.abs(x - width))
          ry = Math.max(Math.abs(y), Math.abs(y - height))
        }
        break
      case 3 /* FARTHEST_CORNER */:
        // Same as closest-corner, except the ending shape is sized based on the farthest corner.
        // If the shape is an ellipse, the ending shape is given the same aspect ratio it would have if farthest-side were specified.
        if (gradient.shape === 0 /* CIRCLE */) {
          rx = ry = Math.max(
            distance(x, y),
            distance(x, y - height),
            distance(x - width, y),
            distance(x - width, y - height)
          )
        } else if (gradient.shape === 1 /* ELLIPSE */) {
          // Compute the ratio ry/rx (which is to be the same as for "farthest-side")
          var c =
            Math.max(Math.abs(y), Math.abs(y - height)) / Math.max(Math.abs(x), Math.abs(x - width))
          var _b = findCorner(width, height, x, y, false),
            cx = _b[0],
            cy = _b[1]
          rx = distance(cx - x, (cy - y) / c)
          ry = c * rx
        }
        break
    }
    if (Array.isArray(gradient.size)) {
      rx = getAbsoluteValue(gradient.size[0], width)
      ry = gradient.size.length === 2 ? getAbsoluteValue(gradient.size[1], height) : rx
    }
    return [rx, ry]
  }

  var linearGradient = function(context, tokens) {
    var angle$1 = deg(180)
    var stops = []
    parseFunctionArgs(tokens).forEach(function(arg, i) {
      if (i === 0) {
        var firstToken = arg[0]
        if (firstToken.type === 20 /* IDENT_TOKEN */ && firstToken.value === 'to') {
          angle$1 = parseNamedSide(arg)
          return
        } else if (isAngle(firstToken)) {
          angle$1 = angle.parse(context, firstToken)
          return
        }
      }
      var colorStop = parseColorStop(context, arg)
      stops.push(colorStop)
    })
    return { angle: angle$1, stops: stops, type: 1 /* LINEAR_GRADIENT */ }
  }

  var prefixLinearGradient = function(context, tokens) {
    var angle$1 = deg(180)
    var stops = []
    parseFunctionArgs(tokens).forEach(function(arg, i) {
      if (i === 0) {
        var firstToken = arg[0]
        if (
          firstToken.type === 20 /* IDENT_TOKEN */ &&
          ['top', 'left', 'right', 'bottom'].indexOf(firstToken.value) !== -1
        ) {
          angle$1 = parseNamedSide(arg)
          return
        } else if (isAngle(firstToken)) {
          angle$1 = (angle.parse(context, firstToken) + deg(270)) % deg(360)
          return
        }
      }
      var colorStop = parseColorStop(context, arg)
      stops.push(colorStop)
    })
    return {
      angle: angle$1,
      stops: stops,
      type: 1 /* LINEAR_GRADIENT */,
    }
  }

  var webkitGradient = function(context, tokens) {
    var angle = deg(180)
    var stops = []
    var type = 1 /* LINEAR_GRADIENT */
    var shape = 0 /* CIRCLE */
    var size = 3 /* FARTHEST_CORNER */
    var position = []
    parseFunctionArgs(tokens).forEach(function(arg, i) {
      var firstToken = arg[0]
      if (i === 0) {
        if (isIdentToken(firstToken) && firstToken.value === 'linear') {
          type = 1 /* LINEAR_GRADIENT */
          return
        } else if (isIdentToken(firstToken) && firstToken.value === 'radial') {
          type = 2 /* RADIAL_GRADIENT */
          return
        }
      }
      if (firstToken.type === 18 /* FUNCTION */) {
        if (firstToken.name === 'from') {
          var color = color$1.parse(context, firstToken.values[0])
          stops.push({ stop: ZERO_LENGTH, color: color })
        } else if (firstToken.name === 'to') {
          var color = color$1.parse(context, firstToken.values[0])
          stops.push({ stop: HUNDRED_PERCENT, color: color })
        } else if (firstToken.name === 'color-stop') {
          var values = firstToken.values.filter(nonFunctionArgSeparator)
          if (values.length === 2) {
            var color = color$1.parse(context, values[1])
            var stop_1 = values[0]
            if (isNumberToken(stop_1)) {
              stops.push({
                stop: {
                  type: 16 /* PERCENTAGE_TOKEN */,
                  number: stop_1.number * 100,
                  flags: stop_1.flags,
                },
                color: color,
              })
            }
          }
        }
      }
    })
    return type === 1 /* LINEAR_GRADIENT */
      ? {
          angle: (angle + deg(180)) % deg(360),
          stops: stops,
          type: type,
        }
      : { size: size, shape: shape, stops: stops, position: position, type: type }
  }

  var CLOSEST_SIDE = 'closest-side'
  var FARTHEST_SIDE = 'farthest-side'
  var CLOSEST_CORNER = 'closest-corner'
  var FARTHEST_CORNER = 'farthest-corner'
  var CIRCLE = 'circle'
  var ELLIPSE = 'ellipse'
  var COVER = 'cover'
  var CONTAIN = 'contain'
  var radialGradient = function(context, tokens) {
    var shape = 0 /* CIRCLE */
    var size = 3 /* FARTHEST_CORNER */
    var stops = []
    var position = []
    parseFunctionArgs(tokens).forEach(function(arg, i) {
      var isColorStop = true
      if (i === 0) {
        var isAtPosition_1 = false
        isColorStop = arg.reduce(function(acc, token) {
          if (isAtPosition_1) {
            if (isIdentToken(token)) {
              switch (token.value) {
                case 'center':
                  position.push(FIFTY_PERCENT)
                  return acc
                case 'top':
                case 'left':
                  position.push(ZERO_LENGTH)
                  return acc
                case 'right':
                case 'bottom':
                  position.push(HUNDRED_PERCENT)
                  return acc
              }
            } else if (isLengthPercentage(token) || isLength(token)) {
              position.push(token)
            }
          } else if (isIdentToken(token)) {
            switch (token.value) {
              case CIRCLE:
                shape = 0 /* CIRCLE */
                return false
              case ELLIPSE:
                shape = 1 /* ELLIPSE */
                return false
              case 'at':
                isAtPosition_1 = true
                return false
              case CLOSEST_SIDE:
                size = 0 /* CLOSEST_SIDE */
                return false
              case COVER:
              case FARTHEST_SIDE:
                size = 1 /* FARTHEST_SIDE */
                return false
              case CONTAIN:
              case CLOSEST_CORNER:
                size = 2 /* CLOSEST_CORNER */
                return false
              case FARTHEST_CORNER:
                size = 3 /* FARTHEST_CORNER */
                return false
            }
          } else if (isLength(token) || isLengthPercentage(token)) {
            if (!Array.isArray(size)) {
              size = []
            }
            size.push(token)
            return false
          }
          return acc
        }, isColorStop)
      }
      if (isColorStop) {
        var colorStop = parseColorStop(context, arg)
        stops.push(colorStop)
      }
    })
    return {
      size: size,
      shape: shape,
      stops: stops,
      position: position,
      type: 2 /* RADIAL_GRADIENT */,
    }
  }

  var prefixRadialGradient = function(context, tokens) {
    var shape = 0 /* CIRCLE */
    var size = 3 /* FARTHEST_CORNER */
    var stops = []
    var position = []
    parseFunctionArgs(tokens).forEach(function(arg, i) {
      var isColorStop = true
      if (i === 0) {
        isColorStop = arg.reduce(function(acc, token) {
          if (isIdentToken(token)) {
            switch (token.value) {
              case 'center':
                position.push(FIFTY_PERCENT)
                return false
              case 'top':
              case 'left':
                position.push(ZERO_LENGTH)
                return false
              case 'right':
              case 'bottom':
                position.push(HUNDRED_PERCENT)
                return false
            }
          } else if (isLengthPercentage(token) || isLength(token)) {
            position.push(token)
            return false
          }
          return acc
        }, isColorStop)
      } else if (i === 1) {
        isColorStop = arg.reduce(function(acc, token) {
          if (isIdentToken(token)) {
            switch (token.value) {
              case CIRCLE:
                shape = 0 /* CIRCLE */
                return false
              case ELLIPSE:
                shape = 1 /* ELLIPSE */
                return false
              case CONTAIN:
              case CLOSEST_SIDE:
                size = 0 /* CLOSEST_SIDE */
                return false
              case FARTHEST_SIDE:
                size = 1 /* FARTHEST_SIDE */
                return false
              case CLOSEST_CORNER:
                size = 2 /* CLOSEST_CORNER */
                return false
              case COVER:
              case FARTHEST_CORNER:
                size = 3 /* FARTHEST_CORNER */
                return false
            }
          } else if (isLength(token) || isLengthPercentage(token)) {
            if (!Array.isArray(size)) {
              size = []
            }
            size.push(token)
            return false
          }
          return acc
        }, isColorStop)
      }
      if (isColorStop) {
        var colorStop = parseColorStop(context, arg)
        stops.push(colorStop)
      }
    })
    return {
      size: size,
      shape: shape,
      stops: stops,
      position: position,
      type: 2 /* RADIAL_GRADIENT */,
    }
  }

  var isLinearGradient = function(background) {
    return background.type === 1 /* LINEAR_GRADIENT */
  }
  var isRadialGradient = function(background) {
    return background.type === 2 /* RADIAL_GRADIENT */
  }
  var image = {
    name: 'image',
    parse: function(context, value) {
      if (value.type === 22 /* URL_TOKEN */) {
        var image_1 = { url: value.value, type: 0 /* URL */ }
        context.cache.addImage(value.value)
        return image_1
      }
      if (value.type === 18 /* FUNCTION */) {
        var imageFunction = SUPPORTED_IMAGE_FUNCTIONS[value.name]
        if (typeof imageFunction === 'undefined') {
          throw new Error('Attempting to parse an unsupported image function "' + value.name + '"')
        }
        return imageFunction(context, value.values)
      }
      throw new Error('Unsupported image type ' + value.type)
    },
  }
  function isSupportedImage(value) {
    return (
      !(value.type === 20 /* IDENT_TOKEN */ && value.value === 'none') &&
      (value.type !== 18 /* FUNCTION */ || !!SUPPORTED_IMAGE_FUNCTIONS[value.name])
    )
  }
  var SUPPORTED_IMAGE_FUNCTIONS = {
    'linear-gradient': linearGradient,
    '-moz-linear-gradient': prefixLinearGradient,
    '-ms-linear-gradient': prefixLinearGradient,
    '-o-linear-gradient': prefixLinearGradient,
    '-webkit-linear-gradient': prefixLinearGradient,
    'radial-gradient': radialGradient,
    '-moz-radial-gradient': prefixRadialGradient,
    '-ms-radial-gradient': prefixRadialGradient,
    '-o-radial-gradient': prefixRadialGradient,
    '-webkit-radial-gradient': prefixRadialGradient,
    '-webkit-gradient': webkitGradient,
  }

  var backgroundImage = {
    name: 'background-image',
    initialValue: 'none',
    type: 1 /* LIST */,
    prefix: false,
    parse: function(context, tokens) {
      if (tokens.length === 0) {
        return []
      }
      var first = tokens[0]
      if (first.type === 20 /* IDENT_TOKEN */ && first.value === 'none') {
        return []
      }
      return tokens
        .filter(function(value) {
          return nonFunctionArgSeparator(value) && isSupportedImage(value)
        })
        .map(function(value) {
          return image.parse(context, value)
        })
    },
  }

  var backgroundOrigin = {
    name: 'background-origin',
    initialValue: 'border-box',
    prefix: false,
    type: 1 /* LIST */,
    parse: function(_context, tokens) {
      return tokens.map(function(token) {
        if (isIdentToken(token)) {
          switch (token.value) {
            case 'padding-box':
              return 1 /* PADDING_BOX */
            case 'content-box':
              return 2 /* CONTENT_BOX */
          }
        }
        return 0 /* BORDER_BOX */
      })
    },
  }

  var backgroundPosition = {
    name: 'background-position',
    initialValue: '0% 0%',
    type: 1 /* LIST */,
    prefix: false,
    parse: function(_context, tokens) {
      return parseFunctionArgs(tokens)
        .map(function(values) {
          return values.filter(isLengthPercentage)
        })
        .map(parseLengthPercentageTuple)
    },
  }

  var backgroundRepeat = {
    name: 'background-repeat',
    initialValue: 'repeat',
    prefix: false,
    type: 1 /* LIST */,
    parse: function(_context, tokens) {
      return parseFunctionArgs(tokens)
        .map(function(values) {
          return values
            .filter(isIdentToken)
            .map(function(token) {
              return token.value
            })
            .join(' ')
        })
        .map(parseBackgroundRepeat)
    },
  }
  var parseBackgroundRepeat = function(value) {
    switch (value) {
      case 'no-repeat':
        return 1 /* NO_REPEAT */
      case 'repeat-x':
      case 'repeat no-repeat':
        return 2 /* REPEAT_X */
      case 'repeat-y':
      case 'no-repeat repeat':
        return 3 /* REPEAT_Y */
      case 'repeat':
      default:
        return 0 /* REPEAT */
    }
  }

  var BACKGROUND_SIZE
  ;(function(BACKGROUND_SIZE) {
    BACKGROUND_SIZE['AUTO'] = 'auto'
    BACKGROUND_SIZE['CONTAIN'] = 'contain'
    BACKGROUND_SIZE['COVER'] = 'cover'
  })(BACKGROUND_SIZE || (BACKGROUND_SIZE = {}))
  var backgroundSize = {
    name: 'background-size',
    initialValue: '0',
    prefix: false,
    type: 1 /* LIST */,
    parse: function(_context, tokens) {
      return parseFunctionArgs(tokens).map(function(values) {
        return values.filter(isBackgroundSizeInfoToken)
      })
    },
  }
  var isBackgroundSizeInfoToken = function(value) {
    return isIdentToken(value) || isLengthPercentage(value)
  }

  var borderColorForSide = function(side) {
    return {
      name: 'border-' + side + '-color',
      initialValue: 'transparent',
      prefix: false,
      type: 3 /* TYPE_VALUE */,
      format: 'color',
    }
  }
  var borderTopColor = borderColorForSide('top')
  var borderRightColor = borderColorForSide('right')
  var borderBottomColor = borderColorForSide('bottom')
  var borderLeftColor = borderColorForSide('left')

  var borderRadiusForSide = function(side) {
    return {
      name: 'border-radius-' + side,
      initialValue: '0 0',
      prefix: false,
      type: 1 /* LIST */,
      parse: function(_context, tokens) {
        return parseLengthPercentageTuple(tokens.filter(isLengthPercentage))
      },
    }
  }
  var borderTopLeftRadius = borderRadiusForSide('top-left')
  var borderTopRightRadius = borderRadiusForSide('top-right')
  var borderBottomRightRadius = borderRadiusForSide('bottom-right')
  var borderBottomLeftRadius = borderRadiusForSide('bottom-left')

  var borderStyleForSide = function(side) {
    return {
      name: 'border-' + side + '-style',
      initialValue: 'solid',
      prefix: false,
      type: 2 /* IDENT_VALUE */,
      parse: function(_context, style) {
        switch (style) {
          case 'none':
            return 0 /* NONE */
          case 'dashed':
            return 2 /* DASHED */
          case 'dotted':
            return 3 /* DOTTED */
          case 'double':
            return 4 /* DOUBLE */
        }
        return 1 /* SOLID */
      },
    }
  }
  var borderTopStyle = borderStyleForSide('top')
  var borderRightStyle = borderStyleForSide('right')
  var borderBottomStyle = borderStyleForSide('bottom')
  var borderLeftStyle = borderStyleForSide('left')

  var borderWidthForSide = function(side) {
    return {
      name: 'border-' + side + '-width',
      initialValue: '0',
      type: 0 /* VALUE */,
      prefix: false,
      parse: function(_context, token) {
        if (isDimensionToken(token)) {
          return token.number
        }
        return 0
      },
    }
  }
  var borderTopWidth = borderWidthForSide('top')
  var borderRightWidth = borderWidthForSide('right')
  var borderBottomWidth = borderWidthForSide('bottom')
  var borderLeftWidth = borderWidthForSide('left')

  var color = {
    name: 'color',
    initialValue: 'transparent',
    prefix: false,
    type: 3 /* TYPE_VALUE */,
    format: 'color',
  }

  var direction = {
    name: 'direction',
    initialValue: 'ltr',
    prefix: false,
    type: 2 /* IDENT_VALUE */,
    parse: function(_context, direction) {
      switch (direction) {
        case 'rtl':
          return 1 /* RTL */
        case 'ltr':
        default:
          return 0 /* LTR */
      }
    },
  }

  var display = {
    name: 'display',
    initialValue: 'inline-block',
    prefix: false,
    type: 1 /* LIST */,
    parse: function(_context, tokens) {
      return tokens.filter(isIdentToken).reduce(function(bit, token) {
        return bit | parseDisplayValue(token.value)
      }, 0 /* NONE */)
    },
  }
  var parseDisplayValue = function(display) {
    switch (display) {
      case 'block':
      case '-webkit-box':
        return 2 /* BLOCK */
      case 'inline':
        return 4 /* INLINE */
      case 'run-in':
        return 8 /* RUN_IN */
      case 'flow':
        return 16 /* FLOW */
      case 'flow-root':
        return 32 /* FLOW_ROOT */
      case 'table':
        return 64 /* TABLE */
      case 'flex':
      case '-webkit-flex':
        return 128 /* FLEX */
      case 'grid':
      case '-ms-grid':
        return 256 /* GRID */
      case 'ruby':
        return 512 /* RUBY */
      case 'subgrid':
        return 1024 /* SUBGRID */
      case 'list-item':
        return 2048 /* LIST_ITEM */
      case 'table-row-group':
        return 4096 /* TABLE_ROW_GROUP */
      case 'table-header-group':
        return 8192 /* TABLE_HEADER_GROUP */
      case 'table-footer-group':
        return 16384 /* TABLE_FOOTER_GROUP */
      case 'table-row':
        return 32768 /* TABLE_ROW */
      case 'table-cell':
        return 65536 /* TABLE_CELL */
      case 'table-column-group':
        return 131072 /* TABLE_COLUMN_GROUP */
      case 'table-column':
        return 262144 /* TABLE_COLUMN */
      case 'table-caption':
        return 524288 /* TABLE_CAPTION */
      case 'ruby-base':
        return 1048576 /* RUBY_BASE */
      case 'ruby-text':
        return 2097152 /* RUBY_TEXT */
      case 'ruby-base-container':
        return 4194304 /* RUBY_BASE_CONTAINER */
      case 'ruby-text-container':
        return 8388608 /* RUBY_TEXT_CONTAINER */
      case 'contents':
        return 16777216 /* CONTENTS */
      case 'inline-block':
        return 33554432 /* INLINE_BLOCK */
      case 'inline-list-item':
        return 67108864 /* INLINE_LIST_ITEM */
      case 'inline-table':
        return 134217728 /* INLINE_TABLE */
      case 'inline-flex':
        return 268435456 /* INLINE_FLEX */
      case 'inline-grid':
        return 536870912 /* INLINE_GRID */
    }
    return 0 /* NONE */
  }

  var float = {
    name: 'float',
    initialValue: 'none',
    prefix: false,
    type: 2 /* IDENT_VALUE */,
    parse: function(_context, float) {
      switch (float) {
        case 'left':
          return 1 /* LEFT */
        case 'right':
          return 2 /* RIGHT */
        case 'inline-start':
          return 3 /* INLINE_START */
        case 'inline-end':
          return 4 /* INLINE_END */
      }
      return 0 /* NONE */
    },
  }

  var letterSpacing = {
    name: 'letter-spacing',
    initialValue: '0',
    prefix: false,
    type: 0 /* VALUE */,
    parse: function(_context, token) {
      if (token.type === 20 /* IDENT_TOKEN */ && token.value === 'normal') {
        return 0
      }
      if (token.type === 17 /* NUMBER_TOKEN */) {
        return token.number
      }
      if (token.type === 15 /* DIMENSION_TOKEN */) {
        return token.number
      }
      return 0
    },
  }

  var LINE_BREAK
  ;(function(LINE_BREAK) {
    LINE_BREAK['NORMAL'] = 'normal'
    LINE_BREAK['STRICT'] = 'strict'
  })(LINE_BREAK || (LINE_BREAK = {}))
  var lineBreak = {
    name: 'line-break',
    initialValue: 'normal',
    prefix: false,
    type: 2 /* IDENT_VALUE */,
    parse: function(_context, lineBreak) {
      switch (lineBreak) {
        case 'strict':
          return LINE_BREAK.STRICT
        case 'normal':
        default:
          return LINE_BREAK.NORMAL
      }
    },
  }

  var lineHeight = {
    name: 'line-height',
    initialValue: 'normal',
    prefix: false,
    type: 4 /* TOKEN_VALUE */,
  }
  var computeLineHeight = function(token, fontSize) {
    if (isIdentToken(token) && token.value === 'normal') {
      return 1.2 * fontSize
    } else if (token.type === 17 /* NUMBER_TOKEN */) {
      return fontSize * token.number
    } else if (isLengthPercentage(token)) {
      return getAbsoluteValue(token, fontSize)
    }
    return fontSize
  }

  var listStyleImage = {
    name: 'list-style-image',
    initialValue: 'none',
    type: 0 /* VALUE */,
    prefix: false,
    parse: function(context, token) {
      if (token.type === 20 /* IDENT_TOKEN */ && token.value === 'none') {
        return null
      }
      return image.parse(context, token)
    },
  }

  var listStylePosition = {
    name: 'list-style-position',
    initialValue: 'outside',
    prefix: false,
    type: 2 /* IDENT_VALUE */,
    parse: function(_context, position) {
      switch (position) {
        case 'inside':
          return 0 /* INSIDE */
        case 'outside':
        default:
          return 1 /* OUTSIDE */
      }
    },
  }

  var listStyleType = {
    name: 'list-style-type',
    initialValue: 'none',
    prefix: false,
    type: 2 /* IDENT_VALUE */,
    parse: function(_context, type) {
      switch (type) {
        case 'disc':
          return 0 /* DISC */
        case 'circle':
          return 1 /* CIRCLE */
        case 'square':
          return 2 /* SQUARE */
        case 'decimal':
          return 3 /* DECIMAL */
        case 'cjk-decimal':
          return 4 /* CJK_DECIMAL */
        case 'decimal-leading-zero':
          return 5 /* DECIMAL_LEADING_ZERO */
        case 'lower-roman':
          return 6 /* LOWER_ROMAN */
        case 'upper-roman':
          return 7 /* UPPER_ROMAN */
        case 'lower-greek':
          return 8 /* LOWER_GREEK */
        case 'lower-alpha':
          return 9 /* LOWER_ALPHA */
        case 'upper-alpha':
          return 10 /* UPPER_ALPHA */
        case 'arabic-indic':
          return 11 /* ARABIC_INDIC */
        case 'armenian':
          return 12 /* ARMENIAN */
        case 'bengali':
          return 13 /* BENGALI */
        case 'cambodian':
          return 14 /* CAMBODIAN */
        case 'cjk-earthly-branch':
          return 15 /* CJK_EARTHLY_BRANCH */
        case 'cjk-heavenly-stem':
          return 16 /* CJK_HEAVENLY_STEM */
        case 'cjk-ideographic':
          return 17 /* CJK_IDEOGRAPHIC */
        case 'devanagari':
          return 18 /* DEVANAGARI */
        case 'ethiopic-numeric':
          return 19 /* ETHIOPIC_NUMERIC */
        case 'georgian':
          return 20 /* GEORGIAN */
        case 'gujarati':
          return 21 /* GUJARATI */
        case 'gurmukhi':
          return 22 /* GURMUKHI */
        case 'hebrew':
          return 22 /* HEBREW */
        case 'hiragana':
          return 23 /* HIRAGANA */
        case 'hiragana-iroha':
          return 24 /* HIRAGANA_IROHA */
        case 'japanese-formal':
          return 25 /* JAPANESE_FORMAL */
        case 'japanese-informal':
          return 26 /* JAPANESE_INFORMAL */
        case 'kannada':
          return 27 /* KANNADA */
        case 'katakana':
          return 28 /* KATAKANA */
        case 'katakana-iroha':
          return 29 /* KATAKANA_IROHA */
        case 'khmer':
          return 30 /* KHMER */
        case 'korean-hangul-formal':
          return 31 /* KOREAN_HANGUL_FORMAL */
        case 'korean-hanja-formal':
          return 32 /* KOREAN_HANJA_FORMAL */
        case 'korean-hanja-informal':
          return 33 /* KOREAN_HANJA_INFORMAL */
        case 'lao':
          return 34 /* LAO */
        case 'lower-armenian':
          return 35 /* LOWER_ARMENIAN */
        case 'malayalam':
          return 36 /* MALAYALAM */
        case 'mongolian':
          return 37 /* MONGOLIAN */
        case 'myanmar':
          return 38 /* MYANMAR */
        case 'oriya':
          return 39 /* ORIYA */
        case 'persian':
          return 40 /* PERSIAN */
        case 'simp-chinese-formal':
          return 41 /* SIMP_CHINESE_FORMAL */
        case 'simp-chinese-informal':
          return 42 /* SIMP_CHINESE_INFORMAL */
        case 'tamil':
          return 43 /* TAMIL */
        case 'telugu':
          return 44 /* TELUGU */
        case 'thai':
          return 45 /* THAI */
        case 'tibetan':
          return 46 /* TIBETAN */
        case 'trad-chinese-formal':
          return 47 /* TRAD_CHINESE_FORMAL */
        case 'trad-chinese-informal':
          return 48 /* TRAD_CHINESE_INFORMAL */
        case 'upper-armenian':
          return 49 /* UPPER_ARMENIAN */
        case 'disclosure-open':
          return 50 /* DISCLOSURE_OPEN */
        case 'disclosure-closed':
          return 51 /* DISCLOSURE_CLOSED */
        case 'none':
        default:
          return -1 /* NONE */
      }
    },
  }

  var marginForSide = function(side) {
    return {
      name: 'margin-' + side,
      initialValue: '0',
      prefix: false,
      type: 4 /* TOKEN_VALUE */,
    }
  }
  var marginTop = marginForSide('top')
  var marginRight = marginForSide('right')
  var marginBottom = marginForSide('bottom')
  var marginLeft = marginForSide('left')

  var overflow = {
    name: 'overflow',
    initialValue: 'visible',
    prefix: false,
    type: 1 /* LIST */,
    parse: function(_context, tokens) {
      return tokens.filter(isIdentToken).map(function(overflow) {
        switch (overflow.value) {
          case 'hidden':
            return 1 /* HIDDEN */
          case 'scroll':
            return 2 /* SCROLL */
          case 'clip':
            return 3 /* CLIP */
          case 'auto':
            return 4 /* AUTO */
          case 'visible':
          default:
            return 0 /* VISIBLE */
        }
      })
    },
  }

  var overflowWrap = {
    name: 'overflow-wrap',
    initialValue: 'normal',
    prefix: false,
    type: 2 /* IDENT_VALUE */,
    parse: function(_context, overflow) {
      switch (overflow) {
        case 'break-word':
          return 'break-word' /* BREAK_WORD */
        case 'normal':
        default:
          return 'normal' /* NORMAL */
      }
    },
  }

  var paddingForSide = function(side) {
    return {
      name: 'padding-' + side,
      initialValue: '0',
      prefix: false,
      type: 3 /* TYPE_VALUE */,
      format: 'length-percentage',
    }
  }
  var paddingTop = paddingForSide('top')
  var paddingRight = paddingForSide('right')
  var paddingBottom = paddingForSide('bottom')
  var paddingLeft = paddingForSide('left')

  var textAlign = {
    name: 'text-align',
    initialValue: 'left',
    prefix: false,
    type: 2 /* IDENT_VALUE */,
    parse: function(_context, textAlign) {
      switch (textAlign) {
        case 'right':
          return 2 /* RIGHT */
        case 'center':
        case 'justify':
          return 1 /* CENTER */
        case 'left':
        default:
          return 0 /* LEFT */
      }
    },
  }

  var position = {
    name: 'position',
    initialValue: 'static',
    prefix: false,
    type: 2 /* IDENT_VALUE */,
    parse: function(_context, position) {
      switch (position) {
        case 'relative':
          return 1 /* RELATIVE */
        case 'absolute':
          return 2 /* ABSOLUTE */
        case 'fixed':
          return 3 /* FIXED */
        case 'sticky':
          return 4 /* STICKY */
      }
      return 0 /* STATIC */
    },
  }

  var textShadow = {
    name: 'text-shadow',
    initialValue: 'none',
    type: 1 /* LIST */,
    prefix: false,
    parse: function(context, tokens) {
      if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) {
        return []
      }
      return parseFunctionArgs(tokens).map(function(values) {
        var shadow = {
          color: COLORS.TRANSPARENT,
          offsetX: ZERO_LENGTH,
          offsetY: ZERO_LENGTH,
          blur: ZERO_LENGTH,
        }
        var c = 0
        for (var i = 0; i < values.length; i++) {
          var token = values[i]
          if (isLength(token)) {
            if (c === 0) {
              shadow.offsetX = token
            } else if (c === 1) {
              shadow.offsetY = token
            } else {
              shadow.blur = token
            }
            c++
          } else {
            shadow.color = color$1.parse(context, token)
          }
        }
        return shadow
      })
    },
  }

  var textTransform = {
    name: 'text-transform',
    initialValue: 'none',
    prefix: false,
    type: 2 /* IDENT_VALUE */,
    parse: function(_context, textTransform) {
      switch (textTransform) {
        case 'uppercase':
          return 2 /* UPPERCASE */
        case 'lowercase':
          return 1 /* LOWERCASE */
        case 'capitalize':
          return 3 /* CAPITALIZE */
      }
      return 0 /* NONE */
    },
  }

  var transform$1 = {
    name: 'transform',
    initialValue: 'none',
    prefix: true,
    type: 0 /* VALUE */,
    parse: function(_context, token) {
      if (token.type === 20 /* IDENT_TOKEN */ && token.value === 'none') {
        return null
      }
      if (token.type === 18 /* FUNCTION */) {
        var transformFunction = SUPPORTED_TRANSFORM_FUNCTIONS[token.name]
        if (typeof transformFunction === 'undefined') {
          throw new Error(
            'Attempting to parse an unsupported transform function "' + token.name + '"'
          )
        }
        return transformFunction(token.values)
      }
      return null
    },
  }
  var matrix = function(args) {
    var values = args
      .filter(function(arg) {
        return arg.type === 17 /* NUMBER_TOKEN */
      })
      .map(function(arg) {
        return arg.number
      })
    return values.length === 6 ? values : null
  }
  // doesn't support 3D transforms at the moment
  var matrix3d = function(args) {
    var values = args
      .filter(function(arg) {
        return arg.type === 17 /* NUMBER_TOKEN */
      })
      .map(function(arg) {
        return arg.number
      })
    var a1 = values[0],
      b1 = values[1]
    values[2]
    values[3]
    var a2 = values[4],
      b2 = values[5]
    values[6]
    values[7]
    values[8]
    values[9]
    values[10]
    values[11]
    var a4 = values[12],
      b4 = values[13]
    values[14]
    values[15]
    return values.length === 16 ? [a1, b1, a2, b2, a4, b4] : null
  }
  var SUPPORTED_TRANSFORM_FUNCTIONS = {
    matrix: matrix,
    matrix3d: matrix3d,
  }

  var DEFAULT_VALUE = {
    type: 16 /* PERCENTAGE_TOKEN */,
    number: 50,
    flags: FLAG_INTEGER,
  }
  var DEFAULT = [DEFAULT_VALUE, DEFAULT_VALUE]
  var transformOrigin = {
    name: 'transform-origin',
    initialValue: '50% 50%',
    prefix: true,
    type: 1 /* LIST */,
    parse: function(_context, tokens) {
      var origins = tokens.filter(isLengthPercentage)
      if (origins.length !== 2) {
        return DEFAULT
      }
      return [origins[0], origins[1]]
    },
  }

  var visibility = {
    name: 'visible',
    initialValue: 'none',
    prefix: false,
    type: 2 /* IDENT_VALUE */,
    parse: function(_context, visibility) {
      switch (visibility) {
        case 'hidden':
          return 1 /* HIDDEN */
        case 'collapse':
          return 2 /* COLLAPSE */
        case 'visible':
        default:
          return 0 /* VISIBLE */
      }
    },
  }

  var WORD_BREAK
  ;(function(WORD_BREAK) {
    WORD_BREAK['NORMAL'] = 'normal'
    WORD_BREAK['BREAK_ALL'] = 'break-all'
    WORD_BREAK['KEEP_ALL'] = 'keep-all'
  })(WORD_BREAK || (WORD_BREAK = {}))
  var wordBreak = {
    name: 'word-break',
    initialValue: 'normal',
    prefix: false,
    type: 2 /* IDENT_VALUE */,
    parse: function(_context, wordBreak) {
      switch (wordBreak) {
        case 'break-all':
          return WORD_BREAK.BREAK_ALL
        case 'keep-all':
          return WORD_BREAK.KEEP_ALL
        case 'normal':
        default:
          return WORD_BREAK.NORMAL
      }
    },
  }

  var zIndex = {
    name: 'z-index',
    initialValue: 'auto',
    prefix: false,
    type: 0 /* VALUE */,
    parse: function(_context, token) {
      if (token.type === 20 /* IDENT_TOKEN */) {
        return { auto: true, order: 0 }
      }
      if (isNumberToken(token)) {
        return { auto: false, order: token.number }
      }
      throw new Error('Invalid z-index number parsed')
    },
  }

  var time = {
    name: 'time',
    parse: function(_context, value) {
      if (value.type === 15 /* DIMENSION_TOKEN */) {
        switch (value.unit.toLowerCase()) {
          case 's':
            return 1000 * value.number
          case 'ms':
            return value.number
        }
      }
      throw new Error('Unsupported time type')
    },
  }

  var opacity = {
    name: 'opacity',
    initialValue: '1',
    type: 0 /* VALUE */,
    prefix: false,
    parse: function(_context, token) {
      if (isNumberToken(token)) {
        return token.number
      }
      return 1
    },
  }

  var textDecorationColor = {
    name: 'text-decoration-color',
    initialValue: 'transparent',
    prefix: false,
    type: 3 /* TYPE_VALUE */,
    format: 'color',
  }

  var textDecorationLine = {
    name: 'text-decoration-line',
    initialValue: 'none',
    prefix: false,
    type: 1 /* LIST */,
    parse: function(_context, tokens) {
      return tokens
        .filter(isIdentToken)
        .map(function(token) {
          switch (token.value) {
            case 'underline':
              return 1 /* UNDERLINE */
            case 'overline':
              return 2 /* OVERLINE */
            case 'line-through':
              return 3 /* LINE_THROUGH */
            case 'none':
              return 4 /* BLINK */
          }
          return 0 /* NONE */
        })
        .filter(function(line) {
          return line !== 0 /* NONE */
        })
    },
  }

  var fontFamily = {
    name: 'font-family',
    initialValue: '',
    prefix: false,
    type: 1 /* LIST */,
    parse: function(_context, tokens) {
      var accumulator = []
      var results = []
      tokens.forEach(function(token) {
        switch (token.type) {
          case 20 /* IDENT_TOKEN */:
          case 0 /* STRING_TOKEN */:
            accumulator.push(token.value)
            break
          case 17 /* NUMBER_TOKEN */:
            accumulator.push(token.number.toString())
            break
          case 4 /* COMMA_TOKEN */:
            results.push(accumulator.join(' '))
            accumulator.length = 0
            break
        }
      })
      if (accumulator.length) {
        results.push(accumulator.join(' '))
      }
      return results.map(function(result) {
        return result.indexOf(' ') === -1 ? result : "'" + result + "'"
      })
    },
  }

  var fontSize = {
    name: 'font-size',
    initialValue: '0',
    prefix: false,
    type: 3 /* TYPE_VALUE */,
    format: 'length',
  }

  var fontWeight = {
    name: 'font-weight',
    initialValue: 'normal',
    type: 0 /* VALUE */,
    prefix: false,
    parse: function(_context, token) {
      if (isNumberToken(token)) {
        return token.number
      }
      if (isIdentToken(token)) {
        switch (token.value) {
          case 'bold':
            return 700
          case 'normal':
          default:
            return 400
        }
      }
      return 400
    },
  }

  var fontVariant = {
    name: 'font-variant',
    initialValue: 'none',
    type: 1 /* LIST */,
    prefix: false,
    parse: function(_context, tokens) {
      return tokens.filter(isIdentToken).map(function(token) {
        return token.value
      })
    },
  }

  var fontStyle = {
    name: 'font-style',
    initialValue: 'normal',
    prefix: false,
    type: 2 /* IDENT_VALUE */,
    parse: function(_context, overflow) {
      switch (overflow) {
        case 'oblique':
          return 'oblique' /* OBLIQUE */
        case 'italic':
          return 'italic' /* ITALIC */
        case 'normal':
        default:
          return 'normal' /* NORMAL */
      }
    },
  }

  var contains = function(bit, value) {
    return (bit & value) !== 0
  }

  var content = {
    name: 'content',
    initialValue: 'none',
    type: 1 /* LIST */,
    prefix: false,
    parse: function(_context, tokens) {
      if (tokens.length === 0) {
        return []
      }
      var first = tokens[0]
      if (first.type === 20 /* IDENT_TOKEN */ && first.value === 'none') {
        return []
      }
      return tokens
    },
  }

  var counterIncrement = {
    name: 'counter-increment',
    initialValue: 'none',
    prefix: true,
    type: 1 /* LIST */,
    parse: function(_context, tokens) {
      if (tokens.length === 0) {
        return null
      }
      var first = tokens[0]
      if (first.type === 20 /* IDENT_TOKEN */ && first.value === 'none') {
        return null
      }
      var increments = []
      var filtered = tokens.filter(nonWhiteSpace)
      for (var i = 0; i < filtered.length; i++) {
        var counter = filtered[i]
        var next = filtered[i + 1]
        if (counter.type === 20 /* IDENT_TOKEN */) {
          var increment = next && isNumberToken(next) ? next.number : 1
          increments.push({ counter: counter.value, increment: increment })
        }
      }
      return increments
    },
  }

  var counterReset = {
    name: 'counter-reset',
    initialValue: 'none',
    prefix: true,
    type: 1 /* LIST */,
    parse: function(_context, tokens) {
      if (tokens.length === 0) {
        return []
      }
      var resets = []
      var filtered = tokens.filter(nonWhiteSpace)
      for (var i = 0; i < filtered.length; i++) {
        var counter = filtered[i]
        var next = filtered[i + 1]
        if (isIdentToken(counter) && counter.value !== 'none') {
          var reset = next && isNumberToken(next) ? next.number : 0
          resets.push({ counter: counter.value, reset: reset })
        }
      }
      return resets
    },
  }

  var duration = {
    name: 'duration',
    initialValue: '0s',
    prefix: false,
    type: 1 /* LIST */,
    parse: function(context, tokens) {
      return tokens.filter(isDimensionToken).map(function(token) {
        return time.parse(context, token)
      })
    },
  }

  var quotes = {
    name: 'quotes',
    initialValue: 'none',
    prefix: true,
    type: 1 /* LIST */,
    parse: function(_context, tokens) {
      if (tokens.length === 0) {
        return null
      }
      var first = tokens[0]
      if (first.type === 20 /* IDENT_TOKEN */ && first.value === 'none') {
        return null
      }
      var quotes = []
      var filtered = tokens.filter(isStringToken)
      if (filtered.length % 2 !== 0) {
        return null
      }
      for (var i = 0; i < filtered.length; i += 2) {
        var open_1 = filtered[i].value
        var close_1 = filtered[i + 1].value
        quotes.push({ open: open_1, close: close_1 })
      }
      return quotes
    },
  }
  var getQuote = function(quotes, depth, open) {
    if (!quotes) {
      return ''
    }
    var quote = quotes[Math.min(depth, quotes.length - 1)]
    if (!quote) {
      return ''
    }
    return open ? quote.open : quote.close
  }

  var boxShadow = {
    name: 'box-shadow',
    initialValue: 'none',
    type: 1 /* LIST */,
    prefix: false,
    parse: function(context, tokens) {
      if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) {
        return []
      }
      return parseFunctionArgs(tokens).map(function(values) {
        var shadow = {
          color: 0x000000ff,
          offsetX: ZERO_LENGTH,
          offsetY: ZERO_LENGTH,
          blur: ZERO_LENGTH,
          spread: ZERO_LENGTH,
          inset: false,
        }
        var c = 0
        for (var i = 0; i < values.length; i++) {
          var token = values[i]
          if (isIdentWithValue(token, 'inset')) {
            shadow.inset = true
          } else if (isLength(token)) {
            if (c === 0) {
              shadow.offsetX = token
            } else if (c === 1) {
              shadow.offsetY = token
            } else if (c === 2) {
              shadow.blur = token
            } else {
              shadow.spread = token
            }
            c++
          } else {
            shadow.color = color$1.parse(context, token)
          }
        }
        return shadow
      })
    },
  }

  var paintOrder = {
    name: 'paint-order',
    initialValue: 'normal',
    prefix: false,
    type: 1 /* LIST */,
    parse: function(_context, tokens) {
      var DEFAULT_VALUE = [0 /* FILL */, 1 /* STROKE */, 2 /* MARKERS */]
      var layers = []
      tokens.filter(isIdentToken).forEach(function(token) {
        switch (token.value) {
          case 'stroke':
            layers.push(1 /* STROKE */)
            break
          case 'fill':
            layers.push(0 /* FILL */)
            break
          case 'markers':
            layers.push(2 /* MARKERS */)
            break
        }
      })
      DEFAULT_VALUE.forEach(function(value) {
        if (layers.indexOf(value) === -1) {
          layers.push(value)
        }
      })
      return layers
    },
  }

  var webkitTextStrokeColor = {
    name: '-webkit-text-stroke-color',
    initialValue: 'currentcolor',
    prefix: false,
    type: 3 /* TYPE_VALUE */,
    format: 'color',
  }

  var webkitTextStrokeWidth = {
    name: '-webkit-text-stroke-width',
    initialValue: '0',
    type: 0 /* VALUE */,
    prefix: false,
    parse: function(_context, token) {
      if (isDimensionToken(token)) {
        return token.number
      }
      return 0
    },
  }

  var CSSParsedDeclaration = /** @class */ (function() {
    function CSSParsedDeclaration(context, declaration) {
      var _a, _b
      this.animationDuration = parse(context, duration, declaration.animationDuration)
      this.backgroundClip = parse(context, backgroundClip, declaration.backgroundClip)
      this.backgroundColor = parse(context, backgroundColor, declaration.backgroundColor)
      this.backgroundImage = parse(context, backgroundImage, declaration.backgroundImage)
      this.backgroundOrigin = parse(context, backgroundOrigin, declaration.backgroundOrigin)
      this.backgroundPosition = parse(context, backgroundPosition, declaration.backgroundPosition)
      this.backgroundRepeat = parse(context, backgroundRepeat, declaration.backgroundRepeat)
      this.backgroundSize = parse(context, backgroundSize, declaration.backgroundSize)
      this.borderTopColor = parse(context, borderTopColor, declaration.borderTopColor)
      this.borderRightColor = parse(context, borderRightColor, declaration.borderRightColor)
      this.borderBottomColor = parse(context, borderBottomColor, declaration.borderBottomColor)
      this.borderLeftColor = parse(context, borderLeftColor, declaration.borderLeftColor)
      this.borderTopLeftRadius = parse(
        context,
        borderTopLeftRadius,
        declaration.borderTopLeftRadius
      )
      this.borderTopRightRadius = parse(
        context,
        borderTopRightRadius,
        declaration.borderTopRightRadius
      )
      this.borderBottomRightRadius = parse(
        context,
        borderBottomRightRadius,
        declaration.borderBottomRightRadius
      )
      this.borderBottomLeftRadius = parse(
        context,
        borderBottomLeftRadius,
        declaration.borderBottomLeftRadius
      )
      this.borderTopStyle = parse(context, borderTopStyle, declaration.borderTopStyle)
      this.borderRightStyle = parse(context, borderRightStyle, declaration.borderRightStyle)
      this.borderBottomStyle = parse(context, borderBottomStyle, declaration.borderBottomStyle)
      this.borderLeftStyle = parse(context, borderLeftStyle, declaration.borderLeftStyle)
      this.borderTopWidth = parse(context, borderTopWidth, declaration.borderTopWidth)
      this.borderRightWidth = parse(context, borderRightWidth, declaration.borderRightWidth)
      this.borderBottomWidth = parse(context, borderBottomWidth, declaration.borderBottomWidth)
      this.borderLeftWidth = parse(context, borderLeftWidth, declaration.borderLeftWidth)
      this.boxShadow = parse(context, boxShadow, declaration.boxShadow)
      this.color = parse(context, color, declaration.color)
      this.direction = parse(context, direction, declaration.direction)
      this.display = parse(context, display, declaration.display)
      this.float = parse(context, float, declaration.cssFloat)
      this.fontFamily = parse(context, fontFamily, declaration.fontFamily)
      this.fontSize = parse(context, fontSize, declaration.fontSize)
      this.fontStyle = parse(context, fontStyle, declaration.fontStyle)
      this.fontVariant = parse(context, fontVariant, declaration.fontVariant)
      this.fontWeight = parse(context, fontWeight, declaration.fontWeight)
      this.letterSpacing = parse(context, letterSpacing, declaration.letterSpacing)
      this.lineBreak = parse(context, lineBreak, declaration.lineBreak)
      this.lineHeight = parse(context, lineHeight, declaration.lineHeight)
      this.listStyleImage = parse(context, listStyleImage, declaration.listStyleImage)
      this.listStylePosition = parse(context, listStylePosition, declaration.listStylePosition)
      this.listStyleType = parse(context, listStyleType, declaration.listStyleType)
      this.marginTop = parse(context, marginTop, declaration.marginTop)
      this.marginRight = parse(context, marginRight, declaration.marginRight)
      this.marginBottom = parse(context, marginBottom, declaration.marginBottom)
      this.marginLeft = parse(context, marginLeft, declaration.marginLeft)
      this.opacity = parse(context, opacity, declaration.opacity)
      var overflowTuple = parse(context, overflow, declaration.overflow)
      this.overflowX = overflowTuple[0]
      this.overflowY = overflowTuple[overflowTuple.length > 1 ? 1 : 0]
      this.overflowWrap = parse(context, overflowWrap, declaration.overflowWrap)
      this.paddingTop = parse(context, paddingTop, declaration.paddingTop)
      this.paddingRight = parse(context, paddingRight, declaration.paddingRight)
      this.paddingBottom = parse(context, paddingBottom, declaration.paddingBottom)
      this.paddingLeft = parse(context, paddingLeft, declaration.paddingLeft)
      this.paintOrder = parse(context, paintOrder, declaration.paintOrder)
      this.position = parse(context, position, declaration.position)
      this.textAlign = parse(context, textAlign, declaration.textAlign)
      this.textDecorationColor = parse(
        context,
        textDecorationColor,
        (_a = declaration.textDecorationColor) !== null && _a !== void 0 ? _a : declaration.color
      )
      this.textDecorationLine = parse(
        context,
        textDecorationLine,
        (_b = declaration.textDecorationLine) !== null && _b !== void 0
          ? _b
          : declaration.textDecoration
      )
      this.textShadow = parse(context, textShadow, declaration.textShadow)
      this.textTransform = parse(context, textTransform, declaration.textTransform)
      this.transform = parse(context, transform$1, declaration.transform)
      this.transformOrigin = parse(context, transformOrigin, declaration.transformOrigin)
      this.visibility = parse(context, visibility, declaration.visibility)
      this.webkitTextStrokeColor = parse(
        context,
        webkitTextStrokeColor,
        declaration.webkitTextStrokeColor
      )
      this.webkitTextStrokeWidth = parse(
        context,
        webkitTextStrokeWidth,
        declaration.webkitTextStrokeWidth
      )
      this.wordBreak = parse(context, wordBreak, declaration.wordBreak)
      this.zIndex = parse(context, zIndex, declaration.zIndex)
    }
    CSSParsedDeclaration.prototype.isVisible = function() {
      return this.display > 0 && this.opacity > 0 && this.visibility === 0 /* VISIBLE */
    }
    CSSParsedDeclaration.prototype.isTransparent = function() {
      return isTransparent(this.backgroundColor)
    }
    CSSParsedDeclaration.prototype.isTransformed = function() {
      return this.transform !== null
    }
    CSSParsedDeclaration.prototype.isPositioned = function() {
      return this.position !== 0 /* STATIC */
    }
    CSSParsedDeclaration.prototype.isPositionedWithZIndex = function() {
      return this.isPositioned() && !this.zIndex.auto
    }
    CSSParsedDeclaration.prototype.isFloating = function() {
      return this.float !== 0 /* NONE */
    }
    CSSParsedDeclaration.prototype.isInlineLevel = function() {
      return (
        contains(this.display, 4 /* INLINE */) ||
        contains(this.display, 33554432 /* INLINE_BLOCK */) ||
        contains(this.display, 268435456 /* INLINE_FLEX */) ||
        contains(this.display, 536870912 /* INLINE_GRID */) ||
        contains(this.display, 67108864 /* INLINE_LIST_ITEM */) ||
        contains(this.display, 134217728 /* INLINE_TABLE */)
      )
    }
    return CSSParsedDeclaration
  })()
  var CSSParsedPseudoDeclaration = /** @class */ (function() {
    function CSSParsedPseudoDeclaration(context, declaration) {
      this.content = parse(context, content, declaration.content)
      this.quotes = parse(context, quotes, declaration.quotes)
    }
    return CSSParsedPseudoDeclaration
  })()
  var CSSParsedCounterDeclaration = /** @class */ (function() {
    function CSSParsedCounterDeclaration(context, declaration) {
      this.counterIncrement = parse(context, counterIncrement, declaration.counterIncrement)
      this.counterReset = parse(context, counterReset, declaration.counterReset)
    }
    return CSSParsedCounterDeclaration
  })()
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var parse = function(context, descriptor, style) {
    var tokenizer = new Tokenizer()
    var value =
      style !== null && typeof style !== 'undefined' ? style.toString() : descriptor.initialValue
    tokenizer.write(value)
    var parser = new Parser(tokenizer.read())
    switch (descriptor.type) {
      case 2 /* IDENT_VALUE */:
        var token = parser.parseComponentValue()
        return descriptor.parse(
          context,
          isIdentToken(token) ? token.value : descriptor.initialValue
        )
      case 0 /* VALUE */:
        return descriptor.parse(context, parser.parseComponentValue())
      case 1 /* LIST */:
        return descriptor.parse(context, parser.parseComponentValues())
      case 4 /* TOKEN_VALUE */:
        return parser.parseComponentValue()
      case 3 /* TYPE_VALUE */:
        switch (descriptor.format) {
          case 'angle':
            return angle.parse(context, parser.parseComponentValue())
          case 'color':
            return color$1.parse(context, parser.parseComponentValue())
          case 'image':
            return image.parse(context, parser.parseComponentValue())
          case 'length':
            var length_1 = parser.parseComponentValue()
            return isLength(length_1) ? length_1 : ZERO_LENGTH
          case 'length-percentage':
            var value_1 = parser.parseComponentValue()
            return isLengthPercentage(value_1) ? value_1 : ZERO_LENGTH
          case 'time':
            return time.parse(context, parser.parseComponentValue())
        }
        break
    }
  }

  var elementDebuggerAttribute = 'data-html2canvas-debug'
  var getElementDebugType = function(element) {
    var attribute = element.getAttribute(elementDebuggerAttribute)
    switch (attribute) {
      case 'all':
        return 1 /* ALL */
      case 'clone':
        return 2 /* CLONE */
      case 'parse':
        return 3 /* PARSE */
      case 'render':
        return 4 /* RENDER */
      default:
        return 0 /* NONE */
    }
  }
  var isDebugging = function(element, type) {
    var elementType = getElementDebugType(element)
    return elementType === 1 /* ALL */ || type === elementType
  }

  var ElementContainer = /** @class */ (function() {
    function ElementContainer(context, element) {
      this.context = context
      this.textNodes = []
      this.elements = []
      this.flags = 0
      if (isDebugging(element, 3 /* PARSE */)) {
        debugger
      }
      this.styles = new CSSParsedDeclaration(context, window.getComputedStyle(element, null))
      if (isHTMLElementNode(element)) {
        if (
          this.styles.animationDuration.some(function(duration) {
            return duration > 0
          })
        ) {
          element.style.animationDuration = '0s'
        }
        if (this.styles.transform !== null) {
          // getBoundingClientRect takes transforms into account
          element.style.transform = 'none'
        }
      }
      this.bounds = parseBounds(this.context, element)
      if (isDebugging(element, 4 /* RENDER */)) {
        this.flags |= 16 /* DEBUG_RENDER */
      }
    }
    return ElementContainer
  })()

  /*
   * text-segmentation 1.0.3 <https://github.com/niklasvh/text-segmentation>
   * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
   * Released under MIT License
   */
  var base64 =
    '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'

  /*
   * utrie 1.0.2 <https://github.com/niklasvh/utrie>
   * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
   * Released under MIT License
   */
  var chars$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
  // Use a lookup table to find the index.
  var lookup$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256)
  for (var i$1 = 0; i$1 < chars$1.length; i$1++) {
    lookup$1[chars$1.charCodeAt(i$1)] = i$1
  }
  var decode = function(base64) {
    var bufferLength = base64.length * 0.75,
      len = base64.length,
      i,
      p = 0,
      encoded1,
      encoded2,
      encoded3,
      encoded4
    if (base64[base64.length - 1] === '=') {
      bufferLength--
      if (base64[base64.length - 2] === '=') {
        bufferLength--
      }
    }
    var buffer =
      typeof ArrayBuffer !== 'undefined' &&
      typeof Uint8Array !== 'undefined' &&
      typeof Uint8Array.prototype.slice !== 'undefined'
        ? new ArrayBuffer(bufferLength)
        : new Array(bufferLength)
    var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer)
    for (i = 0; i < len; i += 4) {
      encoded1 = lookup$1[base64.charCodeAt(i)]
      encoded2 = lookup$1[base64.charCodeAt(i + 1)]
      encoded3 = lookup$1[base64.charCodeAt(i + 2)]
      encoded4 = lookup$1[base64.charCodeAt(i + 3)]
      bytes[p++] = (encoded1 << 2) | (encoded2 >> 4)
      bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2)
      bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63)
    }
    return buffer
  }
  var polyUint16Array = function(buffer) {
    var length = buffer.length
    var bytes = []
    for (var i = 0; i < length; i += 2) {
      bytes.push((buffer[i + 1] << 8) | buffer[i])
    }
    return bytes
  }
  var polyUint32Array = function(buffer) {
    var length = buffer.length
    var bytes = []
    for (var i = 0; i < length; i += 4) {
      bytes.push((buffer[i + 3] << 24) | (buffer[i + 2] << 16) | (buffer[i + 1] << 8) | buffer[i])
    }
    return bytes
  }

  /** Shift size for getting the index-2 table offset. */
  var UTRIE2_SHIFT_2 = 5
  /** Shift size for getting the index-1 table offset. */
  var UTRIE2_SHIFT_1 = 6 + 5
  /**
   * Shift size for shifting left the index array values.
   * Increases possible data size with 16-bit index values at the cost
   * of compactability.
   * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
   */
  var UTRIE2_INDEX_SHIFT = 2
  /**
   * Difference between the two shift sizes,
   * for getting an index-1 offset from an index-2 offset. 6=11-5
   */
  var UTRIE2_SHIFT_1_2 = UTRIE2_SHIFT_1 - UTRIE2_SHIFT_2
  /**
   * The part of the index-2 table for U+D800..U+DBFF stores values for
   * lead surrogate code _units_ not code _points_.
   * Values for lead surrogate code _points_ are indexed with this portion of the table.
   * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
   */
  var UTRIE2_LSCP_INDEX_2_OFFSET = 0x10000 >> UTRIE2_SHIFT_2
  /** Number of entries in a data block. 32=0x20 */
  var UTRIE2_DATA_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_2
  /** Mask for getting the lower bits for the in-data-block offset. */
  var UTRIE2_DATA_MASK = UTRIE2_DATA_BLOCK_LENGTH - 1
  var UTRIE2_LSCP_INDEX_2_LENGTH = 0x400 >> UTRIE2_SHIFT_2
  /** Count the lengths of both BMP pieces. 2080=0x820 */
  var UTRIE2_INDEX_2_BMP_LENGTH = UTRIE2_LSCP_INDEX_2_OFFSET + UTRIE2_LSCP_INDEX_2_LENGTH
  /**
   * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
   * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
   */
  var UTRIE2_UTF8_2B_INDEX_2_OFFSET = UTRIE2_INDEX_2_BMP_LENGTH
  var UTRIE2_UTF8_2B_INDEX_2_LENGTH =
    0x800 >> 6 /* U+0800 is the first code point after 2-byte UTF-8 */
  /**
   * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
   * Variable length, for code points up to highStart, where the last single-value range starts.
   * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
   * (For 0x100000 supplementary code points U+10000..U+10ffff.)
   *
   * The part of the index-2 table for supplementary code points starts
   * after this index-1 table.
   *
   * Both the index-1 table and the following part of the index-2 table
   * are omitted completely if there is only BMP data.
   */
  var UTRIE2_INDEX_1_OFFSET = UTRIE2_UTF8_2B_INDEX_2_OFFSET + UTRIE2_UTF8_2B_INDEX_2_LENGTH
  /**
   * Number of index-1 entries for the BMP. 32=0x20
   * This part of the index-1 table is omitted from the serialized form.
   */
  var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> UTRIE2_SHIFT_1
  /** Number of entries in an index-2 block. 64=0x40 */
  var UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_1_2
  /** Mask for getting the lower bits for the in-index-2-block offset. */
  var UTRIE2_INDEX_2_MASK = UTRIE2_INDEX_2_BLOCK_LENGTH - 1
  var slice16 = function(view, start, end) {
    if (view.slice) {
      return view.slice(start, end)
    }
    return new Uint16Array(Array.prototype.slice.call(view, start, end))
  }
  var slice32 = function(view, start, end) {
    if (view.slice) {
      return view.slice(start, end)
    }
    return new Uint32Array(Array.prototype.slice.call(view, start, end))
  }
  var createTrieFromBase64 = function(base64, _byteLength) {
    var buffer = decode(base64)
    var view32 = Array.isArray(buffer) ? polyUint32Array(buffer) : new Uint32Array(buffer)
    var view16 = Array.isArray(buffer) ? polyUint16Array(buffer) : new Uint16Array(buffer)
    var headerLength = 24
    var index = slice16(view16, headerLength / 2, view32[4] / 2)
    var data =
      view32[5] === 2
        ? slice16(view16, (headerLength + view32[4]) / 2)
        : slice32(view32, Math.ceil((headerLength + view32[4]) / 4))
    return new Trie(view32[0], view32[1], view32[2], view32[3], index, data)
  }
  var Trie = /** @class */ (function() {
    function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
      this.initialValue = initialValue
      this.errorValue = errorValue
      this.highStart = highStart
      this.highValueIndex = highValueIndex
      this.index = index
      this.data = data
    }
    /**
     * Get the value for a code point as stored in the Trie.
     *
     * @param codePoint the code point
     * @return the value
     */
    Trie.prototype.get = function(codePoint) {
      var ix
      if (codePoint >= 0) {
        if (codePoint < 0x0d800 || (codePoint > 0x0dbff && codePoint <= 0x0ffff)) {
          // Ordinary BMP code point, excluding leading surrogates.
          // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
          // 16 bit data is stored in the index array itself.
          ix = this.index[codePoint >> UTRIE2_SHIFT_2]
          ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK)
          return this.data[ix]
        }
        if (codePoint <= 0xffff) {
          // Lead Surrogate Code Point.  A Separate index section is stored for
          // lead surrogate code units and code points.
          //   The main index has the code unit data.
          //   For this function, we need the code point data.
          // Note: this expression could be refactored for slightly improved efficiency, but
          //       surrogate code points will be so rare in practice that it's not worth it.
          ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET + ((codePoint - 0xd800) >> UTRIE2_SHIFT_2)]
          ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK)
          return this.data[ix]
        }
        if (codePoint < this.highStart) {
          // Supplemental code point, use two-level lookup.
          ix =
            UTRIE2_INDEX_1_OFFSET -
            UTRIE2_OMITTED_BMP_INDEX_1_LENGTH +
            (codePoint >> UTRIE2_SHIFT_1)
          ix = this.index[ix]
          ix += (codePoint >> UTRIE2_SHIFT_2) & UTRIE2_INDEX_2_MASK
          ix = this.index[ix]
          ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK)
          return this.data[ix]
        }
        if (codePoint <= 0x10ffff) {
          return this.data[this.highValueIndex]
        }
      }
      // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
      return this.errorValue
    }
    return Trie
  })()

  /*
   * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
   * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
   * Released under MIT License
   */
  var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
  // Use a lookup table to find the index.
  var lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256)
  for (var i = 0; i < chars.length; i++) {
    lookup[chars.charCodeAt(i)] = i
  }

  var Prepend = 1
  var CR = 2
  var LF = 3
  var Control = 4
  var Extend = 5
  var SpacingMark = 7
  var L = 8
  var V = 9
  var T = 10
  var LV = 11
  var LVT = 12
  var ZWJ = 13
  var Extended_Pictographic = 14
  var RI = 15
  var toCodePoints = function(str) {
    var codePoints = []
    var i = 0
    var length = str.length
    while (i < length) {
      var value = str.charCodeAt(i++)
      if (value >= 0xd800 && value <= 0xdbff && i < length) {
        var extra = str.charCodeAt(i++)
        if ((extra & 0xfc00) === 0xdc00) {
          codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000)
        } else {
          codePoints.push(value)
          i--
        }
      } else {
        codePoints.push(value)
      }
    }
    return codePoints
  }
  var fromCodePoint = function() {
    var codePoints = []
    for (var _i = 0; _i < arguments.length; _i++) {
      codePoints[_i] = arguments[_i]
    }
    if (String.fromCodePoint) {
      return String.fromCodePoint.apply(String, codePoints)
    }
    var length = codePoints.length
    if (!length) {
      return ''
    }
    var codeUnits = []
    var index = -1
    var result = ''
    while (++index < length) {
      var codePoint = codePoints[index]
      if (codePoint <= 0xffff) {
        codeUnits.push(codePoint)
      } else {
        codePoint -= 0x10000
        codeUnits.push((codePoint >> 10) + 0xd800, (codePoint % 0x400) + 0xdc00)
      }
      if (index + 1 === length || codeUnits.length > 0x4000) {
        result += String.fromCharCode.apply(String, codeUnits)
        codeUnits.length = 0
      }
    }
    return result
  }
  var UnicodeTrie = createTrieFromBase64(base64)
  var BREAK_NOT_ALLOWED = '×'
  var BREAK_ALLOWED = '÷'
  var codePointToClass = function(codePoint) {
    return UnicodeTrie.get(codePoint)
  }
  var _graphemeBreakAtIndex = function(_codePoints, classTypes, index) {
    var prevIndex = index - 2
    var prev = classTypes[prevIndex]
    var current = classTypes[index - 1]
    var next = classTypes[index]
    // GB3 Do not break between a CR and LF
    if (current === CR && next === LF) {
      return BREAK_NOT_ALLOWED
    }
    // GB4 Otherwise, break before and after controls.
    if (current === CR || current === LF || current === Control) {
      return BREAK_ALLOWED
    }
    // GB5
    if (next === CR || next === LF || next === Control) {
      return BREAK_ALLOWED
    }
    // Do not break Hangul syllable sequences.
    // GB6
    if (current === L && [L, V, LV, LVT].indexOf(next) !== -1) {
      return BREAK_NOT_ALLOWED
    }
    // GB7
    if ((current === LV || current === V) && (next === V || next === T)) {
      return BREAK_NOT_ALLOWED
    }
    // GB8
    if ((current === LVT || current === T) && next === T) {
      return BREAK_NOT_ALLOWED
    }
    // GB9 Do not break before extending characters or ZWJ.
    if (next === ZWJ || next === Extend) {
      return BREAK_NOT_ALLOWED
    }
    // Do not break before SpacingMarks, or after Prepend characters.
    // GB9a
    if (next === SpacingMark) {
      return BREAK_NOT_ALLOWED
    }
    // GB9a
    if (current === Prepend) {
      return BREAK_NOT_ALLOWED
    }
    // GB11 Do not break within emoji modifier sequences or emoji zwj sequences.
    if (current === ZWJ && next === Extended_Pictographic) {
      while (prev === Extend) {
        prev = classTypes[--prevIndex]
      }
      if (prev === Extended_Pictographic) {
        return BREAK_NOT_ALLOWED
      }
    }
    // GB12 Do not break within emoji flag sequences.
    // That is, do not break between regional indicator (RI) symbols
    // if there is an odd number of RI characters before the break point.
    if (current === RI && next === RI) {
      var countRI = 0
      while (prev === RI) {
        countRI++
        prev = classTypes[--prevIndex]
      }
      if (countRI % 2 === 0) {
        return BREAK_NOT_ALLOWED
      }
    }
    return BREAK_ALLOWED
  }
  var GraphemeBreaker = function(str) {
    var codePoints = toCodePoints(str)
    var length = codePoints.length
    var index = 0
    var lastEnd = 0
    var classTypes = codePoints.map(codePointToClass)
    return {
      next: function() {
        if (index >= length) {
          return { done: true, value: null }
        }
        var graphemeBreak = BREAK_NOT_ALLOWED
        while (
          index < length &&
          (graphemeBreak = _graphemeBreakAtIndex(codePoints, classTypes, ++index)) ===
            BREAK_NOT_ALLOWED
        ) {}
        if (graphemeBreak !== BREAK_NOT_ALLOWED || index === length) {
          var value = fromCodePoint.apply(null, codePoints.slice(lastEnd, index))
          lastEnd = index
          return { value: value, done: false }
        }
        return { done: true, value: null }
      },
    }
  }
  var splitGraphemes = function(str) {
    var breaker = GraphemeBreaker(str)
    var graphemes = []
    var bk
    while (!(bk = breaker.next()).done) {
      if (bk.value) {
        graphemes.push(bk.value.slice())
      }
    }
    return graphemes
  }

  var testRangeBounds = function(document) {
    var TEST_HEIGHT = 123
    if (document.createRange) {
      var range = document.createRange()
      if (range.getBoundingClientRect) {
        var testElement = document.createElement('boundtest')
        testElement.style.height = TEST_HEIGHT + 'px'
        testElement.style.display = 'block'
        document.body.appendChild(testElement)
        range.selectNode(testElement)
        var rangeBounds = range.getBoundingClientRect()
        var rangeHeight = Math.round(rangeBounds.height)
        document.body.removeChild(testElement)
        if (rangeHeight === TEST_HEIGHT) {
          return true
        }
      }
    }
    return false
  }
  var testIOSLineBreak = function(document) {
    var testElement = document.createElement('boundtest')
    testElement.style.width = '50px'
    testElement.style.display = 'block'
    testElement.style.fontSize = '12px'
    testElement.style.letterSpacing = '0px'
    testElement.style.wordSpacing = '0px'
    document.body.appendChild(testElement)
    var range = document.createRange()
    testElement.innerHTML = typeof ''.repeat === 'function' ? '&#128104;'.repeat(10) : ''
    var node = testElement.firstChild
    var textList = toCodePoints$1(node.data).map(function(i) {
      return fromCodePoint$1(i)
    })
    var offset = 0
    var prev = {}
    // ios 13 does not handle range getBoundingClientRect line changes correctly #2177
    var supports = textList.every(function(text, i) {
      range.setStart(node, offset)
      range.setEnd(node, offset + text.length)
      var rect = range.getBoundingClientRect()
      offset += text.length
      var boundAhead = rect.x > prev.x || rect.y > prev.y
      prev = rect
      if (i === 0) {
        return true
      }
      return boundAhead
    })
    document.body.removeChild(testElement)
    return supports
  }
  var testCORS = function() {
    return typeof new Image().crossOrigin !== 'undefined'
  }
  var testResponseType = function() {
    return typeof new XMLHttpRequest().responseType === 'string'
  }
  var testSVG = function(document) {
    var img = new Image()
    var canvas = document.createElement('canvas')
    var ctx = canvas.getContext('2d')
    if (!ctx) {
      return false
    }
    img.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>"
    try {
      ctx.drawImage(img, 0, 0)
      canvas.toDataURL()
    } catch (e) {
      return false
    }
    return true
  }
  var isGreenPixel = function(data) {
    return data[0] === 0 && data[1] === 255 && data[2] === 0 && data[3] === 255
  }
  var testForeignObject = function(document) {
    var canvas = document.createElement('canvas')
    var size = 100
    canvas.width = size
    canvas.height = size
    var ctx = canvas.getContext('2d')
    if (!ctx) {
      return Promise.reject(false)
    }
    ctx.fillStyle = 'rgb(0, 255, 0)'
    ctx.fillRect(0, 0, size, size)
    var img = new Image()
    var greenImageSrc = canvas.toDataURL()
    img.src = greenImageSrc
    var svg = createForeignObjectSVG(size, size, 0, 0, img)
    ctx.fillStyle = 'red'
    ctx.fillRect(0, 0, size, size)
    return loadSerializedSVG$1(svg)
      .then(function(img) {
        ctx.drawImage(img, 0, 0)
        var data = ctx.getImageData(0, 0, size, size).data
        ctx.fillStyle = 'red'
        ctx.fillRect(0, 0, size, size)
        var node = document.createElement('div')
        node.style.backgroundImage = 'url(' + greenImageSrc + ')'
        node.style.height = size + 'px'
        // Firefox 55 does not render inline <img /> tags
        return isGreenPixel(data)
          ? loadSerializedSVG$1(createForeignObjectSVG(size, size, 0, 0, node))
          : Promise.reject(false)
      })
      .then(function(img) {
        ctx.drawImage(img, 0, 0)
        // Edge does not render background-images
        return isGreenPixel(ctx.getImageData(0, 0, size, size).data)
      })
      .catch(function() {
        return false
      })
  }
  var createForeignObjectSVG = function(width, height, x, y, node) {
    var xmlns = 'http://www.w3.org/2000/svg'
    var svg = document.createElementNS(xmlns, 'svg')
    var foreignObject = document.createElementNS(xmlns, 'foreignObject')
    svg.setAttributeNS(null, 'width', width.toString())
    svg.setAttributeNS(null, 'height', height.toString())
    foreignObject.setAttributeNS(null, 'width', '100%')
    foreignObject.setAttributeNS(null, 'height', '100%')
    foreignObject.setAttributeNS(null, 'x', x.toString())
    foreignObject.setAttributeNS(null, 'y', y.toString())
    foreignObject.setAttributeNS(null, 'externalResourcesRequired', 'true')
    svg.appendChild(foreignObject)
    foreignObject.appendChild(node)
    return svg
  }
  var loadSerializedSVG$1 = function(svg) {
    return new Promise(function(resolve, reject) {
      var img = new Image()
      img.onload = function() {
        return resolve(img)
      }
      img.onerror = reject
      img.src =
        'data:image/svg+xml;charset=utf-8,' +
        encodeURIComponent(new XMLSerializer().serializeToString(svg))
    })
  }
  var FEATURES = {
    get SUPPORT_RANGE_BOUNDS() {
      var value = testRangeBounds(document)
      Object.defineProperty(FEATURES, 'SUPPORT_RANGE_BOUNDS', { value: value })
      return value
    },
    get SUPPORT_WORD_BREAKING() {
      var value = FEATURES.SUPPORT_RANGE_BOUNDS && testIOSLineBreak(document)
      Object.defineProperty(FEATURES, 'SUPPORT_WORD_BREAKING', { value: value })
      return value
    },
    get SUPPORT_SVG_DRAWING() {
      var value = testSVG(document)
      Object.defineProperty(FEATURES, 'SUPPORT_SVG_DRAWING', { value: value })
      return value
    },
    get SUPPORT_FOREIGNOBJECT_DRAWING() {
      var value =
        typeof Array.from === 'function' && typeof window.fetch === 'function'
          ? testForeignObject(document)
          : Promise.resolve(false)
      Object.defineProperty(FEATURES, 'SUPPORT_FOREIGNOBJECT_DRAWING', { value: value })
      return value
    },
    get SUPPORT_CORS_IMAGES() {
      var value = testCORS()
      Object.defineProperty(FEATURES, 'SUPPORT_CORS_IMAGES', { value: value })
      return value
    },
    get SUPPORT_RESPONSE_TYPE() {
      var value = testResponseType()
      Object.defineProperty(FEATURES, 'SUPPORT_RESPONSE_TYPE', { value: value })
      return value
    },
    get SUPPORT_CORS_XHR() {
      var value = 'withCredentials' in new XMLHttpRequest()
      Object.defineProperty(FEATURES, 'SUPPORT_CORS_XHR', { value: value })
      return value
    },
    get SUPPORT_NATIVE_TEXT_SEGMENTATION() {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      var value = !!(typeof Intl !== 'undefined' && Intl.Segmenter)
      Object.defineProperty(FEATURES, 'SUPPORT_NATIVE_TEXT_SEGMENTATION', { value: value })
      return value
    },
  }

  var TextBounds = /** @class */ (function() {
    function TextBounds(text, bounds) {
      this.text = text
      this.bounds = bounds
    }
    return TextBounds
  })()
  var parseTextBounds = function(context, value, styles, node) {
    var textList = breakText(value, styles)
    var textBounds = []
    var offset = 0
    textList.forEach(function(text) {
      if (styles.textDecorationLine.length || text.trim().length > 0) {
        if (FEATURES.SUPPORT_RANGE_BOUNDS) {
          var clientRects = createRange(node, offset, text.length).getClientRects()
          if (clientRects.length > 1) {
            var subSegments = segmentGraphemes(text)
            var subOffset_1 = 0
            subSegments.forEach(function(subSegment) {
              textBounds.push(
                new TextBounds(
                  subSegment,
                  Bounds.fromDOMRectList(
                    context,
                    createRange(node, subOffset_1 + offset, subSegment.length).getClientRects()
                  )
                )
              )
              subOffset_1 += subSegment.length
            })
          } else {
            textBounds.push(new TextBounds(text, Bounds.fromDOMRectList(context, clientRects)))
          }
        } else {
          var replacementNode = node.splitText(text.length)
          textBounds.push(new TextBounds(text, getWrapperBounds(context, node)))
          node = replacementNode
        }
      } else if (!FEATURES.SUPPORT_RANGE_BOUNDS) {
        node = node.splitText(text.length)
      }
      offset += text.length
    })
    return textBounds
  }
  var getWrapperBounds = function(context, node) {
    var ownerDocument = node.ownerDocument
    if (ownerDocument) {
      var wrapper = ownerDocument.createElement('html2canvaswrapper')
      wrapper.appendChild(node.cloneNode(true))
      var parentNode = node.parentNode
      if (parentNode) {
        parentNode.replaceChild(wrapper, node)
        var bounds = parseBounds(context, wrapper)
        if (wrapper.firstChild) {
          parentNode.replaceChild(wrapper.firstChild, wrapper)
        }
        return bounds
      }
    }
    return Bounds.EMPTY
  }
  var createRange = function(node, offset, length) {
    var ownerDocument = node.ownerDocument
    if (!ownerDocument) {
      throw new Error('Node has no owner document')
    }
    var range = ownerDocument.createRange()
    range.setStart(node, offset)
    range.setEnd(node, offset + length)
    return range
  }
  var segmentGraphemes = function(value) {
    if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      var segmenter = new Intl.Segmenter(void 0, { granularity: 'grapheme' })
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      return Array.from(segmenter.segment(value)).map(function(segment) {
        return segment.segment
      })
    }
    return splitGraphemes(value)
  }
  var segmentWords = function(value, styles) {
    if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      var segmenter = new Intl.Segmenter(void 0, {
        granularity: 'word',
      })
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      return Array.from(segmenter.segment(value)).map(function(segment) {
        return segment.segment
      })
    }
    return breakWords(value, styles)
  }
  var breakText = function(value, styles) {
    return styles.letterSpacing !== 0 ? segmentGraphemes(value) : segmentWords(value, styles)
  }
  // https://drafts.csswg.org/css-text/#word-separator
  var wordSeparators = [0x0020, 0x00a0, 0x1361, 0x10100, 0x10101, 0x1039, 0x1091]
  var breakWords = function(str, styles) {
    var breaker = LineBreaker(str, {
      lineBreak: styles.lineBreak,
      wordBreak:
        styles.overflowWrap === 'break-word' /* BREAK_WORD */ ? 'break-word' : styles.wordBreak,
    })
    var words = []
    var bk
    var _loop_1 = function() {
      if (bk.value) {
        var value = bk.value.slice()
        var codePoints = toCodePoints$1(value)
        var word_1 = ''
        codePoints.forEach(function(codePoint) {
          if (wordSeparators.indexOf(codePoint) === -1) {
            word_1 += fromCodePoint$1(codePoint)
          } else {
            if (word_1.length) {
              words.push(word_1)
            }
            words.push(fromCodePoint$1(codePoint))
            word_1 = ''
          }
        })
        if (word_1.length) {
          words.push(word_1)
        }
      }
    }
    while (!(bk = breaker.next()).done) {
      _loop_1()
    }
    return words
  }

  var TextContainer = /** @class */ (function() {
    function TextContainer(context, node, styles) {
      this.text = transform(node.data, styles.textTransform)
      this.textBounds = parseTextBounds(context, this.text, styles, node)
    }
    return TextContainer
  })()
  var transform = function(text, transform) {
    switch (transform) {
      case 1 /* LOWERCASE */:
        return text.toLowerCase()
      case 3 /* CAPITALIZE */:
        return text.replace(CAPITALIZE, capitalize)
      case 2 /* UPPERCASE */:
        return text.toUpperCase()
      default:
        return text
    }
  }
  var CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g
  var capitalize = function(m, p1, p2) {
    if (m.length > 0) {
      return p1 + p2.toUpperCase()
    }
    return m
  }

  var ImageElementContainer = /** @class */ (function(_super) {
    __extends(ImageElementContainer, _super)
    function ImageElementContainer(context, img) {
      var _this = _super.call(this, context, img) || this
      _this.src = img.currentSrc || img.src
      _this.intrinsicWidth = img.naturalWidth
      _this.intrinsicHeight = img.naturalHeight
      _this.context.cache.addImage(_this.src)
      return _this
    }
    return ImageElementContainer
  })(ElementContainer)

  var CanvasElementContainer = /** @class */ (function(_super) {
    __extends(CanvasElementContainer, _super)
    function CanvasElementContainer(context, canvas) {
      var _this = _super.call(this, context, canvas) || this
      _this.canvas = canvas
      _this.intrinsicWidth = canvas.width
      _this.intrinsicHeight = canvas.height
      return _this
    }
    return CanvasElementContainer
  })(ElementContainer)

  var SVGElementContainer = /** @class */ (function(_super) {
    __extends(SVGElementContainer, _super)
    function SVGElementContainer(context, img) {
      var _this = _super.call(this, context, img) || this
      var s = new XMLSerializer()
      var bounds = parseBounds(context, img)
      img.setAttribute('width', bounds.width + 'px')
      img.setAttribute('height', bounds.height + 'px')
      _this.svg = 'data:image/svg+xml,' + encodeURIComponent(s.serializeToString(img))
      _this.intrinsicWidth = img.width.baseVal.value
      _this.intrinsicHeight = img.height.baseVal.value
      _this.context.cache.addImage(_this.svg)
      return _this
    }
    return SVGElementContainer
  })(ElementContainer)

  var LIElementContainer = /** @class */ (function(_super) {
    __extends(LIElementContainer, _super)
    function LIElementContainer(context, element) {
      var _this = _super.call(this, context, element) || this
      _this.value = element.value
      return _this
    }
    return LIElementContainer
  })(ElementContainer)

  var OLElementContainer = /** @class */ (function(_super) {
    __extends(OLElementContainer, _super)
    function OLElementContainer(context, element) {
      var _this = _super.call(this, context, element) || this
      _this.start = element.start
      _this.reversed = typeof element.reversed === 'boolean' && element.reversed === true
      return _this
    }
    return OLElementContainer
  })(ElementContainer)

  var CHECKBOX_BORDER_RADIUS = [
    {
      type: 15 /* DIMENSION_TOKEN */,
      flags: 0,
      unit: 'px',
      number: 3,
    },
  ]
  var RADIO_BORDER_RADIUS = [
    {
      type: 16 /* PERCENTAGE_TOKEN */,
      flags: 0,
      number: 50,
    },
  ]
  var reformatInputBounds = function(bounds) {
    if (bounds.width > bounds.height) {
      return new Bounds(
        bounds.left + (bounds.width - bounds.height) / 2,
        bounds.top,
        bounds.height,
        bounds.height
      )
    } else if (bounds.width < bounds.height) {
      return new Bounds(
        bounds.left,
        bounds.top + (bounds.height - bounds.width) / 2,
        bounds.width,
        bounds.width
      )
    }
    return bounds
  }
  var getInputValue = function(node) {
    var value =
      node.type === PASSWORD ? new Array(node.value.length + 1).join('\u2022') : node.value
    return value.length === 0 ? node.placeholder || '' : value
  }
  var CHECKBOX = 'checkbox'
  var RADIO = 'radio'
  var PASSWORD = 'password'
  var INPUT_COLOR = 0x2a2a2aff
  var InputElementContainer = /** @class */ (function(_super) {
    __extends(InputElementContainer, _super)
    function InputElementContainer(context, input) {
      var _this = _super.call(this, context, input) || this
      _this.type = input.type.toLowerCase()
      _this.checked = input.checked
      _this.value = getInputValue(input)
      if (_this.type === CHECKBOX || _this.type === RADIO) {
        _this.styles.backgroundColor = 0xdededeff
        _this.styles.borderTopColor = _this.styles.borderRightColor = _this.styles.borderBottomColor = _this.styles.borderLeftColor = 0xa5a5a5ff
        _this.styles.borderTopWidth = _this.styles.borderRightWidth = _this.styles.borderBottomWidth = _this.styles.borderLeftWidth = 1
        _this.styles.borderTopStyle = _this.styles.borderRightStyle = _this.styles.borderBottomStyle = _this.styles.borderLeftStyle = 1 /* SOLID */
        _this.styles.backgroundClip = [0 /* BORDER_BOX */]
        _this.styles.backgroundOrigin = [0 /* BORDER_BOX */]
        _this.bounds = reformatInputBounds(_this.bounds)
      }
      switch (_this.type) {
        case CHECKBOX:
          _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = CHECKBOX_BORDER_RADIUS
          break
        case RADIO:
          _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = RADIO_BORDER_RADIUS
          break
      }
      return _this
    }
    return InputElementContainer
  })(ElementContainer)

  var SelectElementContainer = /** @class */ (function(_super) {
    __extends(SelectElementContainer, _super)
    function SelectElementContainer(context, element) {
      var _this = _super.call(this, context, element) || this
      var option = element.options[element.selectedIndex || 0]
      _this.value = option ? option.text || '' : ''
      return _this
    }
    return SelectElementContainer
  })(ElementContainer)

  var TextareaElementContainer = /** @class */ (function(_super) {
    __extends(TextareaElementContainer, _super)
    function TextareaElementContainer(context, element) {
      var _this = _super.call(this, context, element) || this
      _this.value = element.value
      return _this
    }
    return TextareaElementContainer
  })(ElementContainer)

  var IFrameElementContainer = /** @class */ (function(_super) {
    __extends(IFrameElementContainer, _super)
    function IFrameElementContainer(context, iframe) {
      var _this = _super.call(this, context, iframe) || this
      _this.src = iframe.src
      _this.width = parseInt(iframe.width, 10) || 0
      _this.height = parseInt(iframe.height, 10) || 0
      _this.backgroundColor = _this.styles.backgroundColor
      try {
        if (
          iframe.contentWindow &&
          iframe.contentWindow.document &&
          iframe.contentWindow.document.documentElement
        ) {
          _this.tree = parseTree(context, iframe.contentWindow.document.documentElement)
          // http://www.w3.org/TR/css3-background/#special-backgrounds
          var documentBackgroundColor = iframe.contentWindow.document.documentElement
            ? parseColor(
                context,
                getComputedStyle(iframe.contentWindow.document.documentElement).backgroundColor
              )
            : COLORS.TRANSPARENT
          var bodyBackgroundColor = iframe.contentWindow.document.body
            ? parseColor(
                context,
                getComputedStyle(iframe.contentWindow.document.body).backgroundColor
              )
            : COLORS.TRANSPARENT
          _this.backgroundColor = isTransparent(documentBackgroundColor)
            ? isTransparent(bodyBackgroundColor)
              ? _this.styles.backgroundColor
              : bodyBackgroundColor
            : documentBackgroundColor
        }
      } catch (e) {}
      return _this
    }
    return IFrameElementContainer
  })(ElementContainer)

  var LIST_OWNERS = ['OL', 'UL', 'MENU']
  var parseNodeTree = function(context, node, parent, root) {
    for (var childNode = node.firstChild, nextNode = void 0; childNode; childNode = nextNode) {
      nextNode = childNode.nextSibling
      if (isTextNode(childNode) && childNode.data.trim().length > 0) {
        parent.textNodes.push(new TextContainer(context, childNode, parent.styles))
      } else if (isElementNode(childNode)) {
        if (isSlotElement(childNode) && childNode.assignedNodes) {
          childNode.assignedNodes().forEach(function(childNode) {
            return parseNodeTree(context, childNode, parent, root)
          })
        } else {
          var container = createContainer(context, childNode)
          if (container.styles.isVisible()) {
            if (createsRealStackingContext(childNode, container, root)) {
              container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */
            } else if (createsStackingContext(container.styles)) {
              container.flags |= 2 /* CREATES_STACKING_CONTEXT */
            }
            if (LIST_OWNERS.indexOf(childNode.tagName) !== -1) {
              container.flags |= 8 /* IS_LIST_OWNER */
            }
            parent.elements.push(container)
            childNode.slot
            if (childNode.shadowRoot) {
              parseNodeTree(context, childNode.shadowRoot, container, root)
            } else if (
              !isTextareaElement(childNode) &&
              !isSVGElement(childNode) &&
              !isSelectElement(childNode)
            ) {
              parseNodeTree(context, childNode, container, root)
            }
          }
        }
      }
    }
  }
  var createContainer = function(context, element) {
    if (isImageElement(element)) {
      return new ImageElementContainer(context, element)
    }
    if (isCanvasElement(element)) {
      return new CanvasElementContainer(context, element)
    }
    if (isSVGElement(element)) {
      return new SVGElementContainer(context, element)
    }
    if (isLIElement(element)) {
      return new LIElementContainer(context, element)
    }
    if (isOLElement(element)) {
      return new OLElementContainer(context, element)
    }
    if (isInputElement(element)) {
      return new InputElementContainer(context, element)
    }
    if (isSelectElement(element)) {
      return new SelectElementContainer(context, element)
    }
    if (isTextareaElement(element)) {
      return new TextareaElementContainer(context, element)
    }
    if (isIFrameElement(element)) {
      return new IFrameElementContainer(context, element)
    }
    return new ElementContainer(context, element)
  }
  var parseTree = function(context, element) {
    var container = createContainer(context, element)
    container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */
    parseNodeTree(context, element, container, container)
    return container
  }
  var createsRealStackingContext = function(node, container, root) {
    return (
      container.styles.isPositionedWithZIndex() ||
      container.styles.opacity < 1 ||
      container.styles.isTransformed() ||
      (isBodyElement(node) && root.styles.isTransparent())
    )
  }
  var createsStackingContext = function(styles) {
    return styles.isPositioned() || styles.isFloating()
  }
  var isTextNode = function(node) {
    return node.nodeType === Node.TEXT_NODE
  }
  var isElementNode = function(node) {
    return node.nodeType === Node.ELEMENT_NODE
  }
  var isHTMLElementNode = function(node) {
    return isElementNode(node) && typeof node.style !== 'undefined' && !isSVGElementNode(node)
  }
  var isSVGElementNode = function(element) {
    return typeof element.className === 'object'
  }
  var isLIElement = function(node) {
    return node.tagName === 'LI'
  }
  var isOLElement = function(node) {
    return node.tagName === 'OL'
  }
  var isInputElement = function(node) {
    return node.tagName === 'INPUT'
  }
  var isHTMLElement = function(node) {
    return node.tagName === 'HTML'
  }
  var isSVGElement = function(node) {
    return node.tagName === 'svg'
  }
  var isBodyElement = function(node) {
    return node.tagName === 'BODY'
  }
  var isCanvasElement = function(node) {
    return node.tagName === 'CANVAS'
  }
  var isVideoElement = function(node) {
    return node.tagName === 'VIDEO'
  }
  var isImageElement = function(node) {
    return node.tagName === 'IMG'
  }
  var isIFrameElement = function(node) {
    return node.tagName === 'IFRAME'
  }
  var isStyleElement = function(node) {
    return node.tagName === 'STYLE'
  }
  var isScriptElement = function(node) {
    return node.tagName === 'SCRIPT'
  }
  var isTextareaElement = function(node) {
    return node.tagName === 'TEXTAREA'
  }
  var isSelectElement = function(node) {
    return node.tagName === 'SELECT'
  }
  var isSlotElement = function(node) {
    return node.tagName === 'SLOT'
  }
  // https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
  var isCustomElement = function(node) {
    return node.tagName.indexOf('-') > 0
  }

  var CounterState = /** @class */ (function() {
    function CounterState() {
      this.counters = {}
    }
    CounterState.prototype.getCounterValue = function(name) {
      var counter = this.counters[name]
      if (counter && counter.length) {
        return counter[counter.length - 1]
      }
      return 1
    }
    CounterState.prototype.getCounterValues = function(name) {
      var counter = this.counters[name]
      return counter ? counter : []
    }
    CounterState.prototype.pop = function(counters) {
      var _this = this
      counters.forEach(function(counter) {
        return _this.counters[counter].pop()
      })
    }
    CounterState.prototype.parse = function(style) {
      var _this = this
      var counterIncrement = style.counterIncrement
      var counterReset = style.counterReset
      var canReset = true
      if (counterIncrement !== null) {
        counterIncrement.forEach(function(entry) {
          var counter = _this.counters[entry.counter]
          if (counter && entry.increment !== 0) {
            canReset = false
            if (!counter.length) {
              counter.push(1)
            }
            counter[Math.max(0, counter.length - 1)] += entry.increment
          }
        })
      }
      var counterNames = []
      if (canReset) {
        counterReset.forEach(function(entry) {
          var counter = _this.counters[entry.counter]
          counterNames.push(entry.counter)
          if (!counter) {
            counter = _this.counters[entry.counter] = []
          }
          counter.push(entry.reset)
        })
      }
      return counterNames
    }
    return CounterState
  })()
  var ROMAN_UPPER = {
    integers: [1000, 900, 500, 400, 100, 90, 50, 40, 10, 9, 5, 4, 1],
    values: ['M', 'CM', 'D', 'CD', 'C', 'XC', 'L', 'XL', 'X', 'IX', 'V', 'IV', 'I'],
  }
  var ARMENIAN = {
    integers: [
      9000,
      8000,
      7000,
      6000,
      5000,
      4000,
      3000,
      2000,
      1000,
      900,
      800,
      700,
      600,
      500,
      400,
      300,
      200,
      100,
      90,
      80,
      70,
      60,
      50,
      40,
      30,
      20,
      10,
      9,
      8,
      7,
      6,
      5,
      4,
      3,
      2,
      1,
    ],
    values: [
      'Ք',
      'Փ',
      'Ւ',
      'Ց',
      'Ր',
      'Տ',
      'Վ',
      'Ս',
      'Ռ',
      'Ջ',
      'Պ',
      'Չ',
      'Ո',
      'Շ',
      'Ն',
      'Յ',
      'Մ',
      'Ճ',
      'Ղ',
      'Ձ',
      'Հ',
      'Կ',
      'Ծ',
      'Խ',
      'Լ',
      'Ի',
      'Ժ',
      'Թ',
      'Ը',
      'Է',
      'Զ',
      'Ե',
      'Դ',
      'Գ',
      'Բ',
      'Ա',
    ],
  }
  var HEBREW = {
    integers: [
      10000,
      9000,
      8000,
      7000,
      6000,
      5000,
      4000,
      3000,
      2000,
      1000,
      400,
      300,
      200,
      100,
      90,
      80,
      70,
      60,
      50,
      40,
      30,
      20,
      19,
      18,
      17,
      16,
      15,
      10,
      9,
      8,
      7,
      6,
      5,
      4,
      3,
      2,
      1,
    ],
    values: [
      'י׳',
      'ט׳',
      'ח׳',
      'ז׳',
      'ו׳',
      'ה׳',
      'ד׳',
      'ג׳',
      'ב׳',
      'א׳',
      'ת',
      'ש',
      'ר',
      'ק',
      'צ',
      'פ',
      'ע',
      'ס',
      'נ',
      'מ',
      'ל',
      'כ',
      'יט',
      'יח',
      'יז',
      'טז',
      'טו',
      'י',
      'ט',
      'ח',
      'ז',
      'ו',
      'ה',
      'ד',
      'ג',
      'ב',
      'א',
    ],
  }
  var GEORGIAN = {
    integers: [
      10000,
      9000,
      8000,
      7000,
      6000,
      5000,
      4000,
      3000,
      2000,
      1000,
      900,
      800,
      700,
      600,
      500,
      400,
      300,
      200,
      100,
      90,
      80,
      70,
      60,
      50,
      40,
      30,
      20,
      10,
      9,
      8,
      7,
      6,
      5,
      4,
      3,
      2,
      1,
    ],
    values: [
      'ჵ',
      'ჰ',
      'ჯ',
      'ჴ',
      'ხ',
      'ჭ',
      'წ',
      'ძ',
      'ც',
      'ჩ',
      'შ',
      'ყ',
      'ღ',
      'ქ',
      'ფ',
      'ჳ',
      'ტ',
      'ს',
      'რ',
      'ჟ',
      'პ',
      'ო',
      'ჲ',
      'ნ',
      'მ',
      'ლ',
      'კ',
      'ი',
      'თ',
      'ჱ',
      'ზ',
      'ვ',
      'ე',
      'დ',
      'გ',
      'ბ',
      'ა',
    ],
  }
  var createAdditiveCounter = function(value, min, max, symbols, fallback, suffix) {
    if (value < min || value > max) {
      return createCounterText(value, fallback, suffix.length > 0)
    }
    return (
      symbols.integers.reduce(function(string, integer, index) {
        while (value >= integer) {
          value -= integer
          string += symbols.values[index]
        }
        return string
      }, '') + suffix
    )
  }
  var createCounterStyleWithSymbolResolver = function(
    value,
    codePointRangeLength,
    isNumeric,
    resolver
  ) {
    var string = ''
    do {
      if (!isNumeric) {
        value--
      }
      string = resolver(value) + string
      value /= codePointRangeLength
    } while (value * codePointRangeLength >= codePointRangeLength)
    return string
  }
  var createCounterStyleFromRange = function(
    value,
    codePointRangeStart,
    codePointRangeEnd,
    isNumeric,
    suffix
  ) {
    var codePointRangeLength = codePointRangeEnd - codePointRangeStart + 1
    return (
      (value < 0 ? '-' : '') +
      (createCounterStyleWithSymbolResolver(
        Math.abs(value),
        codePointRangeLength,
        isNumeric,
        function(codePoint) {
          return fromCodePoint$1(Math.floor(codePoint % codePointRangeLength) + codePointRangeStart)
        }
      ) +
        suffix)
    )
  }
  var createCounterStyleFromSymbols = function(value, symbols, suffix) {
    if (suffix === void 0) {
      suffix = '. '
    }
    var codePointRangeLength = symbols.length
    return (
      createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, false, function(
        codePoint
      ) {
        return symbols[Math.floor(codePoint % codePointRangeLength)]
      }) + suffix
    )
  }
  var CJK_ZEROS = 1 << 0
  var CJK_TEN_COEFFICIENTS = 1 << 1
  var CJK_TEN_HIGH_COEFFICIENTS = 1 << 2
  var CJK_HUNDRED_COEFFICIENTS = 1 << 3
  var createCJKCounter = function(value, numbers, multipliers, negativeSign, suffix, flags) {
    if (value < -9999 || value > 9999) {
      return createCounterText(value, 4 /* CJK_DECIMAL */, suffix.length > 0)
    }
    var tmp = Math.abs(value)
    var string = suffix
    if (tmp === 0) {
      return numbers[0] + string
    }
    for (var digit = 0; tmp > 0 && digit <= 4; digit++) {
      var coefficient = tmp % 10
      if (coefficient === 0 && contains(flags, CJK_ZEROS) && string !== '') {
        string = numbers[coefficient] + string
      } else if (
        coefficient > 1 ||
        (coefficient === 1 && digit === 0) ||
        (coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_COEFFICIENTS)) ||
        (coefficient === 1 &&
          digit === 1 &&
          contains(flags, CJK_TEN_HIGH_COEFFICIENTS) &&
          value > 100) ||
        (coefficient === 1 && digit > 1 && contains(flags, CJK_HUNDRED_COEFFICIENTS))
      ) {
        string = numbers[coefficient] + (digit > 0 ? multipliers[digit - 1] : '') + string
      } else if (coefficient === 1 && digit > 0) {
        string = multipliers[digit - 1] + string
      }
      tmp = Math.floor(tmp / 10)
    }
    return (value < 0 ? negativeSign : '') + string
  }
  var CHINESE_INFORMAL_MULTIPLIERS = '十百千萬'
  var CHINESE_FORMAL_MULTIPLIERS = '拾佰仟萬'
  var JAPANESE_NEGATIVE = 'マイナス'
  var KOREAN_NEGATIVE = '마이너스'
  var createCounterText = function(value, type, appendSuffix) {
    var defaultSuffix = appendSuffix ? '. ' : ''
    var cjkSuffix = appendSuffix ? '、' : ''
    var koreanSuffix = appendSuffix ? ', ' : ''
    var spaceSuffix = appendSuffix ? ' ' : ''
    switch (type) {
      case 0 /* DISC */:
        return '•' + spaceSuffix
      case 1 /* CIRCLE */:
        return '◦' + spaceSuffix
      case 2 /* SQUARE */:
        return '◾' + spaceSuffix
      case 5 /* DECIMAL_LEADING_ZERO */:
        var string = createCounterStyleFromRange(value, 48, 57, true, defaultSuffix)
        return string.length < 4 ? '0' + string : string
      case 4 /* CJK_DECIMAL */:
        return createCounterStyleFromSymbols(value, '〇一二三四五六七八九', cjkSuffix)
      case 6 /* LOWER_ROMAN */:
        return createAdditiveCounter(
          value,
          1,
          3999,
          ROMAN_UPPER,
          3 /* DECIMAL */,
          defaultSuffix
        ).toLowerCase()
      case 7 /* UPPER_ROMAN */:
        return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */, defaultSuffix)
      case 8 /* LOWER_GREEK */:
        return createCounterStyleFromRange(value, 945, 969, false, defaultSuffix)
      case 9 /* LOWER_ALPHA */:
        return createCounterStyleFromRange(value, 97, 122, false, defaultSuffix)
      case 10 /* UPPER_ALPHA */:
        return createCounterStyleFromRange(value, 65, 90, false, defaultSuffix)
      case 11 /* ARABIC_INDIC */:
        return createCounterStyleFromRange(value, 1632, 1641, true, defaultSuffix)
      case 12 /* ARMENIAN */:
      case 49 /* UPPER_ARMENIAN */:
        return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */, defaultSuffix)
      case 35 /* LOWER_ARMENIAN */:
        return createAdditiveCounter(
          value,
          1,
          9999,
          ARMENIAN,
          3 /* DECIMAL */,
          defaultSuffix
        ).toLowerCase()
      case 13 /* BENGALI */:
        return createCounterStyleFromRange(value, 2534, 2543, true, defaultSuffix)
      case 14 /* CAMBODIAN */:
      case 30 /* KHMER */:
        return createCounterStyleFromRange(value, 6112, 6121, true, defaultSuffix)
      case 15 /* CJK_EARTHLY_BRANCH */:
        return createCounterStyleFromSymbols(value, '子丑寅卯辰巳午未申酉戌亥', cjkSuffix)
      case 16 /* CJK_HEAVENLY_STEM */:
        return createCounterStyleFromSymbols(value, '甲乙丙丁戊己庚辛壬癸', cjkSuffix)
      case 17 /* CJK_IDEOGRAPHIC */:
      case 48 /* TRAD_CHINESE_INFORMAL */:
        return createCJKCounter(
          value,
          '零一二三四五六七八九',
          CHINESE_INFORMAL_MULTIPLIERS,
          '負',
          cjkSuffix,
          CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS
        )
      case 47 /* TRAD_CHINESE_FORMAL */:
        return createCJKCounter(
          value,
          '零壹貳參肆伍陸柒捌玖',
          CHINESE_FORMAL_MULTIPLIERS,
          '負',
          cjkSuffix,
          CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS
        )
      case 42 /* SIMP_CHINESE_INFORMAL */:
        return createCJKCounter(
          value,
          '零一二三四五六七八九',
          CHINESE_INFORMAL_MULTIPLIERS,
          '负',
          cjkSuffix,
          CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS
        )
      case 41 /* SIMP_CHINESE_FORMAL */:
        return createCJKCounter(
          value,
          '零壹贰叁肆伍陆柒捌玖',
          CHINESE_FORMAL_MULTIPLIERS,
          '负',
          cjkSuffix,
          CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS
        )
      case 26 /* JAPANESE_INFORMAL */:
        return createCJKCounter(
          value,
          '〇一二三四五六七八九',
          '十百千万',
          JAPANESE_NEGATIVE,
          cjkSuffix,
          0
        )
      case 25 /* JAPANESE_FORMAL */:
        return createCJKCounter(
          value,
          '零壱弐参四伍六七八九',
          '拾百千万',
          JAPANESE_NEGATIVE,
          cjkSuffix,
          CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS
        )
      case 31 /* KOREAN_HANGUL_FORMAL */:
        return createCJKCounter(
          value,
          '영일이삼사오육칠팔구',
          '십백천만',
          KOREAN_NEGATIVE,
          koreanSuffix,
          CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS
        )
      case 33 /* KOREAN_HANJA_INFORMAL */:
        return createCJKCounter(
          value,
          '零一二三四五六七八九',
          '十百千萬',
          KOREAN_NEGATIVE,
          koreanSuffix,
          0
        )
      case 32 /* KOREAN_HANJA_FORMAL */:
        return createCJKCounter(
          value,
          '零壹貳參四五六七八九',
          '拾百千',
          KOREAN_NEGATIVE,
          koreanSuffix,
          CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS
        )
      case 18 /* DEVANAGARI */:
        return createCounterStyleFromRange(value, 0x966, 0x96f, true, defaultSuffix)
      case 20 /* GEORGIAN */:
        return createAdditiveCounter(value, 1, 19999, GEORGIAN, 3 /* DECIMAL */, defaultSuffix)
      case 21 /* GUJARATI */:
        return createCounterStyleFromRange(value, 0xae6, 0xaef, true, defaultSuffix)
      case 22 /* GURMUKHI */:
        return createCounterStyleFromRange(value, 0xa66, 0xa6f, true, defaultSuffix)
      case 22 /* HEBREW */:
        return createAdditiveCounter(value, 1, 10999, HEBREW, 3 /* DECIMAL */, defaultSuffix)
      case 23 /* HIRAGANA */:
        return createCounterStyleFromSymbols(
          value,
          'あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやゆよらりるれろわゐゑをん'
        )
      case 24 /* HIRAGANA_IROHA */:
        return createCounterStyleFromSymbols(
          value,
          'いろはにほへとちりぬるをわかよたれそつねならむうゐのおくやまけふこえてあさきゆめみしゑひもせす'
        )
      case 27 /* KANNADA */:
        return createCounterStyleFromRange(value, 0xce6, 0xcef, true, defaultSuffix)
      case 28 /* KATAKANA */:
        return createCounterStyleFromSymbols(
          value,
          'アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヰヱヲン',
          cjkSuffix
        )
      case 29 /* KATAKANA_IROHA */:
        return createCounterStyleFromSymbols(
          value,
          'イロハニホヘトチリヌルヲワカヨタレソツネナラムウヰノオクヤマケフコエテアサキユメミシヱヒモセス',
          cjkSuffix
        )
      case 34 /* LAO */:
        return createCounterStyleFromRange(value, 0xed0, 0xed9, true, defaultSuffix)
      case 37 /* MONGOLIAN */:
        return createCounterStyleFromRange(value, 0x1810, 0x1819, true, defaultSuffix)
      case 38 /* MYANMAR */:
        return createCounterStyleFromRange(value, 0x1040, 0x1049, true, defaultSuffix)
      case 39 /* ORIYA */:
        return createCounterStyleFromRange(value, 0xb66, 0xb6f, true, defaultSuffix)
      case 40 /* PERSIAN */:
        return createCounterStyleFromRange(value, 0x6f0, 0x6f9, true, defaultSuffix)
      case 43 /* TAMIL */:
        return createCounterStyleFromRange(value, 0xbe6, 0xbef, true, defaultSuffix)
      case 44 /* TELUGU */:
        return createCounterStyleFromRange(value, 0xc66, 0xc6f, true, defaultSuffix)
      case 45 /* THAI */:
        return createCounterStyleFromRange(value, 0xe50, 0xe59, true, defaultSuffix)
      case 46 /* TIBETAN */:
        return createCounterStyleFromRange(value, 0xf20, 0xf29, true, defaultSuffix)
      case 3 /* DECIMAL */:
      default:
        return createCounterStyleFromRange(value, 48, 57, true, defaultSuffix)
    }
  }

  var IGNORE_ATTRIBUTE = 'data-html2canvas-ignore'
  var DocumentCloner = /** @class */ (function() {
    function DocumentCloner(context, element, options) {
      this.context = context
      this.options = options
      this.scrolledElements = []
      this.referenceElement = element
      this.counters = new CounterState()
      this.quoteDepth = 0
      if (!element.ownerDocument) {
        throw new Error('Cloned element does not have an owner document')
      }
      this.documentElement = this.cloneNode(element.ownerDocument.documentElement, false)
    }
    DocumentCloner.prototype.toIFrame = function(ownerDocument, windowSize) {
      var _this = this
      var iframe = createIFrameContainer(ownerDocument, windowSize)
      if (!iframe.contentWindow) {
        return Promise.reject('Unable to find iframe window')
      }
      var scrollX = ownerDocument.defaultView.pageXOffset
      var scrollY = ownerDocument.defaultView.pageYOffset
      var cloneWindow = iframe.contentWindow
      var documentClone = cloneWindow.document
      /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
             if window url is about:blank, we can assign the url to current by writing onto the document
             */
      var iframeLoad = iframeLoader(iframe).then(function() {
        return __awaiter(_this, void 0, void 0, function() {
          var onclone, referenceElement
          return __generator(this, function(_a) {
            switch (_a.label) {
              case 0:
                this.scrolledElements.forEach(restoreNodeScroll)
                if (cloneWindow) {
                  cloneWindow.scrollTo(windowSize.left, windowSize.top)
                  if (
                    /(iPad|iPhone|iPod)/g.test(navigator.userAgent) &&
                    (cloneWindow.scrollY !== windowSize.top ||
                      cloneWindow.scrollX !== windowSize.left)
                  ) {
                    this.context.logger.warn(
                      'Unable to restore scroll position for cloned document'
                    )
                    this.context.windowBounds = this.context.windowBounds.add(
                      cloneWindow.scrollX - windowSize.left,
                      cloneWindow.scrollY - windowSize.top,
                      0,
                      0
                    )
                  }
                }
                onclone = this.options.onclone
                referenceElement = this.clonedReferenceElement
                if (typeof referenceElement === 'undefined') {
                  return [
                    2 /*return*/,
                    Promise.reject(
                      'Error finding the ' +
                        this.referenceElement.nodeName +
                        ' in the cloned document'
                    ),
                  ]
                }
                if (!(documentClone.fonts && documentClone.fonts.ready)) return [3 /*break*/, 2]
                return [4 /*yield*/, documentClone.fonts.ready]
              case 1:
                _a.sent()
                _a.label = 2
              case 2:
                if (!/(AppleWebKit)/g.test(navigator.userAgent)) return [3 /*break*/, 4]
                return [4 /*yield*/, imagesReady(documentClone)]
              case 3:
                _a.sent()
                _a.label = 4
              case 4:
                if (typeof onclone === 'function') {
                  return [
                    2 /*return*/,
                    Promise.resolve()
                      .then(function() {
                        return onclone(documentClone, referenceElement)
                      })
                      .then(function() {
                        return iframe
                      }),
                  ]
                }
                return [2 /*return*/, iframe]
            }
          })
        })
      })
      documentClone.open()
      documentClone.write(serializeDoctype(document.doctype) + '<html></html>')
      // Chrome scrolls the parent document for some reason after the write to the cloned window???
      restoreOwnerScroll(this.referenceElement.ownerDocument, scrollX, scrollY)
      documentClone.replaceChild(
        documentClone.adoptNode(this.documentElement),
        documentClone.documentElement
      )
      documentClone.close()
      return iframeLoad
    }
    DocumentCloner.prototype.createElementClone = function(node) {
      if (isDebugging(node, 2 /* CLONE */)) {
        debugger
      }
      if (isCanvasElement(node)) {
        return this.createCanvasClone(node)
      }
      if (isVideoElement(node)) {
        return this.createVideoClone(node)
      }
      if (isStyleElement(node)) {
        return this.createStyleClone(node)
      }
      var clone = node.cloneNode(false)
      if (isImageElement(clone)) {
        if (isImageElement(node) && node.currentSrc && node.currentSrc !== node.src) {
          clone.src = node.currentSrc
          clone.srcset = ''
        }
        if (clone.loading === 'lazy') {
          clone.loading = 'eager'
        }
      }
      if (isCustomElement(clone)) {
        return this.createCustomElementClone(clone)
      }
      return clone
    }
    DocumentCloner.prototype.createCustomElementClone = function(node) {
      var clone = document.createElement('html2canvascustomelement')
      copyCSSStyles(node.style, clone)
      return clone
    }
    DocumentCloner.prototype.createStyleClone = function(node) {
      try {
        var sheet = node.sheet
        if (sheet && sheet.cssRules) {
          var css = [].slice.call(sheet.cssRules, 0).reduce(function(css, rule) {
            if (rule && typeof rule.cssText === 'string') {
              return css + rule.cssText
            }
            return css
          }, '')
          var style = node.cloneNode(false)
          style.textContent = css
          return style
        }
      } catch (e) {
        // accessing node.sheet.cssRules throws a DOMException
        this.context.logger.error('Unable to access cssRules property', e)
        if (e.name !== 'SecurityError') {
          throw e
        }
      }
      return node.cloneNode(false)
    }
    DocumentCloner.prototype.createCanvasClone = function(canvas) {
      var _a
      if (this.options.inlineImages && canvas.ownerDocument) {
        var img = canvas.ownerDocument.createElement('img')
        try {
          img.src = canvas.toDataURL()
          return img
        } catch (e) {
          this.context.logger.info('Unable to inline canvas contents, canvas is tainted', canvas)
        }
      }
      var clonedCanvas = canvas.cloneNode(false)
      try {
        clonedCanvas.width = canvas.width
        clonedCanvas.height = canvas.height
        var ctx = canvas.getContext('2d')
        var clonedCtx = clonedCanvas.getContext('2d')
        if (clonedCtx) {
          if (!this.options.allowTaint && ctx) {
            clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0)
          } else {
            var gl =
              (_a = canvas.getContext('webgl2')) !== null && _a !== void 0
                ? _a
                : canvas.getContext('webgl')
            if (gl) {
              var attribs = gl.getContextAttributes()
              if (
                (attribs === null || attribs === void 0
                  ? void 0
                  : attribs.preserveDrawingBuffer) === false
              ) {
                this.context.logger.warn(
                  'Unable to clone WebGL context as it has preserveDrawingBuffer=false',
                  canvas
                )
              }
            }
            clonedCtx.drawImage(canvas, 0, 0)
          }
        }
        return clonedCanvas
      } catch (e) {
        this.context.logger.info('Unable to clone canvas as it is tainted', canvas)
      }
      return clonedCanvas
    }
    DocumentCloner.prototype.createVideoClone = function(video) {
      var canvas = video.ownerDocument.createElement('canvas')
      canvas.width = video.offsetWidth
      canvas.height = video.offsetHeight
      var ctx = canvas.getContext('2d')
      try {
        if (ctx) {
          ctx.drawImage(video, 0, 0, canvas.width, canvas.height)
          if (!this.options.allowTaint) {
            ctx.getImageData(0, 0, canvas.width, canvas.height)
          }
        }
        return canvas
      } catch (e) {
        this.context.logger.info('Unable to clone video as it is tainted', video)
      }
      var blankCanvas = video.ownerDocument.createElement('canvas')
      blankCanvas.width = video.offsetWidth
      blankCanvas.height = video.offsetHeight
      return blankCanvas
    }
    DocumentCloner.prototype.appendChildNode = function(clone, child, copyStyles) {
      if (
        !isElementNode(child) ||
        (!isScriptElement(child) &&
          !child.hasAttribute(IGNORE_ATTRIBUTE) &&
          (typeof this.options.ignoreElements !== 'function' ||
            !this.options.ignoreElements(child)))
      ) {
        if (!this.options.copyStyles || !isElementNode(child) || !isStyleElement(child)) {
          clone.appendChild(this.cloneNode(child, copyStyles))
        }
      }
    }
    DocumentCloner.prototype.cloneChildNodes = function(node, clone, copyStyles) {
      var _this = this
      for (
        var child = node.shadowRoot ? node.shadowRoot.firstChild : node.firstChild;
        child;
        child = child.nextSibling
      ) {
        if (
          isElementNode(child) &&
          isSlotElement(child) &&
          typeof child.assignedNodes === 'function'
        ) {
          var assignedNodes = child.assignedNodes()
          if (assignedNodes.length) {
            assignedNodes.forEach(function(assignedNode) {
              return _this.appendChildNode(clone, assignedNode, copyStyles)
            })
          }
        } else {
          this.appendChildNode(clone, child, copyStyles)
        }
      }
    }
    DocumentCloner.prototype.cloneNode = function(node, copyStyles) {
      if (isTextNode(node)) {
        return document.createTextNode(node.data)
      }
      if (!node.ownerDocument) {
        return node.cloneNode(false)
      }
      var window = node.ownerDocument.defaultView
      if (window && isElementNode(node) && (isHTMLElementNode(node) || isSVGElementNode(node))) {
        var clone = this.createElementClone(node)
        clone.style.transitionProperty = 'none'
        var style = window.getComputedStyle(node)
        var styleBefore = window.getComputedStyle(node, ':before')
        var styleAfter = window.getComputedStyle(node, ':after')
        if (this.referenceElement === node && isHTMLElementNode(clone)) {
          this.clonedReferenceElement = clone
        }
        if (isBodyElement(clone)) {
          createPseudoHideStyles(clone)
        }
        var counters = this.counters.parse(new CSSParsedCounterDeclaration(this.context, style))
        var before = this.resolvePseudoContent(node, clone, styleBefore, PseudoElementType.BEFORE)
        if (isCustomElement(node)) {
          copyStyles = true
        }
        if (!isVideoElement(node)) {
          this.cloneChildNodes(node, clone, copyStyles)
        }
        if (before) {
          clone.insertBefore(before, clone.firstChild)
        }
        var after = this.resolvePseudoContent(node, clone, styleAfter, PseudoElementType.AFTER)
        if (after) {
          clone.appendChild(after)
        }
        this.counters.pop(counters)
        if (
          (style &&
            (this.options.copyStyles || isSVGElementNode(node)) &&
            !isIFrameElement(node)) ||
          copyStyles
        ) {
          copyCSSStyles(style, clone)
        }
        if (node.scrollTop !== 0 || node.scrollLeft !== 0) {
          this.scrolledElements.push([clone, node.scrollLeft, node.scrollTop])
        }
        if (
          (isTextareaElement(node) || isSelectElement(node)) &&
          (isTextareaElement(clone) || isSelectElement(clone))
        ) {
          clone.value = node.value
        }
        return clone
      }
      return node.cloneNode(false)
    }
    DocumentCloner.prototype.resolvePseudoContent = function(node, clone, style, pseudoElt) {
      var _this = this
      if (!style) {
        return
      }
      var value = style.content
      var document = clone.ownerDocument
      if (
        !document ||
        !value ||
        value === 'none' ||
        value === '-moz-alt-content' ||
        style.display === 'none'
      ) {
        return
      }
      this.counters.parse(new CSSParsedCounterDeclaration(this.context, style))
      var declaration = new CSSParsedPseudoDeclaration(this.context, style)
      var anonymousReplacedElement = document.createElement('html2canvaspseudoelement')
      copyCSSStyles(style, anonymousReplacedElement)
      declaration.content.forEach(function(token) {
        if (token.type === 0 /* STRING_TOKEN */) {
          anonymousReplacedElement.appendChild(document.createTextNode(token.value))
        } else if (token.type === 22 /* URL_TOKEN */) {
          var img = document.createElement('img')
          img.src = token.value
          img.style.opacity = '1'
          anonymousReplacedElement.appendChild(img)
        } else if (token.type === 18 /* FUNCTION */) {
          if (token.name === 'attr') {
            var attr = token.values.filter(isIdentToken)
            if (attr.length) {
              anonymousReplacedElement.appendChild(
                document.createTextNode(node.getAttribute(attr[0].value) || '')
              )
            }
          } else if (token.name === 'counter') {
            var _a = token.values.filter(nonFunctionArgSeparator),
              counter = _a[0],
              counterStyle = _a[1]
            if (counter && isIdentToken(counter)) {
              var counterState = _this.counters.getCounterValue(counter.value)
              var counterType =
                counterStyle && isIdentToken(counterStyle)
                  ? listStyleType.parse(_this.context, counterStyle.value)
                  : 3 /* DECIMAL */
              anonymousReplacedElement.appendChild(
                document.createTextNode(createCounterText(counterState, counterType, false))
              )
            }
          } else if (token.name === 'counters') {
            var _b = token.values.filter(nonFunctionArgSeparator),
              counter = _b[0],
              delim = _b[1],
              counterStyle = _b[2]
            if (counter && isIdentToken(counter)) {
              var counterStates = _this.counters.getCounterValues(counter.value)
              var counterType_1 =
                counterStyle && isIdentToken(counterStyle)
                  ? listStyleType.parse(_this.context, counterStyle.value)
                  : 3 /* DECIMAL */
              var separator = delim && delim.type === 0 /* STRING_TOKEN */ ? delim.value : ''
              var text = counterStates
                .map(function(value) {
                  return createCounterText(value, counterType_1, false)
                })
                .join(separator)
              anonymousReplacedElement.appendChild(document.createTextNode(text))
            }
          } else;
        } else if (token.type === 20 /* IDENT_TOKEN */) {
          switch (token.value) {
            case 'open-quote':
              anonymousReplacedElement.appendChild(
                document.createTextNode(getQuote(declaration.quotes, _this.quoteDepth++, true))
              )
              break
            case 'close-quote':
              anonymousReplacedElement.appendChild(
                document.createTextNode(getQuote(declaration.quotes, --_this.quoteDepth, false))
              )
              break
            default:
              // safari doesn't parse string tokens correctly because of lack of quotes
              anonymousReplacedElement.appendChild(document.createTextNode(token.value))
          }
        }
      })
      anonymousReplacedElement.className =
        PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + ' ' + PSEUDO_HIDE_ELEMENT_CLASS_AFTER
      var newClassName =
        pseudoElt === PseudoElementType.BEFORE
          ? ' ' + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE
          : ' ' + PSEUDO_HIDE_ELEMENT_CLASS_AFTER
      if (isSVGElementNode(clone)) {
        clone.className.baseValue += newClassName
      } else {
        clone.className += newClassName
      }
      return anonymousReplacedElement
    }
    DocumentCloner.destroy = function(container) {
      if (container.parentNode) {
        container.parentNode.removeChild(container)
        return true
      }
      return false
    }
    return DocumentCloner
  })()
  var PseudoElementType
  ;(function(PseudoElementType) {
    PseudoElementType[(PseudoElementType['BEFORE'] = 0)] = 'BEFORE'
    PseudoElementType[(PseudoElementType['AFTER'] = 1)] = 'AFTER'
  })(PseudoElementType || (PseudoElementType = {}))
  var createIFrameContainer = function(ownerDocument, bounds) {
    var cloneIframeContainer = ownerDocument.createElement('iframe')
    cloneIframeContainer.className = 'html2canvas-container'
    cloneIframeContainer.style.visibility = 'hidden'
    cloneIframeContainer.style.position = 'fixed'
    cloneIframeContainer.style.left = '-10000px'
    cloneIframeContainer.style.top = '0px'
    cloneIframeContainer.style.border = '0'
    cloneIframeContainer.width = bounds.width.toString()
    cloneIframeContainer.height = bounds.height.toString()
    cloneIframeContainer.scrolling = 'no' // ios won't scroll without it
    cloneIframeContainer.setAttribute(IGNORE_ATTRIBUTE, 'true')
    ownerDocument.body.appendChild(cloneIframeContainer)
    return cloneIframeContainer
  }
  var imageReady = function(img) {
    return new Promise(function(resolve) {
      if (img.complete) {
        resolve()
        return
      }
      if (!img.src) {
        resolve()
        return
      }
      img.onload = resolve
      img.onerror = resolve
    })
  }
  var imagesReady = function(document) {
    return Promise.all([].slice.call(document.images, 0).map(imageReady))
  }
  var iframeLoader = function(iframe) {
    return new Promise(function(resolve, reject) {
      var cloneWindow = iframe.contentWindow
      if (!cloneWindow) {
        return reject('No window assigned for iframe')
      }
      var documentClone = cloneWindow.document
      cloneWindow.onload = iframe.onload = function() {
        cloneWindow.onload = iframe.onload = null
        var interval = setInterval(function() {
          if (documentClone.body.childNodes.length > 0 && documentClone.readyState === 'complete') {
            clearInterval(interval)
            resolve(iframe)
          }
        }, 50)
      }
    })
  }
  var ignoredStyleProperties = [
    'all',
    'd',
    'content', // Safari shows pseudoelements if content is set
  ]
  var copyCSSStyles = function(style, target) {
    // Edge does not provide value for cssText
    for (var i = style.length - 1; i >= 0; i--) {
      var property = style.item(i)
      if (ignoredStyleProperties.indexOf(property) === -1) {
        target.style.setProperty(property, style.getPropertyValue(property))
      }
    }
    return target
  }
  var serializeDoctype = function(doctype) {
    var str = ''
    if (doctype) {
      str += '<!DOCTYPE '
      if (doctype.name) {
        str += doctype.name
      }
      if (doctype.internalSubset) {
        str += doctype.internalSubset
      }
      if (doctype.publicId) {
        str += '"' + doctype.publicId + '"'
      }
      if (doctype.systemId) {
        str += '"' + doctype.systemId + '"'
      }
      str += '>'
    }
    return str
  }
  var restoreOwnerScroll = function(ownerDocument, x, y) {
    if (
      ownerDocument &&
      ownerDocument.defaultView &&
      (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)
    ) {
      ownerDocument.defaultView.scrollTo(x, y)
    }
  }
  var restoreNodeScroll = function(_a) {
    var element = _a[0],
      x = _a[1],
      y = _a[2]
    element.scrollLeft = x
    element.scrollTop = y
  }
  var PSEUDO_BEFORE = ':before'
  var PSEUDO_AFTER = ':after'
  var PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = '___html2canvas___pseudoelement_before'
  var PSEUDO_HIDE_ELEMENT_CLASS_AFTER = '___html2canvas___pseudoelement_after'
  var PSEUDO_HIDE_ELEMENT_STYLE = '{\n    content: "" !important;\n    display: none !important;\n}'
  var createPseudoHideStyles = function(body) {
    createStyles(
      body,
      '.' +
        PSEUDO_HIDE_ELEMENT_CLASS_BEFORE +
        PSEUDO_BEFORE +
        PSEUDO_HIDE_ELEMENT_STYLE +
        '\n         .' +
        PSEUDO_HIDE_ELEMENT_CLASS_AFTER +
        PSEUDO_AFTER +
        PSEUDO_HIDE_ELEMENT_STYLE
    )
  }
  var createStyles = function(body, styles) {
    var document = body.ownerDocument
    if (document) {
      var style = document.createElement('style')
      style.textContent = styles
      body.appendChild(style)
    }
  }

  var CacheStorage = /** @class */ (function() {
    function CacheStorage() {}
    CacheStorage.getOrigin = function(url) {
      var link = CacheStorage._link
      if (!link) {
        return 'about:blank'
      }
      link.href = url
      link.href = link.href // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/
      return link.protocol + link.hostname + link.port
    }
    CacheStorage.isSameOrigin = function(src) {
      return CacheStorage.getOrigin(src) === CacheStorage._origin
    }
    CacheStorage.setContext = function(window) {
      CacheStorage._link = window.document.createElement('a')
      CacheStorage._origin = CacheStorage.getOrigin(window.location.href)
    }
    CacheStorage._origin = 'about:blank'
    return CacheStorage
  })()
  var Cache = /** @class */ (function() {
    function Cache(context, _options) {
      this.context = context
      this._options = _options
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      this._cache = {}
    }
    Cache.prototype.addImage = function(src) {
      var result = Promise.resolve()
      if (this.has(src)) {
        return result
      }
      if (isBlobImage(src) || isRenderable(src)) {
        ;(this._cache[src] = this.loadImage(src)).catch(function() {
          // prevent unhandled rejection
        })
        return result
      }
      return result
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Cache.prototype.match = function(src) {
      return this._cache[src]
    }
    Cache.prototype.loadImage = function(key) {
      return __awaiter(this, void 0, void 0, function() {
        var isSameOrigin, useCORS, useProxy, src
        var _this = this
        return __generator(this, function(_a) {
          switch (_a.label) {
            case 0:
              isSameOrigin = CacheStorage.isSameOrigin(key)
              useCORS =
                !isInlineImage(key) &&
                this._options.useCORS === true &&
                FEATURES.SUPPORT_CORS_IMAGES &&
                !isSameOrigin
              useProxy =
                !isInlineImage(key) &&
                !isSameOrigin &&
                !isBlobImage(key) &&
                typeof this._options.proxy === 'string' &&
                FEATURES.SUPPORT_CORS_XHR &&
                !useCORS
              if (
                !isSameOrigin &&
                this._options.allowTaint === false &&
                !isInlineImage(key) &&
                !isBlobImage(key) &&
                !useProxy &&
                !useCORS
              ) {
                return [2 /*return*/]
              }
              src = key
              if (!useProxy) return [3 /*break*/, 2]
              return [4 /*yield*/, this.proxy(src)]
            case 1:
              src = _a.sent()
              _a.label = 2
            case 2:
              this.context.logger.debug('Added image ' + key.substring(0, 256))
              return [
                4 /*yield*/,
                new Promise(function(resolve, reject) {
                  var img = new Image()
                  img.onload = function() {
                    return resolve(img)
                  }
                  img.onerror = reject
                  //ios safari 10.3 taints canvas with data urls unless crossOrigin is set to anonymous
                  if (isInlineBase64Image(src) || useCORS) {
                    img.crossOrigin = 'anonymous'
                  }
                  img.src = src
                  if (img.complete === true) {
                    // Inline XML images may fail to parse, throwing an Error later on
                    setTimeout(function() {
                      return resolve(img)
                    }, 500)
                  }
                  if (_this._options.imageTimeout > 0) {
                    setTimeout(function() {
                      return reject(
                        'Timed out (' + _this._options.imageTimeout + 'ms) loading image'
                      )
                    }, _this._options.imageTimeout)
                  }
                }),
              ]
            case 3:
              return [2 /*return*/, _a.sent()]
          }
        })
      })
    }
    Cache.prototype.has = function(key) {
      return typeof this._cache[key] !== 'undefined'
    }
    Cache.prototype.keys = function() {
      return Promise.resolve(Object.keys(this._cache))
    }
    Cache.prototype.proxy = function(src) {
      var _this = this
      var proxy = this._options.proxy
      if (!proxy) {
        throw new Error('No proxy defined')
      }
      var key = src.substring(0, 256)
      return new Promise(function(resolve, reject) {
        var responseType = FEATURES.SUPPORT_RESPONSE_TYPE ? 'blob' : 'text'
        var xhr = new XMLHttpRequest()
        xhr.onload = function() {
          if (xhr.status === 200) {
            if (responseType === 'text') {
              resolve(xhr.response)
            } else {
              var reader_1 = new FileReader()
              reader_1.addEventListener(
                'load',
                function() {
                  return resolve(reader_1.result)
                },
                false
              )
              reader_1.addEventListener(
                'error',
                function(e) {
                  return reject(e)
                },
                false
              )
              reader_1.readAsDataURL(xhr.response)
            }
          } else {
            reject('Failed to proxy resource ' + key + ' with status code ' + xhr.status)
          }
        }
        xhr.onerror = reject
        var queryString = proxy.indexOf('?') > -1 ? '&' : '?'
        xhr.open(
          'GET',
          '' +
            proxy +
            queryString +
            'url=' +
            encodeURIComponent(src) +
            '&responseType=' +
            responseType
        )
        if (responseType !== 'text' && xhr instanceof XMLHttpRequest) {
          xhr.responseType = responseType
        }
        if (_this._options.imageTimeout) {
          var timeout_1 = _this._options.imageTimeout
          xhr.timeout = timeout_1
          xhr.ontimeout = function() {
            return reject('Timed out (' + timeout_1 + 'ms) proxying ' + key)
          }
        }
        xhr.send()
      })
    }
    return Cache
  })()
  var INLINE_SVG = /^data:image\/svg\+xml/i
  var INLINE_BASE64 = /^data:image\/.*;base64,/i
  var INLINE_IMG = /^data:image\/.*/i
  var isRenderable = function(src) {
    return FEATURES.SUPPORT_SVG_DRAWING || !isSVG(src)
  }
  var isInlineImage = function(src) {
    return INLINE_IMG.test(src)
  }
  var isInlineBase64Image = function(src) {
    return INLINE_BASE64.test(src)
  }
  var isBlobImage = function(src) {
    return src.substr(0, 4) === 'blob'
  }
  var isSVG = function(src) {
    return src.substr(-3).toLowerCase() === 'svg' || INLINE_SVG.test(src)
  }

  var Vector = /** @class */ (function() {
    function Vector(x, y) {
      this.type = 0 /* VECTOR */
      this.x = x
      this.y = y
    }
    Vector.prototype.add = function(deltaX, deltaY) {
      return new Vector(this.x + deltaX, this.y + deltaY)
    }
    return Vector
  })()

  var lerp = function(a, b, t) {
    return new Vector(a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t)
  }
  var BezierCurve = /** @class */ (function() {
    function BezierCurve(start, startControl, endControl, end) {
      this.type = 1 /* BEZIER_CURVE */
      this.start = start
      this.startControl = startControl
      this.endControl = endControl
      this.end = end
    }
    BezierCurve.prototype.subdivide = function(t, firstHalf) {
      var ab = lerp(this.start, this.startControl, t)
      var bc = lerp(this.startControl, this.endControl, t)
      var cd = lerp(this.endControl, this.end, t)
      var abbc = lerp(ab, bc, t)
      var bccd = lerp(bc, cd, t)
      var dest = lerp(abbc, bccd, t)
      return firstHalf
        ? new BezierCurve(this.start, ab, abbc, dest)
        : new BezierCurve(dest, bccd, cd, this.end)
    }
    BezierCurve.prototype.add = function(deltaX, deltaY) {
      return new BezierCurve(
        this.start.add(deltaX, deltaY),
        this.startControl.add(deltaX, deltaY),
        this.endControl.add(deltaX, deltaY),
        this.end.add(deltaX, deltaY)
      )
    }
    BezierCurve.prototype.reverse = function() {
      return new BezierCurve(this.end, this.endControl, this.startControl, this.start)
    }
    return BezierCurve
  })()
  var isBezierCurve = function(path) {
    return path.type === 1 /* BEZIER_CURVE */
  }

  var BoundCurves = /** @class */ (function() {
    function BoundCurves(element) {
      var styles = element.styles
      var bounds = element.bounds
      var _a = getAbsoluteValueForTuple(styles.borderTopLeftRadius, bounds.width, bounds.height),
        tlh = _a[0],
        tlv = _a[1]
      var _b = getAbsoluteValueForTuple(styles.borderTopRightRadius, bounds.width, bounds.height),
        trh = _b[0],
        trv = _b[1]
      var _c = getAbsoluteValueForTuple(
          styles.borderBottomRightRadius,
          bounds.width,
          bounds.height
        ),
        brh = _c[0],
        brv = _c[1]
      var _d = getAbsoluteValueForTuple(styles.borderBottomLeftRadius, bounds.width, bounds.height),
        blh = _d[0],
        blv = _d[1]
      var factors = []
      factors.push((tlh + trh) / bounds.width)
      factors.push((blh + brh) / bounds.width)
      factors.push((tlv + blv) / bounds.height)
      factors.push((trv + brv) / bounds.height)
      var maxFactor = Math.max.apply(Math, factors)
      if (maxFactor > 1) {
        tlh /= maxFactor
        tlv /= maxFactor
        trh /= maxFactor
        trv /= maxFactor
        brh /= maxFactor
        brv /= maxFactor
        blh /= maxFactor
        blv /= maxFactor
      }
      var topWidth = bounds.width - trh
      var rightHeight = bounds.height - brv
      var bottomWidth = bounds.width - brh
      var leftHeight = bounds.height - blv
      var borderTopWidth = styles.borderTopWidth
      var borderRightWidth = styles.borderRightWidth
      var borderBottomWidth = styles.borderBottomWidth
      var borderLeftWidth = styles.borderLeftWidth
      var paddingTop = getAbsoluteValue(styles.paddingTop, element.bounds.width)
      var paddingRight = getAbsoluteValue(styles.paddingRight, element.bounds.width)
      var paddingBottom = getAbsoluteValue(styles.paddingBottom, element.bounds.width)
      var paddingLeft = getAbsoluteValue(styles.paddingLeft, element.bounds.width)
      this.topLeftBorderDoubleOuterBox =
        tlh > 0 || tlv > 0
          ? getCurvePoints(
              bounds.left + borderLeftWidth / 3,
              bounds.top + borderTopWidth / 3,
              tlh - borderLeftWidth / 3,
              tlv - borderTopWidth / 3,
              CORNER.TOP_LEFT
            )
          : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3)
      this.topRightBorderDoubleOuterBox =
        tlh > 0 || tlv > 0
          ? getCurvePoints(
              bounds.left + topWidth,
              bounds.top + borderTopWidth / 3,
              trh - borderRightWidth / 3,
              trv - borderTopWidth / 3,
              CORNER.TOP_RIGHT
            )
          : new Vector(
              bounds.left + bounds.width - borderRightWidth / 3,
              bounds.top + borderTopWidth / 3
            )
      this.bottomRightBorderDoubleOuterBox =
        brh > 0 || brv > 0
          ? getCurvePoints(
              bounds.left + bottomWidth,
              bounds.top + rightHeight,
              brh - borderRightWidth / 3,
              brv - borderBottomWidth / 3,
              CORNER.BOTTOM_RIGHT
            )
          : new Vector(
              bounds.left + bounds.width - borderRightWidth / 3,
              bounds.top + bounds.height - borderBottomWidth / 3
            )
      this.bottomLeftBorderDoubleOuterBox =
        blh > 0 || blv > 0
          ? getCurvePoints(
              bounds.left + borderLeftWidth / 3,
              bounds.top + leftHeight,
              blh - borderLeftWidth / 3,
              blv - borderBottomWidth / 3,
              CORNER.BOTTOM_LEFT
            )
          : new Vector(
              bounds.left + borderLeftWidth / 3,
              bounds.top + bounds.height - borderBottomWidth / 3
            )
      this.topLeftBorderDoubleInnerBox =
        tlh > 0 || tlv > 0
          ? getCurvePoints(
              bounds.left + (borderLeftWidth * 2) / 3,
              bounds.top + (borderTopWidth * 2) / 3,
              tlh - (borderLeftWidth * 2) / 3,
              tlv - (borderTopWidth * 2) / 3,
              CORNER.TOP_LEFT
            )
          : new Vector(
              bounds.left + (borderLeftWidth * 2) / 3,
              bounds.top + (borderTopWidth * 2) / 3
            )
      this.topRightBorderDoubleInnerBox =
        tlh > 0 || tlv > 0
          ? getCurvePoints(
              bounds.left + topWidth,
              bounds.top + (borderTopWidth * 2) / 3,
              trh - (borderRightWidth * 2) / 3,
              trv - (borderTopWidth * 2) / 3,
              CORNER.TOP_RIGHT
            )
          : new Vector(
              bounds.left + bounds.width - (borderRightWidth * 2) / 3,
              bounds.top + (borderTopWidth * 2) / 3
            )
      this.bottomRightBorderDoubleInnerBox =
        brh > 0 || brv > 0
          ? getCurvePoints(
              bounds.left + bottomWidth,
              bounds.top + rightHeight,
              brh - (borderRightWidth * 2) / 3,
              brv - (borderBottomWidth * 2) / 3,
              CORNER.BOTTOM_RIGHT
            )
          : new Vector(
              bounds.left + bounds.width - (borderRightWidth * 2) / 3,
              bounds.top + bounds.height - (borderBottomWidth * 2) / 3
            )
      this.bottomLeftBorderDoubleInnerBox =
        blh > 0 || blv > 0
          ? getCurvePoints(
              bounds.left + (borderLeftWidth * 2) / 3,
              bounds.top + leftHeight,
              blh - (borderLeftWidth * 2) / 3,
              blv - (borderBottomWidth * 2) / 3,
              CORNER.BOTTOM_LEFT
            )
          : new Vector(
              bounds.left + (borderLeftWidth * 2) / 3,
              bounds.top + bounds.height - (borderBottomWidth * 2) / 3
            )
      this.topLeftBorderStroke =
        tlh > 0 || tlv > 0
          ? getCurvePoints(
              bounds.left + borderLeftWidth / 2,
              bounds.top + borderTopWidth / 2,
              tlh - borderLeftWidth / 2,
              tlv - borderTopWidth / 2,
              CORNER.TOP_LEFT
            )
          : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2)
      this.topRightBorderStroke =
        tlh > 0 || tlv > 0
          ? getCurvePoints(
              bounds.left + topWidth,
              bounds.top + borderTopWidth / 2,
              trh - borderRightWidth / 2,
              trv - borderTopWidth / 2,
              CORNER.TOP_RIGHT
            )
          : new Vector(
              bounds.left + bounds.width - borderRightWidth / 2,
              bounds.top + borderTopWidth / 2
            )
      this.bottomRightBorderStroke =
        brh > 0 || brv > 0
          ? getCurvePoints(
              bounds.left + bottomWidth,
              bounds.top + rightHeight,
              brh - borderRightWidth / 2,
              brv - borderBottomWidth / 2,
              CORNER.BOTTOM_RIGHT
            )
          : new Vector(
              bounds.left + bounds.width - borderRightWidth / 2,
              bounds.top + bounds.height - borderBottomWidth / 2
            )
      this.bottomLeftBorderStroke =
        blh > 0 || blv > 0
          ? getCurvePoints(
              bounds.left + borderLeftWidth / 2,
              bounds.top + leftHeight,
              blh - borderLeftWidth / 2,
              blv - borderBottomWidth / 2,
              CORNER.BOTTOM_LEFT
            )
          : new Vector(
              bounds.left + borderLeftWidth / 2,
              bounds.top + bounds.height - borderBottomWidth / 2
            )
      this.topLeftBorderBox =
        tlh > 0 || tlv > 0
          ? getCurvePoints(bounds.left, bounds.top, tlh, tlv, CORNER.TOP_LEFT)
          : new Vector(bounds.left, bounds.top)
      this.topRightBorderBox =
        trh > 0 || trv > 0
          ? getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, CORNER.TOP_RIGHT)
          : new Vector(bounds.left + bounds.width, bounds.top)
      this.bottomRightBorderBox =
        brh > 0 || brv > 0
          ? getCurvePoints(
              bounds.left + bottomWidth,
              bounds.top + rightHeight,
              brh,
              brv,
              CORNER.BOTTOM_RIGHT
            )
          : new Vector(bounds.left + bounds.width, bounds.top + bounds.height)
      this.bottomLeftBorderBox =
        blh > 0 || blv > 0
          ? getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, CORNER.BOTTOM_LEFT)
          : new Vector(bounds.left, bounds.top + bounds.height)
      this.topLeftPaddingBox =
        tlh > 0 || tlv > 0
          ? getCurvePoints(
              bounds.left + borderLeftWidth,
              bounds.top + borderTopWidth,
              Math.max(0, tlh - borderLeftWidth),
              Math.max(0, tlv - borderTopWidth),
              CORNER.TOP_LEFT
            )
          : new Vector(bounds.left + borderLeftWidth, bounds.top + borderTopWidth)
      this.topRightPaddingBox =
        trh > 0 || trv > 0
          ? getCurvePoints(
              bounds.left + Math.min(topWidth, bounds.width - borderRightWidth),
              bounds.top + borderTopWidth,
              topWidth > bounds.width + borderRightWidth ? 0 : Math.max(0, trh - borderRightWidth),
              Math.max(0, trv - borderTopWidth),
              CORNER.TOP_RIGHT
            )
          : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + borderTopWidth)
      this.bottomRightPaddingBox =
        brh > 0 || brv > 0
          ? getCurvePoints(
              bounds.left + Math.min(bottomWidth, bounds.width - borderLeftWidth),
              bounds.top + Math.min(rightHeight, bounds.height - borderBottomWidth),
              Math.max(0, brh - borderRightWidth),
              Math.max(0, brv - borderBottomWidth),
              CORNER.BOTTOM_RIGHT
            )
          : new Vector(
              bounds.left + bounds.width - borderRightWidth,
              bounds.top + bounds.height - borderBottomWidth
            )
      this.bottomLeftPaddingBox =
        blh > 0 || blv > 0
          ? getCurvePoints(
              bounds.left + borderLeftWidth,
              bounds.top + Math.min(leftHeight, bounds.height - borderBottomWidth),
              Math.max(0, blh - borderLeftWidth),
              Math.max(0, blv - borderBottomWidth),
              CORNER.BOTTOM_LEFT
            )
          : new Vector(
              bounds.left + borderLeftWidth,
              bounds.top + bounds.height - borderBottomWidth
            )
      this.topLeftContentBox =
        tlh > 0 || tlv > 0
          ? getCurvePoints(
              bounds.left + borderLeftWidth + paddingLeft,
              bounds.top + borderTopWidth + paddingTop,
              Math.max(0, tlh - (borderLeftWidth + paddingLeft)),
              Math.max(0, tlv - (borderTopWidth + paddingTop)),
              CORNER.TOP_LEFT
            )
          : new Vector(
              bounds.left + borderLeftWidth + paddingLeft,
              bounds.top + borderTopWidth + paddingTop
            )
      this.topRightContentBox =
        trh > 0 || trv > 0
          ? getCurvePoints(
              bounds.left + Math.min(topWidth, bounds.width + borderLeftWidth + paddingLeft),
              bounds.top + borderTopWidth + paddingTop,
              topWidth > bounds.width + borderLeftWidth + paddingLeft
                ? 0
                : trh - borderLeftWidth + paddingLeft,
              trv - (borderTopWidth + paddingTop),
              CORNER.TOP_RIGHT
            )
          : new Vector(
              bounds.left + bounds.width - (borderRightWidth + paddingRight),
              bounds.top + borderTopWidth + paddingTop
            )
      this.bottomRightContentBox =
        brh > 0 || brv > 0
          ? getCurvePoints(
              bounds.left + Math.min(bottomWidth, bounds.width - (borderLeftWidth + paddingLeft)),
              bounds.top + Math.min(rightHeight, bounds.height + borderTopWidth + paddingTop),
              Math.max(0, brh - (borderRightWidth + paddingRight)),
              brv - (borderBottomWidth + paddingBottom),
              CORNER.BOTTOM_RIGHT
            )
          : new Vector(
              bounds.left + bounds.width - (borderRightWidth + paddingRight),
              bounds.top + bounds.height - (borderBottomWidth + paddingBottom)
            )
      this.bottomLeftContentBox =
        blh > 0 || blv > 0
          ? getCurvePoints(
              bounds.left + borderLeftWidth + paddingLeft,
              bounds.top + leftHeight,
              Math.max(0, blh - (borderLeftWidth + paddingLeft)),
              blv - (borderBottomWidth + paddingBottom),
              CORNER.BOTTOM_LEFT
            )
          : new Vector(
              bounds.left + borderLeftWidth + paddingLeft,
              bounds.top + bounds.height - (borderBottomWidth + paddingBottom)
            )
    }
    return BoundCurves
  })()
  var CORNER
  ;(function(CORNER) {
    CORNER[(CORNER['TOP_LEFT'] = 0)] = 'TOP_LEFT'
    CORNER[(CORNER['TOP_RIGHT'] = 1)] = 'TOP_RIGHT'
    CORNER[(CORNER['BOTTOM_RIGHT'] = 2)] = 'BOTTOM_RIGHT'
    CORNER[(CORNER['BOTTOM_LEFT'] = 3)] = 'BOTTOM_LEFT'
  })(CORNER || (CORNER = {}))
  var getCurvePoints = function(x, y, r1, r2, position) {
    var kappa = 4 * ((Math.sqrt(2) - 1) / 3)
    var ox = r1 * kappa // control point offset horizontal
    var oy = r2 * kappa // control point offset vertical
    var xm = x + r1 // x-middle
    var ym = y + r2 // y-middle
    switch (position) {
      case CORNER.TOP_LEFT:
        return new BezierCurve(
          new Vector(x, ym),
          new Vector(x, ym - oy),
          new Vector(xm - ox, y),
          new Vector(xm, y)
        )
      case CORNER.TOP_RIGHT:
        return new BezierCurve(
          new Vector(x, y),
          new Vector(x + ox, y),
          new Vector(xm, ym - oy),
          new Vector(xm, ym)
        )
      case CORNER.BOTTOM_RIGHT:
        return new BezierCurve(
          new Vector(xm, y),
          new Vector(xm, y + oy),
          new Vector(x + ox, ym),
          new Vector(x, ym)
        )
      case CORNER.BOTTOM_LEFT:
      default:
        return new BezierCurve(
          new Vector(xm, ym),
          new Vector(xm - ox, ym),
          new Vector(x, y + oy),
          new Vector(x, y)
        )
    }
  }
  var calculateBorderBoxPath = function(curves) {
    return [
      curves.topLeftBorderBox,
      curves.topRightBorderBox,
      curves.bottomRightBorderBox,
      curves.bottomLeftBorderBox,
    ]
  }
  var calculateContentBoxPath = function(curves) {
    return [
      curves.topLeftContentBox,
      curves.topRightContentBox,
      curves.bottomRightContentBox,
      curves.bottomLeftContentBox,
    ]
  }
  var calculatePaddingBoxPath = function(curves) {
    return [
      curves.topLeftPaddingBox,
      curves.topRightPaddingBox,
      curves.bottomRightPaddingBox,
      curves.bottomLeftPaddingBox,
    ]
  }

  var TransformEffect = /** @class */ (function() {
    function TransformEffect(offsetX, offsetY, matrix) {
      this.offsetX = offsetX
      this.offsetY = offsetY
      this.matrix = matrix
      this.type = 0 /* TRANSFORM */
      this.target = 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */
    }
    return TransformEffect
  })()
  var ClipEffect = /** @class */ (function() {
    function ClipEffect(path, target) {
      this.path = path
      this.target = target
      this.type = 1 /* CLIP */
    }
    return ClipEffect
  })()
  var OpacityEffect = /** @class */ (function() {
    function OpacityEffect(opacity) {
      this.opacity = opacity
      this.type = 2 /* OPACITY */
      this.target = 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */
    }
    return OpacityEffect
  })()
  var isTransformEffect = function(effect) {
    return effect.type === 0 /* TRANSFORM */
  }
  var isClipEffect = function(effect) {
    return effect.type === 1 /* CLIP */
  }
  var isOpacityEffect = function(effect) {
    return effect.type === 2 /* OPACITY */
  }

  var equalPath = function(a, b) {
    if (a.length === b.length) {
      return a.some(function(v, i) {
        return v === b[i]
      })
    }
    return false
  }
  var transformPath = function(path, deltaX, deltaY, deltaW, deltaH) {
    return path.map(function(point, index) {
      switch (index) {
        case 0:
          return point.add(deltaX, deltaY)
        case 1:
          return point.add(deltaX + deltaW, deltaY)
        case 2:
          return point.add(deltaX + deltaW, deltaY + deltaH)
        case 3:
          return point.add(deltaX, deltaY + deltaH)
      }
      return point
    })
  }

  var StackingContext = /** @class */ (function() {
    function StackingContext(container) {
      this.element = container
      this.inlineLevel = []
      this.nonInlineLevel = []
      this.negativeZIndex = []
      this.zeroOrAutoZIndexOrTransformedOrOpacity = []
      this.positiveZIndex = []
      this.nonPositionedFloats = []
      this.nonPositionedInlineLevel = []
    }
    return StackingContext
  })()
  var ElementPaint = /** @class */ (function() {
    function ElementPaint(container, parent) {
      this.container = container
      this.parent = parent
      this.effects = []
      this.curves = new BoundCurves(this.container)
      if (this.container.styles.opacity < 1) {
        this.effects.push(new OpacityEffect(this.container.styles.opacity))
      }
      if (this.container.styles.transform !== null) {
        var offsetX = this.container.bounds.left + this.container.styles.transformOrigin[0].number
        var offsetY = this.container.bounds.top + this.container.styles.transformOrigin[1].number
        var matrix = this.container.styles.transform
        this.effects.push(new TransformEffect(offsetX, offsetY, matrix))
      }
      if (this.container.styles.overflowX !== 0 /* VISIBLE */) {
        var borderBox = calculateBorderBoxPath(this.curves)
        var paddingBox = calculatePaddingBoxPath(this.curves)
        if (equalPath(borderBox, paddingBox)) {
          this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */))
        } else {
          this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */))
          this.effects.push(new ClipEffect(paddingBox, 4 /* CONTENT */))
        }
      }
    }
    ElementPaint.prototype.getEffects = function(target) {
      var inFlow = [2 /* ABSOLUTE */, 3 /* FIXED */].indexOf(this.container.styles.position) === -1
      var parent = this.parent
      var effects = this.effects.slice(0)
      while (parent) {
        var croplessEffects = parent.effects.filter(function(effect) {
          return !isClipEffect(effect)
        })
        if (inFlow || parent.container.styles.position !== 0 /* STATIC */ || !parent.parent) {
          effects.unshift.apply(effects, croplessEffects)
          inFlow =
            [2 /* ABSOLUTE */, 3 /* FIXED */].indexOf(parent.container.styles.position) === -1
          if (parent.container.styles.overflowX !== 0 /* VISIBLE */) {
            var borderBox = calculateBorderBoxPath(parent.curves)
            var paddingBox = calculatePaddingBoxPath(parent.curves)
            if (!equalPath(borderBox, paddingBox)) {
              effects.unshift(
                new ClipEffect(paddingBox, 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */)
              )
            }
          }
        } else {
          effects.unshift.apply(effects, croplessEffects)
        }
        parent = parent.parent
      }
      return effects.filter(function(effect) {
        return contains(effect.target, target)
      })
    }
    return ElementPaint
  })()
  var parseStackTree = function(parent, stackingContext, realStackingContext, listItems) {
    parent.container.elements.forEach(function(child) {
      var treatAsRealStackingContext = contains(child.flags, 4 /* CREATES_REAL_STACKING_CONTEXT */)
      var createsStackingContext = contains(child.flags, 2 /* CREATES_STACKING_CONTEXT */)
      var paintContainer = new ElementPaint(child, parent)
      if (contains(child.styles.display, 2048 /* LIST_ITEM */)) {
        listItems.push(paintContainer)
      }
      var listOwnerItems = contains(child.flags, 8 /* IS_LIST_OWNER */) ? [] : listItems
      if (treatAsRealStackingContext || createsStackingContext) {
        var parentStack =
          treatAsRealStackingContext || child.styles.isPositioned()
            ? realStackingContext
            : stackingContext
        var stack = new StackingContext(paintContainer)
        if (
          child.styles.isPositioned() ||
          child.styles.opacity < 1 ||
          child.styles.isTransformed()
        ) {
          var order_1 = child.styles.zIndex.order
          if (order_1 < 0) {
            var index_1 = 0
            parentStack.negativeZIndex.some(function(current, i) {
              if (order_1 > current.element.container.styles.zIndex.order) {
                index_1 = i
                return false
              } else if (index_1 > 0) {
                return true
              }
              return false
            })
            parentStack.negativeZIndex.splice(index_1, 0, stack)
          } else if (order_1 > 0) {
            var index_2 = 0
            parentStack.positiveZIndex.some(function(current, i) {
              if (order_1 >= current.element.container.styles.zIndex.order) {
                index_2 = i + 1
                return false
              } else if (index_2 > 0) {
                return true
              }
              return false
            })
            parentStack.positiveZIndex.splice(index_2, 0, stack)
          } else {
            parentStack.zeroOrAutoZIndexOrTransformedOrOpacity.push(stack)
          }
        } else {
          if (child.styles.isFloating()) {
            parentStack.nonPositionedFloats.push(stack)
          } else {
            parentStack.nonPositionedInlineLevel.push(stack)
          }
        }
        parseStackTree(
          paintContainer,
          stack,
          treatAsRealStackingContext ? stack : realStackingContext,
          listOwnerItems
        )
      } else {
        if (child.styles.isInlineLevel()) {
          stackingContext.inlineLevel.push(paintContainer)
        } else {
          stackingContext.nonInlineLevel.push(paintContainer)
        }
        parseStackTree(paintContainer, stackingContext, realStackingContext, listOwnerItems)
      }
      if (contains(child.flags, 8 /* IS_LIST_OWNER */)) {
        processListItems(child, listOwnerItems)
      }
    })
  }
  var processListItems = function(owner, elements) {
    var numbering = owner instanceof OLElementContainer ? owner.start : 1
    var reversed = owner instanceof OLElementContainer ? owner.reversed : false
    for (var i = 0; i < elements.length; i++) {
      var item = elements[i]
      if (
        item.container instanceof LIElementContainer &&
        typeof item.container.value === 'number' &&
        item.container.value !== 0
      ) {
        numbering = item.container.value
      }
      item.listValue = createCounterText(numbering, item.container.styles.listStyleType, true)
      numbering += reversed ? -1 : 1
    }
  }
  var parseStackingContexts = function(container) {
    var paintContainer = new ElementPaint(container, null)
    var root = new StackingContext(paintContainer)
    var listItems = []
    parseStackTree(paintContainer, root, root, listItems)
    processListItems(paintContainer.container, listItems)
    return root
  }

  var parsePathForBorder = function(curves, borderSide) {
    switch (borderSide) {
      case 0:
        return createPathFromCurves(
          curves.topLeftBorderBox,
          curves.topLeftPaddingBox,
          curves.topRightBorderBox,
          curves.topRightPaddingBox
        )
      case 1:
        return createPathFromCurves(
          curves.topRightBorderBox,
          curves.topRightPaddingBox,
          curves.bottomRightBorderBox,
          curves.bottomRightPaddingBox
        )
      case 2:
        return createPathFromCurves(
          curves.bottomRightBorderBox,
          curves.bottomRightPaddingBox,
          curves.bottomLeftBorderBox,
          curves.bottomLeftPaddingBox
        )
      case 3:
      default:
        return createPathFromCurves(
          curves.bottomLeftBorderBox,
          curves.bottomLeftPaddingBox,
          curves.topLeftBorderBox,
          curves.topLeftPaddingBox
        )
    }
  }
  var parsePathForBorderDoubleOuter = function(curves, borderSide) {
    switch (borderSide) {
      case 0:
        return createPathFromCurves(
          curves.topLeftBorderBox,
          curves.topLeftBorderDoubleOuterBox,
          curves.topRightBorderBox,
          curves.topRightBorderDoubleOuterBox
        )
      case 1:
        return createPathFromCurves(
          curves.topRightBorderBox,
          curves.topRightBorderDoubleOuterBox,
          curves.bottomRightBorderBox,
          curves.bottomRightBorderDoubleOuterBox
        )
      case 2:
        return createPathFromCurves(
          curves.bottomRightBorderBox,
          curves.bottomRightBorderDoubleOuterBox,
          curves.bottomLeftBorderBox,
          curves.bottomLeftBorderDoubleOuterBox
        )
      case 3:
      default:
        return createPathFromCurves(
          curves.bottomLeftBorderBox,
          curves.bottomLeftBorderDoubleOuterBox,
          curves.topLeftBorderBox,
          curves.topLeftBorderDoubleOuterBox
        )
    }
  }
  var parsePathForBorderDoubleInner = function(curves, borderSide) {
    switch (borderSide) {
      case 0:
        return createPathFromCurves(
          curves.topLeftBorderDoubleInnerBox,
          curves.topLeftPaddingBox,
          curves.topRightBorderDoubleInnerBox,
          curves.topRightPaddingBox
        )
      case 1:
        return createPathFromCurves(
          curves.topRightBorderDoubleInnerBox,
          curves.topRightPaddingBox,
          curves.bottomRightBorderDoubleInnerBox,
          curves.bottomRightPaddingBox
        )
      case 2:
        return createPathFromCurves(
          curves.bottomRightBorderDoubleInnerBox,
          curves.bottomRightPaddingBox,
          curves.bottomLeftBorderDoubleInnerBox,
          curves.bottomLeftPaddingBox
        )
      case 3:
      default:
        return createPathFromCurves(
          curves.bottomLeftBorderDoubleInnerBox,
          curves.bottomLeftPaddingBox,
          curves.topLeftBorderDoubleInnerBox,
          curves.topLeftPaddingBox
        )
    }
  }
  var parsePathForBorderStroke = function(curves, borderSide) {
    switch (borderSide) {
      case 0:
        return createStrokePathFromCurves(curves.topLeftBorderStroke, curves.topRightBorderStroke)
      case 1:
        return createStrokePathFromCurves(
          curves.topRightBorderStroke,
          curves.bottomRightBorderStroke
        )
      case 2:
        return createStrokePathFromCurves(
          curves.bottomRightBorderStroke,
          curves.bottomLeftBorderStroke
        )
      case 3:
      default:
        return createStrokePathFromCurves(curves.bottomLeftBorderStroke, curves.topLeftBorderStroke)
    }
  }
  var createStrokePathFromCurves = function(outer1, outer2) {
    var path = []
    if (isBezierCurve(outer1)) {
      path.push(outer1.subdivide(0.5, false))
    } else {
      path.push(outer1)
    }
    if (isBezierCurve(outer2)) {
      path.push(outer2.subdivide(0.5, true))
    } else {
      path.push(outer2)
    }
    return path
  }
  var createPathFromCurves = function(outer1, inner1, outer2, inner2) {
    var path = []
    if (isBezierCurve(outer1)) {
      path.push(outer1.subdivide(0.5, false))
    } else {
      path.push(outer1)
    }
    if (isBezierCurve(outer2)) {
      path.push(outer2.subdivide(0.5, true))
    } else {
      path.push(outer2)
    }
    if (isBezierCurve(inner2)) {
      path.push(inner2.subdivide(0.5, true).reverse())
    } else {
      path.push(inner2)
    }
    if (isBezierCurve(inner1)) {
      path.push(inner1.subdivide(0.5, false).reverse())
    } else {
      path.push(inner1)
    }
    return path
  }

  var paddingBox = function(element) {
    var bounds = element.bounds
    var styles = element.styles
    return bounds.add(
      styles.borderLeftWidth,
      styles.borderTopWidth,
      -(styles.borderRightWidth + styles.borderLeftWidth),
      -(styles.borderTopWidth + styles.borderBottomWidth)
    )
  }
  var contentBox = function(element) {
    var styles = element.styles
    var bounds = element.bounds
    var paddingLeft = getAbsoluteValue(styles.paddingLeft, bounds.width)
    var paddingRight = getAbsoluteValue(styles.paddingRight, bounds.width)
    var paddingTop = getAbsoluteValue(styles.paddingTop, bounds.width)
    var paddingBottom = getAbsoluteValue(styles.paddingBottom, bounds.width)
    return bounds.add(
      paddingLeft + styles.borderLeftWidth,
      paddingTop + styles.borderTopWidth,
      -(styles.borderRightWidth + styles.borderLeftWidth + paddingLeft + paddingRight),
      -(styles.borderTopWidth + styles.borderBottomWidth + paddingTop + paddingBottom)
    )
  }

  var calculateBackgroundPositioningArea = function(backgroundOrigin, element) {
    if (backgroundOrigin === 0 /* BORDER_BOX */) {
      return element.bounds
    }
    if (backgroundOrigin === 2 /* CONTENT_BOX */) {
      return contentBox(element)
    }
    return paddingBox(element)
  }
  var calculateBackgroundPaintingArea = function(backgroundClip, element) {
    if (backgroundClip === 0 /* BORDER_BOX */) {
      return element.bounds
    }
    if (backgroundClip === 2 /* CONTENT_BOX */) {
      return contentBox(element)
    }
    return paddingBox(element)
  }
  var calculateBackgroundRendering = function(container, index, intrinsicSize) {
    var backgroundPositioningArea = calculateBackgroundPositioningArea(
      getBackgroundValueForIndex(container.styles.backgroundOrigin, index),
      container
    )
    var backgroundPaintingArea = calculateBackgroundPaintingArea(
      getBackgroundValueForIndex(container.styles.backgroundClip, index),
      container
    )
    var backgroundImageSize = calculateBackgroundSize(
      getBackgroundValueForIndex(container.styles.backgroundSize, index),
      intrinsicSize,
      backgroundPositioningArea
    )
    var sizeWidth = backgroundImageSize[0],
      sizeHeight = backgroundImageSize[1]
    var position = getAbsoluteValueForTuple(
      getBackgroundValueForIndex(container.styles.backgroundPosition, index),
      backgroundPositioningArea.width - sizeWidth,
      backgroundPositioningArea.height - sizeHeight
    )
    var path = calculateBackgroundRepeatPath(
      getBackgroundValueForIndex(container.styles.backgroundRepeat, index),
      position,
      backgroundImageSize,
      backgroundPositioningArea,
      backgroundPaintingArea
    )
    var offsetX = Math.round(backgroundPositioningArea.left + position[0])
    var offsetY = Math.round(backgroundPositioningArea.top + position[1])
    return [path, offsetX, offsetY, sizeWidth, sizeHeight]
  }
  var isAuto = function(token) {
    return isIdentToken(token) && token.value === BACKGROUND_SIZE.AUTO
  }
  var hasIntrinsicValue = function(value) {
    return typeof value === 'number'
  }
  var calculateBackgroundSize = function(size, _a, bounds) {
    var intrinsicWidth = _a[0],
      intrinsicHeight = _a[1],
      intrinsicProportion = _a[2]
    var first = size[0],
      second = size[1]
    if (!first) {
      return [0, 0]
    }
    if (isLengthPercentage(first) && second && isLengthPercentage(second)) {
      return [getAbsoluteValue(first, bounds.width), getAbsoluteValue(second, bounds.height)]
    }
    var hasIntrinsicProportion = hasIntrinsicValue(intrinsicProportion)
    if (
      isIdentToken(first) &&
      (first.value === BACKGROUND_SIZE.CONTAIN || first.value === BACKGROUND_SIZE.COVER)
    ) {
      if (hasIntrinsicValue(intrinsicProportion)) {
        var targetRatio = bounds.width / bounds.height
        return targetRatio < intrinsicProportion !== (first.value === BACKGROUND_SIZE.COVER)
          ? [bounds.width, bounds.width / intrinsicProportion]
          : [bounds.height * intrinsicProportion, bounds.height]
      }
      return [bounds.width, bounds.height]
    }
    var hasIntrinsicWidth = hasIntrinsicValue(intrinsicWidth)
    var hasIntrinsicHeight = hasIntrinsicValue(intrinsicHeight)
    var hasIntrinsicDimensions = hasIntrinsicWidth || hasIntrinsicHeight
    // If the background-size is auto or auto auto:
    if (isAuto(first) && (!second || isAuto(second))) {
      // If the image has both horizontal and vertical intrinsic dimensions, it's rendered at that size.
      if (hasIntrinsicWidth && hasIntrinsicHeight) {
        return [intrinsicWidth, intrinsicHeight]
      }
      // If the image has no intrinsic dimensions and has no intrinsic proportions,
      // it's rendered at the size of the background positioning area.
      if (!hasIntrinsicProportion && !hasIntrinsicDimensions) {
        return [bounds.width, bounds.height]
      }
      // TODO If the image has no intrinsic dimensions but has intrinsic proportions, it's rendered as if contain had been specified instead.
      // If the image has only one intrinsic dimension and has intrinsic proportions, it's rendered at the size corresponding to that one dimension.
      // The other dimension is computed using the specified dimension and the intrinsic proportions.
      if (hasIntrinsicDimensions && hasIntrinsicProportion) {
        var width_1 = hasIntrinsicWidth ? intrinsicWidth : intrinsicHeight * intrinsicProportion
        var height_1 = hasIntrinsicHeight ? intrinsicHeight : intrinsicWidth / intrinsicProportion
        return [width_1, height_1]
      }
      // If the image has only one intrinsic dimension but has no intrinsic proportions,
      // it's rendered using the specified dimension and the other dimension of the background positioning area.
      var width_2 = hasIntrinsicWidth ? intrinsicWidth : bounds.width
      var height_2 = hasIntrinsicHeight ? intrinsicHeight : bounds.height
      return [width_2, height_2]
    }
    // If the image has intrinsic proportions, it's stretched to the specified dimension.
    // The unspecified dimension is computed using the specified dimension and the intrinsic proportions.
    if (hasIntrinsicProportion) {
      var width_3 = 0
      var height_3 = 0
      if (isLengthPercentage(first)) {
        width_3 = getAbsoluteValue(first, bounds.width)
      } else if (isLengthPercentage(second)) {
        height_3 = getAbsoluteValue(second, bounds.height)
      }
      if (isAuto(first)) {
        width_3 = height_3 * intrinsicProportion
      } else if (!second || isAuto(second)) {
        height_3 = width_3 / intrinsicProportion
      }
      return [width_3, height_3]
    }
    // If the image has no intrinsic proportions, it's stretched to the specified dimension.
    // The unspecified dimension is computed using the image's corresponding intrinsic dimension,
    // if there is one. If there is no such intrinsic dimension,
    // it becomes the corresponding dimension of the background positioning area.
    var width = null
    var height = null
    if (isLengthPercentage(first)) {
      width = getAbsoluteValue(first, bounds.width)
    } else if (second && isLengthPercentage(second)) {
      height = getAbsoluteValue(second, bounds.height)
    }
    if (width !== null && (!second || isAuto(second))) {
      height =
        hasIntrinsicWidth && hasIntrinsicHeight
          ? (width / intrinsicWidth) * intrinsicHeight
          : bounds.height
    }
    if (height !== null && isAuto(first)) {
      width =
        hasIntrinsicWidth && hasIntrinsicHeight
          ? (height / intrinsicHeight) * intrinsicWidth
          : bounds.width
    }
    if (width !== null && height !== null) {
      return [width, height]
    }
    throw new Error('Unable to calculate background-size for element')
  }
  var getBackgroundValueForIndex = function(values, index) {
    var value = values[index]
    if (typeof value === 'undefined') {
      return values[0]
    }
    return value
  }
  var calculateBackgroundRepeatPath = function(
    repeat,
    _a,
    _b,
    backgroundPositioningArea,
    backgroundPaintingArea
  ) {
    var x = _a[0],
      y = _a[1]
    var width = _b[0],
      height = _b[1]
    switch (repeat) {
      case 2 /* REPEAT_X */:
        return [
          new Vector(
            Math.round(backgroundPositioningArea.left),
            Math.round(backgroundPositioningArea.top + y)
          ),
          new Vector(
            Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width),
            Math.round(backgroundPositioningArea.top + y)
          ),
          new Vector(
            Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width),
            Math.round(height + backgroundPositioningArea.top + y)
          ),
          new Vector(
            Math.round(backgroundPositioningArea.left),
            Math.round(height + backgroundPositioningArea.top + y)
          ),
        ]
      case 3 /* REPEAT_Y */:
        return [
          new Vector(
            Math.round(backgroundPositioningArea.left + x),
            Math.round(backgroundPositioningArea.top)
          ),
          new Vector(
            Math.round(backgroundPositioningArea.left + x + width),
            Math.round(backgroundPositioningArea.top)
          ),
          new Vector(
            Math.round(backgroundPositioningArea.left + x + width),
            Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top)
          ),
          new Vector(
            Math.round(backgroundPositioningArea.left + x),
            Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top)
          ),
        ]
      case 1 /* NO_REPEAT */:
        return [
          new Vector(
            Math.round(backgroundPositioningArea.left + x),
            Math.round(backgroundPositioningArea.top + y)
          ),
          new Vector(
            Math.round(backgroundPositioningArea.left + x + width),
            Math.round(backgroundPositioningArea.top + y)
          ),
          new Vector(
            Math.round(backgroundPositioningArea.left + x + width),
            Math.round(backgroundPositioningArea.top + y + height)
          ),
          new Vector(
            Math.round(backgroundPositioningArea.left + x),
            Math.round(backgroundPositioningArea.top + y + height)
          ),
        ]
      default:
        return [
          new Vector(
            Math.round(backgroundPaintingArea.left),
            Math.round(backgroundPaintingArea.top)
          ),
          new Vector(
            Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width),
            Math.round(backgroundPaintingArea.top)
          ),
          new Vector(
            Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width),
            Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top)
          ),
          new Vector(
            Math.round(backgroundPaintingArea.left),
            Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top)
          ),
        ]
    }
  }

  var SMALL_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'

  var SAMPLE_TEXT = 'Hidden Text'
  var FontMetrics = /** @class */ (function() {
    function FontMetrics(document) {
      this._data = {}
      this._document = document
    }
    FontMetrics.prototype.parseMetrics = function(fontFamily, fontSize) {
      var container = this._document.createElement('div')
      var img = this._document.createElement('img')
      var span = this._document.createElement('span')
      var body = this._document.body
      container.style.visibility = 'hidden'
      container.style.fontFamily = fontFamily
      container.style.fontSize = fontSize
      container.style.margin = '0'
      container.style.padding = '0'
      container.style.whiteSpace = 'nowrap'
      body.appendChild(container)
      img.src = SMALL_IMAGE
      img.width = 1
      img.height = 1
      img.style.margin = '0'
      img.style.padding = '0'
      img.style.verticalAlign = 'baseline'
      span.style.fontFamily = fontFamily
      span.style.fontSize = fontSize
      span.style.margin = '0'
      span.style.padding = '0'
      span.appendChild(this._document.createTextNode(SAMPLE_TEXT))
      container.appendChild(span)
      container.appendChild(img)
      var baseline = img.offsetTop - span.offsetTop + 2
      container.removeChild(span)
      container.appendChild(this._document.createTextNode(SAMPLE_TEXT))
      container.style.lineHeight = 'normal'
      img.style.verticalAlign = 'super'
      var middle = img.offsetTop - container.offsetTop + 2
      body.removeChild(container)
      return { baseline: baseline, middle: middle }
    }
    FontMetrics.prototype.getMetrics = function(fontFamily, fontSize) {
      var key = fontFamily + ' ' + fontSize
      if (typeof this._data[key] === 'undefined') {
        this._data[key] = this.parseMetrics(fontFamily, fontSize)
      }
      return this._data[key]
    }
    return FontMetrics
  })()

  var Renderer = /** @class */ (function() {
    function Renderer(context, options) {
      this.context = context
      this.options = options
    }
    return Renderer
  })()

  var MASK_OFFSET = 10000
  var CanvasRenderer = /** @class */ (function(_super) {
    __extends(CanvasRenderer, _super)
    function CanvasRenderer(context, options) {
      var _this = _super.call(this, context, options) || this
      _this._activeEffects = []
      _this.canvas = options.canvas ? options.canvas : document.createElement('canvas')
      _this.ctx = _this.canvas.getContext('2d')
      if (!options.canvas) {
        _this.canvas.width = Math.floor(options.width * options.scale)
        _this.canvas.height = Math.floor(options.height * options.scale)
        _this.canvas.style.width = options.width + 'px'
        _this.canvas.style.height = options.height + 'px'
      }
      _this.fontMetrics = new FontMetrics(document)
      _this.ctx.scale(_this.options.scale, _this.options.scale)
      _this.ctx.translate(-options.x, -options.y)
      _this.ctx.textBaseline = 'bottom'
      _this._activeEffects = []
      _this.context.logger.debug(
        'Canvas renderer initialized (' +
          options.width +
          'x' +
          options.height +
          ') with scale ' +
          options.scale
      )
      return _this
    }
    CanvasRenderer.prototype.applyEffects = function(effects) {
      var _this = this
      while (this._activeEffects.length) {
        this.popEffect()
      }
      effects.forEach(function(effect) {
        return _this.applyEffect(effect)
      })
    }
    CanvasRenderer.prototype.applyEffect = function(effect) {
      this.ctx.save()
      if (isOpacityEffect(effect)) {
        this.ctx.globalAlpha = effect.opacity
      }
      if (isTransformEffect(effect)) {
        this.ctx.translate(effect.offsetX, effect.offsetY)
        this.ctx.transform(
          effect.matrix[0],
          effect.matrix[1],
          effect.matrix[2],
          effect.matrix[3],
          effect.matrix[4],
          effect.matrix[5]
        )
        this.ctx.translate(-effect.offsetX, -effect.offsetY)
      }
      if (isClipEffect(effect)) {
        this.path(effect.path)
        this.ctx.clip()
      }
      this._activeEffects.push(effect)
    }
    CanvasRenderer.prototype.popEffect = function() {
      this._activeEffects.pop()
      this.ctx.restore()
    }
    CanvasRenderer.prototype.renderStack = function(stack) {
      return __awaiter(this, void 0, void 0, function() {
        var styles
        return __generator(this, function(_a) {
          switch (_a.label) {
            case 0:
              styles = stack.element.container.styles
              if (!styles.isVisible()) return [3 /*break*/, 2]
              return [4 /*yield*/, this.renderStackContent(stack)]
            case 1:
              _a.sent()
              _a.label = 2
            case 2:
              return [2 /*return*/]
          }
        })
      })
    }
    CanvasRenderer.prototype.renderNode = function(paint) {
      return __awaiter(this, void 0, void 0, function() {
        return __generator(this, function(_a) {
          switch (_a.label) {
            case 0:
              if (contains(paint.container.flags, 16 /* DEBUG_RENDER */)) {
                debugger
              }
              if (!paint.container.styles.isVisible()) return [3 /*break*/, 3]
              return [4 /*yield*/, this.renderNodeBackgroundAndBorders(paint)]
            case 1:
              _a.sent()
              return [4 /*yield*/, this.renderNodeContent(paint)]
            case 2:
              _a.sent()
              _a.label = 3
            case 3:
              return [2 /*return*/]
          }
        })
      })
    }
    CanvasRenderer.prototype.renderTextWithLetterSpacing = function(text, letterSpacing, baseline) {
      var _this = this
      if (letterSpacing === 0) {
        this.ctx.fillText(text.text, text.bounds.left, text.bounds.top + baseline)
      } else {
        var letters = segmentGraphemes(text.text)
        letters.reduce(function(left, letter) {
          _this.ctx.fillText(letter, left, text.bounds.top + baseline)
          return left + _this.ctx.measureText(letter).width
        }, text.bounds.left)
      }
    }
    CanvasRenderer.prototype.createFontStyle = function(styles) {
      var fontVariant = styles.fontVariant
        .filter(function(variant) {
          return variant === 'normal' || variant === 'small-caps'
        })
        .join('')
      var fontFamily = fixIOSSystemFonts(styles.fontFamily).join(', ')
      var fontSize = isDimensionToken(styles.fontSize)
        ? '' + styles.fontSize.number + styles.fontSize.unit
        : styles.fontSize.number + 'px'
      return [
        [styles.fontStyle, fontVariant, styles.fontWeight, fontSize, fontFamily].join(' '),
        fontFamily,
        fontSize,
      ]
    }
    CanvasRenderer.prototype.renderTextNode = function(text, styles) {
      return __awaiter(this, void 0, void 0, function() {
        var _a, font, fontFamily, fontSize, _b, baseline, middle, paintOrder
        var _this = this
        return __generator(this, function(_c) {
          ;(_a = this.createFontStyle(styles)),
            (font = _a[0]),
            (fontFamily = _a[1]),
            (fontSize = _a[2])
          this.ctx.font = font
          this.ctx.direction = styles.direction === 1 /* RTL */ ? 'rtl' : 'ltr'
          this.ctx.textAlign = 'left'
          this.ctx.textBaseline = 'alphabetic'
          ;(_b = this.fontMetrics.getMetrics(fontFamily, fontSize)),
            (baseline = _b.baseline),
            (middle = _b.middle)
          paintOrder = styles.paintOrder
          text.textBounds.forEach(function(text) {
            paintOrder.forEach(function(paintOrderLayer) {
              switch (paintOrderLayer) {
                case 0 /* FILL */:
                  _this.ctx.fillStyle = asString(styles.color)
                  _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline)
                  var textShadows = styles.textShadow
                  if (textShadows.length && text.text.trim().length) {
                    textShadows
                      .slice(0)
                      .reverse()
                      .forEach(function(textShadow) {
                        _this.ctx.shadowColor = asString(textShadow.color)
                        _this.ctx.shadowOffsetX = textShadow.offsetX.number * _this.options.scale
                        _this.ctx.shadowOffsetY = textShadow.offsetY.number * _this.options.scale
                        _this.ctx.shadowBlur = textShadow.blur.number
                        _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline)
                      })
                    _this.ctx.shadowColor = ''
                    _this.ctx.shadowOffsetX = 0
                    _this.ctx.shadowOffsetY = 0
                    _this.ctx.shadowBlur = 0
                  }
                  if (styles.textDecorationLine.length) {
                    _this.ctx.fillStyle = asString(styles.textDecorationColor || styles.color)
                    styles.textDecorationLine.forEach(function(textDecorationLine) {
                      switch (textDecorationLine) {
                        case 1 /* UNDERLINE */:
                          // Draws a line at the baseline of the font
                          // TODO As some browsers display the line as more than 1px if the font-size is big,
                          // need to take that into account both in position and size
                          _this.ctx.fillRect(
                            text.bounds.left,
                            Math.round(text.bounds.top + baseline),
                            text.bounds.width,
                            1
                          )
                          break
                        case 2 /* OVERLINE */:
                          _this.ctx.fillRect(
                            text.bounds.left,
                            Math.round(text.bounds.top),
                            text.bounds.width,
                            1
                          )
                          break
                        case 3 /* LINE_THROUGH */:
                          // TODO try and find exact position for line-through
                          _this.ctx.fillRect(
                            text.bounds.left,
                            Math.ceil(text.bounds.top + middle),
                            text.bounds.width,
                            1
                          )
                          break
                      }
                    })
                  }
                  break
                case 1 /* STROKE */:
                  if (styles.webkitTextStrokeWidth && text.text.trim().length) {
                    _this.ctx.strokeStyle = asString(styles.webkitTextStrokeColor)
                    _this.ctx.lineWidth = styles.webkitTextStrokeWidth
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    _this.ctx.lineJoin = !!window.chrome ? 'miter' : 'round'
                    _this.ctx.strokeText(text.text, text.bounds.left, text.bounds.top + baseline)
                  }
                  _this.ctx.strokeStyle = ''
                  _this.ctx.lineWidth = 0
                  _this.ctx.lineJoin = 'miter'
                  break
              }
            })
          })
          return [2 /*return*/]
        })
      })
    }
    CanvasRenderer.prototype.renderReplacedElement = function(container, curves, image) {
      if (image && container.intrinsicWidth > 0 && container.intrinsicHeight > 0) {
        var box = contentBox(container)
        var path = calculatePaddingBoxPath(curves)
        this.path(path)
        this.ctx.save()
        this.ctx.clip()
        this.ctx.drawImage(
          image,
          0,
          0,
          container.intrinsicWidth,
          container.intrinsicHeight,
          box.left,
          box.top,
          box.width,
          box.height
        )
        this.ctx.restore()
      }
    }
    CanvasRenderer.prototype.renderNodeContent = function(paint) {
      return __awaiter(this, void 0, void 0, function() {
        var container,
          curves,
          styles,
          _i,
          _a,
          child,
          image,
          image,
          iframeRenderer,
          canvas,
          size,
          _b,
          fontFamily,
          fontSize,
          baseline,
          bounds,
          x,
          textBounds,
          img,
          image,
          url,
          fontFamily,
          bounds
        return __generator(this, function(_c) {
          switch (_c.label) {
            case 0:
              this.applyEffects(paint.getEffects(4 /* CONTENT */))
              container = paint.container
              curves = paint.curves
              styles = container.styles
              ;(_i = 0), (_a = container.textNodes)
              _c.label = 1
            case 1:
              if (!(_i < _a.length)) return [3 /*break*/, 4]
              child = _a[_i]
              return [4 /*yield*/, this.renderTextNode(child, styles)]
            case 2:
              _c.sent()
              _c.label = 3
            case 3:
              _i++
              return [3 /*break*/, 1]
            case 4:
              if (!(container instanceof ImageElementContainer)) return [3 /*break*/, 8]
              _c.label = 5
            case 5:
              _c.trys.push([5, 7, , 8])
              return [4 /*yield*/, this.context.cache.match(container.src)]
            case 6:
              image = _c.sent()
              this.renderReplacedElement(container, curves, image)
              return [3 /*break*/, 8]
            case 7:
              _c.sent()
              this.context.logger.error('Error loading image ' + container.src)
              return [3 /*break*/, 8]
            case 8:
              if (container instanceof CanvasElementContainer) {
                this.renderReplacedElement(container, curves, container.canvas)
              }
              if (!(container instanceof SVGElementContainer)) return [3 /*break*/, 12]
              _c.label = 9
            case 9:
              _c.trys.push([9, 11, , 12])
              return [4 /*yield*/, this.context.cache.match(container.svg)]
            case 10:
              image = _c.sent()
              this.renderReplacedElement(container, curves, image)
              return [3 /*break*/, 12]
            case 11:
              _c.sent()
              this.context.logger.error('Error loading svg ' + container.svg.substring(0, 255))
              return [3 /*break*/, 12]
            case 12:
              if (!(container instanceof IFrameElementContainer && container.tree))
                return [3 /*break*/, 14]
              iframeRenderer = new CanvasRenderer(this.context, {
                scale: this.options.scale,
                backgroundColor: container.backgroundColor,
                x: 0,
                y: 0,
                width: container.width,
                height: container.height,
              })
              return [4 /*yield*/, iframeRenderer.render(container.tree)]
            case 13:
              canvas = _c.sent()
              if (container.width && container.height) {
                this.ctx.drawImage(
                  canvas,
                  0,
                  0,
                  container.width,
                  container.height,
                  container.bounds.left,
                  container.bounds.top,
                  container.bounds.width,
                  container.bounds.height
                )
              }
              _c.label = 14
            case 14:
              if (container instanceof InputElementContainer) {
                size = Math.min(container.bounds.width, container.bounds.height)
                if (container.type === CHECKBOX) {
                  if (container.checked) {
                    this.ctx.save()
                    this.path([
                      new Vector(
                        container.bounds.left + size * 0.39363,
                        container.bounds.top + size * 0.79
                      ),
                      new Vector(
                        container.bounds.left + size * 0.16,
                        container.bounds.top + size * 0.5549
                      ),
                      new Vector(
                        container.bounds.left + size * 0.27347,
                        container.bounds.top + size * 0.44071
                      ),
                      new Vector(
                        container.bounds.left + size * 0.39694,
                        container.bounds.top + size * 0.5649
                      ),
                      new Vector(
                        container.bounds.left + size * 0.72983,
                        container.bounds.top + size * 0.23
                      ),
                      new Vector(
                        container.bounds.left + size * 0.84,
                        container.bounds.top + size * 0.34085
                      ),
                      new Vector(
                        container.bounds.left + size * 0.39363,
                        container.bounds.top + size * 0.79
                      ),
                    ])
                    this.ctx.fillStyle = asString(INPUT_COLOR)
                    this.ctx.fill()
                    this.ctx.restore()
                  }
                } else if (container.type === RADIO) {
                  if (container.checked) {
                    this.ctx.save()
                    this.ctx.beginPath()
                    this.ctx.arc(
                      container.bounds.left + size / 2,
                      container.bounds.top + size / 2,
                      size / 4,
                      0,
                      Math.PI * 2,
                      true
                    )
                    this.ctx.fillStyle = asString(INPUT_COLOR)
                    this.ctx.fill()
                    this.ctx.restore()
                  }
                }
              }
              if (isTextInputElement(container) && container.value.length) {
                ;(_b = this.createFontStyle(styles)), (fontFamily = _b[0]), (fontSize = _b[1])
                baseline = this.fontMetrics.getMetrics(fontFamily, fontSize).baseline
                this.ctx.font = fontFamily
                this.ctx.fillStyle = asString(styles.color)
                this.ctx.textBaseline = 'alphabetic'
                this.ctx.textAlign = canvasTextAlign(container.styles.textAlign)
                bounds = contentBox(container)
                x = 0
                switch (container.styles.textAlign) {
                  case 1 /* CENTER */:
                    x += bounds.width / 2
                    break
                  case 2 /* RIGHT */:
                    x += bounds.width
                    break
                }
                textBounds = bounds.add(x, 0, 0, -bounds.height / 2 + 1)
                this.ctx.save()
                this.path([
                  new Vector(bounds.left, bounds.top),
                  new Vector(bounds.left + bounds.width, bounds.top),
                  new Vector(bounds.left + bounds.width, bounds.top + bounds.height),
                  new Vector(bounds.left, bounds.top + bounds.height),
                ])
                this.ctx.clip()
                this.renderTextWithLetterSpacing(
                  new TextBounds(container.value, textBounds),
                  styles.letterSpacing,
                  baseline
                )
                this.ctx.restore()
                this.ctx.textBaseline = 'alphabetic'
                this.ctx.textAlign = 'left'
              }
              if (!contains(container.styles.display, 2048 /* LIST_ITEM */))
                return [3 /*break*/, 20]
              if (!(container.styles.listStyleImage !== null)) return [3 /*break*/, 19]
              img = container.styles.listStyleImage
              if (!((img.type === 0) /* URL */)) return [3 /*break*/, 18]
              image = void 0
              url = img.url
              _c.label = 15
            case 15:
              _c.trys.push([15, 17, , 18])
              return [4 /*yield*/, this.context.cache.match(url)]
            case 16:
              image = _c.sent()
              this.ctx.drawImage(
                image,
                container.bounds.left - (image.width + 10),
                container.bounds.top
              )
              return [3 /*break*/, 18]
            case 17:
              _c.sent()
              this.context.logger.error('Error loading list-style-image ' + url)
              return [3 /*break*/, 18]
            case 18:
              return [3 /*break*/, 20]
            case 19:
              if (paint.listValue && container.styles.listStyleType !== -1 /* NONE */) {
                fontFamily = this.createFontStyle(styles)[0]
                this.ctx.font = fontFamily
                this.ctx.fillStyle = asString(styles.color)
                this.ctx.textBaseline = 'middle'
                this.ctx.textAlign = 'right'
                bounds = new Bounds(
                  container.bounds.left,
                  container.bounds.top +
                    getAbsoluteValue(container.styles.paddingTop, container.bounds.width),
                  container.bounds.width,
                  computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 1
                )
                this.renderTextWithLetterSpacing(
                  new TextBounds(paint.listValue, bounds),
                  styles.letterSpacing,
                  computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 2
                )
                this.ctx.textBaseline = 'bottom'
                this.ctx.textAlign = 'left'
              }
              _c.label = 20
            case 20:
              return [2 /*return*/]
          }
        })
      })
    }
    CanvasRenderer.prototype.renderStackContent = function(stack) {
      return __awaiter(this, void 0, void 0, function() {
        var _i,
          _a,
          child,
          _b,
          _c,
          child,
          _d,
          _e,
          child,
          _f,
          _g,
          child,
          _h,
          _j,
          child,
          _k,
          _l,
          child,
          _m,
          _o,
          child
        return __generator(this, function(_p) {
          switch (_p.label) {
            case 0:
              if (contains(stack.element.container.flags, 16 /* DEBUG_RENDER */)) {
                debugger
              }
              // https://www.w3.org/TR/css-position-3/#painting-order
              // 1. the background and borders of the element forming the stacking context.
              return [4 /*yield*/, this.renderNodeBackgroundAndBorders(stack.element)]
            case 1:
              // https://www.w3.org/TR/css-position-3/#painting-order
              // 1. the background and borders of the element forming the stacking context.
              _p.sent()
              ;(_i = 0), (_a = stack.negativeZIndex)
              _p.label = 2
            case 2:
              if (!(_i < _a.length)) return [3 /*break*/, 5]
              child = _a[_i]
              return [4 /*yield*/, this.renderStack(child)]
            case 3:
              _p.sent()
              _p.label = 4
            case 4:
              _i++
              return [3 /*break*/, 2]
            case 5:
              // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
              return [4 /*yield*/, this.renderNodeContent(stack.element)]
            case 6:
              // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
              _p.sent()
              ;(_b = 0), (_c = stack.nonInlineLevel)
              _p.label = 7
            case 7:
              if (!(_b < _c.length)) return [3 /*break*/, 10]
              child = _c[_b]
              return [4 /*yield*/, this.renderNode(child)]
            case 8:
              _p.sent()
              _p.label = 9
            case 9:
              _b++
              return [3 /*break*/, 7]
            case 10:
              ;(_d = 0), (_e = stack.nonPositionedFloats)
              _p.label = 11
            case 11:
              if (!(_d < _e.length)) return [3 /*break*/, 14]
              child = _e[_d]
              return [4 /*yield*/, this.renderStack(child)]
            case 12:
              _p.sent()
              _p.label = 13
            case 13:
              _d++
              return [3 /*break*/, 11]
            case 14:
              ;(_f = 0), (_g = stack.nonPositionedInlineLevel)
              _p.label = 15
            case 15:
              if (!(_f < _g.length)) return [3 /*break*/, 18]
              child = _g[_f]
              return [4 /*yield*/, this.renderStack(child)]
            case 16:
              _p.sent()
              _p.label = 17
            case 17:
              _f++
              return [3 /*break*/, 15]
            case 18:
              ;(_h = 0), (_j = stack.inlineLevel)
              _p.label = 19
            case 19:
              if (!(_h < _j.length)) return [3 /*break*/, 22]
              child = _j[_h]
              return [4 /*yield*/, this.renderNode(child)]
            case 20:
              _p.sent()
              _p.label = 21
            case 21:
              _h++
              return [3 /*break*/, 19]
            case 22:
              ;(_k = 0), (_l = stack.zeroOrAutoZIndexOrTransformedOrOpacity)
              _p.label = 23
            case 23:
              if (!(_k < _l.length)) return [3 /*break*/, 26]
              child = _l[_k]
              return [4 /*yield*/, this.renderStack(child)]
            case 24:
              _p.sent()
              _p.label = 25
            case 25:
              _k++
              return [3 /*break*/, 23]
            case 26:
              ;(_m = 0), (_o = stack.positiveZIndex)
              _p.label = 27
            case 27:
              if (!(_m < _o.length)) return [3 /*break*/, 30]
              child = _o[_m]
              return [4 /*yield*/, this.renderStack(child)]
            case 28:
              _p.sent()
              _p.label = 29
            case 29:
              _m++
              return [3 /*break*/, 27]
            case 30:
              return [2 /*return*/]
          }
        })
      })
    }
    CanvasRenderer.prototype.mask = function(paths) {
      this.ctx.beginPath()
      this.ctx.moveTo(0, 0)
      this.ctx.lineTo(this.canvas.width, 0)
      this.ctx.lineTo(this.canvas.width, this.canvas.height)
      this.ctx.lineTo(0, this.canvas.height)
      this.ctx.lineTo(0, 0)
      this.formatPath(paths.slice(0).reverse())
      this.ctx.closePath()
    }
    CanvasRenderer.prototype.path = function(paths) {
      this.ctx.beginPath()
      this.formatPath(paths)
      this.ctx.closePath()
    }
    CanvasRenderer.prototype.formatPath = function(paths) {
      var _this = this
      paths.forEach(function(point, index) {
        var start = isBezierCurve(point) ? point.start : point
        if (index === 0) {
          _this.ctx.moveTo(start.x, start.y)
        } else {
          _this.ctx.lineTo(start.x, start.y)
        }
        if (isBezierCurve(point)) {
          _this.ctx.bezierCurveTo(
            point.startControl.x,
            point.startControl.y,
            point.endControl.x,
            point.endControl.y,
            point.end.x,
            point.end.y
          )
        }
      })
    }
    CanvasRenderer.prototype.renderRepeat = function(path, pattern, offsetX, offsetY) {
      this.path(path)
      this.ctx.fillStyle = pattern
      this.ctx.translate(offsetX, offsetY)
      this.ctx.fill()
      this.ctx.translate(-offsetX, -offsetY)
    }
    CanvasRenderer.prototype.resizeImage = function(image, width, height) {
      var _a
      if (image.width === width && image.height === height) {
        return image
      }
      var ownerDocument = (_a = this.canvas.ownerDocument) !== null && _a !== void 0 ? _a : document
      var canvas = ownerDocument.createElement('canvas')
      canvas.width = Math.max(1, width)
      canvas.height = Math.max(1, height)
      var ctx = canvas.getContext('2d')
      ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height)
      return canvas
    }
    CanvasRenderer.prototype.renderBackgroundImage = function(container) {
      return __awaiter(this, void 0, void 0, function() {
        var index, _loop_1, this_1, _i, _a, backgroundImage
        return __generator(this, function(_b) {
          switch (_b.label) {
            case 0:
              index = container.styles.backgroundImage.length - 1
              _loop_1 = function(backgroundImage) {
                var image,
                  url,
                  _c,
                  path,
                  x,
                  y,
                  width,
                  height,
                  pattern,
                  _d,
                  path,
                  x,
                  y,
                  width,
                  height,
                  _e,
                  lineLength,
                  x0,
                  x1,
                  y0,
                  y1,
                  canvas,
                  ctx,
                  gradient_1,
                  pattern,
                  _f,
                  path,
                  left,
                  top_1,
                  width,
                  height,
                  position,
                  x,
                  y,
                  _g,
                  rx,
                  ry,
                  radialGradient_1,
                  midX,
                  midY,
                  f,
                  invF
                return __generator(this, function(_h) {
                  switch (_h.label) {
                    case 0:
                      if (!((backgroundImage.type === 0) /* URL */)) return [3 /*break*/, 5]
                      image = void 0
                      url = backgroundImage.url
                      _h.label = 1
                    case 1:
                      _h.trys.push([1, 3, , 4])
                      return [4 /*yield*/, this_1.context.cache.match(url)]
                    case 2:
                      image = _h.sent()
                      return [3 /*break*/, 4]
                    case 3:
                      _h.sent()
                      this_1.context.logger.error('Error loading background-image ' + url)
                      return [3 /*break*/, 4]
                    case 4:
                      if (image) {
                        ;(_c = calculateBackgroundRendering(container, index, [
                          image.width,
                          image.height,
                          image.width / image.height,
                        ])),
                          (path = _c[0]),
                          (x = _c[1]),
                          (y = _c[2]),
                          (width = _c[3]),
                          (height = _c[4])
                        pattern = this_1.ctx.createPattern(
                          this_1.resizeImage(image, width, height),
                          'repeat'
                        )
                        this_1.renderRepeat(path, pattern, x, y)
                      }
                      return [3 /*break*/, 6]
                    case 5:
                      if (isLinearGradient(backgroundImage)) {
                        ;(_d = calculateBackgroundRendering(container, index, [null, null, null])),
                          (path = _d[0]),
                          (x = _d[1]),
                          (y = _d[2]),
                          (width = _d[3]),
                          (height = _d[4])
                        ;(_e = calculateGradientDirection(backgroundImage.angle, width, height)),
                          (lineLength = _e[0]),
                          (x0 = _e[1]),
                          (x1 = _e[2]),
                          (y0 = _e[3]),
                          (y1 = _e[4])
                        canvas = document.createElement('canvas')
                        canvas.width = width
                        canvas.height = height
                        ctx = canvas.getContext('2d')
                        gradient_1 = ctx.createLinearGradient(x0, y0, x1, y1)
                        processColorStops(backgroundImage.stops, lineLength).forEach(function(
                          colorStop
                        ) {
                          return gradient_1.addColorStop(colorStop.stop, asString(colorStop.color))
                        })
                        ctx.fillStyle = gradient_1
                        ctx.fillRect(0, 0, width, height)
                        if (width > 0 && height > 0) {
                          pattern = this_1.ctx.createPattern(canvas, 'repeat')
                          this_1.renderRepeat(path, pattern, x, y)
                        }
                      } else if (isRadialGradient(backgroundImage)) {
                        ;(_f = calculateBackgroundRendering(container, index, [null, null, null])),
                          (path = _f[0]),
                          (left = _f[1]),
                          (top_1 = _f[2]),
                          (width = _f[3]),
                          (height = _f[4])
                        position =
                          backgroundImage.position.length === 0
                            ? [FIFTY_PERCENT]
                            : backgroundImage.position
                        x = getAbsoluteValue(position[0], width)
                        y = getAbsoluteValue(position[position.length - 1], height)
                        ;(_g = calculateRadius(backgroundImage, x, y, width, height)),
                          (rx = _g[0]),
                          (ry = _g[1])
                        if (rx > 0 && ry > 0) {
                          radialGradient_1 = this_1.ctx.createRadialGradient(
                            left + x,
                            top_1 + y,
                            0,
                            left + x,
                            top_1 + y,
                            rx
                          )
                          processColorStops(backgroundImage.stops, rx * 2).forEach(function(
                            colorStop
                          ) {
                            return radialGradient_1.addColorStop(
                              colorStop.stop,
                              asString(colorStop.color)
                            )
                          })
                          this_1.path(path)
                          this_1.ctx.fillStyle = radialGradient_1
                          if (rx !== ry) {
                            midX = container.bounds.left + 0.5 * container.bounds.width
                            midY = container.bounds.top + 0.5 * container.bounds.height
                            f = ry / rx
                            invF = 1 / f
                            this_1.ctx.save()
                            this_1.ctx.translate(midX, midY)
                            this_1.ctx.transform(1, 0, 0, f, 0, 0)
                            this_1.ctx.translate(-midX, -midY)
                            this_1.ctx.fillRect(
                              left,
                              invF * (top_1 - midY) + midY,
                              width,
                              height * invF
                            )
                            this_1.ctx.restore()
                          } else {
                            this_1.ctx.fill()
                          }
                        }
                      }
                      _h.label = 6
                    case 6:
                      index--
                      return [2 /*return*/]
                  }
                })
              }
              this_1 = this
              ;(_i = 0), (_a = container.styles.backgroundImage.slice(0).reverse())
              _b.label = 1
            case 1:
              if (!(_i < _a.length)) return [3 /*break*/, 4]
              backgroundImage = _a[_i]
              return [5 /*yield**/, _loop_1(backgroundImage)]
            case 2:
              _b.sent()
              _b.label = 3
            case 3:
              _i++
              return [3 /*break*/, 1]
            case 4:
              return [2 /*return*/]
          }
        })
      })
    }
    CanvasRenderer.prototype.renderSolidBorder = function(color, side, curvePoints) {
      return __awaiter(this, void 0, void 0, function() {
        return __generator(this, function(_a) {
          this.path(parsePathForBorder(curvePoints, side))
          this.ctx.fillStyle = asString(color)
          this.ctx.fill()
          return [2 /*return*/]
        })
      })
    }
    CanvasRenderer.prototype.renderDoubleBorder = function(color, width, side, curvePoints) {
      return __awaiter(this, void 0, void 0, function() {
        var outerPaths, innerPaths
        return __generator(this, function(_a) {
          switch (_a.label) {
            case 0:
              if (!(width < 3)) return [3 /*break*/, 2]
              return [4 /*yield*/, this.renderSolidBorder(color, side, curvePoints)]
            case 1:
              _a.sent()
              return [2 /*return*/]
            case 2:
              outerPaths = parsePathForBorderDoubleOuter(curvePoints, side)
              this.path(outerPaths)
              this.ctx.fillStyle = asString(color)
              this.ctx.fill()
              innerPaths = parsePathForBorderDoubleInner(curvePoints, side)
              this.path(innerPaths)
              this.ctx.fill()
              return [2 /*return*/]
          }
        })
      })
    }
    CanvasRenderer.prototype.renderNodeBackgroundAndBorders = function(paint) {
      return __awaiter(this, void 0, void 0, function() {
        var styles, hasBackground, borders, backgroundPaintingArea, side, _i, borders_1, border
        var _this = this
        return __generator(this, function(_a) {
          switch (_a.label) {
            case 0:
              this.applyEffects(paint.getEffects(2 /* BACKGROUND_BORDERS */))
              styles = paint.container.styles
              hasBackground =
                !isTransparent(styles.backgroundColor) || styles.backgroundImage.length
              borders = [
                {
                  style: styles.borderTopStyle,
                  color: styles.borderTopColor,
                  width: styles.borderTopWidth,
                },
                {
                  style: styles.borderRightStyle,
                  color: styles.borderRightColor,
                  width: styles.borderRightWidth,
                },
                {
                  style: styles.borderBottomStyle,
                  color: styles.borderBottomColor,
                  width: styles.borderBottomWidth,
                },
                {
                  style: styles.borderLeftStyle,
                  color: styles.borderLeftColor,
                  width: styles.borderLeftWidth,
                },
              ]
              backgroundPaintingArea = calculateBackgroundCurvedPaintingArea(
                getBackgroundValueForIndex(styles.backgroundClip, 0),
                paint.curves
              )
              if (!(hasBackground || styles.boxShadow.length)) return [3 /*break*/, 2]
              this.ctx.save()
              this.path(backgroundPaintingArea)
              this.ctx.clip()
              if (!isTransparent(styles.backgroundColor)) {
                this.ctx.fillStyle = asString(styles.backgroundColor)
                this.ctx.fill()
              }
              return [4 /*yield*/, this.renderBackgroundImage(paint.container)]
            case 1:
              _a.sent()
              this.ctx.restore()
              styles.boxShadow
                .slice(0)
                .reverse()
                .forEach(function(shadow) {
                  _this.ctx.save()
                  var borderBoxArea = calculateBorderBoxPath(paint.curves)
                  var maskOffset = shadow.inset ? 0 : MASK_OFFSET
                  var shadowPaintingArea = transformPath(
                    borderBoxArea,
                    -maskOffset + (shadow.inset ? 1 : -1) * shadow.spread.number,
                    (shadow.inset ? 1 : -1) * shadow.spread.number,
                    shadow.spread.number * (shadow.inset ? -2 : 2),
                    shadow.spread.number * (shadow.inset ? -2 : 2)
                  )
                  if (shadow.inset) {
                    _this.path(borderBoxArea)
                    _this.ctx.clip()
                    _this.mask(shadowPaintingArea)
                  } else {
                    _this.mask(borderBoxArea)
                    _this.ctx.clip()
                    _this.path(shadowPaintingArea)
                  }
                  _this.ctx.shadowOffsetX = shadow.offsetX.number + maskOffset
                  _this.ctx.shadowOffsetY = shadow.offsetY.number
                  _this.ctx.shadowColor = asString(shadow.color)
                  _this.ctx.shadowBlur = shadow.blur.number
                  _this.ctx.fillStyle = shadow.inset ? asString(shadow.color) : 'rgba(0,0,0,1)'
                  _this.ctx.fill()
                  _this.ctx.restore()
                })
              _a.label = 2
            case 2:
              side = 0
              ;(_i = 0), (borders_1 = borders)
              _a.label = 3
            case 3:
              if (!(_i < borders_1.length)) return [3 /*break*/, 13]
              border = borders_1[_i]
              if (
                !(border.style !== 0 /* NONE */ && !isTransparent(border.color) && border.width > 0)
              )
                return [3 /*break*/, 11]
              if (!((border.style === 2) /* DASHED */)) return [3 /*break*/, 5]
              return [
                4 /*yield*/,
                this.renderDashedDottedBorder(
                  border.color,
                  border.width,
                  side,
                  paint.curves,
                  2 /* DASHED */
                ),
              ]
            case 4:
              _a.sent()
              return [3 /*break*/, 11]
            case 5:
              if (!((border.style === 3) /* DOTTED */)) return [3 /*break*/, 7]
              return [
                4 /*yield*/,
                this.renderDashedDottedBorder(
                  border.color,
                  border.width,
                  side,
                  paint.curves,
                  3 /* DOTTED */
                ),
              ]
            case 6:
              _a.sent()
              return [3 /*break*/, 11]
            case 7:
              if (!((border.style === 4) /* DOUBLE */)) return [3 /*break*/, 9]
              return [
                4 /*yield*/,
                this.renderDoubleBorder(border.color, border.width, side, paint.curves),
              ]
            case 8:
              _a.sent()
              return [3 /*break*/, 11]
            case 9:
              return [4 /*yield*/, this.renderSolidBorder(border.color, side, paint.curves)]
            case 10:
              _a.sent()
              _a.label = 11
            case 11:
              side++
              _a.label = 12
            case 12:
              _i++
              return [3 /*break*/, 3]
            case 13:
              return [2 /*return*/]
          }
        })
      })
    }
    CanvasRenderer.prototype.renderDashedDottedBorder = function(
      color,
      width,
      side,
      curvePoints,
      style
    ) {
      return __awaiter(this, void 0, void 0, function() {
        var strokePaths,
          boxPaths,
          startX,
          startY,
          endX,
          endY,
          length,
          dashLength,
          spaceLength,
          useLineDash,
          multiplier,
          numberOfDashes,
          minSpace,
          maxSpace,
          path1,
          path2,
          path1,
          path2
        return __generator(this, function(_a) {
          this.ctx.save()
          strokePaths = parsePathForBorderStroke(curvePoints, side)
          boxPaths = parsePathForBorder(curvePoints, side)
          if (style === 2 /* DASHED */) {
            this.path(boxPaths)
            this.ctx.clip()
          }
          if (isBezierCurve(boxPaths[0])) {
            startX = boxPaths[0].start.x
            startY = boxPaths[0].start.y
          } else {
            startX = boxPaths[0].x
            startY = boxPaths[0].y
          }
          if (isBezierCurve(boxPaths[1])) {
            endX = boxPaths[1].end.x
            endY = boxPaths[1].end.y
          } else {
            endX = boxPaths[1].x
            endY = boxPaths[1].y
          }
          if (side === 0 || side === 2) {
            length = Math.abs(startX - endX)
          } else {
            length = Math.abs(startY - endY)
          }
          this.ctx.beginPath()
          if (style === 3 /* DOTTED */) {
            this.formatPath(strokePaths)
          } else {
            this.formatPath(boxPaths.slice(0, 2))
          }
          dashLength = width < 3 ? width * 3 : width * 2
          spaceLength = width < 3 ? width * 2 : width
          if (style === 3 /* DOTTED */) {
            dashLength = width
            spaceLength = width
          }
          useLineDash = true
          if (length <= dashLength * 2) {
            useLineDash = false
          } else if (length <= dashLength * 2 + spaceLength) {
            multiplier = length / (2 * dashLength + spaceLength)
            dashLength *= multiplier
            spaceLength *= multiplier
          } else {
            numberOfDashes = Math.floor((length + spaceLength) / (dashLength + spaceLength))
            minSpace = (length - numberOfDashes * dashLength) / (numberOfDashes - 1)
            maxSpace = (length - (numberOfDashes + 1) * dashLength) / numberOfDashes
            spaceLength =
              maxSpace <= 0 || Math.abs(spaceLength - minSpace) < Math.abs(spaceLength - maxSpace)
                ? minSpace
                : maxSpace
          }
          if (useLineDash) {
            if (style === 3 /* DOTTED */) {
              this.ctx.setLineDash([0, dashLength + spaceLength])
            } else {
              this.ctx.setLineDash([dashLength, spaceLength])
            }
          }
          if (style === 3 /* DOTTED */) {
            this.ctx.lineCap = 'round'
            this.ctx.lineWidth = width
          } else {
            this.ctx.lineWidth = width * 2 + 1.1
          }
          this.ctx.strokeStyle = asString(color)
          this.ctx.stroke()
          this.ctx.setLineDash([])
          // dashed round edge gap
          if (style === 2 /* DASHED */) {
            if (isBezierCurve(boxPaths[0])) {
              path1 = boxPaths[3]
              path2 = boxPaths[0]
              this.ctx.beginPath()
              this.formatPath([
                new Vector(path1.end.x, path1.end.y),
                new Vector(path2.start.x, path2.start.y),
              ])
              this.ctx.stroke()
            }
            if (isBezierCurve(boxPaths[1])) {
              path1 = boxPaths[1]
              path2 = boxPaths[2]
              this.ctx.beginPath()
              this.formatPath([
                new Vector(path1.end.x, path1.end.y),
                new Vector(path2.start.x, path2.start.y),
              ])
              this.ctx.stroke()
            }
          }
          this.ctx.restore()
          return [2 /*return*/]
        })
      })
    }
    CanvasRenderer.prototype.render = function(element) {
      return __awaiter(this, void 0, void 0, function() {
        var stack
        return __generator(this, function(_a) {
          switch (_a.label) {
            case 0:
              if (this.options.backgroundColor) {
                this.ctx.fillStyle = asString(this.options.backgroundColor)
                this.ctx.fillRect(
                  this.options.x,
                  this.options.y,
                  this.options.width,
                  this.options.height
                )
              }
              stack = parseStackingContexts(element)
              return [4 /*yield*/, this.renderStack(stack)]
            case 1:
              _a.sent()
              this.applyEffects([])
              return [2 /*return*/, this.canvas]
          }
        })
      })
    }
    return CanvasRenderer
  })(Renderer)
  var isTextInputElement = function(container) {
    if (container instanceof TextareaElementContainer) {
      return true
    } else if (container instanceof SelectElementContainer) {
      return true
    } else if (
      container instanceof InputElementContainer &&
      container.type !== RADIO &&
      container.type !== CHECKBOX
    ) {
      return true
    }
    return false
  }
  var calculateBackgroundCurvedPaintingArea = function(clip, curves) {
    switch (clip) {
      case 0 /* BORDER_BOX */:
        return calculateBorderBoxPath(curves)
      case 2 /* CONTENT_BOX */:
        return calculateContentBoxPath(curves)
      case 1 /* PADDING_BOX */:
      default:
        return calculatePaddingBoxPath(curves)
    }
  }
  var canvasTextAlign = function(textAlign) {
    switch (textAlign) {
      case 1 /* CENTER */:
        return 'center'
      case 2 /* RIGHT */:
        return 'right'
      case 0 /* LEFT */:
      default:
        return 'left'
    }
  }
  // see https://github.com/niklasvh/html2canvas/pull/2645
  var iOSBrokenFonts = ['-apple-system', 'system-ui']
  var fixIOSSystemFonts = function(fontFamilies) {
    return /iPhone OS 15_(0|1)/.test(window.navigator.userAgent)
      ? fontFamilies.filter(function(fontFamily) {
          return iOSBrokenFonts.indexOf(fontFamily) === -1
        })
      : fontFamilies
  }

  var ForeignObjectRenderer = /** @class */ (function(_super) {
    __extends(ForeignObjectRenderer, _super)
    function ForeignObjectRenderer(context, options) {
      var _this = _super.call(this, context, options) || this
      _this.canvas = options.canvas ? options.canvas : document.createElement('canvas')
      _this.ctx = _this.canvas.getContext('2d')
      _this.options = options
      _this.canvas.width = Math.floor(options.width * options.scale)
      _this.canvas.height = Math.floor(options.height * options.scale)
      _this.canvas.style.width = options.width + 'px'
      _this.canvas.style.height = options.height + 'px'
      _this.ctx.scale(_this.options.scale, _this.options.scale)
      _this.ctx.translate(-options.x, -options.y)
      _this.context.logger.debug(
        'EXPERIMENTAL ForeignObject renderer initialized (' +
          options.width +
          'x' +
          options.height +
          ' at ' +
          options.x +
          ',' +
          options.y +
          ') with scale ' +
          options.scale
      )
      return _this
    }
    ForeignObjectRenderer.prototype.render = function(element) {
      return __awaiter(this, void 0, void 0, function() {
        var svg, img
        return __generator(this, function(_a) {
          switch (_a.label) {
            case 0:
              svg = createForeignObjectSVG(
                this.options.width * this.options.scale,
                this.options.height * this.options.scale,
                this.options.scale,
                this.options.scale,
                element
              )
              return [4 /*yield*/, loadSerializedSVG(svg)]
            case 1:
              img = _a.sent()
              if (this.options.backgroundColor) {
                this.ctx.fillStyle = asString(this.options.backgroundColor)
                this.ctx.fillRect(
                  0,
                  0,
                  this.options.width * this.options.scale,
                  this.options.height * this.options.scale
                )
              }
              this.ctx.drawImage(
                img,
                -this.options.x * this.options.scale,
                -this.options.y * this.options.scale
              )
              return [2 /*return*/, this.canvas]
          }
        })
      })
    }
    return ForeignObjectRenderer
  })(Renderer)
  var loadSerializedSVG = function(svg) {
    return new Promise(function(resolve, reject) {
      var img = new Image()
      img.onload = function() {
        resolve(img)
      }
      img.onerror = reject
      img.src =
        'data:image/svg+xml;charset=utf-8,' +
        encodeURIComponent(new XMLSerializer().serializeToString(svg))
    })
  }

  var Logger = /** @class */ (function() {
    function Logger(_a) {
      var id = _a.id,
        enabled = _a.enabled
      this.id = id
      this.enabled = enabled
      this.start = Date.now()
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Logger.prototype.debug = function() {
      var args = []
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i]
      }
      if (this.enabled) {
        // eslint-disable-next-line no-console
        if (
          typeof window !== 'undefined' &&
          window.console &&
          typeof console.debug === 'function'
        ) {
          // eslint-disable-next-line no-console
        } else {
          this.info.apply(this, args)
        }
      }
    }
    Logger.prototype.getTime = function() {
      return Date.now() - this.start
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Logger.prototype.info = function() {
      var args = []
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i]
      }
      if (this.enabled) {
        // eslint-disable-next-line no-console
        if (typeof window !== 'undefined' && window.console && typeof console.info === 'function') {
          // eslint-disable-next-line no-console
        }
      }
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Logger.prototype.warn = function() {
      var args = []
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i]
      }
      if (this.enabled) {
        // eslint-disable-next-line no-console
        if (typeof window !== 'undefined' && window.console && typeof console.warn === 'function') {
          // eslint-disable-next-line no-console
        } else {
          this.info.apply(this, args)
        }
      }
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Logger.prototype.error = function() {
      var args = []
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i]
      }
      if (this.enabled) {
        // eslint-disable-next-line no-console
        if (
          typeof window !== 'undefined' &&
          window.console &&
          typeof console.error === 'function'
        ) {
          // eslint-disable-next-line no-console
        } else {
          this.info.apply(this, args)
        }
      }
    }
    Logger.instances = {}
    return Logger
  })()

  var Context = /** @class */ (function() {
    function Context(options, windowBounds) {
      var _a
      this.windowBounds = windowBounds
      this.instanceName = '#' + Context.instanceCount++
      this.logger = new Logger({ id: this.instanceName, enabled: options.logging })
      this.cache = (_a = options.cache) !== null && _a !== void 0 ? _a : new Cache(this, options)
    }
    Context.instanceCount = 1
    return Context
  })()

  var html2canvas = function(element, options) {
    if (options === void 0) {
      options = {}
    }
    return renderElement(element, options)
  }
  if (typeof window !== 'undefined') {
    CacheStorage.setContext(window)
  }
  var renderElement = function(element, opts) {
    return __awaiter(void 0, void 0, void 0, function() {
      var ownerDocument,
        defaultView,
        resourceOptions,
        contextOptions,
        windowOptions,
        windowBounds,
        context,
        foreignObjectRendering,
        cloneOptions,
        documentCloner,
        clonedElement,
        container,
        _a,
        width,
        height,
        left,
        top,
        backgroundColor,
        renderOptions,
        canvas,
        renderer,
        root,
        renderer
      var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t
      return __generator(this, function(_u) {
        switch (_u.label) {
          case 0:
            if (!element || typeof element !== 'object') {
              return [2 /*return*/, Promise.reject('Invalid element provided as first argument')]
            }
            ownerDocument = element.ownerDocument
            if (!ownerDocument) {
              throw new Error('Element is not attached to a Document')
            }
            defaultView = ownerDocument.defaultView
            if (!defaultView) {
              throw new Error('Document is not attached to a Window')
            }
            resourceOptions = {
              allowTaint: (_b = opts.allowTaint) !== null && _b !== void 0 ? _b : false,
              imageTimeout: (_c = opts.imageTimeout) !== null && _c !== void 0 ? _c : 15000,
              proxy: opts.proxy,
              useCORS: (_d = opts.useCORS) !== null && _d !== void 0 ? _d : false,
            }
            contextOptions = __assign(
              {
                logging: (_e = opts.logging) !== null && _e !== void 0 ? _e : true,
                cache: opts.cache,
              },
              resourceOptions
            )
            windowOptions = {
              windowWidth:
                (_f = opts.windowWidth) !== null && _f !== void 0 ? _f : defaultView.innerWidth,
              windowHeight:
                (_g = opts.windowHeight) !== null && _g !== void 0 ? _g : defaultView.innerHeight,
              scrollX: (_h = opts.scrollX) !== null && _h !== void 0 ? _h : defaultView.pageXOffset,
              scrollY: (_j = opts.scrollY) !== null && _j !== void 0 ? _j : defaultView.pageYOffset,
            }
            windowBounds = new Bounds(
              windowOptions.scrollX,
              windowOptions.scrollY,
              windowOptions.windowWidth,
              windowOptions.windowHeight
            )
            context = new Context(contextOptions, windowBounds)
            foreignObjectRendering =
              (_k = opts.foreignObjectRendering) !== null && _k !== void 0 ? _k : false
            cloneOptions = {
              allowTaint: (_l = opts.allowTaint) !== null && _l !== void 0 ? _l : false,
              onclone: opts.onclone,
              ignoreElements: opts.ignoreElements,
              inlineImages: foreignObjectRendering,
              copyStyles: foreignObjectRendering,
            }
            context.logger.debug(
              'Starting document clone with size ' +
                windowBounds.width +
                'x' +
                windowBounds.height +
                ' scrolled to ' +
                -windowBounds.left +
                ',' +
                -windowBounds.top
            )
            documentCloner = new DocumentCloner(context, element, cloneOptions)
            clonedElement = documentCloner.clonedReferenceElement
            if (!clonedElement) {
              return [2 /*return*/, Promise.reject('Unable to find element in cloned iframe')]
            }
            return [4 /*yield*/, documentCloner.toIFrame(ownerDocument, windowBounds)]
          case 1:
            container = _u.sent()
            ;(_a =
              isBodyElement(clonedElement) || isHTMLElement(clonedElement)
                ? parseDocumentSize(clonedElement.ownerDocument)
                : parseBounds(context, clonedElement)),
              (width = _a.width),
              (height = _a.height),
              (left = _a.left),
              (top = _a.top)
            backgroundColor = parseBackgroundColor(context, clonedElement, opts.backgroundColor)
            renderOptions = {
              canvas: opts.canvas,
              backgroundColor: backgroundColor,
              scale:
                (_o =
                  (_m = opts.scale) !== null && _m !== void 0
                    ? _m
                    : defaultView.devicePixelRatio) !== null && _o !== void 0
                  ? _o
                  : 1,
              x: ((_p = opts.x) !== null && _p !== void 0 ? _p : 0) + left,
              y: ((_q = opts.y) !== null && _q !== void 0 ? _q : 0) + top,
              width: (_r = opts.width) !== null && _r !== void 0 ? _r : Math.ceil(width),
              height: (_s = opts.height) !== null && _s !== void 0 ? _s : Math.ceil(height),
            }
            if (!foreignObjectRendering) return [3 /*break*/, 3]
            context.logger.debug('Document cloned, using foreign object rendering')
            renderer = new ForeignObjectRenderer(context, renderOptions)
            return [4 /*yield*/, renderer.render(clonedElement)]
          case 2:
            canvas = _u.sent()
            return [3 /*break*/, 5]
          case 3:
            context.logger.debug(
              'Document cloned, element located at ' +
                left +
                ',' +
                top +
                ' with size ' +
                width +
                'x' +
                height +
                ' using computed rendering'
            )
            context.logger.debug('Starting DOM parsing')
            root = parseTree(context, clonedElement)
            if (backgroundColor === root.styles.backgroundColor) {
              root.styles.backgroundColor = COLORS.TRANSPARENT
            }
            context.logger.debug(
              'Starting renderer for element at ' +
                renderOptions.x +
                ',' +
                renderOptions.y +
                ' with size ' +
                renderOptions.width +
                'x' +
                renderOptions.height
            )
            renderer = new CanvasRenderer(context, renderOptions)
            return [4 /*yield*/, renderer.render(root)]
          case 4:
            canvas = _u.sent()
            _u.label = 5
          case 5:
            if ((_t = opts.removeContainer) !== null && _t !== void 0 ? _t : true) {
              if (!DocumentCloner.destroy(container)) {
                context.logger.error('Cannot detach cloned iframe as it is not in the DOM anymore')
              }
            }
            context.logger.debug('Finished rendering')
            return [2 /*return*/, canvas]
        }
      })
    })
  }
  var parseBackgroundColor = function(context, element, backgroundColorOverride) {
    var ownerDocument = element.ownerDocument
    // http://www.w3.org/TR/css3-background/#special-backgrounds
    var documentBackgroundColor = ownerDocument.documentElement
      ? parseColor(context, getComputedStyle(ownerDocument.documentElement).backgroundColor)
      : COLORS.TRANSPARENT
    var bodyBackgroundColor = ownerDocument.body
      ? parseColor(context, getComputedStyle(ownerDocument.body).backgroundColor)
      : COLORS.TRANSPARENT
    var defaultBackgroundColor =
      typeof backgroundColorOverride === 'string'
        ? parseColor(context, backgroundColorOverride)
        : backgroundColorOverride === null
        ? COLORS.TRANSPARENT
        : 0xffffffff
    return element === ownerDocument.documentElement
      ? isTransparent(documentBackgroundColor)
        ? isTransparent(bodyBackgroundColor)
          ? defaultBackgroundColor
          : bodyBackgroundColor
        : documentBackgroundColor
      : defaultBackgroundColor
  }

  function getNodeLocal(player, nodePtr) {
    var _a, _b, _c, _d
    return __awaiter$1(this, void 0, void 0, function*() {
      const isNode = yield (_a = player.Native) === null || _a === void 0
        ? void 0
        : _a.NodeProxy.isNode(nodePtr)
      if (!isNode)
        return {
          status: false,
          message: 'nodePtr不是一个节点对象',
        }
      let localPos = {
        Position: [],
        Rotate: [],
        Scale: [],
      }
      localPos.Position = yield (_b = player.Native) === null || _b === void 0
        ? void 0
        : _b.NodeProxy.localTranslation(nodePtr)
      localPos.Rotate = yield (_c = player.Native) === null || _c === void 0
        ? void 0
        : _c.NodeProxy.localRotation(nodePtr)
      localPos.Scale = yield (_d = player.Native) === null || _d === void 0
        ? void 0
        : _d.NodeProxy.localScaling(nodePtr)
      return {
        status: true,
        data: localPos,
        message: '',
      }
    })
  }
  function ToRGB(color) {
    const regex = /\((.*?)\)/
    const res = regex.exec(color)
    if (res && res.length > 1) {
      const numArr = res[1].split(',')
      const r = numArr[0] << 24
      const g = numArr[1] << 16
      const b = numArr[2] << 8
      const a = Math.round(numArr[3] * 255)
      return r + g + b + a
    }
    return null
  }
  // 将颜色转为十进制
  function dealColorToNumber(param) {
    let color = param.toString()
    let type = null
    const regex = /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6}|[0-9A-Fa-f]{8})$/
    const regexRGBA = /^rgba\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*,\s*(0(\.\d+)?|1(\.0+)?)\s*\)$/i
    const regex0X = /^0x[0-9A-Fa-f]{6}$/i
    const regexNumber = /^\d+$/
    // 颜色类型校验
    regex.test(color) ? (type = 1) : null
    regex0X.test(color) ? (type = 2) : null
    regexRGBA.test(color) ? (type = 3) : null
    regexNumber.test(color) ? (type = 4) : null
    let colorNum = null
    switch (type) {
      case 1:
        //#十六进制
        if (color.length == 9) {
          color = color.replace('#', '0x')
        } else {
          color = color.replace('#', '0x') + 'ff'
        }
        colorNum = Number(color)
        break
      case 2:
        colorNum = Number(color)
        break
      case 3:
        colorNum = ToRGB(color)
        break
      case 4:
        colorNum = parseInt(color)
        break
      default:
        colorNum = null
        break
    }
    if (!colorNum) return { status: false, message: '不支持该类型颜色' }
    return {
      status: true,
      data: colorNum,
      message: '颜色转换完成',
    }
  }
  function isValidKey(key, object) {
    return key in object
  }

  const WIDTH_SIZE_MAP = {
    min: 6,
    mid: 12,
    max: 20,
  }
  const HEIGHT_SIZE_MAP = {
    min: 3,
    mid: 6,
    max: 10,
  }
  class Marker {
    /**
     * @description: 单行标签创建
     * @param {IPlayer} player
     * @param {IMarkSingleLineOption} markSingleLineOption
     * @return {*}
     */
    static createBySingleLine(player, markSingleLineOption) {
      var _a, _b
      return __awaiter$1(this, void 0, void 0, function*() {
        if (!checkPlayerLoad(player)) {
          // 加载失败
          return {
            status: false,
            message: 'player无效',
          }
        }
        if (!Array.isArray(markSingleLineOption)) {
          markSingleLineOption = [markSingleLineOption]
        }
        // 加载标签
        // 计算文本大小
        markSingleLineOption = fetchTextStyle(markSingleLineOption)
        // 获取需要加载标签的列表
        const createIds = []
        // 整理图片
        const imgList = fetchImgList('single', markSingleLineOption)
        const imgIdList = yield (_a = player.Native) === null || _a === void 0
          ? void 0
          : _a.GisMarker.loadImages(imgList)
        // 批量加载标签
        const optionList = fetchSingleMarkerOption(markSingleLineOption, imgIdList)
        const optionsPtr = yield (_b = player.Native) === null || _b === void 0
          ? void 0
          : _b.GisMarker.batchCreate(optionList)
        this.currentLoadMarkers.push(
          ...optionsPtr.map((el, index) => {
            const id = markSingleLineOption[index].id || generateUUID()
            createIds.push(id)
            return {
              id,
              pointer: el,
              type: 'single',
              markOption: markSingleLineOption[index],
              realOption: optionList[index],
            }
          })
        )
        return {
          status: true,
          message: '加载成功',
          data: createIds,
        }
      })
    }
    /**
     * @description: 单行标签的更新
     * @param {IPlayer} player
     * @param {IMarkSingleLineOption} markSingleLineOption
     * @return {*}
     */
    static updateBySingleLine(player, markSingleLineOption) {
      var _a, _b
      return __awaiter$1(this, void 0, void 0, function*() {
        if (!checkPlayerLoad(player)) {
          // 加载失败
          return {
            status: false,
            message: 'player无效',
          }
        }
        if (!Array.isArray(markSingleLineOption)) {
          markSingleLineOption = [markSingleLineOption]
        }
        // 过滤掉类型不为single的数据
        const markerSingleList = this.currentLoadMarkers.filter((el) => {
          return el.type === 'single'
        })
        const arrayHasId = markSingleLineOption.every((el) => {
          return (
            !!el.id &&
            markerSingleList.find((item) => {
              return item.id === el.id
            })
          )
        })
        if (!arrayHasId) {
          return {
            status: false,
            message: '更新标记时,每项需要传递id, 且当前id创建的标签未单行类型的标签',
          }
        }
        // 处理选项
        markSingleLineOption = markSingleLineOption.map((element) => {
          // 获取当前id关联的标记
          const currentData = this.currentLoadMarkers.find((item) => {
            return item.id === element.id
          })
          return Object.assign(
            Object.assign(
              {},
              currentData === null || currentData === void 0 ? void 0 : currentData.markOption
            ),
            element
          )
        })
        // 计算文本大小
        markSingleLineOption = fetchTextStyle(markSingleLineOption)
        // 整理图片
        const imgList = fetchImgList('single', markSingleLineOption)
        const imgIdList = yield (_a = player.Native) === null || _a === void 0
          ? void 0
          : _a.GisMarker.loadImages(imgList)
        // 批量加载标签
        let optionList = fetchSingleMarkerOption(markSingleLineOption, imgIdList)
        // 过滤掉相同的配置项
        const batchUpdateData = optionList.map((el, index) => {
          const currentMarkerData = this.currentLoadMarkers.find((item) => {
            return item.id === markSingleLineOption[index].id
          })
          Object.entries(
            currentMarkerData === null || currentMarkerData === void 0
              ? void 0
              : currentMarkerData.realOption
          ).forEach((item) => {
            if (isValidKey(item[0], el)) {
              if (item[1] === el[item[0]]) {
                delete el[item[0]]
              }
            }
          })
          return {
            markerId:
              currentMarkerData === null || currentMarkerData === void 0
                ? void 0
                : currentMarkerData.pointer,
            options: el,
          }
        })
        yield (_b = player.Native) === null || _b === void 0
          ? void 0
          : _b.GisMarker.batchUpdate(batchUpdateData)
        // 更新option
        this.currentLoadMarkers.forEach((el, index) => {
          const currentIndex = markSingleLineOption.findIndex((i) => {
            return i.id === el.id
          })
          if (currentIndex !== -1) {
            el.markOption = markSingleLineOption[index]
            el.realOption = optionList[index]
          }
        })
        return {
          status: true,
          message: '更新成功',
        }
      })
    }
    // 多行标签
    static createByMultiLine(player, markMultiLineOption) {
      var _a, _b
      return __awaiter$1(this, void 0, void 0, function*() {
        if (!checkPlayerLoad(player)) {
          // 加载失败
          return {
            status: false,
            message: 'player无效',
          }
        }
        if (!Array.isArray(markMultiLineOption)) {
          markMultiLineOption = [markMultiLineOption]
        }
        // 计算文本大小
        markMultiLineOption = fetchTextStyleByMulti(markMultiLineOption)
        // 获取需要加载标签的列表
        const imgList = fetchImgList('multi', markMultiLineOption)
        const imgIdList = yield (_a = player.Native) === null || _a === void 0
          ? void 0
          : _a.GisMarker.loadImages(imgList)
        // 批量加载标签
        const optionList = fetchMultiMarkerOption(markMultiLineOption, imgIdList)
        const optionsPtr = yield (_b = player.Native) === null || _b === void 0
          ? void 0
          : _b.GisMarker.batchCreate(optionList)
        this.currentLoadMarkers.push(
          ...optionsPtr.map((el, index) => {
            return {
              id: markMultiLineOption[index].id || generateUUID(),
              pointer: el,
              type: 'multi',
              markOption: markMultiLineOption[index],
              realOption: optionList[index],
            }
          })
        )
        return {
          status: true,
          message: '加载成功',
        }
      })
    }
    /**
     * @description: 更新多行标签
     * @param {IPlayer} player
     * @param {IMarkMultiLineOption} markMultiLineOption
     * @return {*}
     */
    static updateByMultiLine(player, markMultiLineOption) {
      var _a, _b
      return __awaiter$1(this, void 0, void 0, function*() {
        if (!checkPlayerLoad(player)) {
          // 加载失败
          return {
            status: false,
            message: 'player无效',
          }
        }
        if (!Array.isArray(markMultiLineOption)) {
          markMultiLineOption = [markMultiLineOption]
        }
        // 过滤掉类型不为single的数据
        const markerMultiList = this.currentLoadMarkers.filter((el) => {
          return el.type === 'single'
        })
        const arrayHasId = markMultiLineOption.every((el) => {
          return (
            !!el.id &&
            markerMultiList.find((item) => {
              return item.id === el.id
            })
          )
        })
        if (!arrayHasId) {
          return {
            status: false,
            message: '更新标记时,每项需要传递id, 且当前id创建的标签未多行类型的标签',
          }
        }
        // 处理选项
        markMultiLineOption = markMultiLineOption.map((element) => {
          // 获取当前id关联的标记
          const currentData = this.currentLoadMarkers.find((item) => {
            return item.id === element.id
          })
          return Object.assign(
            Object.assign(
              {},
              currentData === null || currentData === void 0 ? void 0 : currentData.markOption
            ),
            element
          )
        })
        // 计算文本大小
        markMultiLineOption = fetchTextStyleByMulti(markMultiLineOption)
        // 整理图片
        const imgList = fetchImgList('multi', markMultiLineOption)
        const imgIdList = yield (_a = player.Native) === null || _a === void 0
          ? void 0
          : _a.GisMarker.loadImages(imgList)
        // 批量加载标签
        let optionList = fetchMultiMarkerOption(markMultiLineOption, imgIdList)
        // 过滤掉相同的配置项
        const batchUpdateData = optionList.map((el, index) => {
          const currentMarkerData = this.currentLoadMarkers.find((item) => {
            return item.id === markMultiLineOption[index].id
          })
          Object.entries(
            currentMarkerData === null || currentMarkerData === void 0
              ? void 0
              : currentMarkerData.realOption
          ).forEach((item) => {
            if (isValidKey(item[0], el)) {
              if (item[1] === el[item[0]]) {
                delete el[item[0]]
              }
            }
          })
          return {
            markerId:
              currentMarkerData === null || currentMarkerData === void 0
                ? void 0
                : currentMarkerData.pointer,
            options: el,
          }
        })
        yield (_b = player.Native) === null || _b === void 0
          ? void 0
          : _b.GisMarker.batchUpdate(batchUpdateData)
        // 更新option
        this.currentLoadMarkers.forEach((el, index) => {
          const currentIndex = markMultiLineOption.findIndex((i) => {
            return i.id === el.id
          })
          if (currentIndex !== -1) {
            el.markOption = markMultiLineOption[index]
            el.realOption = optionList[index]
          }
        })
        return {
          status: true,
          message: '更新成功',
        }
      })
    }
    // 圆形标签
    static createByRound(player, markRoundOption) {
      var _a, _b
      return __awaiter$1(this, void 0, void 0, function*() {
        if (!checkPlayerLoad(player)) {
          // 加载失败
          return {
            status: false,
            message: 'player无效',
          }
        }
        if (!Array.isArray(markRoundOption)) {
          markRoundOption = [markRoundOption]
        }
        // 获取需要加载标签的列表
        // 整理图片
        const imgList = fetchImgList('round', markRoundOption)
        const imgIdList = yield (_a = player.Native) === null || _a === void 0
          ? void 0
          : _a.GisMarker.loadImages(imgList)
        // 批量加载标签
        const optionList = fetchRoundMarkerOption(markRoundOption, imgIdList)
        const optionsPtr = yield (_b = player.Native) === null || _b === void 0
          ? void 0
          : _b.GisMarker.batchCreate(optionList)
        this.currentLoadMarkers.push(
          ...optionsPtr.map((el, index) => {
            return {
              id: markRoundOption[index].id || generateUUID(),
              pointer: el,
              type: 'round',
              markOption: markRoundOption[index],
              realOption: optionList[index],
            }
          })
        )
        return {
          status: true,
          message: '加载成功',
        }
      })
    }
    /**
     * @description: 更新圆形标签
     * @param {IPlayer} player
     * @param {IMarkRoundOption} markRoundOption
     * @return {*}
     */
    static updateByRound(player, markRoundOption) {
      var _a, _b
      return __awaiter$1(this, void 0, void 0, function*() {
        if (!checkPlayerLoad(player)) {
          // 加载失败
          return {
            status: false,
            message: 'player无效',
          }
        }
        if (!Array.isArray(markRoundOption)) {
          markRoundOption = [markRoundOption]
        }
        // 过滤掉类型不为round的数据
        const markerRoundList = this.currentLoadMarkers.filter((el) => {
          return el.type === 'round'
        })
        const arrayHasId = markRoundOption.every((el) => {
          return (
            !!el.id &&
            markerRoundList.find((item) => {
              return item.id === el.id
            })
          )
        })
        if (!arrayHasId) {
          return {
            status: false,
            message: '更新标记时,每项需要传递id, 且当前id已创建圆形类型的标签',
          }
        }
        // 处理选项
        markRoundOption = markRoundOption.map((element) => {
          // 获取当前id关联的标记
          const currentData = this.currentLoadMarkers.find((item) => {
            return item.id === element.id
          })
          return Object.assign(
            Object.assign(
              {},
              currentData === null || currentData === void 0 ? void 0 : currentData.markOption
            ),
            element
          )
        })
        // 整理图片
        const imgList = fetchImgList('round', markRoundOption)
        const imgIdList = yield (_a = player.Native) === null || _a === void 0
          ? void 0
          : _a.GisMarker.loadImages(imgList)
        // 批量加载标签
        let optionList = fetchRoundMarkerOption(markRoundOption, imgIdList)
        // 过滤掉相同的配置项
        const batchUpdateData = optionList.map((el, index) => {
          const currentMarkerData = this.currentLoadMarkers.find((item) => {
            return item.id === markRoundOption[index].id
          })
          Object.entries(
            currentMarkerData === null || currentMarkerData === void 0
              ? void 0
              : currentMarkerData.realOption
          ).forEach((item) => {
            if (isValidKey(item[0], el)) {
              if (item[1] === el[item[0]]) {
                delete el[item[0]]
              }
            }
          })
          return {
            markerId:
              currentMarkerData === null || currentMarkerData === void 0
                ? void 0
                : currentMarkerData.pointer,
            options: el,
          }
        })
        yield (_b = player.Native) === null || _b === void 0
          ? void 0
          : _b.GisMarker.batchUpdate(batchUpdateData)
        // 更新option
        this.currentLoadMarkers.forEach((el, index) => {
          const currentIndex = markRoundOption.findIndex((i) => {
            return i.id === el.id
          })
          if (currentIndex !== -1) {
            el.markOption = markRoundOption[index]
            el.realOption = optionList[index]
          }
        })
        return {
          status: true,
          message: '更新成功',
        }
      })
    }
    // 图片标签
    static createByPicture(player, markPictureOption) {
      var _a, _b
      return __awaiter$1(this, void 0, void 0, function*() {
        if (!checkPlayerLoad(player)) {
          // 加载失败
          return {
            status: false,
            message: 'player无效',
          }
        }
        if (!Array.isArray(markPictureOption)) {
          markPictureOption = [markPictureOption]
        }
        // 获取需要加载标签的列表
        const imgList = markPictureOption.map((element) => {
          return element.backgroundUrl
        })
        const imgIdList = yield (_a = player.Native) === null || _a === void 0
          ? void 0
          : _a.GisMarker.loadImages(imgList)
        // 批量加载标签
        const optionList = fetchPictureMarkerOption(markPictureOption, imgIdList)
        const optionsPtr = yield (_b = player.Native) === null || _b === void 0
          ? void 0
          : _b.GisMarker.batchCreate(optionList)
        this.currentLoadMarkers.push(
          ...optionsPtr.map((el, index) => {
            return {
              id: markPictureOption[index].id || generateUUID(),
              pointer: el,
              type: 'picture',
              markOption: markPictureOption[index],
              realOption: optionList[index],
            }
          })
        )
        return {
          status: true,
          message: '加载成功',
        }
      })
    }
    /**
     * @description: 更新图片标签
     * @param {IPlayer} player
     * @param {IMarkPictureOption} markPictureOption
     * @return {*}
     */
    static updateByPicture(player, markPictureOption) {
      var _a, _b
      return __awaiter$1(this, void 0, void 0, function*() {
        if (!checkPlayerLoad(player)) {
          // 加载失败
          return {
            status: false,
            message: 'player无效',
          }
        }
        if (!Array.isArray(markPictureOption)) {
          markPictureOption = [markPictureOption]
        }
        // 过滤掉类型不为picture的数据
        const markerPictureList = this.currentLoadMarkers.filter((el) => {
          return el.type === 'picture'
        })
        const arrayHasId = markPictureOption.every((el) => {
          return (
            !!el.id &&
            markerPictureList.find((item) => {
              return item.id === el.id
            })
          )
        })
        if (!arrayHasId) {
          return {
            status: false,
            message: '更新标记时,每项需要传递id, 且当前id已创建图片类型的标签',
          }
        }
        // 处理选项
        markPictureOption = markPictureOption.map((element) => {
          // 获取当前id关联的标记
          const currentData = this.currentLoadMarkers.find((item) => {
            return item.id === element.id
          })
          return Object.assign(
            Object.assign(
              {},
              currentData === null || currentData === void 0 ? void 0 : currentData.markOption
            ),
            element
          )
        })
        // 整理图片
        // 获取需要加载标签的列表
        const imgList = markPictureOption.map((element) => {
          return element.backgroundUrl
        })
        const imgIdList = yield (_a = player.Native) === null || _a === void 0
          ? void 0
          : _a.GisMarker.loadImages(imgList)
        // 批量加载标签
        let optionList = fetchPictureMarkerOption(markPictureOption, imgIdList)
        // 过滤掉相同的配置项
        const batchUpdateData = optionList.map((el, index) => {
          const currentMarkerData = this.currentLoadMarkers.find((item) => {
            return item.id === markPictureOption[index].id
          })
          Object.entries(
            currentMarkerData === null || currentMarkerData === void 0
              ? void 0
              : currentMarkerData.realOption
          ).forEach((item) => {
            if (isValidKey(item[0], el)) {
              if (item[1] === el[item[0]]) {
                delete el[item[0]]
              }
            }
          })
          return {
            markerId:
              currentMarkerData === null || currentMarkerData === void 0
                ? void 0
                : currentMarkerData.pointer,
            options: el,
          }
        })
        yield (_b = player.Native) === null || _b === void 0
          ? void 0
          : _b.GisMarker.batchUpdate(batchUpdateData)
        // 更新option
        this.currentLoadMarkers.forEach((el, index) => {
          const currentIndex = markPictureOption.findIndex((i) => {
            return i.id === el.id
          })
          if (currentIndex !== -1) {
            el.markOption = markPictureOption[index]
            el.realOption = optionList[index]
          }
        })
        return {
          status: true,
          message: '更新成功',
        }
      })
    }
    // dom标签
    static createByDom(player, markDomOption) {
      var _a, _b
      return __awaiter$1(this, void 0, void 0, function*() {
        if (!checkPlayerLoad(player)) {
          // 加载失败
          return {
            status: false,
            message: 'player无效',
          }
        }
        if (!Array.isArray(markDomOption)) {
          markDomOption = [markDomOption]
        }
        const markDomList = markDomOption.map((el) => {
          return el.dom
        })
        const imgList = []
        for (let i = 0; i < 1; i++) {
          const element = markDomList[i]
          const convas = yield html2canvas(element, {})
          imgList.push(convas.toDataURL())
        }
        const imgIdList = yield (_a = player.Native) === null || _a === void 0
          ? void 0
          : _a.GisMarker.loadImages(imgList)
        // 批量加载标签
        const optionList = fetchDomOption(markDomOption, imgIdList)
        const optionsPtr = yield (_b = player.Native) === null || _b === void 0
          ? void 0
          : _b.GisMarker.batchCreate(optionList)
        this.currentLoadMarkers.push(
          ...optionsPtr.map((el, index) => {
            return {
              id: markDomOption[index].id || generateUUID(),
              pointer: el,
              type: 'dom',
              markOption: markDomOption[index],
              realOption: optionList[index],
            }
          })
        )
        return {
          status: true,
          message: '加载成功',
        }
      })
    }
    /**
     * @description: 更新dom标签
     * @param {IPlayer} player
     * @param {IMarkDomOption} markDomOption
     * @return {*}
     */
    static updateByDom(player, markDomOption) {
      var _a, _b
      return __awaiter$1(this, void 0, void 0, function*() {
        if (!checkPlayerLoad(player)) {
          // 加载失败
          return {
            status: false,
            message: 'player无效',
          }
        }
        if (!Array.isArray(markDomOption)) {
          markDomOption = [markDomOption]
        }
        // 过滤掉类型不为dom的数据
        const markerDomList = this.currentLoadMarkers.filter((el) => {
          return el.type === 'dom'
        })
        const arrayHasId = markDomOption.every((el) => {
          return (
            !!el.id &&
            markerDomList.find((item) => {
              return item.id === el.id
            })
          )
        })
        if (!arrayHasId) {
          return {
            status: false,
            message: '更新标记时,每项需要传递id, 且当前id已创建dom类型的标签',
          }
        }
        // 处理选项
        markDomOption = markDomOption.map((element) => {
          // 获取当前id关联的标记
          const currentData = this.currentLoadMarkers.find((item) => {
            return item.id === element.id
          })
          return Object.assign(
            Object.assign(
              {},
              currentData === null || currentData === void 0 ? void 0 : currentData.markOption
            ),
            element
          )
        })
        // 整理图片
        const markDomList = markDomOption.map((el) => {
          return el.dom
        })
        // 获取需要加载标签的列表
        const imgList = []
        for (let i = 0; i < 1; i++) {
          const element = markDomList[i]
          const convas = yield html2canvas(element, {})
          imgList.push(convas.toDataURL())
        }
        const imgIdList = yield (_a = player.Native) === null || _a === void 0
          ? void 0
          : _a.GisMarker.loadImages(imgList)
        // 批量加载标签
        let optionList = fetchDomOption(markDomOption, imgIdList)
        // 过滤掉相同的配置项
        const batchUpdateData = optionList.map((el, index) => {
          const currentMarkerData = this.currentLoadMarkers.find((item) => {
            return item.id === markDomOption[index].id
          })
          Object.entries(
            currentMarkerData === null || currentMarkerData === void 0
              ? void 0
              : currentMarkerData.realOption
          ).forEach((item) => {
            if (isValidKey(item[0], el)) {
              if (item[1] === el[item[0]]) {
                delete el[item[0]]
              }
            }
          })
          return {
            markerId:
              currentMarkerData === null || currentMarkerData === void 0
                ? void 0
                : currentMarkerData.pointer,
            options: el,
          }
        })
        yield (_b = player.Native) === null || _b === void 0
          ? void 0
          : _b.GisMarker.batchUpdate(batchUpdateData)
        // 更新option
        this.currentLoadMarkers.forEach((el, index) => {
          const currentIndex = markDomOption.findIndex((i) => {
            return i.id === el.id
          })
          if (currentIndex !== -1) {
            el.markOption = markDomOption[index]
            el.realOption = optionList[index]
          }
        })
        return {
          status: true,
          message: '更新成功',
        }
      })
    }
    // 销毁标签
    static destoryMarker(player, markerId) {
      var _a
      return __awaiter$1(this, void 0, void 0, function*() {
        if (!checkPlayerLoad(player)) {
          // 加载失败
          return {
            status: false,
            message: 'player无效',
          }
        }
        if (!Array.isArray(markerId)) {
          markerId = [markerId]
        }
        const removeMarker = this.currentLoadMarkers.filter((el) => {
          return markerId.includes(el.id)
        })
        this.currentLoadMarkers = this.currentLoadMarkers.filter((el) => {
          return !removeMarker.includes(el)
        })
        yield (_a = player.Native) === null || _a === void 0
          ? void 0
          : _a.GisMarker.batchDestroy(
              removeMarker.map((el) => {
                return el.pointer
              })
            )
        return {
          status: true,
          message: '卸载成功',
          data: markerId,
        }
      })
    }
  }
  Marker.WIDTH_SIZE_MAP = {
    min: 6,
    mid: 12,
    max: 20,
  }
  Marker.HEIGHT_SIZE_MAP = {
    min: 3,
    mid: 6,
    max: 10,
  }
  Marker.currentLoadMarkers = []
  /**
   * @description: 整理图片路径
   * @param {Array} optionList
   * @return {*}
   */
  function fetchImgList(type, optionList) {
    return optionList.map((element) => {
      if (element.background.includes('#')) {
        const rgba = hex2rgba(element.background)
        return `rgba:${rgba.r},${rgba.g},${rgba.b},${rgba.a}`
      } else {
        return `data://../apps/markers/${element.background}/${type}${(type === 'round'
          ? ''
          : `_${element.textSize}`) + (element.hasTriangle ? '_triangle' : '')}.png`
      }
    })
  }
  // 整理单行标签的样式
  function fetchTextStyle(optionList) {
    return optionList.map((element) => {
      const textLen = computedByteLen(
        (element === null || element === void 0 ? void 0 : element.text) || ''
      )
      const textWidth = computedTextWidth(
        (element === null || element === void 0 ? void 0 : element.text) || ''
      )
      element.textSize = 'min'
      element.textWidth = textWidth
      if (WIDTH_SIZE_MAP['mid'] <= textLen && textLen < WIDTH_SIZE_MAP['max']) {
        element.textSize = 'mid'
      } else if (WIDTH_SIZE_MAP['max'] <= textLen) {
        element.textSize = 'max'
      }
      return Object.assign({}, element)
    })
  }
  // 整理多行标签的样式
  function fetchTextStyleByMulti(optionList) {
    return optionList.map((element) => {
      const dataLen = element.dataList.length
      element.textSize = 'min'
      if (HEIGHT_SIZE_MAP['mid'] <= dataLen && dataLen < HEIGHT_SIZE_MAP['max']) {
        element.textSize = 'mid'
      } else if (HEIGHT_SIZE_MAP['max'] <= dataLen) {
        element.textSize = 'max'
      }
      return Object.assign({}, element)
    })
  }
  /**
   * @description: 整理单行标签的选项
   * @param {Array} markSingleLineOption
   * @param {Array} imgIdList
   * @return {*}
   */
  function fetchSingleMarkerOption(markSingleLineOption, imgIdList) {
    return markSingleLineOption.map((element, index) => {
      var _a, _b, _c
      // 判断是否带三角，若是背景颜色则不允许设置三角
      let imgSize = [0, 0]
      let padding = 0
      let contentPadding = [0, 0, 0, 0]
      if (!element.background.includes('#') && element.hasTriangle) {
        imgSize = [(element.textWidth || 0) + 20 > 80 ? (element.textWidth || 0) + 20 : 80, 42]
        padding = (element.textWidth || 0) + 20 > 80 ? 10 : (80 - (element.textWidth || 0)) / 2
        contentPadding = [padding, 10, padding, 20]
      } else {
        imgSize = [(element.textWidth || 0) + 20 > 80 ? (element.textWidth || 0) + 20 : 80, 32]
        padding = (element.textWidth || 0) + 20 > 80 ? 10 : (80 - (element.textWidth || 0)) / 2
        contentPadding = [padding, 10, padding, 10]
      }
      // 根据定位点位置 修改marker的nodeOffset
      const nodeOffset = fetchNodeOffset(
        (_a = element.markPosType) !== null && _a !== void 0 ? _a : EMarkPosType.leftTop,
        element.nodeOffset,
        imgSize
      )
      const option = {
        parentNode: (element === null || element === void 0 ? void 0 : element.parentNode) || null,
        pos: (element === null || element === void 0 ? void 0 : element.pos) || [0, 0, 0],
        visible:
          (_b = element === null || element === void 0 ? void 0 : element.visible) !== null &&
          _b !== void 0
            ? _b
            : true,
        size: -1,
        nodeOffset,
        imgId: imgIdList[index],
        imgSize,
        text: (element === null || element === void 0 ? void 0 : element.text) || '',
        fontSize: 14.0,
        breakWidth: -1,
        contentPadding,
        textColor: Number(
          ((_c = element === null || element === void 0 ? void 0 : element.textColor) === null ||
          _c === void 0
            ? void 0
            : _c.replace('#', '0x')) || 0xffffffff
        ),
        title: '',
        titleFontSize: 18.0,
        titleColor: 0xffffffff,
        userData: null, // 用户数据，仅帮外部系统保存数据
      }
      if (element.LodRange && element.LodRange.length > 2) {
        option.minLod = element.LodRange[0]
        option.maxLod = element.LodRange[1]
      }
      if (option.parentNode) delete option.pos
      return option
    })
  }
  /**
   * @description: 多行标签label定位
   * @param {Array} dataList
   * @return {*}
   */
  function fetchMutiTextAndWidth(dataList, alignLocation) {
    let text = ''
    let textWidth = 0
    if (dataList && dataList.every((i) => typeof i === 'string')) {
      const dataLenList = dataList.map((item) => {
        text = text + '\n' + item
        return computedTextWidth(item)
      })
      textWidth = Math.max(...dataLenList)
    } else {
      let dataKeyLenList = []
      let dataValueLenList = []
      // key value格式，分别算出key和value的最大宽度
      dataList.forEach((item) => {
        dataKeyLenList.push(computedTextWidth(item.label))
        dataValueLenList.push(computedTextWidth(item.value))
      })
      const keyMaxWidth = Math.max(...dataKeyLenList)
      const valueMaxWidth = Math.max(...dataValueLenList)
      const colonWidth = computedTextWidth(': ')
      textWidth = keyMaxWidth + valueMaxWidth + colonWidth
      // 将未达到最大宽度的文字，做补空处理
      // 获取一个空格所占的宽度
      const spaceWidth = computedTextWidth(' ')
      dataList.forEach((item, index) => {
        const labelLen = computedTextWidth(item.label)
        const emptyWidth = Math.ceil((keyMaxWidth - labelLen) / spaceWidth)
        if (emptyWidth > 0) {
          new Array(emptyWidth).fill(' ').join('')
        }
        if (alignLocation === 'left') {
          item.label = item.label + new Array(emptyWidth).fill(' ').join('')
        } else if (alignLocation === 'right') {
          item.label = new Array(emptyWidth).fill(' ').join('') + item.label
        }
        if (emptyWidth > 0) {
          item.label = new Array(emptyWidth).fill(' ').join('') + item.label
        }
        // 求出需要展示的文本
        if (index === 0) {
          text = item.label + ': ' + item.value
        } else {
          text += '\n' + item.label + ': ' + item.value
        }
      })
    }
    return { text, textWidth }
  }
  /**
   * @description: 整理多行标签的配置项
   * @param {Array} markMultiLineOption
   * @param {Array} imgIdList
   * @return {*}
   */
  function fetchMultiMarkerOption(markMultiLineOption, imgIdList) {
    // 计算最长的数据
    return markMultiLineOption.map((element, index) => {
      var _a, _b, _c
      const { text, textWidth } = fetchMutiTextAndWidth(element.dataList, element.alignLocation)
      let imgSize = [0, 0]
      let padding = 0
      let contentPadding = [0, 0, 0, 0]
      if (!element.background.includes('#') && element.hasTriangle) {
        imgSize = [textWidth + 20, 14 * element.dataList.length + 40]
        contentPadding = [10, 10, 10, 30]
      } else {
        imgSize = [
          (textWidth || 0) + 20 > 80 ? (textWidth || 0) + 20 : 80,
          16 * element.dataList.length + 20,
        ]
        padding = (textWidth || 0) + 20 > 80 ? 10 : (80 - (textWidth || 0)) / 2
        contentPadding = [padding, 10, padding, 10]
      }
      const nodeOffset = fetchNodeOffset(
        (_a = element.markPosType) !== null && _a !== void 0 ? _a : EMarkPosType.leftTop,
        element.nodeOffset,
        imgSize
      )
      const option = {
        parentNode: (element === null || element === void 0 ? void 0 : element.parentNode) || null,
        pos: (element === null || element === void 0 ? void 0 : element.pos) || [0, 0, 0],
        visible:
          (_b = element === null || element === void 0 ? void 0 : element.visible) !== null &&
          _b !== void 0
            ? _b
            : true,
        size: -1,
        nodeOffset,
        imgId: imgIdList[index],
        imgSize,
        text: text || '',
        fontSize: 14.0,
        breakWidth: -1,
        contentPadding,
        textColor: Number(
          ((_c = element === null || element === void 0 ? void 0 : element.textColor) === null ||
          _c === void 0
            ? void 0
            : _c.replace('#', '0x')) || 0xffffffff
        ),
        title: '',
        titleFontSize: 18.0,
        titleColor: 0xffffffff,
        userData: null, // 用户数据，仅帮外部系统保存数据
      }
      if (element.LodRange && element.LodRange.length > 2) {
        option.minLod = element.LodRange[0]
        option.maxLod = element.LodRange[1]
      }
      if (option.parentNode) delete option.pos
      return option
    })
  }
  /**
   * @description: 整理原型标签的配置项
   * @param {Array} markRoundOption
   * @param {Array} imgIdList
   * @return {*}
   */
  function fetchRoundMarkerOption(markRoundOption, imgIdList) {
    return markRoundOption.map((element, index) => {
      var _a, _b, _c
      const textWidth = computedTextWidth(
        (element === null || element === void 0 ? void 0 : element.text) || ''
      )
      let contentPadding = [0, 0, 0, 0]
      if (60 - textWidth > 0) {
        contentPadding = [
          (60 - textWidth) / 2,
          element.hasTriangle ? 20 : 22,
          (60 - textWidth) / 2,
          element.hasTriangle ? 20 : 22,
        ]
      } else {
        contentPadding = [0, element.hasTriangle ? 20 : 22, 0, element.hasTriangle ? 20 : 22]
      }
      const imgSize = [60, element.hasTriangle ? 64 : 60]
      const nodeOffset = fetchNodeOffset(
        (_a = element.markPosType) !== null && _a !== void 0 ? _a : EMarkPosType.leftTop,
        element.nodeOffset,
        imgSize
      )
      const option = {
        parentNode: (element === null || element === void 0 ? void 0 : element.parentNode) || null,
        pos: (element === null || element === void 0 ? void 0 : element.pos) || [0, 0, 0],
        visible:
          (_b = element === null || element === void 0 ? void 0 : element.visible) !== null &&
          _b !== void 0
            ? _b
            : true,
        size: -1,
        nodeOffset,
        imgId: imgIdList[index],
        imgSize,
        text: (element === null || element === void 0 ? void 0 : element.text) || '',
        fontSize: 14.0,
        breakWidth: -1,
        contentPadding,
        textColor: Number(
          ((_c = element === null || element === void 0 ? void 0 : element.textColor) === null ||
          _c === void 0
            ? void 0
            : _c.replace('#', '0x')) || 0xffffffff
        ),
        title: '',
        titleFontSize: 18.0,
        titleColor: 0xffffffff,
        userData: null, // 用户数据，仅帮外部系统保存数据
      }
      if (element.LodRange && element.LodRange.length > 2) {
        option.minLod = element.LodRange[0]
        option.maxLod = element.LodRange[1]
      }
      if (option.parentNode) delete option.pos
      return option
    })
  }
  /**
   * @description: 整理通过图片加载标签的配置项
   * @param {Array} markPictureOption
   * @param {Array} imgIdList
   * @return {*}
   */
  function fetchPictureMarkerOption(markPictureOption, imgIdList) {
    return markPictureOption.map((element, index) => {
      var _a, _b, _c
      const imgSize =
        (_a = element === null || element === void 0 ? void 0 : element.imgSize) !== null &&
        _a !== void 0
          ? _a
          : [-1, -1]
      let nodeOffset = element.nodeOffset
      if (element.imgSize) {
        nodeOffset = fetchNodeOffset(
          (_b = element.markPosType) !== null && _b !== void 0 ? _b : EMarkPosType.leftTop,
          element.nodeOffset,
          imgSize
        )
      }
      const option = {
        parentNode: (element === null || element === void 0 ? void 0 : element.parentNode) || null,
        pos: (element === null || element === void 0 ? void 0 : element.pos) || [0, 0, 0],
        visible:
          (_c = element === null || element === void 0 ? void 0 : element.visible) !== null &&
          _c !== void 0
            ? _c
            : true,
        size: -1,
        nodeOffset,
        imgId: imgIdList[index],
        imgSize,
        text: '',
        fontSize: 14.0,
        breakWidth: -1,
        contentPadding: [10, 10, 10, 10],
        textColor: -1,
        title: '',
        titleFontSize: 18.0,
        titleColor: 0xffffffff,
        userData: null, // 用户数据，仅帮外部系统保存数据
      }
      if (element.LodRange && element.LodRange.length > 2) {
        option.minLod = element.LodRange[0]
        option.maxLod = element.LodRange[1]
      }
      if (option.parentNode) delete option.pos
      return option
    })
  }
  /**
   * @description: 整理通过dom加载标签的配置项
   * @param {Array} markDomOption
   * @param {Array} imgIdList
   * @return {*}
   */
  function fetchDomOption(markDomOption, imgIdList) {
    return markDomOption.map((element, index) => {
      var _a, _b
      const imgSize = element.imgSize || [-1, -1]
      let nodeOffset = element.nodeOffset
      if (element.imgSize) {
        nodeOffset = fetchNodeOffset(
          (_a = element.markPosType) !== null && _a !== void 0 ? _a : EMarkPosType.leftTop,
          element.nodeOffset,
          imgSize
        )
      }
      const option = {
        parentNode: (element === null || element === void 0 ? void 0 : element.parentNode) || null,
        pos: (element === null || element === void 0 ? void 0 : element.pos) || [0, 0, 0],
        visible:
          (_b = element === null || element === void 0 ? void 0 : element.visible) !== null &&
          _b !== void 0
            ? _b
            : true,
        size: -1,
        nodeOffset,
        imgId: imgIdList[index],
        imgSize,
        userData: null, // 用户数据，仅帮外部系统保存数据
      }
      if (element.LodRange && element.LodRange.length > 2) {
        option.minLod = element.LodRange[0]
        option.maxLod = element.LodRange[1]
      }
      if (option.parentNode) delete option.pos
      return option
    })
  }
  function fetchNodeOffset(markPosType, nodeOffset, imgSize) {
    let nodeOffsetCopy = JSON.parse(JSON.stringify(nodeOffset))
    let imgSizeCopy = JSON.parse(JSON.stringify(imgSize))
    switch (markPosType) {
      case EMarkPosType.leftTop:
        return nodeOffsetCopy
      case EMarkPosType.midTop:
        nodeOffsetCopy[0] = nodeOffsetCopy[0] - imgSizeCopy[0] / 2
        return nodeOffsetCopy
      case EMarkPosType.rightTop:
        nodeOffsetCopy[0] = nodeOffsetCopy[0] - imgSizeCopy[0]
        return nodeOffsetCopy
      case EMarkPosType.leftBottom:
        nodeOffsetCopy[1] = -imgSizeCopy[1]
        return nodeOffsetCopy
      case EMarkPosType.midBottom:
        nodeOffsetCopy[0] = nodeOffsetCopy[0] - imgSizeCopy[0] / 2
        nodeOffsetCopy[1] = -imgSizeCopy[1]
        return nodeOffsetCopy
      case EMarkPosType.rightBottom:
        nodeOffsetCopy[0] = nodeOffsetCopy[0] - imgSizeCopy[0]
        nodeOffsetCopy[1] = -imgSizeCopy[1]
        return nodeOffsetCopy
      default:
        return nodeOffsetCopy
    }
  }

  var IAxis
  ;(function(IAxis) {
    IAxis[(IAxis['X'] = 0)] = 'X'
    IAxis[(IAxis['Y'] = 1)] = 'Y'
    IAxis[(IAxis['Z'] = 2)] = 'Z'
  })(IAxis || (IAxis = {}))
  //粒子创建方式1.通过位号2.数据创建3.只创建粒子在原点
  var IPartilceCreateType
  ;(function(IPartilceCreateType) {
    IPartilceCreateType[(IPartilceCreateType['code'] = 0)] = 'code'
    IPartilceCreateType[(IPartilceCreateType['data'] = 1)] = 'data'
    IPartilceCreateType[(IPartilceCreateType['none'] = 2)] = 'none'
  })(IPartilceCreateType || (IPartilceCreateType = {}))

  let particleObjectList = []
  let Player = {}
  let createType = null
  let createOptions = null
  let particleId = 0
  let createRes = {}
  //通过code定位
  const createByCode = () =>
    __awaiter$1(void 0, void 0, void 0, function*() {
      var _a, _b, _c
      const itemInfo = yield (_a = Player.Native) === null || _a === void 0
        ? void 0
        : _a.ModelTree.findItemByCode(
            createOptions === null || createOptions === void 0 ? void 0 : createOptions.code
          )
      const gTrans = yield (_b = Player.Native) === null || _b === void 0
        ? void 0
        : _b.NodeProxy.globalTransform(itemInfo.ownModel)
      const itemAabb = yield (_c = Player.Native) === null || _c === void 0
        ? void 0
        : _c.ModelTree.calcItemAabb(itemInfo.item)
      //包围盒z面中心位置
      const Position = Aabb.faceCenter(Aabb.deMap(itemAabb.aabb))
      return {
        Position: Position,
        gTrans: gTrans,
      }
    })
  /**
   *
   * @param player
   * @param particleObject
   * @param colorOptions
   * @returns
   */
  //设置粒子颜色
  const setParticleColor = (player, particleObject, colorOptions) =>
    __awaiter$1(void 0, void 0, void 0, function*() {
      var _d, _e, _f, _g, _h, _j, _k, _l
      const isCurrentPlayer = checkPlayerLoad(player)
      if (!isCurrentPlayer)
        return {
          status: false,
          message: 'player实例无效',
        }
      const particleChildrens = yield (_d = player.Native) === null || _d === void 0
        ? void 0
        : _d.NodeProxy.getNodeChildren(particleObject)
      let colorList = []
      try {
        ;(_e = colorOptions.colorList) === null || _e === void 0
          ? void 0
          : _e.forEach((item) => {
              let start = dealColorToNumber(item.startColor)
              let end = dealColorToNumber(item.endColor)
              let obj = { startColor: null, endColor: null }
              if (start.status && start.data != null) {
                obj.startColor = start.data
              }
              if (end.status && end.data != null) {
                obj.endColor = end.data
              }
              colorList.push(obj)
            })
        if (colorList.length <= 0) return { status: false, message: '颜色无效' }
        //判断颜色设置模式，默认为计算模式
        if (!colorOptions.customModel) {
          colorList = colorList.slice(0, 2)
          let colorClip = {
            startClip: 0,
            endClip: 0,
          }
          if (colorList.length == 2) {
            //计算开始颜色的平均差值
            colorClip.startClip =
              particleChildrens.length > 1
                ? (colorList[0].startColor - colorList[1].startColor) /
                  (particleChildrens.length - 1)
                : 0
            //计算结束颜色的平均差值
            colorClip.endClip =
              particleChildrens.length > 1
                ? (colorList[0].endColor - colorList[1].endColor) / (particleChildrens.length - 1)
                : 0
            for (let i = 0; i < particleChildrens.length; i++) {
              yield (_f = player.Native) === null || _f === void 0
                ? void 0
                : _f.ParticleEffekseer.setStartColor(
                    particleChildrens[i].nodePtr,
                    Math.round(colorList[0].startColor - i * colorClip.startClip)
                  )
              yield (_g = player.Native) === null || _g === void 0
                ? void 0
                : _g.ParticleEffekseer.setEndColor(
                    particleChildrens[i].nodePtr,
                    Math.round(colorList[0].endColor - i * colorClip.endClip)
                  )
            }
          }
        } else {
          //用户自定义样式，子节点和颜色一一对应
          for (let i = 0; i < particleChildrens.length; i++) {
            ;((_h = colorList[i]) === null || _h === void 0
            ? void 0
            : _h.startColor)
              ? yield (_j = player.Native) === null || _j === void 0
                  ? void 0
                  : _j.ParticleEffekseer.setStartColor(
                      particleChildrens[i].nodePtr,
                      colorList[i].startColor
                    )
              : null
            ;((_k = colorList[i]) === null || _k === void 0
            ? void 0
            : _k.endColor)
              ? yield (_l = player.Native) === null || _l === void 0
                  ? void 0
                  : _l.ParticleEffekseer.setEndColor(
                      particleChildrens[i].nodePtr,
                      colorList[i].endColor
                    )
              : null
          }
        }
        return {
          status: true,
          message: '',
        }
      } catch (error) {
        return {
          status: false,
          data: null,
          message: error,
        }
      }
    })
  //监听粒子文件状态
  const fileLinstener = (e) =>
    __awaiter$1(void 0, void 0, void 0, function*() {
      var _m, _o, _p, _q, _r, _s
      const detail = e.detail
      //  如果粒子文件存在或是已下载完成
      if (
        ((_m = detail.data) === null || _m === void 0 ? void 0 : _m.type) == 'fileStauts' &&
        ((_o = detail.data) === null || _o === void 0 ? void 0 : _o.currentState) == 2
      ) {
        //移除文件状态监听
        window.removeEventListener('File', fileLinstener)
        const particleObject = yield (_p = Player.Native) === null || _p === void 0
          ? void 0
          : _p.ParticleEffekseer.createParticle(
              createOptions === null || createOptions === void 0 ? void 0 : createOptions.targetUrl
            )
        const isExist = particleObjectList.find((item) => {
          return item.id == particleId
        })
        if (isExist) {
          yield destroyParticle(Player, { id: particleId })
        }
        particleObjectList.push({
          id: particleId,
          particlePtr: particleObject,
        })
        let localPos = {
          Position: [],
          Rotate: [],
          Scale: [],
        }
        switch (createType) {
          case IPartilceCreateType.code:
            const res = yield createByCode()
            localPos.Position = res.Position
            if (
              !(createOptions === null || createOptions === void 0 ? void 0 : createOptions.Rotate)
            ) {
              let axisObj = {
                axis: null,
                angle:
                  ((_q =
                    createOptions === null || createOptions === void 0
                      ? void 0
                      : createOptions.rotateOption) === null || _q === void 0
                    ? void 0
                    : _q.angle) || 90,
              }
              switch (
                (_r =
                  createOptions === null || createOptions === void 0
                    ? void 0
                    : createOptions.rotateOption) === null || _r === void 0
                  ? void 0
                  : _r.axis
              ) {
                case IAxis.Y:
                  axisObj.axis = [0.0, 1.0, 0.0]
                  break
                case IAxis.Z:
                  axisObj.axis = [0.0, 0.0, 1.0]
                  break
                default:
                  axisObj.axis = [1.0, 0.0, 0.0]
                  break
              }
              localPos.Rotate = Matrix4.decompose(
                Matrix4.multiply(
                  res.gTrans,
                  Matrix4.makeRotationAxis(axisObj.angle, axisObj.axis || [1.0, 0.0, 0.0])
                )
              ).quaternion
            } else {
              localPos.Rotate =
                createOptions === null || createOptions === void 0 ? void 0 : createOptions.Rotate
            }
            break
          case IPartilceCreateType.data:
            localPos.Position =
              createOptions === null || createOptions === void 0 ? void 0 : createOptions.Position
            localPos.Rotate =
              createOptions === null || createOptions === void 0 ? void 0 : createOptions.Rotate
            break
          case IPartilceCreateType.none:
            localPos.Position = undefined
            localPos.Rotate =
              createOptions === null || createOptions === void 0 ? void 0 : createOptions.Rotate
            break
          default:
            if (
              !(createOptions === null || createOptions === void 0 ? void 0 : createOptions.code)
            ) {
              createRes = { status: false, message: '不支持该类型创建' }
            }
            break
        }
        // 判断是否创建在世界原点,不是则设置位置
        localPos.Scale = (createOptions === null || createOptions === void 0
          ? void 0
          : createOptions.Scale) || [1, 1, 1]
        const res = yield setNodeLocal(Player, particleObject, localPos)
        // 如果位置信息设置不成功则返回 失败信息
        if (!res.status) {
          sendEvent(
            {
              message: res.message,
              status: res.status,
              data: {
                type: 'Particle',
                currentState: 0,
                data: res.data,
              },
            },
            'Particle'
          )
          particleId = 0
          return
        }
        let setColorRes = { status: true }
        //设置粒子颜色
        if (
          (createOptions === null || createOptions === void 0
            ? void 0
            : createOptions.colorOptions) &&
          ((_s =
            createOptions === null || createOptions === void 0
              ? void 0
              : createOptions.colorOptions.colorList) === null || _s === void 0
            ? void 0
            : _s.length) > 0
        ) {
          const res = yield setParticleColor(
            Player,
            particleObject,
            createOptions === null || createOptions === void 0 ? void 0 : createOptions.colorOptions
          )
          if (!res.status) {
            setColorRes.status = false
            setColorRes.message = res.message
            setColorRes.data = null
          }
        }
        createRes = {
          status: (setColorRes === null || setColorRes === void 0
          ? void 0
          : setColorRes.status)
            ? true
            : false,
          message: (setColorRes === null || setColorRes === void 0
          ? void 0
          : setColorRes.message)
            ? setColorRes === null || setColorRes === void 0
              ? void 0
              : setColorRes.message
            : '粒子创建成功',
          data: (setColorRes === null || setColorRes === void 0
          ? void 0
          : setColorRes.status)
            ? {
                id: particleId,
                // localInfo: localPos,
              }
            : null,
        }
      } else {
        createRes = detail
      }
      sendEvent(
        {
          message: createRes.message,
          status: createRes.status,
          data: {
            type: 'Particle',
            currentState: 1,
            data: createRes.data,
          },
        },
        'Particle'
      )
      particleId = 0
    })
  /**
   *
   * @param {IPlayer} player
   * @param {IParticleBaseOption} options
   * @returns {*}
   */
  //   创建粒子节点（1.位号创建 2.坐标数据创建）
  function createParticle(player, id, type, options) {
    var _a
    return __awaiter$1(this, void 0, void 0, function*() {
      if (type == IPartilceCreateType.code) {
        let itemInfo = null
        if (options.code) {
          itemInfo = yield (_a = player.Native) === null || _a === void 0
            ? void 0
            : _a.ModelTree.findItemByCode(options.code)
        }
        if (itemInfo == null || Object.keys(itemInfo).length <= 0) {
          sendEvent(
            {
              message: '位号为空或不存在,创建失败',
              status: false,
              data: {
                type: 'Particle',
                currentState: 0,
                data: null,
              },
            },
            'Particle'
          )
          return
        }
      }
      particleId = id || generateUUID() //创建粒子id
      const fileData = {
        fileList: [
          {
            targetUrl: options.targetUrl,
            fileUrl: options.fileUrl,
          },
        ],
        httpOptions: { methods: 'Get' },
        type: '',
      }
      createOptions = options
      Player = player
      createType = Number(type)
      //文件路径是否存在，若不存在则下载文件
      new File(player, fileData)
      //监听粒子文件状态
      window.addEventListener('File', fileLinstener)
    })
  }
  /**
   *
   * @param {IPlayer} player
   * @param {Number} particlePtr
   * @param {INodeEditorType } type
   * @returns {*}
   */
  //工具编辑粒子
  function setParticleEditor(player, id, type) {
    return __awaiter$1(this, void 0, void 0, function*() {
      if (!id) {
        return {
          status: false,
          message: '粒子Id为空',
        }
      }
      const particle = particleObjectList.find((item) => {
        return item.id == id
      })
      if (!particle || !particle.particlePtr)
        return {
          status: false,
          message: '该粒子不存在',
        }
      const isCurrentPlayer = checkPlayerLoad(player)
      if (!isCurrentPlayer)
        return {
          status: false,
          message: 'player实例无效',
        }
      const result = yield setNodeEditType(player, particle.particlePtr, type)
      return result
    })
  }
  /**
   *
   * @param {IPlayer} player
   * @param {Number} particlePtr
   * @param {ILocalOptions} options
   * @returns {*}
   */
  //设置粒子
  function setParticle(player, id, options) {
    return __awaiter$1(this, void 0, void 0, function*() {
      if (!id) {
        return {
          status: false,
          message: '粒子Id为空',
        }
      }
      const particle = particleObjectList.find((item) => {
        return item.id == id
      })
      if (!particle || !particle.particlePtr)
        return {
          status: false,
          message: '该粒子不存在',
        }
      const isCurrentPlayer = checkPlayerLoad(player)
      if (!isCurrentPlayer)
        return {
          status: false,
          message: 'player实例无效',
        }
      try {
        const result = yield setNodeLocal(player, particle.particlePtr, options)
        if (!result.status) return result
        if (options.colorOptions) {
          const res = yield setParticleColor(Player, particle.particlePtr, options.colorOptions)
          if (!res.status) return res
        }
        return {
          status: true,
          message: '',
        }
      } catch (error) {
        return {
          status: false,
          data: null,
          message: error,
        }
      }
    })
  }
  /**
   *
   * @param {IPlayer} player
   * @param {Number} particlePtr
   * @returns {*}
   */
  //销毁粒子
  function destroyParticle(player, particleObj) {
    return __awaiter$1(this, void 0, void 0, function*() {
      if (
        !particleObj ||
        !(particleObj === null || particleObj === void 0 ? void 0 : particleObj.id)
      )
        return {
          status: false,
          message: '粒子Id为空',
        }
      const isCurrentPlayer = checkPlayerLoad(player)
      if (!isCurrentPlayer)
        return {
          status: false,
          message: 'player实例无效',
        }
      const particle = particleObjectList.find((item) => {
        return item.id == particleObj.id
      })
      if (!particle || !particle.particlePtr)
        return {
          status: false,
          message: '粒子已销毁',
        }
      const result = yield destroyNode(player, particle.particlePtr)
      if (result.status) {
        let index = null
        particleObjectList === null || particleObjectList === void 0
          ? void 0
          : particleObjectList.forEach((item, i) => {
              if (item.id == particleObj.id) {
                index = i
              }
            })
        index != null ? particleObjectList.splice(index, 1) : null
      }
      return result
    })
  }
  /**
   *
   * @param {IPlayer} player
   * @param {Number} particlePtr
   * @returns {*}
   */
  //批量销毁粒子
  function destroyBatchParticle(player, particleList) {
    return __awaiter$1(this, void 0, void 0, function*() {
      const isCurrentPlayer = checkPlayerLoad(player)
      if (!isCurrentPlayer)
        return {
          status: false,
          message: 'player实例无效',
        }
      let indexList = []
      try {
        for (let i = 0; i < particleObjectList.length; i++) {
          let isFind = particleList.find((element) => {
            return element.id == particleObjectList[i].id
          })
          if (isFind) {
            const particle = particleObjectList.find((item) => {
              return item.id == particleObjectList[i].id
            })
            if (particle && particle.particlePtr) {
              const res = yield destroyNode(player, particle.particlePtr)
              if (res.status) {
                indexList.push(i)
              }
            }
          }
        }
        indexList.forEach((item) => {
          particleObjectList.splice(item, 1)
        })
        return {
          status: true,
        }
      } catch (error) {
        return {
          status: false,
        }
      }
    })
  }
  /**
   * 查询粒子颜色
   * @param player
   * @param id
   * @returns
   */
  function getParticleColor(player, id) {
    var _a
    return __awaiter$1(this, void 0, void 0, function*() {
      if (!id) {
        return {
          status: false,
          message: '粒子Id为空',
        }
      }
      const item = particleObjectList.find((item) => {
        return item.id == id
      })
      if (!item || !(item === null || item === void 0 ? void 0 : item.particlePtr)) {
        return {
          status: false,
          message: '粒子不存在',
        }
      }
      const isCurrentPlayer = checkPlayerLoad(player)
      if (!isCurrentPlayer)
        return {
          status: false,
          message: 'player实例无效',
        }
      const particleChildrens = yield (_a = player.Native) === null || _a === void 0
        ? void 0
        : _a.NodeProxy.getNodeChildren(item === null || item === void 0 ? void 0 : item.particlePtr)
      let list = []
      particleChildrens === null || particleChildrens === void 0
        ? void 0
        : particleChildrens.forEach((node) =>
            __awaiter$1(this, void 0, void 0, function*() {
              var _b, _c
              let startColor = yield (_b = player.Native) === null || _b === void 0
                ? void 0
                : _b.ParticleEffekseer.getStartColor(node.nodePtr)
              let endColor = yield (_c = player.Native) === null || _c === void 0
                ? void 0
                : _c.ParticleEffekseer.getEndColor(node.nodePtr)
              list.push({
                startColor: startColor,
                endColor: endColor,
              })
            })
          )
      return {
        status: true,
        data: list,
        message: '',
      }
    })
  }
  /**
   *
   * @param player
   * @returns
   */
  // 获取所有粒子,返回粒子id和localdata
  function getAllParticle(player) {
    return __awaiter$1(this, void 0, void 0, function*() {
      const isCurrentPlayer = checkPlayerLoad(player)
      if (!isCurrentPlayer)
        return {
          status: false,
          message: 'player实例无效',
        }
      let list = []
      let result = null
      for (let i = 0; i < particleObjectList.length; i++) {
        const res = yield getNodeLocal(player, particleObjectList[i].particlePtr)
        if (res.status && res.data) {
          const localPos = res.data
          const resColor = yield getParticleColor(player, particleObjectList[i].id)
          list.push({
            id: particleObjectList[i].id,
            localInfo: localPos,
            colorList: resColor.data ? resColor.data : [],
          })
        } else {
          result = res
        }
      }
      if (result) return result
      return {
        status: true,
        data: list,
        message: '获取所有粒子',
      }
    })
  }
  // 获取粒子,返回粒子id和localdata
  function getParticleInfo(player, id) {
    return __awaiter$1(this, void 0, void 0, function*() {
      if (!id) {
        return {
          status: false,
          message: '粒子Id为空',
        }
      }
      const item = particleObjectList.find((item) => {
        return item.id == id
      })
      if (!item || !(item === null || item === void 0 ? void 0 : item.particlePtr)) {
        return {
          status: false,
          message: '粒子不存在',
        }
      }
      const isCurrentPlayer = checkPlayerLoad(player)
      if (!isCurrentPlayer)
        return {
          status: false,
          message: 'player实例无效',
        }
      const res = yield getNodeLocal(
        player,
        item === null || item === void 0 ? void 0 : item.particlePtr
      )
      if (!res.status || !res.data) {
        return {
          status: false,
          message: '查询失败',
        }
      }
      const resColor = yield getParticleColor(player, item.id)
      if (!resColor.status) return resColor
      return {
        status: true,
        data: {
          id: id,
          localInfo: res.data,
          colorList: resColor.data ? resColor.data : [],
        },
        message: '获取粒子信息',
      }
    })
  }
  /**
   * 显示/隐藏粒子
   * @param {IPlayer}player
   * @param {string|number}id
   * @param {Boolean} visible
   * @returns
   */
  function setParticleVisible(player, id, visible) {
    return __awaiter$1(this, void 0, void 0, function*() {
      if (!id) {
        return {
          status: false,
          message: '粒子Id为空',
        }
      }
      const item = particleObjectList.find((item) => {
        return item.id == id
      })
      if (!item || !(item === null || item === void 0 ? void 0 : item.particlePtr)) {
        return {
          status: false,
          message: '粒子不存在',
        }
      }
      const isCurrentPlayer = checkPlayerLoad(player)
      if (!isCurrentPlayer)
        return {
          status: false,
          message: 'player实例无效',
        }
      const res = yield setNodeStatus(
        player,
        item === null || item === void 0 ? void 0 : item.particlePtr,
        visible
      )
      return res
    })
  }
  const Particle = {
    createParticle,
    setParticleEditor,
    setParticle,
    destroyParticle,
    destroyBatchParticle,
    getParticleColor,
    getAllParticle,
    getParticleInfo,
    setParticleVisible,
  }

  var EStyleType
  ;(function(EStyleType) {
    EStyleType['riskArea'] = 'riskArea'
    EStyleType['fence'] = 'fence'
  })(EStyleType || (EStyleType = {}))

  let currentMousePos = []
  let currentLoadFence = []
  class ElectoronicRail {
    // 激活编辑模式
    static changeActiveStatus(player, active, id) {
      var _a
      return __awaiter$1(this, void 0, void 0, function*() {
        if (!checkPlayerLoad(player)) {
          // 加载失败
          return {
            status: false,
            message: 'player无效',
            data: {},
          }
        }
        // 设置编辑方式，监听编辑结果
        yield (_a = player.Native) === null || _a === void 0
          ? void 0
          : _a.ElectoronicRail.setEditType(active ? 2 : 0)
        const currentFence = currentLoadFence.find((item) => {
          return item.id === id
        })
        if (currentFence && currentFence.fenceObject) {
          railUpdateListener(player, currentFence.fenceObject)
        }
        return {
          status: true,
          message: '切换成功',
          data: {},
        }
      })
    }
    // 激活鼠标创建方式
    static activeCreateByMouse(player, baseOptions, styleOptions, markerOptions) {
      var _a, _b, _c, _d
      return __awaiter$1(this, void 0, void 0, function*() {
        if (!checkPlayerLoad(player)) {
          // 加载失败
          return {
            status: false,
            message: 'player无效',
            data: {
              id: baseOptions.id,
              fenceObject: null,
            },
          }
        }
        // 设置编辑模式
        yield (_a = player.Native) === null || _a === void 0
          ? void 0
          : _a.ElectoronicRail.setEditMode(true)
        let currentFence = 0
        // 多点顺时针创建
        currentFence = yield (_b = player.Native) === null || _b === void 0
          ? void 0
          : _b.ElectoronicRail.createByMouse(baseOptions.name, 1, baseOptions.height)
        // 围栏样式设置
        yield setFenceStyle(player, currentFence, styleOptions)
        currentLoadFence.push({
          id: baseOptions.id,
          fenceObject: currentFence,
        })
        if (baseOptions.editMode) {
          // 设置编辑方式，监听编辑结果
          this.changeActiveStatus(player, baseOptions.editMode, baseOptions.id)
        }
        yield (_c = player.Native) === null || _c === void 0
          ? void 0
          : _c.ModelTree.EventBrowseLClick.connect(browseLClick)
        yield (_d = player.Native) === null || _d === void 0
          ? void 0
          : _d.ModelTree.EventBrowseRClick.connect(
              browseRClick(player, baseOptions.id, markerOptions)
            )
        return {
          status: true,
          message: '激活成功',
          data: {
            id: baseOptions.id,
            fenceObject: currentFence,
          },
        }
      })
    }
    // 创建电子围栏
    static createByPosition(player, baseOptions, styleOptions, markerOptions) {
      var _a, _b, _c, _d
      return __awaiter$1(this, void 0, void 0, function*() {
        if (!checkPlayerLoad(player)) {
          // 加载失败
          return {
            status: false,
            message: 'player无效',
            data: {
              id: baseOptions.id,
              fenceObject: null,
            },
          }
        }
        // 设置编辑模式
        yield (_a = player.Native) === null || _a === void 0
          ? void 0
          : _a.ElectoronicRail.setEditMode(true)
        let currentFence = 0
        currentFence = yield (_b = player.Native) === null || _b === void 0
          ? void 0
          : _b.ElectoronicRail.create(baseOptions.name, baseOptions.height)
        // 围栏样式设置
        setFenceStyle(player, currentFence, styleOptions)
        if (baseOptions.pos && baseOptions.pos.length) {
          for (let i = 0; i < baseOptions.pos.length; i++) {
            const element = baseOptions.pos[i]
            // 添加围栏柱子
            yield (_c = player.Native) === null || _c === void 0
              ? void 0
              : _c.ElectoronicRail.addFencePillar(currentFence, element)
          }
          yield (_d = player.Native) === null || _d === void 0
            ? void 0
            : _d.ElectoronicRail.updateVerticesData(currentFence)
        }
        currentLoadFence.push({
          id: baseOptions.id,
          fenceObject: currentFence,
        })
        if (markerOptions && markerOptions.showMarker) {
          createFenceMarker(player, baseOptions.id, markerOptions.options)
        }
        if (baseOptions.editMode) {
          // 设置编辑方式，监听编辑结果
          this.changeActiveStatus(player, baseOptions.editMode, baseOptions.id)
        }
        return {
          status: true,
          message: '新增成功',
          data: {
            id: baseOptions.id,
            fenceObject: currentFence,
          },
        }
      })
    }
    // 重置电子围栏
    static reset(player, id) {
      var _a, _b, _c, _d
      return __awaiter$1(this, void 0, void 0, function*() {
        if (!checkPlayerLoad(player)) {
          // 加载失败
          return {
            status: false,
            message: 'player无效',
            data: {
              id: id,
              fenceObject: null,
            },
          }
        }
        yield this.destroy(player, [id])
        currentMousePos = []
        yield (_a = player.Native) === null || _a === void 0
          ? void 0
          : _a.ModelTree.EventBrowseLClick.disconnect(browseLClick)
        yield (_b = player.Native) === null || _b === void 0
          ? void 0
          : _b.ModelTree.EventBrowseRClick.disconnect(browseRClick(player, id, null))
        ;(_c = player.Native) === null || _c === void 0
          ? void 0
          : _c.ElectoronicRail.setEditMode(false)
        ;(_d = player.Native) === null || _d === void 0 ? void 0 : _d.ElectoronicRail.setEditType(0)
        return {
          status: true,
          message: '重置成功',
          data: {
            id: id,
            fenceObject: null,
          },
        }
      })
    }
    // 更新电子围栏
    static update(player, id, updateOptions, styleOptions) {
      var _a, _b, _c, _d, _e, _f
      return __awaiter$1(this, void 0, void 0, function*() {
        if (!checkPlayerLoad(player)) {
          // 加载失败
          return {
            status: false,
            message: 'player无效',
            data: {
              id,
              fenceObject: null,
            },
          }
        }
        const currentFence = currentLoadFence.find((item) => {
          return item.id === id
        })
        if (!currentFence || !currentFence.fenceObject) {
          return {
            status: false,
            message: '未找到围栏',
            data: {},
          }
        }
        // 设置高度
        if (updateOptions.height) {
          ;(_a = player.Native) === null || _a === void 0
            ? void 0
            : _a.ElectoronicRail.setHeight(currentFence.fenceObject, updateOptions.height)
        }
        // 设置显隐
        if (typeof updateOptions.visible === 'boolean') {
          ;(_b = player.Native) === null || _b === void 0
            ? void 0
            : _b.ElectoronicRail.setVisible(updateOptions.visible)
        }
        // 更新围栏柱子位置
        if (updateOptions.updatePos) {
          const pillarCount = yield (_c = player.Native) === null || _c === void 0
            ? void 0
            : _c.ElectoronicRail.fencePillarCount(currentFence.fenceObject)
          const differ = pillarCount - updateOptions.updatePos.length
          if (differ > 0) {
            for (let i = 0; i < differ; i += 1) {
              yield (_d = player.Native) === null || _d === void 0
                ? void 0
                : _d.ElectoronicRail.removeFencePillar(
                    currentFence.fenceObject,
                    pillarCount - 1 - i
                  )
            }
          }
          for (let i = 0; i < updateOptions.updatePos.length; i += 1) {
            const item = updateOptions.updatePos[i]
            if (i > pillarCount - 1) {
              ;(_e = player.Native) === null || _e === void 0
                ? void 0
                : _e.ElectoronicRail.addFencePillar(currentFence.fenceObject, item)
            } else {
              ;(_f = player.Native) === null || _f === void 0
                ? void 0
                : _f.ElectoronicRail.updateFencePillar(currentFence.fenceObject, i, item)
            }
          }
        }
        // 设置样式
        setFenceStyle(player, currentFence.fenceObject, styleOptions)
        return {
          status: true,
          message: '编辑成功',
          data: {
            id,
            fenceObject: currentFence,
          },
        }
      })
    }
    // 销毁电子围栏
    static destroy(player, ids) {
      var _a
      return __awaiter$1(this, void 0, void 0, function*() {
        if (!checkPlayerLoad(player)) {
          // 加载失败
          return {
            status: false,
            message: 'player无效',
            data: {},
          }
        }
        const currentFenceList = currentLoadFence.filter((item) => {
          return ids.includes(item.id)
        })
        for (let i = 0; i < currentFenceList.length; i += 1) {
          const item = currentFenceList[i]
          const index = currentLoadFence.findIndex((el) => {
            return el.id === item.id && el.fenceObject === item.fenceObject
          })
          currentLoadFence.splice(index, 1)
          if (item.fenceObject) {
            yield (_a = player.Native) === null || _a === void 0
              ? void 0
              : _a.ElectoronicRail.destroy(item.fenceObject)
            item.fenceObject = 0
          }
        }
        return {
          status: true,
          message: '销毁成功',
          data: {},
        }
      })
    }
  }
  // 创建围栏标签
  function createFenceMarker(player, id, markerOptions) {
    var _a
    return __awaiter$1(this, void 0, void 0, function*() {
      if (!checkPlayerLoad(player)) {
        // 加载失败
        return {
          status: false,
          message: 'player无效',
          data: {},
        }
      }
      const currentFence = currentLoadFence.find((item) => {
        return item.id === id
      })
      if (currentFence && currentFence.fenceObject) {
        const aabb = yield (_a = player.Native) === null || _a === void 0
          ? void 0
          : _a.ElectoronicRail.getAabb(currentFence.fenceObject)
        const fenceCenter = Aabb.faceCenter(aabb)
        markerOptions.pos = fenceCenter
        yield Marker.createBySingleLine(player, markerOptions)
      }
      return {
        status: true,
        message: '创建成功',
        data: {
          id,
          fenceObject: currentFence,
        },
      }
    })
  }
  // 监听围栏编辑操作
  function railUpdateListener(player, objectId) {
    var _a
    if (checkPlayerLoad(player) && objectId) {
      ;(_a = player.Native) === null || _a === void 0
        ? void 0
        : _a.ElectoronicRail.EventEditFinished.connect((data) =>
            __awaiter$1(this, void 0, void 0, function*() {
              var _b, _c
              if (data.fence === objectId) {
                const points = []
                const wallCount = yield (_b = player.Native) === null || _b === void 0
                  ? void 0
                  : _b.ElectoronicRail.wallCount(objectId)
                for (let i = 0; i < wallCount; i += 1) {
                  const wallData = yield (_c = player.Native) === null || _c === void 0
                    ? void 0
                    : _c.ElectoronicRail.wallData(objectId, i)
                  points.push(wallData.prevBottomPt)
                }
                sendEvent(
                  {
                    status: true,
                    message: '成功',
                    data: {
                      type: 'updateElectoronicRail',
                      currentState: 1,
                      data: points,
                    },
                  },
                  'ElectoronicRail'
                )
              }
            })
          )
    }
  }
  // 左键点击事件
  function browseLClick(data) {
    if (data && data.object) {
      currentMousePos.push(data.pos)
      sendEvent(
        {
          status: true,
          message: '成功',
          data: {
            type: 'createByMouse',
            currentState: 1,
            data: data.pos,
          },
        },
        'ElectoronicRail'
      )
    }
  }
  // 右键键点击事件
  function browseRClick(player, id, markerOptions) {
    const fun = (data) => {
      var _a, _b
      if (currentMousePos.length === 1 && data && data.object) {
        return
      }
      if (currentMousePos.length === 2 && data && data.object) {
        sendEvent(
          {
            status: true,
            message: '成功',
            data: {
              type: 'createByMouse',
              currentState: 1,
              data: data.pos,
            },
          },
          'ElectoronicRail'
        )
      }
      currentMousePos = []
      ;(_a = player.Native) === null || _a === void 0
        ? void 0
        : _a.ModelTree.EventBrowseLClick.disconnect(browseLClick)
      ;(_b = player.Native) === null || _b === void 0
        ? void 0
        : _b.ModelTree.EventBrowseRClick.disconnect(fun)
      if (markerOptions && markerOptions.showMarker) {
        createFenceMarker(player, id, markerOptions.options)
      }
    }
    return fun
  }
  // 设置围栏样式
  function setFenceStyle(player, objectId, styleOptions) {
    var _a, _b, _c, _d, _e, _f
    return __awaiter$1(this, void 0, void 0, function*() {
      if (checkPlayerLoad(player) && objectId) {
        let outsideTexture = ''
        let insideTexture = ''
        let pillarTexture = ''
        if (styleOptions.type === EStyleType.riskArea) {
          const rgba = hex2rgba(styleOptions.style)
          // 设置盖子的颜色
          yield (_a = player.Native) === null || _a === void 0
            ? void 0
            : _a.ElectoronicRail.setFenceCapColor(objectId, [
                rgba.r / 255,
                rgba.g / 255,
                rgba.b / 255,
                rgba.a / 255,
              ])
          outsideTexture = insideTexture = pillarTexture = styleOptions.style
        } else {
          outsideTexture = `data://../apps/fenceImg/${styleOptions.style}/outside.png`
          insideTexture = `data://../apps/fenceImg/${styleOptions.style}/inside.png`
          pillarTexture = `data://../apps/fenceImg/${styleOptions.style}/pillar.png`
        }
        // 围栏外墙贴图
        let outsideTextureObj = outsideTexture
          ? (yield createTextureByImage(player, outsideTexture)).data || 0
          : 0
        // 围栏外墙贴图
        let insideTextureObj = insideTexture
          ? (yield createTextureByImage(player, insideTexture)).data || 0
          : 0
        // 围栏柱子贴图
        let pillarTextureObj = pillarTexture
          ? (yield createTextureByImage(player, pillarTexture)).data || 0
          : 0
        // 设置围栏柱子显隐
        yield (_b = player.Native) === null || _b === void 0
          ? void 0
          : _b.ElectoronicRail.setFencePillarVisible(
              objectId,
              styleOptions.type !== EStyleType.riskArea
            )
        // 显示盖子
        yield (_c = player.Native) === null || _c === void 0
          ? void 0
          : _c.ElectoronicRail.setFenceCapVisible(
              objectId,
              styleOptions.type === EStyleType.riskArea
            )
        // 设置围栏柱子贴图
        if (pillarTextureObj !== 0) {
          yield (_d = player.Native) === null || _d === void 0
            ? void 0
            : _d.ElectoronicRail.setPillarTexture(objectId, pillarTextureObj)
        }
        // 设置围栏外墙贴图
        if (outsideTextureObj !== 0) {
          yield (_e = player.Native) === null || _e === void 0
            ? void 0
            : _e.ElectoronicRail.setWallOutsideTexture(objectId, outsideTextureObj)
        }
        // 设置围栏内墙贴图
        if (insideTextureObj !== 0) {
          yield (_f = player.Native) === null || _f === void 0
            ? void 0
            : _f.ElectoronicRail.setWallInsideTexture(objectId, insideTextureObj)
        }
      }
    })
  }
  // 创建材质贴图
  function createTextureByImage(player, image) {
    var _a, _b
    return __awaiter$1(this, void 0, void 0, function*() {
      if (!checkPlayerLoad(player)) {
        // 加载失败
        return {
          status: false,
          message: 'player无效',
          data: null,
        }
      }
      let imageStr = null
      if (image.includes('#')) {
        const rgba = hex2rgba(image)
        imageStr = `rgba:${rgba.r},${rgba.g},${rgba.b},${rgba.a}`
      } else {
        const isExists = yield (_a = player.Native) === null || _a === void 0
          ? void 0
          : _a.File.exists(image)
        imageStr = isExists ? image : ''
      }
      const texture = yield (_b = player.Native) === null || _b === void 0
        ? void 0
        : _b.ElectoronicRail.createTextureByImage(imageStr)
      return {
        status: true,
        message: '',
        data: texture,
      }
    })
  }

  /*
   * @Author: fengxiaojing
   * @LastEditTime: 2023-10-24 10:16:37
   * @Description:
   * @LastEditors: fengxiaojing
   */
  // 加载场景                                                                                                          
  const cloudRender = {
    Node: Node$1,
    Camera,
    Clip,
    setTool,
    Setting: setting,
    Walking: walking,
    GIS,
    Engine,
    Model,
    ModelGlitter,
    Marker,
    Particle,
    electoronicRail: ElectoronicRail,
  }

  return cloudRender
})
